import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: { input: any; output: any; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type ActivateBundledBodForCompanyInput = {
  companyId: Scalars['Int']['input'];
  useBundledBOD: Scalars['Boolean']['input'];
};

export type ActivateBundledBodForCompanyPayload = {
  __typename?: 'ActivateBundledBODForCompanyPayload';
  company?: Maybe<Company>;
};

export type ActivateCustomerProfileData = {
  __typename?: 'ActivateCustomerProfileData';
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ActivateCustomerProfileResponse = {
  __typename?: 'ActivateCustomerProfileResponse';
  data?: Maybe<ActivateCustomerProfileData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type ActivateEcobankDirectDebitCustomerProfileInput = {
  accountNumber: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};

export type ActivateEcobankDirectDebitCustomerProfilePayload = {
  __typename?: 'ActivateEcobankDirectDebitCustomerProfilePayload';
  activateCustomerProfileResponse?: Maybe<ActivateCustomerProfileResponse>;
};

export type AddCustomerDestinationInput = {
  customerId: Scalars['Int']['input'];
  destinationId: Scalars['Int']['input'];
};

export type AddCustomerDestinationPayload = {
  __typename?: 'AddCustomerDestinationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type AddDeliveredOrdersEmailJobInput = {
  companyId: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  localTriggerTime: Scalars['String']['input'];
};

export type AddDeliveredOrdersEmailJobPayload = {
  __typename?: 'AddDeliveredOrdersEmailJobPayload';
  deliveredOrdersEmailJob?: Maybe<DeliveredOrdersEmailJob>;
};

export type AddFeedbackMessageInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
};

export type AddFeedbackMessagePayload = {
  __typename?: 'AddFeedbackMessagePayload';
  feedbackMessage?: Maybe<FeedbackMessage>;
};

export type AddLocationDestinationInput = {
  costCentre?: InputMaybe<Scalars['String']['input']>;
  destinationId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};

export type AddLocationDestinationPayload = {
  __typename?: 'AddLocationDestinationPayload';
  locationDestination?: Maybe<LocationDestination>;
};

export type AddLocationMappingInput = {
  costCentre: Scalars['String']['input'];
  destinationId: Scalars['Int']['input'];
  sourceLocationId: Scalars['Int']['input'];
};

export type AddLocationMappingPayload = {
  __typename?: 'AddLocationMappingPayload';
  depoDestinationMapping?: Maybe<DepoDestinationMapping>;
};

export type AddSalesVoucherItemsInput = {
  items?: InputMaybe<Array<SalesVoucherItemInput>>;
  salesVoucherId: Scalars['Int']['input'];
};

export type AddUserToLocationInput = {
  locationIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type AddUserToLocationPayload = {
  __typename?: 'AddUserToLocationPayload';
  user?: Maybe<User>;
};

export type AddUserToMailingGroupInput = {
  companyId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  mailingGroupId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddUserToMailingGroupPayload = {
  __typename?: 'AddUserToMailingGroupPayload';
  companyMailingGroup?: Maybe<CompanyMailingGroup>;
};

export type AdminDashboardGraph = {
  __typename?: 'AdminDashboardGraph';
  date: Scalars['DateTime']['output'];
  totalAmountApproved: Scalars['Decimal']['output'];
};

export type AdminSummaryReport = {
  __typename?: 'AdminSummaryReport';
  count: Scalars['Int']['output'];
  reportType: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type AllLocationsConnection = {
  __typename?: 'AllLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AllLocationsEdge = {
  __typename?: 'AllLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Location;
};

export type AmendSalesOrderInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['Int']['input']>;
  isDeliveryInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  salesVoucherItemId: Scalars['Int']['input'];
  sourceLocationId?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
};

export type AmendSalesOrderPayload = {
  __typename?: 'AmendSalesOrderPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type AmendableFields = {
  __typename?: 'AmendableFields';
  deliveryType: Scalars['Boolean']['output'];
  destination: Scalars['Boolean']['output'];
  driver: Scalars['Boolean']['output'];
  loadingPoint: Scalars['Boolean']['output'];
  orderReference: Scalars['Boolean']['output'];
  product: Scalars['Boolean']['output'];
  quantity: Scalars['Boolean']['output'];
  transporter: Scalars['Boolean']['output'];
  truck: Scalars['Boolean']['output'];
};

export type AmendableFieldsFilterInput = {
  and?: InputMaybe<Array<AmendableFieldsFilterInput>>;
  deliveryType?: InputMaybe<BooleanOperationFilterInput>;
  destination?: InputMaybe<BooleanOperationFilterInput>;
  driver?: InputMaybe<BooleanOperationFilterInput>;
  loadingPoint?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AmendableFieldsFilterInput>>;
  orderReference?: InputMaybe<BooleanOperationFilterInput>;
  product?: InputMaybe<BooleanOperationFilterInput>;
  quantity?: InputMaybe<BooleanOperationFilterInput>;
  transporter?: InputMaybe<BooleanOperationFilterInput>;
  truck?: InputMaybe<BooleanOperationFilterInput>;
};

export type AmendableFieldsInput = {
  deliveryType: Scalars['Boolean']['input'];
  destination: Scalars['Boolean']['input'];
  driver: Scalars['Boolean']['input'];
  loadingPoint: Scalars['Boolean']['input'];
  orderReference: Scalars['Boolean']['input'];
  product: Scalars['Boolean']['input'];
  quantity: Scalars['Boolean']['input'];
  transporter: Scalars['Boolean']['input'];
  truck: Scalars['Boolean']['input'];
};

export type AmendableFieldsSortInput = {
  deliveryType?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<SortEnumType>;
  driver?: InputMaybe<SortEnumType>;
  loadingPoint?: InputMaybe<SortEnumType>;
  orderReference?: InputMaybe<SortEnumType>;
  product?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  transporter?: InputMaybe<SortEnumType>;
  truck?: InputMaybe<SortEnumType>;
};

export type AmendmentRequest = {
  __typename?: 'AmendmentRequest';
  customerRef?: Maybe<Scalars['String']['output']>;
  destinationId?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['Int']['output']>;
  isDeliveryInclusive?: Maybe<Scalars['Boolean']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  sourceLocationId?: Maybe<Scalars['Int']['output']>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
};

export type AmendmentRequestFilterInput = {
  and?: InputMaybe<Array<AmendmentRequestFilterInput>>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  driverId?: InputMaybe<IntOperationFilterInput>;
  isDeliveryInclusive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AmendmentRequestFilterInput>>;
  productId?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  sourceLocationId?: InputMaybe<IntOperationFilterInput>;
  supplierId?: InputMaybe<IntOperationFilterInput>;
  vehicleId?: InputMaybe<IntOperationFilterInput>;
};

export type AppUpdates = {
  __typename?: 'AppUpdates';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isMandatory: Scalars['Boolean']['output'];
  releaseDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionCode: Scalars['Int']['output'];
  versionName: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AppUpdatesConnection = {
  __typename?: 'AppUpdatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AppUpdatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AppUpdates>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AppUpdatesEdge = {
  __typename?: 'AppUpdatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AppUpdates;
};

export type AppUpdatesFilterInput = {
  and?: InputMaybe<Array<AppUpdatesFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isMandatory?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AppUpdatesFilterInput>>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  versionCode?: InputMaybe<IntOperationFilterInput>;
  versionName?: InputMaybe<StringOperationFilterInput>;
};

export type AppUpdatesSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMandatory?: InputMaybe<SortEnumType>;
  releaseDate?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  versionCode?: InputMaybe<SortEnumType>;
  versionName?: InputMaybe<SortEnumType>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type ApprovePaymentInput = {
  paymentApprovalStatusId: Scalars['Int']['input'];
  paymentId: Scalars['Int']['input'];
  reasonId?: InputMaybe<Scalars['Int']['input']>;
  rejectionComment?: InputMaybe<Scalars['String']['input']>;
};

export type ApprovePaymentPayload = {
  __typename?: 'ApprovePaymentPayload';
  payment?: Maybe<Payment>;
};

export type ApprovePendingDeliveryDateInput = {
  overrideDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesVoucherItemId: Scalars['Int']['input'];
};

export type ApprovePendingDeliveryDatePayload = {
  __typename?: 'ApprovePendingDeliveryDatePayload';
  salesVoucherItem?: Maybe<SalesVoucherItem>;
};

export type AvailableBalanceResponse = {
  __typename?: 'AvailableBalanceResponse';
  amountPendingApproval: Scalars['Decimal']['output'];
  amountUsed: Scalars['Decimal']['output'];
  bank: Scalars['String']['output'];
  cashDepositSlipNumber: Scalars['String']['output'];
  chequeDate?: Maybe<Scalars['DateTime']['output']>;
  depositorName: Scalars['String']['output'];
  isExistingPayment: Scalars['Boolean']['output'];
  paymentId: Scalars['Int']['output'];
  paymentMode: Scalars['String']['output'];
  remainingBalance: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type BackOfficePaymentsConnection = {
  __typename?: 'BackOfficePaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BackOfficePaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BackOfficePaymentsEdge = {
  __typename?: 'BackOfficePaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

/** A connection to a list of items. */
export type BackOfficeSalesVouchersConnection = {
  __typename?: 'BackOfficeSalesVouchersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BackOfficeSalesVouchersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucher>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BackOfficeSalesVouchersEdge = {
  __typename?: 'BackOfficeSalesVouchersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucher;
};

export type Bank = {
  __typename?: 'Bank';
  bankBranches: Array<BankBranch>;
  code: Scalars['String']['output'];
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankBranch = {
  __typename?: 'BankBranch';
  bankId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankBranchFilterInput = {
  and?: InputMaybe<Array<BankBranchFilterInput>>;
  bankId?: InputMaybe<IntOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankBranchFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BankBranchSortInput = {
  bankId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BankBranchesConnection = {
  __typename?: 'BankBranchesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BankBranchesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BankBranch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BankBranchesEdge = {
  __typename?: 'BankBranchesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BankBranch;
};

export type BankFilterInput = {
  and?: InputMaybe<Array<BankFilterInput>>;
  bankBranches?: InputMaybe<ListFilterInputTypeOfBankBranchFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BankGuarantee = {
  __typename?: 'BankGuarantee';
  bankGuaranteeActivityLogs: Array<BankGuaranteeActivityLog>;
  bankGuaranteeRef: Scalars['String']['output'];
  certificateUrl: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['Int']['output'];
  creditLimit: Scalars['Decimal']['output'];
  creditRemaining: Scalars['Decimal']['output'];
  creditUsed: Scalars['Decimal']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  expiryDate: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  guaranteeBank: Bank;
  guaranteeBankId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  issuedDate: Scalars['DateTime']['output'];
  reference: Scalars['String']['output'];
  salesOffice: Location;
  salesOfficeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankGuaranteeActivityLog = {
  __typename?: 'BankGuaranteeActivityLog';
  activityType: BankGuarnateeActivityType;
  activityTypeId: Scalars['Int']['output'];
  bankGuaranteeReference: Scalars['String']['output'];
  certificateUrl: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['Int']['output'];
  creditLimit: Scalars['Decimal']['output'];
  expiryDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  issuedDate: Scalars['DateTime']['output'];
  previousCertificateUrl?: Maybe<Scalars['String']['output']>;
  previousCreditLimit?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankGuaranteeActivityLogFilterInput = {
  activityType?: InputMaybe<BankGuarnateeActivityTypeFilterInput>;
  activityTypeId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<BankGuaranteeActivityLogFilterInput>>;
  bankGuaranteeReference?: InputMaybe<StringOperationFilterInput>;
  certificateUrl?: InputMaybe<StringOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  creditLimit?: InputMaybe<DecimalOperationFilterInput>;
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  issuedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BankGuaranteeActivityLogFilterInput>>;
  previousCertificateUrl?: InputMaybe<StringOperationFilterInput>;
  previousCreditLimit?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BankGuaranteeFilterInput = {
  and?: InputMaybe<Array<BankGuaranteeFilterInput>>;
  bankGuaranteeActivityLogs?: InputMaybe<ListFilterInputTypeOfBankGuaranteeActivityLogFilterInput>;
  bankGuaranteeRef?: InputMaybe<StringOperationFilterInput>;
  certificateUrl?: InputMaybe<StringOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  creditLimit?: InputMaybe<DecimalOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  guaranteeBank?: InputMaybe<BankFilterInput>;
  guaranteeBankId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  issuedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BankGuaranteeFilterInput>>;
  reference?: InputMaybe<StringOperationFilterInput>;
  salesOffice?: InputMaybe<LocationFilterInput>;
  salesOfficeId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BankGuaranteeSortInput = {
  bankGuaranteeRef?: InputMaybe<SortEnumType>;
  certificateUrl?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  creditLimit?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  expiryDate?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  guaranteeBank?: InputMaybe<BankSortInput>;
  guaranteeBankId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  issuedDate?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  salesOffice?: InputMaybe<LocationSortInput>;
  salesOfficeId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type BankGuarnateeActivityType = {
  __typename?: 'BankGuarnateeActivityType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type BankGuarnateeActivityTypeFilterInput = {
  and?: InputMaybe<Array<BankGuarnateeActivityTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BankGuarnateeActivityTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type BankGuranteeSummary = {
  __typename?: 'BankGuranteeSummary';
  expiredCredit: Scalars['Decimal']['output'];
  totalCredit: Scalars['Decimal']['output'];
  validCredit: Scalars['Decimal']['output'];
};

export type BankSortInput = {
  code?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BanksConnection = {
  __typename?: 'BanksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BanksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Bank>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BanksEdge = {
  __typename?: 'BanksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Bank;
};

export type Basket = {
  __typename?: 'Basket';
  basketItems: Array<BasketItems>;
  basketOrderNumber: Scalars['String']['output'];
  basketOrderStatus: BasketOrderStatus;
  basketOrderStatusId: Scalars['Int']['output'];
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['Int']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  quantityLeft: Scalars['Decimal']['output'];
  quantityUsed: Scalars['Decimal']['output'];
  salesVoucherCount: Scalars['Int']['output'];
  salesVouchers: Array<SalesVoucher>;
  totalQuantity: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BasketFilterInput = {
  and?: InputMaybe<Array<BasketFilterInput>>;
  basketItems?: InputMaybe<ListFilterInputTypeOfBasketItemsFilterInput>;
  basketOrderNumber?: InputMaybe<StringOperationFilterInput>;
  basketOrderStatus?: InputMaybe<BasketOrderStatusFilterInput>;
  basketOrderStatusId?: InputMaybe<IntOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BasketFilterInput>>;
  quantityLeft?: InputMaybe<DecimalOperationFilterInput>;
  quantityUsed?: InputMaybe<DecimalOperationFilterInput>;
  salesVoucherCount?: InputMaybe<IntOperationFilterInput>;
  salesVouchers?: InputMaybe<ListFilterInputTypeOfSalesVoucherFilterInput>;
  totalQuantity?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BasketItems = {
  __typename?: 'BasketItems';
  basket?: Maybe<Basket>;
  basketId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  quantity: Scalars['Decimal']['output'];
  quantityUsed: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BasketItemsFilterInput = {
  and?: InputMaybe<Array<BasketItemsFilterInput>>;
  basket?: InputMaybe<BasketFilterInput>;
  basketId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BasketItemsFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  quantityUsed?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BasketOrderItemInput = {
  productId: Scalars['Int']['input'];
  quantity: Scalars['Decimal']['input'];
};

export type BasketOrderStatus = {
  __typename?: 'BasketOrderStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type BasketOrderStatusFilterInput = {
  and?: InputMaybe<Array<BasketOrderStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BasketOrderStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type BasketOrderStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BasketOrdersByCompanyConnection = {
  __typename?: 'BasketOrdersByCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BasketOrdersByCompanyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Basket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BasketOrdersByCompanyEdge = {
  __typename?: 'BasketOrdersByCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Basket;
};

/** A connection to a list of items. */
export type BasketOrdersByCustomerConnection = {
  __typename?: 'BasketOrdersByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BasketOrdersByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Basket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BasketOrdersByCustomerEdge = {
  __typename?: 'BasketOrdersByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Basket;
};

/** A connection to a list of items. */
export type BasketOrdersConnection = {
  __typename?: 'BasketOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BasketOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Basket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BasketOrdersEdge = {
  __typename?: 'BasketOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Basket;
};

export type BasketSortInput = {
  basketOrderNumber?: InputMaybe<SortEnumType>;
  basketOrderStatus?: InputMaybe<BasketOrderStatusSortInput>;
  basketOrderStatusId?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  quantityLeft?: InputMaybe<SortEnumType>;
  quantityUsed?: InputMaybe<SortEnumType>;
  salesVoucherCount?: InputMaybe<SortEnumType>;
  totalQuantity?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type BodGenerationHistory = {
  __typename?: 'BodGenerationHistory';
  bodGenerationRetryCount: Scalars['Int']['output'];
  bodGenerationStatus: BodGenerationStatus;
  bodGenerationStatusId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isJournalPosting: Scalars['Boolean']['output'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  salesVoucher?: Maybe<SalesVoucher>;
  salesVoucherId?: Maybe<Scalars['Int']['output']>;
  salesVoucherItem?: Maybe<SalesVoucherItem>;
  salesVoucherItemId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BodGenerationHistoryFilterInput = {
  and?: InputMaybe<Array<BodGenerationHistoryFilterInput>>;
  bodGenerationRetryCount?: InputMaybe<IntOperationFilterInput>;
  bodGenerationStatus?: InputMaybe<BodGenerationStatusFilterInput>;
  bodGenerationStatusId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isJournalPosting?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BodGenerationHistoryFilterInput>>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemFilterInput>;
  salesVoucherItemId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BodGenerationStatus = {
  __typename?: 'BodGenerationStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type BodGenerationStatusFilterInput = {
  and?: InputMaybe<Array<BodGenerationStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BodGenerationStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type BodRetryResult = {
  __typename?: 'BodRetryResult';
  itemsQueued: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  paymentId?: Maybe<Scalars['Int']['output']>;
  salesVoucherId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkVoidDeliveredOrdersSalesVouchersInput = {
  salesVoucherIds: Array<Scalars['Int']['input']>;
};

export type BulkVoidDeliveredOrdersSalesVouchersPayload = {
  __typename?: 'BulkVoidDeliveredOrdersSalesVouchersPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelBasketOrderInput = {
  basketOrderId: Scalars['Int']['input'];
};

export type CancelBasketOrderPayload = {
  __typename?: 'CancelBasketOrderPayload';
  basket?: Maybe<Basket>;
};

export type ChangeCustomerRefInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  salesVoucherItemId: Scalars['Int']['input'];
};

export type ChangeCustomerRefOfOrdersInput = {
  customerRefChanges: Array<ChangeCustomerRefInput>;
  salesVoucherId: Scalars['Int']['input'];
};

export type ChangeCustomerRefOfOrdersPayload = {
  __typename?: 'ChangeCustomerRefOfOrdersPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckTransactionStatusData = {
  __typename?: 'CheckTransactionStatusData';
  externalRefNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<Scalars['String']['output']>;
};

export type CheckTransactionStatusResponse = {
  __typename?: 'CheckTransactionStatusResponse';
  data?: Maybe<CheckTransactionStatusData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type Cheque = {
  __typename?: 'Cheque';
  actionDate: Scalars['DateTime']['output'];
  chequeNumber: Scalars['String']['output'];
  chequeStatus: ChequeStatus;
  chequeStatusId: Scalars['Int']['output'];
  chequeTrackerHistories: Array<ChequeTrackerHistory>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  payment: Payment;
  paymentId: Scalars['Int']['output'];
  settlementBank?: Maybe<SettlementBank>;
  settlementBankId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChequeDashboardReport = {
  __typename?: 'ChequeDashboardReport';
  totalAmount: Array<KeyValuePairOfChequeStatusEnumAndDecimal>;
};

export type ChequeFilterInput = {
  actionDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ChequeFilterInput>>;
  chequeNumber?: InputMaybe<StringOperationFilterInput>;
  chequeStatus?: InputMaybe<ChequeStatusFilterInput>;
  chequeStatusId?: InputMaybe<IntOperationFilterInput>;
  chequeTrackerHistories?: InputMaybe<ListFilterInputTypeOfChequeTrackerHistoryFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ChequeFilterInput>>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  settlementBank?: InputMaybe<SettlementBankFilterInput>;
  settlementBankId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ChequeSortInput = {
  actionDate?: InputMaybe<SortEnumType>;
  chequeNumber?: InputMaybe<SortEnumType>;
  chequeStatus?: InputMaybe<ChequeStatusSortInput>;
  chequeStatusId?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  payment?: InputMaybe<PaymentSortInput>;
  paymentId?: InputMaybe<SortEnumType>;
  settlementBank?: InputMaybe<SettlementBankSortInput>;
  settlementBankId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ChequeStatus = {
  __typename?: 'ChequeStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export enum ChequeStatusEnum {
  Cleared = 'CLEARED',
  Open = 'OPEN',
  Presented = 'PRESENTED',
  Returned = 'RETURNED'
}

export type ChequeStatusFilterInput = {
  and?: InputMaybe<Array<ChequeStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ChequeStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type ChequeStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ChequeTrackerHistoriesConnection = {
  __typename?: 'ChequeTrackerHistoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ChequeTrackerHistoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ChequeTrackerHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChequeTrackerHistoriesEdge = {
  __typename?: 'ChequeTrackerHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ChequeTrackerHistory;
};

export type ChequeTrackerHistory = {
  __typename?: 'ChequeTrackerHistory';
  activityDate: Scalars['DateTime']['output'];
  cheque: Cheque;
  chequeId: Scalars['Int']['output'];
  chequeStatus: ChequeStatus;
  chequeStatusId: Scalars['Int']['output'];
  comments: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  processedBy: User;
  processedById: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChequeTrackerHistoryFilterInput = {
  activityDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ChequeTrackerHistoryFilterInput>>;
  cheque?: InputMaybe<ChequeFilterInput>;
  chequeId?: InputMaybe<IntOperationFilterInput>;
  chequeStatus?: InputMaybe<ChequeStatusFilterInput>;
  chequeStatusId?: InputMaybe<IntOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ChequeTrackerHistoryFilterInput>>;
  processedBy?: InputMaybe<UserFilterInput>;
  processedById?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ChequeTrackerHistorySortInput = {
  activityDate?: InputMaybe<SortEnumType>;
  cheque?: InputMaybe<ChequeSortInput>;
  chequeId?: InputMaybe<SortEnumType>;
  chequeStatus?: InputMaybe<ChequeStatusSortInput>;
  chequeStatusId?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  processedBy?: InputMaybe<UserSortInput>;
  processedById?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CompaniesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Company>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompaniesEdge = {
  __typename?: 'CompaniesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Company;
};

export type Company = {
  __typename?: 'Company';
  allowDepotSelection: Scalars['Boolean']['output'];
  allowNewDriverAndVehicle: Scalars['Boolean']['output'];
  allowOrderAmendment: Scalars['Boolean']['output'];
  allowOrderCancellation: Scalars['Boolean']['output'];
  amendableFields?: Maybe<AmendableFields>;
  code: Scalars['String']['output'];
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Array<Currency>;
  customerSegments: Array<CustomerSegment>;
  customerTranscription: Scalars['Boolean']['output'];
  customers: Array<Customer>;
  defaultCurrencyCode: Scalars['String']['output'];
  defaultCurrencySymbol: Scalars['String']['output'];
  defaultSupplier?: Maybe<Supplier>;
  defaultSupplierId?: Maybe<Scalars['Int']['output']>;
  eamOrganization: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enableInvoicesReportPage: Scalars['Boolean']['output'];
  enableSalesOfficerLocationScope: Scalars['Boolean']['output'];
  enableSalesOrderReportPage: Scalars['Boolean']['output'];
  enableTransactionReportPage: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  locations: Array<Location>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sunBusinessUnit: Scalars['String']['output'];
  suppliers: Array<Supplier>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useBundledBOD: Scalars['Boolean']['output'];
  useMAPaymentInJournalPostingsBOD: Scalars['Boolean']['output'];
  users: Array<User>;
};

export type CompanyCurrency = {
  __typename?: 'CompanyCurrency';
  companyId: Scalars['Int']['output'];
  currencyId: Scalars['Int']['output'];
};

export type CompanyCurrencyFilterInput = {
  and?: InputMaybe<Array<CompanyCurrencyFilterInput>>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CompanyCurrencyFilterInput>>;
};

export type CompanyCurrencySortInput = {
  companyId?: InputMaybe<SortEnumType>;
  currencyId?: InputMaybe<SortEnumType>;
};

export type CompanyFilterInput = {
  allowDepotSelection?: InputMaybe<BooleanOperationFilterInput>;
  allowNewDriverAndVehicle?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderAmendment?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderCancellation?: InputMaybe<BooleanOperationFilterInput>;
  amendableFields?: InputMaybe<AmendableFieldsFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currency?: InputMaybe<ListFilterInputTypeOfCurrencyFilterInput>;
  customerSegments?: InputMaybe<ListFilterInputTypeOfCustomerSegmentFilterInput>;
  customerTranscription?: InputMaybe<BooleanOperationFilterInput>;
  customers?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  defaultCurrencyCode?: InputMaybe<StringOperationFilterInput>;
  defaultCurrencySymbol?: InputMaybe<StringOperationFilterInput>;
  defaultSupplier?: InputMaybe<SupplierFilterInput>;
  defaultSupplierId?: InputMaybe<IntOperationFilterInput>;
  eamOrganization?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  enableInvoicesReportPage?: InputMaybe<BooleanOperationFilterInput>;
  enableSalesOfficerLocationScope?: InputMaybe<BooleanOperationFilterInput>;
  enableSalesOrderReportPage?: InputMaybe<BooleanOperationFilterInput>;
  enableTransactionReportPage?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  mobileNumber?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  sunBusinessUnit?: InputMaybe<StringOperationFilterInput>;
  suppliers?: InputMaybe<ListFilterInputTypeOfSupplierFilterInput>;
  telephoneNumber?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  useBundledBOD?: InputMaybe<BooleanOperationFilterInput>;
  useMAPaymentInJournalPostingsBOD?: InputMaybe<BooleanOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
};

export type CompanyMailingGroup = {
  __typename?: 'CompanyMailingGroup';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['Int']['output']>;
  mailingGroup: MailingGroup;
  mailingGroupId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CompanySms = {
  __typename?: 'CompanySMS';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  login: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<Scalars['String']['output']>;
};

export type CompanySocialMedia = {
  __typename?: 'CompanySocialMedia';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  socialMediaLink: Scalars['String']['output'];
  socialMediaType: SocialMediaType;
  socialMediaTypeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanySocialMediaFilterInput = {
  and?: InputMaybe<Array<CompanySocialMediaFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CompanySocialMediaFilterInput>>;
  socialMediaLink?: InputMaybe<StringOperationFilterInput>;
  socialMediaType?: InputMaybe<SocialMediaTypeFilterInput>;
  socialMediaTypeId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CompanySocialMediaSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  socialMediaLink?: InputMaybe<SortEnumType>;
  socialMediaType?: InputMaybe<SocialMediaTypeSortInput>;
  socialMediaTypeId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CompanySortInput = {
  allowDepotSelection?: InputMaybe<SortEnumType>;
  allowNewDriverAndVehicle?: InputMaybe<SortEnumType>;
  allowOrderAmendment?: InputMaybe<SortEnumType>;
  allowOrderCancellation?: InputMaybe<SortEnumType>;
  amendableFields?: InputMaybe<AmendableFieldsSortInput>;
  code?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerTranscription?: InputMaybe<SortEnumType>;
  defaultCurrencyCode?: InputMaybe<SortEnumType>;
  defaultCurrencySymbol?: InputMaybe<SortEnumType>;
  defaultSupplier?: InputMaybe<SupplierSortInput>;
  defaultSupplierId?: InputMaybe<SortEnumType>;
  eamOrganization?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  enableInvoicesReportPage?: InputMaybe<SortEnumType>;
  enableSalesOfficerLocationScope?: InputMaybe<SortEnumType>;
  enableSalesOrderReportPage?: InputMaybe<SortEnumType>;
  enableTransactionReportPage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mobileNumber?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sunBusinessUnit?: InputMaybe<SortEnumType>;
  telephoneNumber?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  useBundledBOD?: InputMaybe<SortEnumType>;
  useMAPaymentInJournalPostingsBOD?: InputMaybe<SortEnumType>;
};

export type CompleteCustomerProfileData = {
  __typename?: 'CompleteCustomerProfileData';
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CompleteCustomerProfileResponse = {
  __typename?: 'CompleteCustomerProfileResponse';
  data?: Maybe<CompleteCustomerProfileData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type CompleteEcobankDirectDebitCustomerProfileInput = {
  accountNumber: Scalars['String']['input'];
  totp: Scalars['String']['input'];
};

export type CompleteEcobankDirectDebitCustomerProfilePayload = {
  __typename?: 'CompleteEcobankDirectDebitCustomerProfilePayload';
  completeCustomerProfileResponse?: Maybe<CompleteCustomerProfileResponse>;
};

export type ConfigureCompanyAmendableFieldsInput = {
  amendableFields: AmendableFieldsInput;
  companyId: Scalars['Int']['input'];
};

export type ConfigureCompanyAmendableFieldsPayload = {
  __typename?: 'ConfigureCompanyAmendableFieldsPayload';
  company?: Maybe<Company>;
};

export type ConfigureCustomerPortalReportsInput = {
  companyId: Scalars['Int']['input'];
  enableInvoicesReportPage?: InputMaybe<Scalars['Boolean']['input']>;
  enableSalesOrderReportPage?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransactionReportPage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfigureCustomerPortalReportsPayload = {
  __typename?: 'ConfigureCustomerPortalReportsPayload';
  company?: Maybe<Company>;
};

export type ConfigureSalesOfficerLocationScopeInput = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ConfigureSalesOfficerLocationScopePayload = {
  __typename?: 'ConfigureSalesOfficerLocationScopePayload';
  company?: Maybe<Company>;
};

export type ConfirmDeliveredOrdersInput = {
  salesVoucherIds: Array<Scalars['Int']['input']>;
};

export type ConfirmDeliveredOrdersPayload = {
  __typename?: 'ConfirmDeliveredOrdersPayload';
  salesVoucher?: Maybe<Array<SalesVoucher>>;
};

export type ConfirmSalesVoucherQuotationInput = {
  id: Scalars['Int']['input'];
};

export type ConfirmSalesVoucherQuotationPayload = {
  __typename?: 'ConfirmSalesVoucherQuotationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: Location;
  locationId: Scalars['Int']['output'];
  physicalAddress: Scalars['String']['output'];
  postalAddress?: Maybe<Scalars['String']['output']>;
  telephoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  physicalAddress?: InputMaybe<StringOperationFilterInput>;
  postalAddress?: InputMaybe<StringOperationFilterInput>;
  telephoneNumber?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ContactSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  physicalAddress?: InputMaybe<SortEnumType>;
  postalAddress?: InputMaybe<SortEnumType>;
  telephoneNumber?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type Content = {
  __typename?: 'Content';
  author: User;
  authorId: Scalars['Int']['output'];
  company: Company;
  companyId: Scalars['Int']['output'];
  contentType: ContentType;
  contentTypeId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentFilterInput = {
  and?: InputMaybe<Array<ContentFilterInput>>;
  author?: InputMaybe<UserFilterInput>;
  authorId?: InputMaybe<IntOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  contentType?: InputMaybe<ContentTypeFilterInput>;
  contentTypeId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  featuredImageUrl?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ContentFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ContentSortInput = {
  author?: InputMaybe<UserSortInput>;
  authorId?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<ContentTypeSortInput>;
  contentTypeId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  featuredImageUrl?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ContentType = {
  __typename?: 'ContentType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type ContentTypeFilterInput = {
  and?: InputMaybe<Array<ContentTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContentTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type ContentTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContentsConnection = {
  __typename?: 'ContentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Content>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContentsEdge = {
  __typename?: 'ContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Content;
};

export type Country = {
  __typename?: 'Country';
  adGroupId: Scalars['UUID']['output'];
  adGroupName: Scalars['String']['output'];
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  callingCode: Scalars['String']['output'];
  cluster?: Maybe<Scalars['Int']['output']>;
  companies: Array<Company>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  utcOffset: Scalars['Int']['output'];
};

export type CountryFilterInput = {
  adGroupId?: InputMaybe<UuidOperationFilterInput>;
  adGroupName?: InputMaybe<StringOperationFilterInput>;
  alpha2?: InputMaybe<StringOperationFilterInput>;
  alpha3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CountryFilterInput>>;
  callingCode?: InputMaybe<StringOperationFilterInput>;
  cluster?: InputMaybe<IntOperationFilterInput>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  utcOffset?: InputMaybe<IntOperationFilterInput>;
};

export type CountrySortInput = {
  adGroupId?: InputMaybe<SortEnumType>;
  adGroupName?: InputMaybe<SortEnumType>;
  alpha2?: InputMaybe<SortEnumType>;
  alpha3?: InputMaybe<SortEnumType>;
  callingCode?: InputMaybe<SortEnumType>;
  cluster?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  utcOffset?: InputMaybe<SortEnumType>;
};

export type CreateBasketOrderInput = {
  items: Array<BasketOrderItemInput>;
};

export type CreateCustomerProfileData = {
  __typename?: 'CreateCustomerProfileData';
  data?: Maybe<CreateCustomerProfileDataDetail>;
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerProfileDataDetail = {
  __typename?: 'CreateCustomerProfileDataDetail';
  recipient?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerProfileResponse = {
  __typename?: 'CreateCustomerProfileResponse';
  data?: Maybe<CreateCustomerProfileData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type CreateEcobankDirectDebitCustomerProfileInput = {
  accountNumber: Scalars['String']['input'];
};

export type CreateEcobankDirectDebitCustomerProfilePayload = {
  __typename?: 'CreateEcobankDirectDebitCustomerProfilePayload';
  createCustomerProfileResponse?: Maybe<CreateCustomerProfileResponse>;
};

export type CreateNotificationsInput = {
  notificationTypeId: Scalars['Int']['input'];
  orderReference: Scalars['String']['input'];
};

export type CreateNotificationsPayload = {
  __typename?: 'CreateNotificationsPayload';
  notification?: Maybe<Notification>;
};

export type CreateSalesVoucherFromBasketInput = {
  basketOrderItemId: Scalars['Int']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  customerReference?: InputMaybe<Scalars['String']['input']>;
  deliveryContact?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  featuredImageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeliveryInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  localPurchaseOrder?: InputMaybe<Scalars['String']['input']>;
  salesVoucherItemInputs: Array<SalesVoucherItemInput>;
  sourceLocationId: Scalars['Int']['input'];
};

export type CreateSalesVoucherFromBasketPayload = {
  __typename?: 'CreateSalesVoucherFromBasketPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type Currency = {
  __typename?: 'Currency';
  company: Array<Company>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  currencyName: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type CurrencyConnection = {
  __typename?: 'CurrencyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CurrencyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Currency>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CurrencyEdge = {
  __typename?: 'CurrencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Currency;
};

export type CurrencyFilterInput = {
  and?: InputMaybe<Array<CurrencyFilterInput>>;
  company?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  currencyName?: InputMaybe<StringOperationFilterInput>;
  currencySymbol?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CurrencySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  currencyName?: InputMaybe<SortEnumType>;
  currencySymbol?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type Customer = {
  __typename?: 'Customer';
  active: Scalars['Boolean']['output'];
  altPhoneNumber?: Maybe<Scalars['Long']['output']>;
  bankGuarantees?: Maybe<Array<BankGuarantee>>;
  businessUnitCurrency?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerAccountBalance?: Maybe<Scalars['Decimal']['output']>;
  customerAltPhone?: Maybe<Scalars['String']['output']>;
  customerAvailableCredit?: Maybe<Scalars['Decimal']['output']>;
  customerAvailableCreditWithoutOrders?: Maybe<Scalars['Decimal']['output']>;
  customerCode: Scalars['String']['output'];
  customerCountry?: Maybe<Scalars['String']['output']>;
  customerCrLimit?: Maybe<Scalars['Decimal']['output']>;
  customerCrLimitExpDate?: Maybe<Scalars['Date']['output']>;
  customerCurrency?: Maybe<Scalars['String']['output']>;
  customerDeliveryType?: Maybe<Scalars['String']['output']>;
  customerDestination?: Maybe<Scalars['String']['output']>;
  customerGroup?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerOnOrderBalance?: Maybe<Scalars['Decimal']['output']>;
  customerOpenOrders?: Maybe<Scalars['Decimal']['output']>;
  customerOverdueInvoiceAmt?: Maybe<Scalars['Decimal']['output']>;
  customerSegment?: Maybe<CustomerSegment>;
  customerSegmentId?: Maybe<Scalars['Int']['output']>;
  customerStatus?: Maybe<Scalars['Short']['output']>;
  customerStatusDesc?: Maybe<Scalars['String']['output']>;
  customerVATCode?: Maybe<Scalars['String']['output']>;
  destinations: Array<Destination>;
  email?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  locations: Array<Location>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['Long']['output']>;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime']['output'];
  userRoles: Array<CustomerUserRole>;
  users?: Maybe<Array<User>>;
  vehicles: Array<Vehicle>;
};

export type CustomerActivityReport = {
  __typename?: 'CustomerActivityReport';
  customerCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  lastActivityDate: Scalars['DateTime']['output'];
  orderVolume: Scalars['Decimal']['output'];
  totalOrderAmount: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type CustomerBasketOrdersConnection = {
  __typename?: 'CustomerBasketOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerBasketOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Basket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerBasketOrdersEdge = {
  __typename?: 'CustomerBasketOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Basket;
};

/** A connection to a list of items. */
export type CustomerDestinationsConnection = {
  __typename?: 'CustomerDestinationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerDestinationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Destination>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerDestinationsEdge = {
  __typename?: 'CustomerDestinationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Destination;
};

export type CustomerFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  altPhoneNumber?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFilterInput>>;
  bankGuarantees?: InputMaybe<ListFilterInputTypeOfBankGuaranteeFilterInput>;
  businessUnitCurrency?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerAccountBalance?: InputMaybe<DecimalOperationFilterInput>;
  customerAltPhone?: InputMaybe<StringOperationFilterInput>;
  customerAvailableCredit?: InputMaybe<DecimalOperationFilterInput>;
  customerAvailableCreditWithoutOrders?: InputMaybe<DecimalOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  customerCountry?: InputMaybe<StringOperationFilterInput>;
  customerCrLimit?: InputMaybe<DecimalOperationFilterInput>;
  customerCrLimitExpDate?: InputMaybe<DateOperationFilterInput>;
  customerCurrency?: InputMaybe<StringOperationFilterInput>;
  customerDeliveryType?: InputMaybe<StringOperationFilterInput>;
  customerDestination?: InputMaybe<StringOperationFilterInput>;
  customerGroup?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  customerOnOrderBalance?: InputMaybe<DecimalOperationFilterInput>;
  customerOpenOrders?: InputMaybe<DecimalOperationFilterInput>;
  customerOverdueInvoiceAmt?: InputMaybe<DecimalOperationFilterInput>;
  customerSegment?: InputMaybe<CustomerSegmentFilterInput>;
  customerSegmentId?: InputMaybe<IntOperationFilterInput>;
  customerStatus?: InputMaybe<ShortOperationFilterInput>;
  customerStatusDesc?: InputMaybe<StringOperationFilterInput>;
  customerVATCode?: InputMaybe<StringOperationFilterInput>;
  destinations?: InputMaybe<ListFilterInputTypeOfDestinationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  payments?: InputMaybe<ListFilterInputTypeOfPaymentFilterInput>;
  phoneNumber?: InputMaybe<LongOperationFilterInput>;
  transactions?: InputMaybe<ListFilterInputTypeOfTransactionFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  userRoles?: InputMaybe<ListFilterInputTypeOfCustomerUserRoleFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  vehicles?: InputMaybe<ListFilterInputTypeOfVehicleFilterInput>;
};

/** A connection to a list of items. */
export type CustomerInvoiceConnection = {
  __typename?: 'CustomerInvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerInvoiceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucherOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerInvoiceEdge = {
  __typename?: 'CustomerInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucherOrder;
};

export type CustomerProfileDataWrapper = {
  __typename?: 'CustomerProfileDataWrapper';
  data?: Maybe<CustomerProfileDetail>;
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CustomerProfileDetail = {
  __typename?: 'CustomerProfileDetail';
  affiliateCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  objectId?: Maybe<Scalars['String']['output']>;
  registrationChannelCode?: Maybe<Scalars['String']['output']>;
  registrationChannelName?: Maybe<Scalars['String']['output']>;
  setupStatus?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  validationStatus?: Maybe<Scalars['String']['output']>;
};

export type CustomerSalesActivityReport = {
  __typename?: 'CustomerSalesActivityReport';
  customerCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  lastActivityDate: Scalars['DateTime']['output'];
  salesVolume: Scalars['Decimal']['output'];
  totalSalesAmount: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type CustomerSalesInvoicesConnection = {
  __typename?: 'CustomerSalesInvoicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerSalesInvoicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucherOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerSalesInvoicesEdge = {
  __typename?: 'CustomerSalesInvoicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucherOrder;
};

/** A connection to a list of items. */
export type CustomerSalesVoucherOrdersConnection = {
  __typename?: 'CustomerSalesVoucherOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerSalesVoucherOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucherOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerSalesVoucherOrdersEdge = {
  __typename?: 'CustomerSalesVoucherOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucherOrder;
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerSegmentFilterInput = {
  and?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerSegmentSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomerSegmentsConnection = {
  __typename?: 'CustomerSegmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerSegmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerSegment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerSegmentsEdge = {
  __typename?: 'CustomerSegmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerSegment;
};

export type CustomerSortInput = {
  active?: InputMaybe<SortEnumType>;
  altPhoneNumber?: InputMaybe<SortEnumType>;
  businessUnitCurrency?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerAccountBalance?: InputMaybe<SortEnumType>;
  customerAltPhone?: InputMaybe<SortEnumType>;
  customerAvailableCredit?: InputMaybe<SortEnumType>;
  customerAvailableCreditWithoutOrders?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  customerCountry?: InputMaybe<SortEnumType>;
  customerCrLimit?: InputMaybe<SortEnumType>;
  customerCrLimitExpDate?: InputMaybe<SortEnumType>;
  customerCurrency?: InputMaybe<SortEnumType>;
  customerDeliveryType?: InputMaybe<SortEnumType>;
  customerDestination?: InputMaybe<SortEnumType>;
  customerGroup?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  customerOnOrderBalance?: InputMaybe<SortEnumType>;
  customerOpenOrders?: InputMaybe<SortEnumType>;
  customerOverdueInvoiceAmt?: InputMaybe<SortEnumType>;
  customerSegment?: InputMaybe<CustomerSegmentSortInput>;
  customerSegmentId?: InputMaybe<SortEnumType>;
  customerStatus?: InputMaybe<SortEnumType>;
  customerStatusDesc?: InputMaybe<SortEnumType>;
  customerVATCode?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CustomerTranscriptionItemInput = {
  bankBranchId?: InputMaybe<Scalars['Int']['input']>;
  bankId?: InputMaybe<Scalars['Int']['input']>;
  depositorContact?: InputMaybe<Scalars['String']['input']>;
  depositorName?: InputMaybe<Scalars['String']['input']>;
  documentDate: Scalars['DateTime']['input'];
  documentReference?: InputMaybe<Scalars['String']['input']>;
  documentTypeId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTranscriptionStatusId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerUserRole = {
  __typename?: 'CustomerUserRole';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: Role;
  roleId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type CustomerUserRoleFilterInput = {
  and?: InputMaybe<Array<CustomerUserRoleFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomerUserRoleFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type CustomerUserRoleSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomerUserRolesConnection = {
  __typename?: 'CustomerUserRolesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerUserRolesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerUserRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerUserRolesEdge = {
  __typename?: 'CustomerUserRolesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerUserRole;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Customer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Customer;
};

export type DashboardReport = {
  __typename?: 'DashboardReport';
  dashboardReportTypeEnumId: Scalars['Int']['output'];
  dataPoints: Array<KeyValuePairOfDateTimeAndDecimal>;
  difference: Scalars['Decimal']['output'];
  percentage: Scalars['Decimal']['output'];
  quantity: Array<KeyValuePairOfUnitOfMeasureEnumAndDecimal>;
  total: Scalars['Decimal']['output'];
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteContactInput = {
  id: Scalars['Int']['input'];
};

export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContentInput = {
  id: Scalars['Int']['input'];
};

export type DeleteContentPayload = {
  __typename?: 'DeleteContentPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEPaymentAccountNumberInput = {
  id: Scalars['Int']['input'];
};

export type DeleteEPaymentAccountNumberPayload = {
  __typename?: 'DeleteEPaymentAccountNumberPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePredefinedReportFilterInput = {
  id: Scalars['Int']['input'];
};

export type DeletePredefinedReportFilterPayload = {
  __typename?: 'DeletePredefinedReportFilterPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductConstraintInput = {
  id: Scalars['Int']['input'];
};

export type DeleteProductConstraintPayload = {
  __typename?: 'DeleteProductConstraintPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductInput = {
  id: Scalars['Int']['input'];
};

export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliveredItemValidationInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  destinationCode?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNo?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  rowIndex: Scalars['Int']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
  vehicleNo?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveredItemValidationResult = {
  __typename?: 'DeliveredItemValidationResult';
  customerRef?: Maybe<Scalars['String']['output']>;
  customerRefError?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  destinationCode?: Maybe<Scalars['String']['output']>;
  destinationError?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Driver>;
  driverError?: Maybe<Scalars['String']['output']>;
  driverLicenseNo?: Maybe<Scalars['String']['output']>;
  isCustomerRefValid: Scalars['Boolean']['output'];
  isDestinationValid: Scalars['Boolean']['output'];
  isDriverValid: Scalars['Boolean']['output'];
  isProjectValid: Scalars['Boolean']['output'];
  isQuantityValid: Scalars['Boolean']['output'];
  isRowValid: Scalars['Boolean']['output'];
  isSupplierValid: Scalars['Boolean']['output'];
  isVATCodeValid: Scalars['Boolean']['output'];
  isVehicleValid: Scalars['Boolean']['output'];
  project?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityError?: Maybe<Scalars['String']['output']>;
  resolvedDestinationId?: Maybe<Scalars['Int']['output']>;
  resolvedDriverId?: Maybe<Scalars['Int']['output']>;
  resolvedSupplierId?: Maybe<Scalars['Int']['output']>;
  resolvedVehicleId?: Maybe<Scalars['Int']['output']>;
  rowIndex: Scalars['Int']['output'];
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']['output']>;
  supplierError?: Maybe<Scalars['String']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
  vatCodeError?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
  vehicleError?: Maybe<Scalars['String']['output']>;
  vehicleNo?: Maybe<Scalars['String']['output']>;
};

export type DeliveredOrdersEmailJob = {
  __typename?: 'DeliveredOrdersEmailJob';
  company: Company;
  companyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  triggerTime: Scalars['TimeSpan']['output'];
};

export type DepoDestinationMapping = {
  __typename?: 'DepoDestinationMapping';
  costCentre: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  destination: Destination;
  destinationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  plantLocation: Location;
  plantLocationId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DepoDestinationMappingFilterInput = {
  and?: InputMaybe<Array<DepoDestinationMappingFilterInput>>;
  costCentre?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  destination?: InputMaybe<DestinationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DepoDestinationMappingFilterInput>>;
  plantLocation?: InputMaybe<LocationFilterInput>;
  plantLocationId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DepoDestinationMappingSortInput = {
  costCentre?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<DestinationSortInput>;
  destinationId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  plantLocation?: InputMaybe<LocationSortInput>;
  plantLocationId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type DescriptionValue = {
  __typename?: 'DescriptionValue';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type DescriptionValueFilterInput = {
  and?: InputMaybe<Array<DescriptionValueFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DescriptionValueFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type DescriptionValueSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type Destination = {
  __typename?: 'Destination';
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['Int']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customers: Array<Customer>;
  distance?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  lookup?: Maybe<Scalars['String']['output']>;
  minDeliveryDays?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  transportType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DestinationFilterInput = {
  and?: InputMaybe<Array<DestinationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customers?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  distance?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lookup?: InputMaybe<StringOperationFilterInput>;
  minDeliveryDays?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DestinationFilterInput>>;
  region?: InputMaybe<StringOperationFilterInput>;
  transportType?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DestinationSortInput = {
  code?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  distance?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lookup?: InputMaybe<SortEnumType>;
  minDeliveryDays?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  transportType?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DestinationsConnection = {
  __typename?: 'DestinationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DestinationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Destination>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DestinationsEdge = {
  __typename?: 'DestinationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Destination;
};

/** A connection to a list of items. */
export type DfsPaymentsConnection = {
  __typename?: 'DfsPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DfsPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Cheque>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DfsPaymentsEdge = {
  __typename?: 'DfsPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Cheque;
};

export type DocumentStatus = {
  __typename?: 'DocumentStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type DocumentStatusFilterInput = {
  and?: InputMaybe<Array<DocumentStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DocumentStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type DocumentTypeFilterInput = {
  and?: InputMaybe<Array<DocumentTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type Driver = {
  __typename?: 'Driver';
  comment?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  dispatch: Scalars['Boolean']['output'];
  eamId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isBanned: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  licenseExpDate?: Maybe<Scalars['Date']['output']>;
  licenseNo: Scalars['String']['output'];
  phoneNo?: Maybe<Scalars['String']['output']>;
  receiving: Scalars['Boolean']['output'];
  transporterCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DriverFilterInput = {
  and?: InputMaybe<Array<DriverFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dispatch?: InputMaybe<BooleanOperationFilterInput>;
  eamId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isBanned?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  licenseExpDate?: InputMaybe<DateOperationFilterInput>;
  licenseNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DriverFilterInput>>;
  phoneNo?: InputMaybe<StringOperationFilterInput>;
  receiving?: InputMaybe<BooleanOperationFilterInput>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DriverRequest = {
  __typename?: 'DriverRequest';
  createdAt: Scalars['DateTime']['output'];
  driverRequestStatus: DriverRequestStatus;
  driverRequestStatusId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  licenseExpDate: Scalars['Date']['output'];
  licenseNo: Scalars['String']['output'];
  transporterCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DriverRequestFilterInput = {
  and?: InputMaybe<Array<DriverRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  driverRequestStatus?: InputMaybe<DriverRequestStatusFilterInput>;
  driverRequestStatusId?: InputMaybe<IntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  licenseExpDate?: InputMaybe<DateOperationFilterInput>;
  licenseNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DriverRequestFilterInput>>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DriverRequestInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licenseExpDate: Scalars['Date']['input'];
  licenseNo: Scalars['String']['input'];
  transporterCode?: InputMaybe<Scalars['String']['input']>;
};

export type DriverRequestResponse = {
  __typename?: 'DriverRequestResponse';
  createdAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  customerRef?: Maybe<Scalars['String']['output']>;
  driverRequestFirstName: Scalars['String']['output'];
  driverRequestLastName: Scalars['String']['output'];
  driverRequestLicenseNo: Scalars['String']['output'];
  driverRequestStatus: DriverRequestStatusEnum;
  requestId: Scalars['Int']['output'];
  salesVoucherId: Scalars['Int']['output'];
  voucherNumber: Scalars['String']['output'];
};

export type DriverRequestResponseFilterInput = {
  and?: InputMaybe<Array<DriverRequestResponseFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  driverRequestFirstName?: InputMaybe<StringOperationFilterInput>;
  driverRequestLastName?: InputMaybe<StringOperationFilterInput>;
  driverRequestLicenseNo?: InputMaybe<StringOperationFilterInput>;
  driverRequestStatus?: InputMaybe<DriverRequestStatusEnumOperationFilterInput>;
  or?: InputMaybe<Array<DriverRequestResponseFilterInput>>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  voucherNumber?: InputMaybe<StringOperationFilterInput>;
};

export type DriverRequestResponseSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  driverRequestFirstName?: InputMaybe<SortEnumType>;
  driverRequestLastName?: InputMaybe<SortEnumType>;
  driverRequestLicenseNo?: InputMaybe<SortEnumType>;
  driverRequestStatus?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  voucherNumber?: InputMaybe<SortEnumType>;
};

export type DriverRequestSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  driverRequestStatus?: InputMaybe<DriverRequestStatusSortInput>;
  driverRequestStatusId?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  licenseExpDate?: InputMaybe<SortEnumType>;
  licenseNo?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type DriverRequestStatus = {
  __typename?: 'DriverRequestStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export enum DriverRequestStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type DriverRequestStatusEnumOperationFilterInput = {
  eq?: InputMaybe<DriverRequestStatusEnum>;
  in?: InputMaybe<Array<DriverRequestStatusEnum>>;
  neq?: InputMaybe<DriverRequestStatusEnum>;
  nin?: InputMaybe<Array<DriverRequestStatusEnum>>;
};

export type DriverRequestStatusFilterInput = {
  and?: InputMaybe<Array<DriverRequestStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DriverRequestStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type DriverRequestStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DriverRequestsConnection = {
  __typename?: 'DriverRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DriverRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DriverRequestResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DriverRequestsEdge = {
  __typename?: 'DriverRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DriverRequestResponse;
};

export type DriverSortInput = {
  comment?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  dispatch?: InputMaybe<SortEnumType>;
  eamId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isBanned?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  licenseExpDate?: InputMaybe<SortEnumType>;
  licenseNo?: InputMaybe<SortEnumType>;
  phoneNo?: InputMaybe<SortEnumType>;
  receiving?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DriversConnection = {
  __typename?: 'DriversConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DriversEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Driver>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DriversEdge = {
  __typename?: 'DriversEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Driver;
};

export type EPaymentAccountNumbers = {
  __typename?: 'EPaymentAccountNumbers';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  ePaymentProvider: EPaymentProvider;
  epaymentProviderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EPaymentAccountNumbersFilterInput = {
  accountId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EPaymentAccountNumbersFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  ePaymentProvider?: InputMaybe<EPaymentProviderFilterInput>;
  epaymentProviderId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EPaymentAccountNumbersFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EPaymentAccountNumbersSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  ePaymentProvider?: InputMaybe<EPaymentProviderSortInput>;
  epaymentProviderId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type EPaymentProvider = {
  __typename?: 'EPaymentProvider';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type EPaymentProviderFilterInput = {
  and?: InputMaybe<Array<EPaymentProviderFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EPaymentProviderFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type EPaymentProviderSettlementBankMapping = {
  __typename?: 'EPaymentProviderSettlementBankMapping';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ePaymentProvider: EPaymentProvider;
  ePaymentProviderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  settlementBank: SettlementBank;
  settlementBankId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EPaymentProviderSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type EcobankHeaderResponse = {
  __typename?: 'EcobankHeaderResponse';
  affiliateCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  responseDesc?: Maybe<Scalars['String']['output']>;
  responseMessage?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
};

export type EnableNewDriverAndVehicleForCompanyInput = {
  allowNewDriverAndVehicle: Scalars['Boolean']['input'];
  companyId: Scalars['Int']['input'];
};

export type EnableNewDriverAndVehicleForCompanyPayload = {
  __typename?: 'EnableNewDriverAndVehicleForCompanyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type EnableOrderAmendmentForCompanyInput = {
  allowOrderAmendment: Scalars['Boolean']['input'];
  companyId: Scalars['Int']['input'];
};

export type EnableOrderAmendmentForCompanyPayload = {
  __typename?: 'EnableOrderAmendmentForCompanyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type EnableOrderCancellationForCompanyInput = {
  allowOrderCancellation: Scalars['Boolean']['input'];
  companyId: Scalars['Int']['input'];
};

export type EnableOrderCancellationForCompanyPayload = {
  __typename?: 'EnableOrderCancellationForCompanyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type FeedbackMessage = {
  __typename?: 'FeedbackMessage';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeedbackMessageFilterInput = {
  and?: InputMaybe<Array<FeedbackMessageFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FeedbackMessageFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FeedbackMessageSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type GetCustomerProfileByAccountNumberResponse = {
  __typename?: 'GetCustomerProfileByAccountNumberResponse';
  data?: Maybe<CustomerProfileDataWrapper>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type IlDriverInput = {
  active: Scalars['String']['input'];
  banned: Scalars['String']['input'];
  changeStatusCode: Scalars['String']['input'];
  created: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dispatch: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licenseExpiration?: InputMaybe<Scalars['Date']['input']>;
  licenseNo: Scalars['String']['input'];
  org: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  receiving: Scalars['String']['input'];
  source: Scalars['String']['input'];
  systemID: Scalars['String']['input'];
  transporter: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  ymid: Scalars['String']['input'];
};

export type IlSupplierInput = {
  accountingEntityId: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  altPhoneNo?: InputMaybe<Scalars['Long']['input']>;
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['Long']['input']>;
  supplierName: Scalars['String']['input'];
  systemID: Scalars['String']['input'];
  transporter: Scalars['Boolean']['input'];
};

export type IlVehicleInput = {
  active: Scalars['String']['input'];
  banned: Scalars['String']['input'];
  capacity?: InputMaybe<Scalars['Decimal']['input']>;
  changeStatusCode: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dispatch: Scalars['String']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  forHire: Scalars['String']['input'];
  insuranceCompany: Scalars['String']['input'];
  insuranceExpiration?: InputMaybe<Scalars['Date']['input']>;
  insuranceNo?: InputMaybe<Scalars['String']['input']>;
  manuf?: InputMaybe<Scalars['String']['input']>;
  maxWt?: InputMaybe<Scalars['Decimal']['input']>;
  minWt?: InputMaybe<Scalars['Decimal']['input']>;
  mizaniID: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  org: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  plate: Scalars['String']['input'];
  receiving: Scalars['String']['input'];
  source: Scalars['String']['input'];
  systemID: Scalars['String']['input'];
  trackingPhoneNo?: InputMaybe<Scalars['String']['input']>;
  trackingRef?: InputMaybe<Scalars['String']['input']>;
  transporter: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  vehicleOrganizations: Array<IlVehicleOrganizationInput>;
};

export type IlVehicleOrganizationInput = {
  transCode: Scalars['String']['input'];
  vehOrg: Scalars['String']['input'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type KeyValuePairOfChequeStatusEnumAndDecimal = {
  __typename?: 'KeyValuePairOfChequeStatusEnumAndDecimal';
  key: ChequeStatusEnum;
  value: Scalars['Decimal']['output'];
};

export type KeyValuePairOfDateTimeAndDecimal = {
  __typename?: 'KeyValuePairOfDateTimeAndDecimal';
  key: Scalars['DateTime']['output'];
  value: Scalars['Decimal']['output'];
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfUnitOfMeasureEnumAndDecimal = {
  __typename?: 'KeyValuePairOfUnitOfMeasureEnumAndDecimal';
  key: UnitOfMeasureEnum;
  value: Scalars['Decimal']['output'];
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lang: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LanguageFilterInput = {
  and?: InputMaybe<Array<LanguageFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lang?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LanguageFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type LanguageSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lang?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type LinkUserAccountInput = {
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type LinkUserAccountPayload = {
  __typename?: 'LinkUserAccountPayload';
  customerUserRole?: Maybe<CustomerUserRole>;
};

export type ListFilterInputTypeOfBankBranchFilterInput = {
  all?: InputMaybe<BankBranchFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BankBranchFilterInput>;
  some?: InputMaybe<BankBranchFilterInput>;
};

export type ListFilterInputTypeOfBankGuaranteeActivityLogFilterInput = {
  all?: InputMaybe<BankGuaranteeActivityLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BankGuaranteeActivityLogFilterInput>;
  some?: InputMaybe<BankGuaranteeActivityLogFilterInput>;
};

export type ListFilterInputTypeOfBankGuaranteeFilterInput = {
  all?: InputMaybe<BankGuaranteeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BankGuaranteeFilterInput>;
  some?: InputMaybe<BankGuaranteeFilterInput>;
};

export type ListFilterInputTypeOfBasketItemsFilterInput = {
  all?: InputMaybe<BasketItemsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BasketItemsFilterInput>;
  some?: InputMaybe<BasketItemsFilterInput>;
};

export type ListFilterInputTypeOfBodGenerationHistoryFilterInput = {
  all?: InputMaybe<BodGenerationHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BodGenerationHistoryFilterInput>;
  some?: InputMaybe<BodGenerationHistoryFilterInput>;
};

export type ListFilterInputTypeOfChequeTrackerHistoryFilterInput = {
  all?: InputMaybe<ChequeTrackerHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ChequeTrackerHistoryFilterInput>;
  some?: InputMaybe<ChequeTrackerHistoryFilterInput>;
};

export type ListFilterInputTypeOfCompanyFilterInput = {
  all?: InputMaybe<CompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CompanyFilterInput>;
  some?: InputMaybe<CompanyFilterInput>;
};

export type ListFilterInputTypeOfCurrencyFilterInput = {
  all?: InputMaybe<CurrencyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CurrencyFilterInput>;
  some?: InputMaybe<CurrencyFilterInput>;
};

export type ListFilterInputTypeOfCustomerFilterInput = {
  all?: InputMaybe<CustomerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerFilterInput>;
  some?: InputMaybe<CustomerFilterInput>;
};

export type ListFilterInputTypeOfCustomerSegmentFilterInput = {
  all?: InputMaybe<CustomerSegmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerSegmentFilterInput>;
  some?: InputMaybe<CustomerSegmentFilterInput>;
};

export type ListFilterInputTypeOfCustomerUserRoleFilterInput = {
  all?: InputMaybe<CustomerUserRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerUserRoleFilterInput>;
  some?: InputMaybe<CustomerUserRoleFilterInput>;
};

export type ListFilterInputTypeOfDestinationFilterInput = {
  all?: InputMaybe<DestinationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DestinationFilterInput>;
  some?: InputMaybe<DestinationFilterInput>;
};

export type ListFilterInputTypeOfLocationFilterInput = {
  all?: InputMaybe<LocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationFilterInput>;
  some?: InputMaybe<LocationFilterInput>;
};

export type ListFilterInputTypeOfLocationProductFilterInput = {
  all?: InputMaybe<LocationProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationProductFilterInput>;
  some?: InputMaybe<LocationProductFilterInput>;
};

export type ListFilterInputTypeOfNotificationPreferenceTypeFilterInput = {
  all?: InputMaybe<NotificationPreferenceTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NotificationPreferenceTypeFilterInput>;
  some?: InputMaybe<NotificationPreferenceTypeFilterInput>;
};

export type ListFilterInputTypeOfNotificationUserFilterInput = {
  all?: InputMaybe<NotificationUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NotificationUserFilterInput>;
  some?: InputMaybe<NotificationUserFilterInput>;
};

export type ListFilterInputTypeOfPaymentApprovalFilterInput = {
  all?: InputMaybe<PaymentApprovalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentApprovalFilterInput>;
  some?: InputMaybe<PaymentApprovalFilterInput>;
};

export type ListFilterInputTypeOfPaymentDocumentFilterInput = {
  all?: InputMaybe<PaymentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentDocumentFilterInput>;
  some?: InputMaybe<PaymentDocumentFilterInput>;
};

export type ListFilterInputTypeOfPaymentFilterInput = {
  all?: InputMaybe<PaymentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentFilterInput>;
  some?: InputMaybe<PaymentFilterInput>;
};

export type ListFilterInputTypeOfPaymentTranscriptionFilterInput = {
  all?: InputMaybe<PaymentTranscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaymentTranscriptionFilterInput>;
  some?: InputMaybe<PaymentTranscriptionFilterInput>;
};

export type ListFilterInputTypeOfRoleFilterInput = {
  all?: InputMaybe<RoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleFilterInput>;
  some?: InputMaybe<RoleFilterInput>;
};

export type ListFilterInputTypeOfSalesOrderAmendmentRequestsFilterInput = {
  all?: InputMaybe<SalesOrderAmendmentRequestsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesOrderAmendmentRequestsFilterInput>;
  some?: InputMaybe<SalesOrderAmendmentRequestsFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherDocumentFilterInput = {
  all?: InputMaybe<SalesVoucherDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherDocumentFilterInput>;
  some?: InputMaybe<SalesVoucherDocumentFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherFilterInput = {
  all?: InputMaybe<SalesVoucherFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherFilterInput>;
  some?: InputMaybe<SalesVoucherFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherHistoryFilterInput = {
  all?: InputMaybe<SalesVoucherHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherHistoryFilterInput>;
  some?: InputMaybe<SalesVoucherHistoryFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherItemFilterInput = {
  all?: InputMaybe<SalesVoucherItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherItemFilterInput>;
  some?: InputMaybe<SalesVoucherItemFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherItemHistoryFilterInput = {
  all?: InputMaybe<SalesVoucherItemHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherItemHistoryFilterInput>;
  some?: InputMaybe<SalesVoucherItemHistoryFilterInput>;
};

export type ListFilterInputTypeOfSalesVoucherOrderFilterInput = {
  all?: InputMaybe<SalesVoucherOrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesVoucherOrderFilterInput>;
  some?: InputMaybe<SalesVoucherOrderFilterInput>;
};

export type ListFilterInputTypeOfSupplierFilterInput = {
  all?: InputMaybe<SupplierFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SupplierFilterInput>;
  some?: InputMaybe<SupplierFilterInput>;
};

export type ListFilterInputTypeOfTransactionFilterInput = {
  all?: InputMaybe<TransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TransactionFilterInput>;
  some?: InputMaybe<TransactionFilterInput>;
};

export type ListFilterInputTypeOfTransitionalSalesVoucherItemFilterInput = {
  all?: InputMaybe<TransitionalSalesVoucherItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TransitionalSalesVoucherItemFilterInput>;
  some?: InputMaybe<TransitionalSalesVoucherItemFilterInput>;
};

export type ListFilterInputTypeOfUserAccountDeletionHistoryFilterInput = {
  all?: InputMaybe<UserAccountDeletionHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserAccountDeletionHistoryFilterInput>;
  some?: InputMaybe<UserAccountDeletionHistoryFilterInput>;
};

export type ListFilterInputTypeOfUserDeviceFilterInput = {
  all?: InputMaybe<UserDeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserDeviceFilterInput>;
  some?: InputMaybe<UserDeviceFilterInput>;
};

export type ListFilterInputTypeOfUserFilterInput = {
  all?: InputMaybe<UserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserFilterInput>;
  some?: InputMaybe<UserFilterInput>;
};

export type ListFilterInputTypeOfVehicleFilterInput = {
  all?: InputMaybe<VehicleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VehicleFilterInput>;
  some?: InputMaybe<VehicleFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type Location = {
  __typename?: 'Location';
  allowBankGuarantee: Scalars['Boolean']['output'];
  allowBasketOrders: Scalars['Boolean']['output'];
  allowBulkOrder: Scalars['Boolean']['output'];
  allowDeliveryTypeSelection: Scalars['Boolean']['output'];
  allowDeliveryTypeSelectionForProduct: Scalars['Boolean']['output'];
  allowDestinationSelectionFromMasterData: Scalars['Boolean']['output'];
  allowDriverSelection: Scalars['Boolean']['output'];
  allowDriverSelectionForDelivered: Scalars['Boolean']['output'];
  allowLoadingPointSelectionForProduct: Scalars['Boolean']['output'];
  allowOrderReference: Scalars['Boolean']['output'];
  allowStandAlonePayment: Scalars['Boolean']['output'];
  allowTruckSelection?: Maybe<Scalars['Boolean']['output']>;
  allowTruckSelectionForDelivered: Scalars['Boolean']['output'];
  autoConfirmNewSOs: Scalars['Boolean']['output'];
  businessUnitLine?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['Int']['output'];
  contact?: Maybe<Contact>;
  costCentre?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultDeliveryType?: Maybe<Scalars['String']['output']>;
  defaultTransporter?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  mergeCustomerDestinations: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentLocation?: Maybe<Location>;
  parentLocationId?: Maybe<Scalars['Int']['output']>;
  pmEmployee: Scalars['Boolean']['output'];
  quotationRentionDuration: Scalars['Int']['output'];
  requireDestinationSelectionForExworks: Scalars['Boolean']['output'];
  requireFileUpload: Scalars['Boolean']['output'];
  truckSelectionAllowed?: Maybe<Scalars['Boolean']['output']>;
  truckSelectionFromMasterAllowed: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useComments: Scalars['Boolean']['output'];
  useConfirmQuotation: Scalars['Boolean']['output'];
  useDeliveredOrderManagement: Scalars['Boolean']['output'];
  useDeliveryContact: Scalars['Boolean']['output'];
  useDescription: Scalars['Boolean']['output'];
  useFileUpload: Scalars['Boolean']['output'];
  useLocalPoNumber: Scalars['Boolean']['output'];
  users: Array<User>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type LocationDestination = {
  __typename?: 'LocationDestination';
  costCentre?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  destination: Destination;
  destinationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  locationId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LocationDestinationFilterInput = {
  and?: InputMaybe<Array<LocationDestinationFilterInput>>;
  costCentre?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  destination?: InputMaybe<DestinationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LocationDestinationFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type LocationDestinationSortInput = {
  costCentre?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<DestinationSortInput>;
  destinationId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationDestinationsConnection = {
  __typename?: 'LocationDestinationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationDestinationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationDestination>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationDestinationsEdge = {
  __typename?: 'LocationDestinationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationDestination;
};

export type LocationFilterInput = {
  allowBankGuarantee?: InputMaybe<BooleanOperationFilterInput>;
  allowBasketOrders?: InputMaybe<BooleanOperationFilterInput>;
  allowBulkOrder?: InputMaybe<BooleanOperationFilterInput>;
  allowDeliveryTypeSelection?: InputMaybe<BooleanOperationFilterInput>;
  allowDeliveryTypeSelectionForProduct?: InputMaybe<BooleanOperationFilterInput>;
  allowDestinationSelectionFromMasterData?: InputMaybe<BooleanOperationFilterInput>;
  allowDriverSelection?: InputMaybe<BooleanOperationFilterInput>;
  allowDriverSelectionForDelivered?: InputMaybe<BooleanOperationFilterInput>;
  allowLoadingPointSelectionForProduct?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderReference?: InputMaybe<BooleanOperationFilterInput>;
  allowStandAlonePayment?: InputMaybe<BooleanOperationFilterInput>;
  allowTruckSelection?: InputMaybe<BooleanOperationFilterInput>;
  allowTruckSelectionForDelivered?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<LocationFilterInput>>;
  autoConfirmNewSOs?: InputMaybe<BooleanOperationFilterInput>;
  businessUnitLine?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  costCentre?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  defaultDeliveryType?: InputMaybe<StringOperationFilterInput>;
  defaultTransporter?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  mergeCustomerDestinations?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationFilterInput>>;
  parentLocation?: InputMaybe<LocationFilterInput>;
  parentLocationId?: InputMaybe<IntOperationFilterInput>;
  pmEmployee?: InputMaybe<BooleanOperationFilterInput>;
  quotationRentionDuration?: InputMaybe<IntOperationFilterInput>;
  requireDestinationSelectionForExworks?: InputMaybe<BooleanOperationFilterInput>;
  requireFileUpload?: InputMaybe<BooleanOperationFilterInput>;
  truckSelectionAllowed?: InputMaybe<BooleanOperationFilterInput>;
  truckSelectionFromMasterAllowed?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  useComments?: InputMaybe<BooleanOperationFilterInput>;
  useConfirmQuotation?: InputMaybe<BooleanOperationFilterInput>;
  useDeliveredOrderManagement?: InputMaybe<BooleanOperationFilterInput>;
  useDeliveryContact?: InputMaybe<BooleanOperationFilterInput>;
  useDescription?: InputMaybe<BooleanOperationFilterInput>;
  useFileUpload?: InputMaybe<BooleanOperationFilterInput>;
  useLocalPoNumber?: InputMaybe<BooleanOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  vatCode?: InputMaybe<StringOperationFilterInput>;
};

export type LocationMappingInput = {
  id: Scalars['Int']['input'];
};

export type LocationMappingPayload = {
  __typename?: 'LocationMappingPayload';
  depoDestinationMapping?: Maybe<DepoDestinationMapping>;
};

export type LocationProduct = {
  __typename?: 'LocationProduct';
  costCentre?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  location: Location;
  locationId: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type LocationProductConnection = {
  __typename?: 'LocationProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationProductEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationProduct>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationProductEdge = {
  __typename?: 'LocationProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationProduct;
};

export type LocationProductFilterInput = {
  and?: InputMaybe<Array<LocationProductFilterInput>>;
  costCentre?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LocationProductFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type LocationProductSortInput = {
  costCentre?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<ProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type LocationSortInput = {
  allowBankGuarantee?: InputMaybe<SortEnumType>;
  allowBasketOrders?: InputMaybe<SortEnumType>;
  allowBulkOrder?: InputMaybe<SortEnumType>;
  allowDeliveryTypeSelection?: InputMaybe<SortEnumType>;
  allowDeliveryTypeSelectionForProduct?: InputMaybe<SortEnumType>;
  allowDestinationSelectionFromMasterData?: InputMaybe<SortEnumType>;
  allowDriverSelection?: InputMaybe<SortEnumType>;
  allowDriverSelectionForDelivered?: InputMaybe<SortEnumType>;
  allowLoadingPointSelectionForProduct?: InputMaybe<SortEnumType>;
  allowOrderReference?: InputMaybe<SortEnumType>;
  allowStandAlonePayment?: InputMaybe<SortEnumType>;
  allowTruckSelection?: InputMaybe<SortEnumType>;
  allowTruckSelectionForDelivered?: InputMaybe<SortEnumType>;
  autoConfirmNewSOs?: InputMaybe<SortEnumType>;
  businessUnitLine?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<ContactSortInput>;
  costCentre?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  defaultDeliveryType?: InputMaybe<SortEnumType>;
  defaultTransporter?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  mergeCustomerDestinations?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocation?: InputMaybe<LocationSortInput>;
  parentLocationId?: InputMaybe<SortEnumType>;
  pmEmployee?: InputMaybe<SortEnumType>;
  quotationRentionDuration?: InputMaybe<SortEnumType>;
  requireDestinationSelectionForExworks?: InputMaybe<SortEnumType>;
  requireFileUpload?: InputMaybe<SortEnumType>;
  truckSelectionAllowed?: InputMaybe<SortEnumType>;
  truckSelectionFromMasterAllowed?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  useComments?: InputMaybe<SortEnumType>;
  useConfirmQuotation?: InputMaybe<SortEnumType>;
  useDeliveredOrderManagement?: InputMaybe<SortEnumType>;
  useDeliveryContact?: InputMaybe<SortEnumType>;
  useDescription?: InputMaybe<SortEnumType>;
  useFileUpload?: InputMaybe<SortEnumType>;
  useLocalPoNumber?: InputMaybe<SortEnumType>;
  vatCode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Location;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MailingGroup = {
  __typename?: 'MailingGroup';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateBundledBODForCompany: ActivateBundledBodForCompanyPayload;
  activateEcobankDirectDebitCustomerProfile: ActivateEcobankDirectDebitCustomerProfilePayload;
  addCustomerDestination: AddCustomerDestinationPayload;
  addDeliveredOrdersEmailJob: AddDeliveredOrdersEmailJobPayload;
  addFeedbackMessage: AddFeedbackMessagePayload;
  addLocationDestination: AddLocationDestinationPayload;
  addLocationMapping: AddLocationMappingPayload;
  addUserToLocation: AddUserToLocationPayload;
  addUserToMailingGroup: AddUserToMailingGroupPayload;
  amendSalesOrder: AmendSalesOrderPayload;
  approvePayment: ApprovePaymentPayload;
  approvePendingDeliveryDate: ApprovePendingDeliveryDatePayload;
  bulkVoidDeliveredOrdersSalesVouchers: BulkVoidDeliveredOrdersSalesVouchersPayload;
  cancelBasketOrder: CancelBasketOrderPayload;
  changeCustomerRefOfOrders: ChangeCustomerRefOfOrdersPayload;
  completeEcobankDirectDebitCustomerProfile: CompleteEcobankDirectDebitCustomerProfilePayload;
  configureCompanyAmendableFields: ConfigureCompanyAmendableFieldsPayload;
  configureCustomerPortalReports: ConfigureCustomerPortalReportsPayload;
  configureSalesOfficerLocationScope: ConfigureSalesOfficerLocationScopePayload;
  confirmDeliveredOrders: ConfirmDeliveredOrdersPayload;
  confirmSalesVoucherQuotation: ConfirmSalesVoucherQuotationPayload;
  createEcobankDirectDebitCustomerProfile: CreateEcobankDirectDebitCustomerProfilePayload;
  createNotifications: CreateNotificationsPayload;
  createSalesVoucherFromBasket: CreateSalesVoucherFromBasketPayload;
  deleteContact: DeleteContactPayload;
  deleteContent: DeleteContentPayload;
  deleteEPaymentAccountNumber: DeleteEPaymentAccountNumberPayload;
  deletePredefinedReportFilter: DeletePredefinedReportFilterPayload;
  deleteProduct: DeleteProductPayload;
  deleteProductConstraint: DeleteProductConstraintPayload;
  enableNewDriverAndVehicleForCompany: EnableNewDriverAndVehicleForCompanyPayload;
  enableOrderAmendmentForCompany: EnableOrderAmendmentForCompanyPayload;
  enableOrderCancellationForCompany: EnableOrderCancellationForCompanyPayload;
  linkUserAccount: LinkUserAccountPayload;
  locationMapping: LocationMappingPayload;
  offBoardEcobankDirectDebitCustomer: OffBoardEcobankDirectDebitCustomerPayload;
  readAllUserNotification: ReadAllUserNotificationPayload;
  readUserNotification: ReadUserNotificationPayload;
  rejectPendingDeliveryDate: RejectPendingDeliveryDatePayload;
  removeCustomerDestination: RemoveCustomerDestinationPayload;
  removeLocationDestination: RemoveLocationDestinationPayload;
  removeLocationMapping: RemoveLocationMappingPayload;
  removeLocationProduct: RemoveLocationProductPayload;
  removeUserDevice: RemoveUserDevicePayload;
  removeUserFromMailingGroup: RemoveUserFromMailingGroupPayload;
  requestAccountDeletion: RequestAccountDeletionPayload;
  requestAccountDeletionWhenLoggedOut: RequestAccountDeletionWhenLoggedOutPayload;
  resendEcobankDirectDebitCustomerOnboardingOtp: ResendEcobankDirectDebitCustomerOnboardingOtpPayload;
  resolveSalesOrderAmendment: ResolveSalesOrderAmendmentPayload;
  resolveVoidOrderRequest: ResolveVoidOrderRequestPayload;
  retractAccountDeletion: RetractAccountDeletionPayload;
  retryPaymentJournalPostingBodGeneration: RetryPaymentJournalPostingBodGenerationPayload;
  retryQuotationBodGeneration: RetryQuotationBodGenerationPayload;
  retrySalesOrderBodGeneration: RetrySalesOrderBodGenerationPayload;
  retryVoidSalesOrderBodGeneration: RetryVoidSalesOrderBodGenerationPayload;
  sendEcobankDirectDebitCustomerOnboardingOtp: SendEcobankDirectDebitCustomerOnboardingOtpPayload;
  setDeliveryDate: SetDeliveryDatePayload;
  statementRequest: StatementRequestPayload;
  triggerEcobankDirectDebitPayment: TriggerEcobankDirectDebitPaymentPayload;
  unlinkUserAccount: UnlinkUserAccountPayload;
  updateCustomerLocations: UpdateCustomerLocationsPayload;
  updateDriverRequestStatus: UpdateDriverRequestStatusPayload;
  updateLocationMapping: UpdateLocationMappingPayload;
  updateSalesVoucherItems: UpdateSalesVoucherItemsPayload;
  updateUser: UpdateUserPayload;
  updateUserActive: UpdateUserActivePayload;
  updateUserDefaultAccount: UpdateUserDefaultAccountPayload;
  updateUserDefaultLanguage: UpdateUserDefaultLanguagePayload;
  updateUserDefaultLocation: UpdateUserDefaultLocationPayload;
  updateUserLocations: UpdateUserLocationsPayload;
  updateUserProfile: UpdateUserProfilePayload;
  updateUserTermsAndCondition: UpdateUserTermsAndConditionPayload;
  updateVehicleRequestStatus: UpdateVehicleRequestStatusPayload;
  upsertBank: UpsertBankPayload;
  upsertBankBranch: UpsertBankBranchPayload;
  upsertBankGuarantee: UpsertBankGuaranteePayload;
  upsertBasketOrder: UpsertBasketOrderPayload;
  upsertCheque: UpsertChequePayload;
  upsertCompany: UpsertCompanyPayload;
  upsertCompanyCurrency: UpsertCompanyCurrencyPayload;
  upsertCompanySocialMedia: UpsertCompanySocialMediaPayload;
  upsertContact: UpsertContactPayload;
  upsertContent: UpsertContentPayload;
  upsertCurrency: UpsertCurrencyPayload;
  upsertCustomer: UpsertCustomerPayload;
  upsertCustomerVehicle: UpsertCustomerVehiclePayload;
  upsertDriver: UpsertDriverPayload;
  upsertDriverSyncData: UpsertDriverSyncDataPayload;
  upsertEPaymentAccountNumber: UpsertEPaymentAccountNumberPayload;
  upsertEPaymentProviderSettlementBankMapping: UpsertEPaymentProviderSettlementBankMappingPayload;
  upsertLocation: UpsertLocationPayload;
  upsertLocationProduct: UpsertLocationProductPayload;
  upsertPayment: UpsertPaymentPayload;
  upsertPaymentApproval: UpsertPaymentApprovalPayload;
  upsertPaymentTranscription: UpsertPaymentTranscriptionPayload;
  upsertPredefinedReportFilter: UpsertPredefinedReportFilterPayload;
  upsertProduct: UpsertProductPayload;
  upsertProductConstraint: UpsertProductConstraintPayload;
  /** @deprecated SMS providers are managed by sms-core. This mutation always fails. */
  upsertSMSConfiguration: UpsertSmsConfigurationPayload;
  upsertSalesVoucher: UpsertSalesVoucherPayload;
  upsertSettlementBank: UpsertSettlementBankPayload;
  upsertSupplier: UpsertSupplierPayload;
  upsertSupplierSyncData: UpsertSupplierSyncDataPayload;
  upsertTermsAndCondition: UpsertTermsAndConditionPayload;
  upsertUserDevice: UpsertUserDevicePayload;
  upsertUserNotificationPreference: UpsertUserNotificationPreferencePayload;
  upsertVehicle: UpsertVehiclePayload;
  upsertVehicleSupplier: UpsertVehicleSupplierPayload;
  upsertVehicleSyncData: UpsertVehicleSyncDataPayload;
  validateDeliveredOrderItems: ValidateDeliveredOrderItemsPayload;
  validateEcobankDirectDebitCustomerOnboardingOtp: ValidateEcobankDirectDebitCustomerOnboardingOtpPayload;
  validateEcobankDirectDebitPayment: ValidateEcobankDirectDebitPaymentPayload;
  validateQuotationData: ValidateQuotationDataPayload;
  verifyOTP: VerifyOtpPayload;
  voidCustomerSalesVouchers: VoidCustomerSalesVouchersPayload;
  voidDeliveredOrdersSalesVoucher: VoidDeliveredOrdersSalesVoucherPayload;
  voidSalesVoucher: VoidSalesVoucherPayload;
};


export type MutationActivateBundledBodForCompanyArgs = {
  input: ActivateBundledBodForCompanyInput;
};


export type MutationActivateEcobankDirectDebitCustomerProfileArgs = {
  input: ActivateEcobankDirectDebitCustomerProfileInput;
};


export type MutationAddCustomerDestinationArgs = {
  input: AddCustomerDestinationInput;
};


export type MutationAddDeliveredOrdersEmailJobArgs = {
  input: AddDeliveredOrdersEmailJobInput;
};


export type MutationAddFeedbackMessageArgs = {
  input: AddFeedbackMessageInput;
};


export type MutationAddLocationDestinationArgs = {
  input: AddLocationDestinationInput;
};


export type MutationAddLocationMappingArgs = {
  input: AddLocationMappingInput;
};


export type MutationAddUserToLocationArgs = {
  input: AddUserToLocationInput;
};


export type MutationAddUserToMailingGroupArgs = {
  input: AddUserToMailingGroupInput;
};


export type MutationAmendSalesOrderArgs = {
  amendments: Array<AmendSalesOrderInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  salesVoucherId: Scalars['Int']['input'];
};


export type MutationApprovePaymentArgs = {
  input: ApprovePaymentInput;
};


export type MutationApprovePendingDeliveryDateArgs = {
  input: ApprovePendingDeliveryDateInput;
};


export type MutationBulkVoidDeliveredOrdersSalesVouchersArgs = {
  input: BulkVoidDeliveredOrdersSalesVouchersInput;
};


export type MutationCancelBasketOrderArgs = {
  input: CancelBasketOrderInput;
};


export type MutationChangeCustomerRefOfOrdersArgs = {
  input: ChangeCustomerRefOfOrdersInput;
};


export type MutationCompleteEcobankDirectDebitCustomerProfileArgs = {
  input: CompleteEcobankDirectDebitCustomerProfileInput;
};


export type MutationConfigureCompanyAmendableFieldsArgs = {
  input: ConfigureCompanyAmendableFieldsInput;
};


export type MutationConfigureCustomerPortalReportsArgs = {
  input: ConfigureCustomerPortalReportsInput;
};


export type MutationConfigureSalesOfficerLocationScopeArgs = {
  input: ConfigureSalesOfficerLocationScopeInput;
};


export type MutationConfirmDeliveredOrdersArgs = {
  input: ConfirmDeliveredOrdersInput;
};


export type MutationConfirmSalesVoucherQuotationArgs = {
  input: ConfirmSalesVoucherQuotationInput;
};


export type MutationCreateEcobankDirectDebitCustomerProfileArgs = {
  input: CreateEcobankDirectDebitCustomerProfileInput;
};


export type MutationCreateNotificationsArgs = {
  input: CreateNotificationsInput;
};


export type MutationCreateSalesVoucherFromBasketArgs = {
  input: CreateSalesVoucherFromBasketInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteContentArgs = {
  input: DeleteContentInput;
};


export type MutationDeleteEPaymentAccountNumberArgs = {
  input: DeleteEPaymentAccountNumberInput;
};


export type MutationDeletePredefinedReportFilterArgs = {
  input: DeletePredefinedReportFilterInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteProductConstraintArgs = {
  input: DeleteProductConstraintInput;
};


export type MutationEnableNewDriverAndVehicleForCompanyArgs = {
  input: EnableNewDriverAndVehicleForCompanyInput;
};


export type MutationEnableOrderAmendmentForCompanyArgs = {
  input: EnableOrderAmendmentForCompanyInput;
};


export type MutationEnableOrderCancellationForCompanyArgs = {
  input: EnableOrderCancellationForCompanyInput;
};


export type MutationLinkUserAccountArgs = {
  input: LinkUserAccountInput;
};


export type MutationLocationMappingArgs = {
  input: LocationMappingInput;
};


export type MutationOffBoardEcobankDirectDebitCustomerArgs = {
  input: OffBoardEcobankDirectDebitCustomerInput;
};


export type MutationReadUserNotificationArgs = {
  input: ReadUserNotificationInput;
};


export type MutationRejectPendingDeliveryDateArgs = {
  input: RejectPendingDeliveryDateInput;
};


export type MutationRemoveCustomerDestinationArgs = {
  input: RemoveCustomerDestinationInput;
};


export type MutationRemoveLocationDestinationArgs = {
  input: RemoveLocationDestinationInput;
};


export type MutationRemoveLocationMappingArgs = {
  input: RemoveLocationMappingInput;
};


export type MutationRemoveLocationProductArgs = {
  input: RemoveLocationProductInput;
};


export type MutationRemoveUserDeviceArgs = {
  input: RemoveUserDeviceInput;
};


export type MutationRemoveUserFromMailingGroupArgs = {
  input: RemoveUserFromMailingGroupInput;
};


export type MutationRequestAccountDeletionWhenLoggedOutArgs = {
  input: RequestAccountDeletionWhenLoggedOutInput;
};


export type MutationResendEcobankDirectDebitCustomerOnboardingOtpArgs = {
  input: ResendEcobankDirectDebitCustomerOnboardingOtpInput;
};


export type MutationResolveSalesOrderAmendmentArgs = {
  input: ResolveSalesOrderAmendmentInput;
};


export type MutationResolveVoidOrderRequestArgs = {
  input: ResolveVoidOrderRequestInput;
};


export type MutationRetryPaymentJournalPostingBodGenerationArgs = {
  input: RetryPaymentJournalPostingBodGenerationInput;
};


export type MutationRetryQuotationBodGenerationArgs = {
  input: RetryQuotationBodGenerationInput;
};


export type MutationRetrySalesOrderBodGenerationArgs = {
  input: RetrySalesOrderBodGenerationInput;
};


export type MutationRetryVoidSalesOrderBodGenerationArgs = {
  input: RetryVoidSalesOrderBodGenerationInput;
};


export type MutationSendEcobankDirectDebitCustomerOnboardingOtpArgs = {
  input: SendEcobankDirectDebitCustomerOnboardingOtpInput;
};


export type MutationSetDeliveryDateArgs = {
  input: SetDeliveryDateInput;
};


export type MutationStatementRequestArgs = {
  input: StatementRequestInput;
};


export type MutationTriggerEcobankDirectDebitPaymentArgs = {
  input: TriggerEcobankDirectDebitPaymentInput;
};


export type MutationUnlinkUserAccountArgs = {
  input: UnlinkUserAccountInput;
};


export type MutationUpdateCustomerLocationsArgs = {
  input: UpdateCustomerLocationsInput;
};


export type MutationUpdateDriverRequestStatusArgs = {
  input: UpdateDriverRequestStatusInput;
};


export type MutationUpdateLocationMappingArgs = {
  input: UpdateLocationMappingInput;
};


export type MutationUpdateSalesVoucherItemsArgs = {
  input: UpdateSalesVoucherItemsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserActiveArgs = {
  input: UpdateUserActiveInput;
};


export type MutationUpdateUserDefaultAccountArgs = {
  input: UpdateUserDefaultAccountInput;
};


export type MutationUpdateUserDefaultLanguageArgs = {
  input: UpdateUserDefaultLanguageInput;
};


export type MutationUpdateUserDefaultLocationArgs = {
  input: UpdateUserDefaultLocationInput;
};


export type MutationUpdateUserLocationsArgs = {
  input: UpdateUserLocationsInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateVehicleRequestStatusArgs = {
  input: UpdateVehicleRequestStatusInput;
};


export type MutationUpsertBankArgs = {
  input: UpsertBankInput;
};


export type MutationUpsertBankBranchArgs = {
  input: UpsertBankBranchInput;
};


export type MutationUpsertBankGuaranteeArgs = {
  input: UpsertBankGuaranteeInput;
};


export type MutationUpsertBasketOrderArgs = {
  input: UpsertBasketOrderInput;
};


export type MutationUpsertChequeArgs = {
  input: UpsertChequeInput;
};


export type MutationUpsertCompanyArgs = {
  input: UpsertCompanyInput;
};


export type MutationUpsertCompanyCurrencyArgs = {
  input: UpsertCompanyCurrencyInput;
};


export type MutationUpsertCompanySocialMediaArgs = {
  input: UpsertCompanySocialMediaInput;
};


export type MutationUpsertContactArgs = {
  input: UpsertContactInput;
};


export type MutationUpsertContentArgs = {
  input: UpsertContentInput;
};


export type MutationUpsertCurrencyArgs = {
  input: UpsertCurrencyInput;
};


export type MutationUpsertCustomerArgs = {
  input: UpsertCustomerInput;
};


export type MutationUpsertCustomerVehicleArgs = {
  input: UpsertCustomerVehicleInput;
};


export type MutationUpsertDriverArgs = {
  input: UpsertDriverInput;
};


export type MutationUpsertDriverSyncDataArgs = {
  input: UpsertDriverSyncDataInput;
};


export type MutationUpsertEPaymentAccountNumberArgs = {
  input: UpsertEPaymentAccountNumberInput;
};


export type MutationUpsertEPaymentProviderSettlementBankMappingArgs = {
  input: UpsertEPaymentProviderSettlementBankMappingInput;
};


export type MutationUpsertLocationArgs = {
  input: UpsertLocationInput;
};


export type MutationUpsertLocationProductArgs = {
  input: UpsertLocationProductInput;
};


export type MutationUpsertPaymentArgs = {
  input: UpsertPaymentInput;
};


export type MutationUpsertPaymentApprovalArgs = {
  input: UpsertPaymentApprovalInput;
};


export type MutationUpsertPaymentTranscriptionArgs = {
  input: UpsertPaymentTranscriptionInput;
};


export type MutationUpsertPredefinedReportFilterArgs = {
  input: UpsertPredefinedReportFilterInput;
};


export type MutationUpsertProductArgs = {
  input: UpsertProductInput;
};


export type MutationUpsertProductConstraintArgs = {
  input: UpsertProductConstraintInput;
};


export type MutationUpsertSmsConfigurationArgs = {
  input: UpsertSmsConfigurationInput;
};


export type MutationUpsertSalesVoucherArgs = {
  input: UpsertSalesVoucherInput;
};


export type MutationUpsertSettlementBankArgs = {
  input: UpsertSettlementBankInput;
};


export type MutationUpsertSupplierArgs = {
  input: UpsertSupplierInput;
};


export type MutationUpsertSupplierSyncDataArgs = {
  input: UpsertSupplierSyncDataInput;
};


export type MutationUpsertTermsAndConditionArgs = {
  input: UpsertTermsAndConditionInput;
};


export type MutationUpsertUserDeviceArgs = {
  input: UpsertUserDeviceInput;
};


export type MutationUpsertUserNotificationPreferenceArgs = {
  input: UpsertUserNotificationPreferenceInput;
};


export type MutationUpsertVehicleArgs = {
  input: UpsertVehicleInput;
};


export type MutationUpsertVehicleSupplierArgs = {
  input: UpsertVehicleSupplierInput;
};


export type MutationUpsertVehicleSyncDataArgs = {
  input: UpsertVehicleSyncDataInput;
};


export type MutationValidateDeliveredOrderItemsArgs = {
  input: ValidateDeliveredOrderItemsInput;
};


export type MutationValidateEcobankDirectDebitCustomerOnboardingOtpArgs = {
  input: ValidateEcobankDirectDebitCustomerOnboardingOtpInput;
};


export type MutationValidateEcobankDirectDebitPaymentArgs = {
  input: ValidateEcobankDirectDebitPaymentInput;
};


export type MutationValidateQuotationDataArgs = {
  input: ValidateQuotationDataInput;
};


export type MutationVerifyOtpArgs = {
  input: VerifyOtpInput;
};


export type MutationVoidCustomerSalesVouchersArgs = {
  input: VoidCustomerSalesVouchersInput;
};


export type MutationVoidDeliveredOrdersSalesVoucherArgs = {
  input: VoidDeliveredOrdersSalesVoucherInput;
};


export type MutationVoidSalesVoucherArgs = {
  input: VoidSalesVoucherInput;
};

export type NavigationState = {
  __typename?: 'NavigationState';
  apparentDataLoss: Scalars['Boolean']['output'];
  hasGoBackRequest: Scalars['Boolean']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  componentId?: Maybe<Scalars['String']['output']>;
  componentName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notificationType: NotificationType;
  notificationTypeId: Scalars['Int']['output'];
  notificationUsers: Array<NotificationUser>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  body?: InputMaybe<StringOperationFilterInput>;
  componentId?: InputMaybe<StringOperationFilterInput>;
  componentName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notificationType?: InputMaybe<NotificationTypeFilterInput>;
  notificationTypeId?: InputMaybe<IntOperationFilterInput>;
  notificationUsers?: InputMaybe<ListFilterInputTypeOfNotificationUserFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type NotificationPreferenceType = {
  __typename?: 'NotificationPreferenceType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
  users: Array<User>;
};

export type NotificationPreferenceTypeFilterInput = {
  and?: InputMaybe<Array<NotificationPreferenceTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NotificationPreferenceTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
};

export type NotificationSortInput = {
  body?: InputMaybe<SortEnumType>;
  componentId?: InputMaybe<SortEnumType>;
  componentName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<NotificationTypeSortInput>;
  notificationTypeId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type NotificationStatus = {
  __typename?: 'NotificationStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type NotificationStatusFilterInput = {
  and?: InputMaybe<Array<NotificationStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NotificationStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type NotificationStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type NotificationTypeFilterInput = {
  and?: InputMaybe<Array<NotificationTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NotificationTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type NotificationTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type NotificationUser = {
  __typename?: 'NotificationUser';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  notification: Notification;
  notificationId: Scalars['Int']['output'];
  notificationStatus: NotificationStatus;
  notificationStatusId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type NotificationUserFilterInput = {
  and?: InputMaybe<Array<NotificationUserFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  notification?: InputMaybe<NotificationFilterInput>;
  notificationId?: InputMaybe<IntOperationFilterInput>;
  notificationStatus?: InputMaybe<NotificationStatusFilterInput>;
  notificationStatusId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NotificationUserFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type NotificationUserSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idempotencyKey?: InputMaybe<SortEnumType>;
  notification?: InputMaybe<NotificationSortInput>;
  notificationId?: InputMaybe<SortEnumType>;
  notificationStatus?: InputMaybe<NotificationStatusSortInput>;
  notificationStatusId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NotificationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Notification;
};

export type OffBoardCustomerData = {
  __typename?: 'OffBoardCustomerData';
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type OffBoardCustomerResponse = {
  __typename?: 'OffBoardCustomerResponse';
  data?: Maybe<OffBoardCustomerData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type OffBoardEcobankDirectDebitCustomerInput = {
  accountNumber: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};

export type OffBoardEcobankDirectDebitCustomerPayload = {
  __typename?: 'OffBoardEcobankDirectDebitCustomerPayload';
  offBoardCustomerResponse?: Maybe<OffBoardCustomerResponse>;
};

export type OrderBalanceByBusinessUnitLine = {
  __typename?: 'OrderBalanceByBusinessUnitLine';
  amountTotal: Scalars['Decimal']['output'];
  businessUnitLine: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type OrderStatusFilterInput = {
  and?: InputMaybe<Array<OrderStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type OrderStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Decimal']['output'];
  amountApproved?: Maybe<Scalars['Decimal']['output']>;
  availableBalanceRef?: Maybe<Scalars['String']['output']>;
  cheque?: Maybe<Cheque>;
  createdAt: Scalars['DateTime']['output'];
  customReference?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  ePaymentCheckOutUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  paymentApprovals: Array<PaymentApproval>;
  paymentDocuments: Array<PaymentDocument>;
  paymentMode: PaymentMode;
  paymentModeId: Scalars['Int']['output'];
  paymentReference: Scalars['String']['output'];
  paymentStatus: PaymentStatus;
  paymentStatusId: Scalars['Int']['output'];
  paymentTranscriptions: Array<PaymentTranscription>;
  postedToJournal: Scalars['Boolean']['output'];
  reason?: Maybe<Reason>;
  reasonId?: Maybe<Scalars['Int']['output']>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  salesVoucher?: Maybe<SalesVoucher>;
  salesVoucherId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentAccess = {
  __typename?: 'PaymentAccess';
  companyId: Scalars['Int']['output'];
  kind: PaymentAccessKind;
  locationIds: Array<Scalars['Int']['output']>;
  sessionLocationId?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentAccessKind {
  Finance = 'FINANCE',
  None = 'NONE',
  SalesOfficerScoped = 'SALES_OFFICER_SCOPED',
  SessionLocation = 'SESSION_LOCATION'
}

export type PaymentApproval = {
  __typename?: 'PaymentApproval';
  amountApproved: Scalars['Decimal']['output'];
  approvalComment?: Maybe<Scalars['String']['output']>;
  bankGuarantee?: Maybe<BankGuarantee>;
  bankGuaranteeId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  journalReference?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  payment: Payment;
  paymentApprovalStatus: PaymentApprovalStatus;
  paymentApprovalStatusId: Scalars['Int']['output'];
  paymentApprovalType: PaymentApprovalType;
  paymentApprovalTypeId: Scalars['Int']['output'];
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentId: Scalars['Int']['output'];
  reason?: Maybe<Reason>;
  reasonId?: Maybe<Scalars['Int']['output']>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  settlementBank?: Maybe<SettlementBank>;
  settlementBankId?: Maybe<Scalars['Int']['output']>;
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentApprovalFilterInput = {
  amountApproved?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentApprovalFilterInput>>;
  approvalComment?: InputMaybe<StringOperationFilterInput>;
  bankGuarantee?: InputMaybe<BankGuaranteeFilterInput>;
  bankGuaranteeId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  journalReference?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentApprovalFilterInput>>;
  orderDate?: InputMaybe<DateTimeOperationFilterInput>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentApprovalStatus?: InputMaybe<PaymentApprovalStatusFilterInput>;
  paymentApprovalStatusId?: InputMaybe<IntOperationFilterInput>;
  paymentApprovalType?: InputMaybe<PaymentApprovalTypeFilterInput>;
  paymentApprovalTypeId?: InputMaybe<IntOperationFilterInput>;
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  reason?: InputMaybe<ReasonFilterInput>;
  reasonId?: InputMaybe<IntOperationFilterInput>;
  rejectionComment?: InputMaybe<StringOperationFilterInput>;
  settlementBank?: InputMaybe<SettlementBankFilterInput>;
  settlementBankId?: InputMaybe<IntOperationFilterInput>;
  subscriberNumber?: InputMaybe<StringOperationFilterInput>;
  transactionId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentApprovalSortInput = {
  amountApproved?: InputMaybe<SortEnumType>;
  approvalComment?: InputMaybe<SortEnumType>;
  bankGuarantee?: InputMaybe<BankGuaranteeSortInput>;
  bankGuaranteeId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  journalReference?: InputMaybe<SortEnumType>;
  orderDate?: InputMaybe<SortEnumType>;
  payment?: InputMaybe<PaymentSortInput>;
  paymentApprovalStatus?: InputMaybe<PaymentApprovalStatusSortInput>;
  paymentApprovalStatusId?: InputMaybe<SortEnumType>;
  paymentApprovalType?: InputMaybe<PaymentApprovalTypeSortInput>;
  paymentApprovalTypeId?: InputMaybe<SortEnumType>;
  paymentDate?: InputMaybe<SortEnumType>;
  paymentId?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<ReasonSortInput>;
  reasonId?: InputMaybe<SortEnumType>;
  rejectionComment?: InputMaybe<SortEnumType>;
  settlementBank?: InputMaybe<SettlementBankSortInput>;
  settlementBankId?: InputMaybe<SortEnumType>;
  subscriberNumber?: InputMaybe<SortEnumType>;
  transactionId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type PaymentApprovalStatus = {
  __typename?: 'PaymentApprovalStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentApprovalStatusFilterInput = {
  and?: InputMaybe<Array<PaymentApprovalStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentApprovalStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentApprovalStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type PaymentApprovalType = {
  __typename?: 'PaymentApprovalType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentApprovalTypeFilterInput = {
  and?: InputMaybe<Array<PaymentApprovalTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentApprovalTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentApprovalTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PaymentApprovalsConnection = {
  __typename?: 'PaymentApprovalsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PaymentApprovalsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PaymentApproval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentApprovalsEdge = {
  __typename?: 'PaymentApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentApproval;
};

export type PaymentDocument = {
  __typename?: 'PaymentDocument';
  createdAt: Scalars['DateTime']['output'];
  documentName?: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  payment: Payment;
  paymentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentDocumentFilterInput = {
  and?: InputMaybe<Array<PaymentDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentName?: InputMaybe<StringOperationFilterInput>;
  documentUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentDocumentFilterInput>>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  amountApproved?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentFilterInput>>;
  availableBalanceRef?: InputMaybe<StringOperationFilterInput>;
  cheque?: InputMaybe<ChequeFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customReference?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  ePaymentCheckOutUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentFilterInput>>;
  paymentApprovals?: InputMaybe<ListFilterInputTypeOfPaymentApprovalFilterInput>;
  paymentDocuments?: InputMaybe<ListFilterInputTypeOfPaymentDocumentFilterInput>;
  paymentMode?: InputMaybe<PaymentModeFilterInput>;
  paymentModeId?: InputMaybe<IntOperationFilterInput>;
  paymentReference?: InputMaybe<StringOperationFilterInput>;
  paymentStatus?: InputMaybe<PaymentStatusFilterInput>;
  paymentStatusId?: InputMaybe<IntOperationFilterInput>;
  paymentTranscriptions?: InputMaybe<ListFilterInputTypeOfPaymentTranscriptionFilterInput>;
  postedToJournal?: InputMaybe<BooleanOperationFilterInput>;
  reason?: InputMaybe<ReasonFilterInput>;
  reasonId?: InputMaybe<IntOperationFilterInput>;
  rejectionComment?: InputMaybe<StringOperationFilterInput>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  transactionId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentLocationScope = {
  __typename?: 'PaymentLocationScope';
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  kind: PaymentAccessKind;
  locations: Array<PaymentScopeLocation>;
  sessionLocationId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMode = {
  __typename?: 'PaymentMode';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentType: DocumentType;
  documentTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  paymentModeStatus: PaymentModeStatus;
  paymentModeStatusId: Scalars['Int']['output'];
  paymentModeType: PaymentModeType;
  paymentModeTypeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentModeFilterInput = {
  and?: InputMaybe<Array<PaymentModeFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentModeFilterInput>>;
  paymentModeStatus?: InputMaybe<PaymentModeStatusFilterInput>;
  paymentModeStatusId?: InputMaybe<IntOperationFilterInput>;
  paymentModeType?: InputMaybe<PaymentModeTypeFilterInput>;
  paymentModeTypeId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentModeSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  paymentModeStatus?: InputMaybe<PaymentModeStatusSortInput>;
  paymentModeStatusId?: InputMaybe<SortEnumType>;
  paymentModeType?: InputMaybe<PaymentModeTypeSortInput>;
  paymentModeTypeId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type PaymentModeStatus = {
  __typename?: 'PaymentModeStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentModeStatusFilterInput = {
  and?: InputMaybe<Array<PaymentModeStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentModeStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentModeStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type PaymentModeType = {
  __typename?: 'PaymentModeType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentModeTypeFilterInput = {
  and?: InputMaybe<Array<PaymentModeTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentModeTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentModeTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type PaymentScopeLocation = {
  __typename?: 'PaymentScopeLocation';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PaymentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  amountApproved?: InputMaybe<SortEnumType>;
  availableBalanceRef?: InputMaybe<SortEnumType>;
  cheque?: InputMaybe<ChequeSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  customReference?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  ePaymentCheckOutUrl?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  paymentMode?: InputMaybe<PaymentModeSortInput>;
  paymentModeId?: InputMaybe<SortEnumType>;
  paymentReference?: InputMaybe<SortEnumType>;
  paymentStatus?: InputMaybe<PaymentStatusSortInput>;
  paymentStatusId?: InputMaybe<SortEnumType>;
  postedToJournal?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<ReasonSortInput>;
  reasonId?: InputMaybe<SortEnumType>;
  rejectionComment?: InputMaybe<SortEnumType>;
  salesVoucher?: InputMaybe<SalesVoucherSortInput>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  transactionId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentStatusFilterInput = {
  and?: InputMaybe<Array<PaymentStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type PaymentTranscription = {
  __typename?: 'PaymentTranscription';
  amount: Scalars['Decimal']['output'];
  bank?: Maybe<Bank>;
  bankBranch?: Maybe<BankBranch>;
  bankBranchId?: Maybe<Scalars['Int']['output']>;
  bankId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']['output']>;
  depositorContact?: Maybe<Scalars['String']['output']>;
  depositorName?: Maybe<Scalars['String']['output']>;
  documentDate: Scalars['DateTime']['output'];
  documentReference?: Maybe<Scalars['String']['output']>;
  documentType: DocumentType;
  documentTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  paymentId: Scalars['Int']['output'];
  paymentTranscriptionStatus: PaymentTranscriptionStatus;
  paymentTranscriptionStatusId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentTranscriptionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentTranscriptionFilterInput>>;
  bank?: InputMaybe<BankFilterInput>;
  bankBranch?: InputMaybe<BankBranchFilterInput>;
  bankBranchId?: InputMaybe<IntOperationFilterInput>;
  bankId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  depositorContact?: InputMaybe<StringOperationFilterInput>;
  depositorName?: InputMaybe<StringOperationFilterInput>;
  documentDate?: InputMaybe<DateTimeOperationFilterInput>;
  documentReference?: InputMaybe<StringOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PaymentTranscriptionFilterInput>>;
  payment?: InputMaybe<PaymentFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  paymentTranscriptionStatus?: InputMaybe<PaymentTranscriptionStatusFilterInput>;
  paymentTranscriptionStatusId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PaymentTranscriptionSortInput = {
  amount?: InputMaybe<SortEnumType>;
  bank?: InputMaybe<BankSortInput>;
  bankBranch?: InputMaybe<BankBranchSortInput>;
  bankBranchId?: InputMaybe<SortEnumType>;
  bankId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  depositorContact?: InputMaybe<SortEnumType>;
  depositorName?: InputMaybe<SortEnumType>;
  documentDate?: InputMaybe<SortEnumType>;
  documentReference?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  payment?: InputMaybe<PaymentSortInput>;
  paymentId?: InputMaybe<SortEnumType>;
  paymentTranscriptionStatus?: InputMaybe<PaymentTranscriptionStatusSortInput>;
  paymentTranscriptionStatusId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type PaymentTranscriptionStatus = {
  __typename?: 'PaymentTranscriptionStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentTranscriptionStatusFilterInput = {
  and?: InputMaybe<Array<PaymentTranscriptionStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentTranscriptionStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type PaymentTranscriptionStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PaymentTranscriptionsConnection = {
  __typename?: 'PaymentTranscriptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PaymentTranscriptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PaymentTranscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentTranscriptionsEdge = {
  __typename?: 'PaymentTranscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentTranscription;
};

/** A connection to a list of items. */
export type PaymentsConnection = {
  __typename?: 'PaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentsEdge = {
  __typename?: 'PaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

export type PayswitchTransactionStatusResponse = {
  __typename?: 'PayswitchTransactionStatusResponse';
  amount: Scalars['String']['output'];
  checkOutUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PermissionState = {
  __typename?: 'PermissionState';
  permissions: Scalars['String']['output'];
};

export type PredefinedReportFilter = {
  __typename?: 'PredefinedReportFilter';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  reportType: ReportType;
  reportTypeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PredefinedReportFilterFilterInput = {
  and?: InputMaybe<Array<PredefinedReportFilterFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PredefinedReportFilterFilterInput>>;
  reportType?: InputMaybe<ReportTypeFilterInput>;
  reportTypeId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PredefinedReportFilterSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  reportType?: InputMaybe<ReportTypeSortInput>;
  reportTypeId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type Product = {
  __typename?: 'Product';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPublished: Scalars['Boolean']['output'];
  itemCode: Scalars['String']['output'];
  locationProducts?: Maybe<Array<LocationProduct>>;
  lookup?: Maybe<Scalars['String']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  productMeasurement?: Maybe<ProductMeasurement>;
  productMeasurementId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  titleColor?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  unitOfMeasureId?: Maybe<Scalars['Int']['output']>;
  uoS?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  weighPiece: Scalars['Decimal']['output'];
};

export type ProductConstraint = {
  __typename?: 'ProductConstraint';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerSegment: CustomerSegment;
  customerSegmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  maxProductQuantity: Scalars['Long']['output'];
  maxTruckQuantity: Scalars['Long']['output'];
  minProductQuantity: Scalars['Long']['output'];
  minTruckQuantity: Scalars['Long']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductConstraintFilterInput = {
  and?: InputMaybe<Array<ProductConstraintFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerSegment?: InputMaybe<CustomerSegmentFilterInput>;
  customerSegmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  maxProductQuantity?: InputMaybe<LongOperationFilterInput>;
  maxTruckQuantity?: InputMaybe<LongOperationFilterInput>;
  minProductQuantity?: InputMaybe<LongOperationFilterInput>;
  minTruckQuantity?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ProductConstraintFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ProductConstraintSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerSegment?: InputMaybe<CustomerSegmentSortInput>;
  customerSegmentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  maxProductQuantity?: InputMaybe<SortEnumType>;
  maxTruckQuantity?: InputMaybe<SortEnumType>;
  minProductQuantity?: InputMaybe<SortEnumType>;
  minTruckQuantity?: InputMaybe<SortEnumType>;
  product?: InputMaybe<ProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductConstraintsConnection = {
  __typename?: 'ProductConstraintsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductConstraintsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductConstraint>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductConstraintsEdge = {
  __typename?: 'ProductConstraintsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductConstraint;
};

export type ProductFilterInput = {
  and?: InputMaybe<Array<ProductFilterInput>>;
  backgroundColor?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  featuredImageUrl?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationProducts?: InputMaybe<ListFilterInputTypeOfLocationProductFilterInput>;
  lookup?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  productMeasurement?: InputMaybe<ProductMeasurementFilterInput>;
  productMeasurementId?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  titleColor?: InputMaybe<StringOperationFilterInput>;
  unitOfMeasure?: InputMaybe<UnitOfMeasureFilterInput>;
  unitOfMeasureId?: InputMaybe<IntOperationFilterInput>;
  uoS?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  weighPiece?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductMeasurement = {
  __typename?: 'ProductMeasurement';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type ProductMeasurementFilterInput = {
  and?: InputMaybe<Array<ProductMeasurementFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductMeasurementFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type ProductMeasurementSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type ProductSortInput = {
  backgroundColor?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  featuredImageUrl?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPublished?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  lookup?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  productMeasurement?: InputMaybe<ProductMeasurementSortInput>;
  productMeasurementId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  titleColor?: InputMaybe<SortEnumType>;
  unitOfMeasure?: InputMaybe<UnitOfMeasureSortInput>;
  unitOfMeasureId?: InputMaybe<SortEnumType>;
  uoS?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  weighPiece?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Product;
};

export type Query = {
  __typename?: 'Query';
  activeBankBranches: Array<BankBranch>;
  activeBanks: Array<Bank>;
  adminSummaryReport: Array<AdminSummaryReport>;
  allLocations?: Maybe<AllLocationsConnection>;
  appUpdates?: Maybe<AppUpdatesConnection>;
  backOfficePayments?: Maybe<BackOfficePaymentsConnection>;
  backOfficeSalesVouchers?: Maybe<BackOfficeSalesVouchersConnection>;
  bank?: Maybe<Bank>;
  bankBranch?: Maybe<BankBranch>;
  bankBranches?: Maybe<BankBranchesConnection>;
  bankGuarantees: Array<BankGuarantee>;
  banks?: Maybe<BanksConnection>;
  basketOrderById?: Maybe<Basket>;
  basketOrders?: Maybe<BasketOrdersConnection>;
  basketOrdersByCompany?: Maybe<BasketOrdersByCompanyConnection>;
  basketOrdersByCustomer?: Maybe<BasketOrdersByCustomerConnection>;
  checkEcobankDirectDebitEnrollmentStatus: GetCustomerProfileByAccountNumberResponse;
  checkEcobankDirectDebitTransactionStatus: CheckTransactionStatusResponse;
  checkPayswitchTransactionStatus: PayswitchTransactionStatusResponse;
  checkPayswitchTransactionStatusWithoutJournalPosting: PayswitchTransactionStatusResponse;
  checkStandardCharteredTransactionStatus: S2bCheckTransactionStatusResponse;
  checkStatus: PayswitchTransactionStatusResponse;
  chequeDashboard: ChequeDashboardReport;
  chequeTrackerHistories?: Maybe<ChequeTrackerHistoriesConnection>;
  companies?: Maybe<CompaniesConnection>;
  companyCurrency: Array<CompanyCurrency>;
  companySocials: Array<CompanySocialMedia>;
  contacts?: Maybe<ContactsConnection>;
  contents?: Maybe<ContentsConnection>;
  countries: Array<Country>;
  currency?: Maybe<CurrencyConnection>;
  customerAvailableBalance?: Maybe<Customer>;
  customerBankGuaranteeSummary: BankGuranteeSummary;
  customerBankGuarantees: Array<BankGuarantee>;
  customerBasketOrders?: Maybe<CustomerBasketOrdersConnection>;
  customerById?: Maybe<Customer>;
  customerDestinations?: Maybe<CustomerDestinationsConnection>;
  customerInvoice?: Maybe<CustomerInvoiceConnection>;
  customerOrderBalancesByBusinessUnitLine: Array<OrderBalanceByBusinessUnitLine>;
  customerOrderBalancesByBusinessUnitLineForAdmin: Array<OrderBalanceByBusinessUnitLine>;
  customerOrdersActivityReport: Array<CustomerActivityReport>;
  customerReferenceExist: Scalars['Boolean']['output'];
  customerReport: Scalars['Boolean']['output'];
  customerRoles: Array<Role>;
  customerSalesActivityReport: Array<CustomerSalesActivityReport>;
  customerSalesInvoices?: Maybe<CustomerSalesInvoicesConnection>;
  customerSalesVoucherOrders?: Maybe<CustomerSalesVoucherOrdersConnection>;
  customerSegments?: Maybe<CustomerSegmentsConnection>;
  customerUserRoles?: Maybe<CustomerUserRolesConnection>;
  customers?: Maybe<CustomersConnection>;
  dashboard: DashboardReport;
  dashboardTz: DashboardReport;
  descriptionValues: Array<DescriptionValue>;
  destinations?: Maybe<DestinationsConnection>;
  dfsPayments?: Maybe<DfsPaymentsConnection>;
  distinctVatCodes: Array<Scalars['String']['output']>;
  documentStatus: Array<DocumentStatus>;
  documentTypes: Array<DocumentType>;
  driverRequests?: Maybe<DriverRequestsConnection>;
  drivers?: Maybe<DriversConnection>;
  ePaymentAccountNumbers: Array<EPaymentAccountNumbers>;
  feedbackMessages: Array<FeedbackMessage>;
  filteredVolumeBalance: Array<VolumeBalanceReport>;
  generateDfsReportExcel: Scalars['String']['output'];
  languages: Array<Language>;
  lifteredOrders: Array<VolumeBalanceReport>;
  locationDestinations?: Maybe<LocationDestinationsConnection>;
  locationMappings: Array<DepoDestinationMapping>;
  locationProduct?: Maybe<LocationProductConnection>;
  locations?: Maybe<LocationsConnection>;
  navigateState: NavigationState;
  notificationPreferenceTypes: Array<NotificationPreferenceType>;
  notificationTypes: Array<NotificationType>;
  notifications?: Maybe<NotificationsConnection>;
  paymentAccess: PaymentAccess;
  paymentApprovalStatus: Array<PaymentApprovalStatus>;
  paymentApprovalType: Array<PaymentApprovalType>;
  paymentApprovals?: Maybe<PaymentApprovalsConnection>;
  paymentImageDownloadUrl: Scalars['String']['output'];
  paymentLocationScopes: Array<PaymentLocationScope>;
  paymentModes: Array<PaymentMode>;
  paymentTranscriptions?: Maybe<PaymentTranscriptionsConnection>;
  payments?: Maybe<PaymentsConnection>;
  permissionState: PermissionState;
  predefinedReportFilters: Array<PredefinedReportFilter>;
  productConstraints?: Maybe<ProductConstraintsConnection>;
  productMeasurements: Array<ProductMeasurement>;
  products?: Maybe<ProductsConnection>;
  reasonTypes: Array<ReasonType>;
  reasons: Array<Reason>;
  remainingBalanceForPaymentReference: AvailableBalanceResponse;
  revenueGraph: Array<AdminDashboardGraph>;
  salesOrderBacklogs: Array<SalesOrderBackLogReport>;
  salesVoucherItems?: Maybe<SalesVoucherItemsConnection>;
  salesVoucherOrders?: Maybe<SalesVoucherOrdersConnection>;
  salesVouchers?: Maybe<SalesVouchersConnection>;
  salesVouchersByCompany?: Maybe<SalesVouchersByCompanyConnection>;
  salesVouchersInBasket?: Maybe<SalesVouchersInBasketConnection>;
  settlementBanks?: Maybe<SettlementBanksConnection>;
  soldProducts: Array<VolumeBalanceReport>;
  suppliers?: Maybe<SuppliersConnection>;
  termsAndConditions: Array<TermsAndCondition>;
  topProductsOrdered: Array<TopProductOrderedReport>;
  totalSalesVolume: SalesVolumeReport;
  totalTrips: Scalars['Int']['output'];
  trackingInfo: TrackingResponse;
  transactionSummary: TransactionSummaryReport;
  transactions?: Maybe<TransactionsConnection>;
  transportRequests?: Maybe<TransportRequestsConnection>;
  unitsOfMeasure: Array<UnitOfMeasure>;
  userByEmail?: Maybe<User>;
  userById?: Maybe<User>;
  userMHCPermissions: Array<Scalars['String']['output']>;
  userMHCRoles: Array<Scalars['String']['output']>;
  userNotifications?: Maybe<UserNotificationsConnection>;
  userPayments?: Maybe<UserPaymentsConnection>;
  userPermissions: Array<Scalars['String']['output']>;
  userProfile?: Maybe<User>;
  userRoles: Array<Scalars['String']['output']>;
  userTransactions?: Maybe<UserTransactionsConnection>;
  users?: Maybe<UsersConnection>;
  usersByCompany?: Maybe<UsersByCompanyConnection>;
  vehicleRequests?: Maybe<VehicleRequestsConnection>;
  vehicles?: Maybe<VehiclesConnection>;
  volumeBalance: Array<VolumeBalanceReport>;
};


export type QueryActiveBankBranchesArgs = {
  order?: InputMaybe<Array<BankBranchSortInput>>;
  where?: InputMaybe<BankBranchFilterInput>;
};


export type QueryActiveBanksArgs = {
  order?: InputMaybe<Array<BankSortInput>>;
  where?: InputMaybe<BankFilterInput>;
};


export type QueryAdminSummaryReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationSortInput>>;
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryAppUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AppUpdatesSortInput>>;
  where?: InputMaybe<AppUpdatesFilterInput>;
};


export type QueryBackOfficePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  order?: InputMaybe<Array<PaymentSortInput>>;
  where?: InputMaybe<PaymentFilterInput>;
};


export type QueryBackOfficeSalesVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  order?: InputMaybe<Array<SalesVoucherSortInput>>;
  where?: InputMaybe<SalesVoucherFilterInput>;
};


export type QueryBankArgs = {
  bankId: Scalars['Int']['input'];
};


export type QueryBankBranchArgs = {
  bankBranchId: Scalars['Int']['input'];
};


export type QueryBankBranchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BankBranchSortInput>>;
  where?: InputMaybe<BankBranchFilterInput>;
};


export type QueryBankGuaranteesArgs = {
  companyId: Scalars['Int']['input'];
  order?: InputMaybe<Array<BankGuaranteeSortInput>>;
  where?: InputMaybe<BankGuaranteeFilterInput>;
};


export type QueryBanksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BankSortInput>>;
  where?: InputMaybe<BankFilterInput>;
};


export type QueryBasketOrderByIdArgs = {
  basketOrderId: Scalars['Int']['input'];
};


export type QueryBasketOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BasketSortInput>>;
  where?: InputMaybe<BasketFilterInput>;
};


export type QueryBasketOrdersByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BasketSortInput>>;
  where?: InputMaybe<BasketFilterInput>;
};


export type QueryBasketOrdersByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BasketSortInput>>;
  where?: InputMaybe<BasketFilterInput>;
};


export type QueryCheckEcobankDirectDebitEnrollmentStatusArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryCheckEcobankDirectDebitTransactionStatusArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryCheckPayswitchTransactionStatusArgs = {
  payswitchReturnUrlPayload?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};


export type QueryCheckPayswitchTransactionStatusWithoutJournalPostingArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryCheckStandardCharteredTransactionStatusArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryCheckStatusArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryChequeDashboardArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryChequeTrackerHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chequeId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ChequeTrackerHistorySortInput>>;
  where?: InputMaybe<ChequeTrackerHistoryFilterInput>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CompanySortInput>>;
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryCompanyCurrencyArgs = {
  order?: InputMaybe<Array<CompanyCurrencySortInput>>;
  where?: InputMaybe<CompanyCurrencyFilterInput>;
};


export type QueryCompanySocialsArgs = {
  companyId: Scalars['Int']['input'];
  order?: InputMaybe<Array<CompanySocialMediaSortInput>>;
  where?: InputMaybe<CompanySocialMediaFilterInput>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContactSortInput>>;
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  where?: InputMaybe<ContentFilterInput>;
};


export type QueryCountriesArgs = {
  order?: InputMaybe<Array<CountrySortInput>>;
  where?: InputMaybe<CountryFilterInput>;
};


export type QueryCurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CurrencySortInput>>;
  where?: InputMaybe<CurrencyFilterInput>;
};


export type QueryCustomerBankGuaranteesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<BankGuaranteeSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<BankGuaranteeFilterInput>;
};


export type QueryCustomerBasketOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BasketSortInput>>;
  where?: InputMaybe<BasketFilterInput>;
};


export type QueryCustomerByIdArgs = {
  id: Scalars['Int']['input'];
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryCustomerDestinationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  order?: InputMaybe<Array<DestinationSortInput>>;
  where?: InputMaybe<DestinationFilterInput>;
};


export type QueryCustomerInvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherOrderSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<SalesVoucherOrderFilterInput>;
};


export type QueryCustomerOrderBalancesByBusinessUnitLineForAdminArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryCustomerOrdersActivityReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerReferenceExistArgs = {
  companyId: Scalars['Int']['input'];
  customerReference: Scalars['String']['input'];
};


export type QueryCustomerReportArgs = {
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  reportType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerRolesArgs = {
  order?: InputMaybe<Array<RoleSortInput>>;
  where?: InputMaybe<RoleFilterInput>;
};


export type QueryCustomerSalesActivityReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerSalesInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherOrderSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<SalesVoucherOrderFilterInput>;
};


export type QueryCustomerSalesVoucherOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherOrderSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<SalesVoucherOrderFilterInput>;
};


export type QueryCustomerSegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerSegmentSortInput>>;
  where?: InputMaybe<CustomerSegmentFilterInput>;
};


export type QueryCustomerUserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerUserRoleSortInput>>;
  where?: InputMaybe<CustomerUserRoleFilterInput>;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerSortInput>>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryDashboardArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  reportType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDashboardTzArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  reportType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDescriptionValuesArgs = {
  order?: InputMaybe<Array<DescriptionValueSortInput>>;
  where?: InputMaybe<DescriptionValueFilterInput>;
};


export type QueryDestinationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DestinationSortInput>>;
  where?: InputMaybe<DestinationFilterInput>;
};


export type QueryDfsPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ChequeSortInput>>;
  where?: InputMaybe<ChequeFilterInput>;
};


export type QueryDistinctVatCodesArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryDocumentStatusArgs = {
  order?: InputMaybe<Array<DocumentStatusSortInput>>;
  where?: InputMaybe<DocumentStatusFilterInput>;
};


export type QueryDocumentTypesArgs = {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  where?: InputMaybe<DocumentTypeFilterInput>;
};


export type QueryDriverRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyIds: Array<Scalars['Int']['input']>;
  driverRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DriverRequestResponseSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<DriverRequestResponseFilterInput>;
};


export type QueryDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DriverSortInput>>;
  where?: InputMaybe<DriverFilterInput>;
};


export type QueryEPaymentAccountNumbersArgs = {
  customerId: Scalars['Int']['input'];
  epaymentProviderId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EPaymentAccountNumbersSortInput>>;
  where?: InputMaybe<EPaymentAccountNumbersFilterInput>;
};


export type QueryFeedbackMessagesArgs = {
  order?: InputMaybe<Array<FeedbackMessageSortInput>>;
  where?: InputMaybe<FeedbackMessageFilterInput>;
};


export type QueryFilteredVolumeBalanceArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryLifteredOrdersArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryLocationDestinationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationDestinationSortInput>>;
  where?: InputMaybe<LocationDestinationFilterInput>;
};


export type QueryLocationMappingsArgs = {
  order?: InputMaybe<Array<DepoDestinationMappingSortInput>>;
  where?: InputMaybe<DepoDestinationMappingFilterInput>;
};


export type QueryLocationProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  order?: InputMaybe<Array<LocationProductSortInput>>;
  where?: InputMaybe<LocationProductFilterInput>;
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationSortInput>>;
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryNotificationTypesArgs = {
  order?: InputMaybe<Array<NotificationTypeSortInput>>;
  where?: InputMaybe<NotificationTypeFilterInput>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NotificationSortInput>>;
  where?: InputMaybe<NotificationFilterInput>;
};


export type QueryPaymentAccessArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryPaymentApprovalStatusArgs = {
  order?: InputMaybe<Array<PaymentApprovalStatusSortInput>>;
  where?: InputMaybe<PaymentApprovalStatusFilterInput>;
};


export type QueryPaymentApprovalTypeArgs = {
  order?: InputMaybe<Array<PaymentApprovalTypeSortInput>>;
  where?: InputMaybe<PaymentApprovalTypeFilterInput>;
};


export type QueryPaymentApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentApprovalSortInput>>;
  where?: InputMaybe<PaymentApprovalFilterInput>;
};


export type QueryPaymentImageDownloadUrlArgs = {
  blobName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type QueryPaymentModesArgs = {
  order?: InputMaybe<Array<PaymentModeSortInput>>;
  where?: InputMaybe<PaymentModeFilterInput>;
};


export type QueryPaymentTranscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentTranscriptionSortInput>>;
  where?: InputMaybe<PaymentTranscriptionFilterInput>;
};


export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentSortInput>>;
  where?: InputMaybe<PaymentFilterInput>;
};


export type QueryPredefinedReportFiltersArgs = {
  order?: InputMaybe<Array<PredefinedReportFilterSortInput>>;
  where?: InputMaybe<PredefinedReportFilterFilterInput>;
};


export type QueryProductConstraintsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductConstraintSortInput>>;
  where?: InputMaybe<ProductConstraintFilterInput>;
};


export type QueryProductMeasurementsArgs = {
  order?: InputMaybe<Array<ProductMeasurementSortInput>>;
  where?: InputMaybe<ProductMeasurementFilterInput>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductSortInput>>;
  where?: InputMaybe<ProductFilterInput>;
};


export type QueryReasonTypesArgs = {
  order?: InputMaybe<Array<ReasonTypeSortInput>>;
  where?: InputMaybe<ReasonTypeFilterInput>;
};


export type QueryReasonsArgs = {
  order?: InputMaybe<Array<ReasonSortInput>>;
  where?: InputMaybe<ReasonFilterInput>;
};


export type QueryRemainingBalanceForPaymentReferenceArgs = {
  documentReference: Scalars['String']['input'];
};


export type QueryRevenueGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySalesVoucherItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherItemSortInput>>;
  where?: InputMaybe<SalesVoucherItemFilterInput>;
};


export type QuerySalesVoucherOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherOrderSortInput>>;
  where?: InputMaybe<SalesVoucherOrderFilterInput>;
};


export type QuerySalesVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherSortInput>>;
  where?: InputMaybe<SalesVoucherFilterInput>;
};


export type QuerySalesVouchersByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherSortInput>>;
  where?: InputMaybe<SalesVoucherFilterInput>;
};


export type QuerySalesVouchersInBasketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  basketOrderItemId: Scalars['Int']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherSortInput>>;
  where?: InputMaybe<SalesVoucherFilterInput>;
};


export type QuerySettlementBanksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SettlementBankSortInput>>;
  where?: InputMaybe<SettlementBankFilterInput>;
};


export type QuerySoldProductsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SupplierSortInput>>;
  where?: InputMaybe<SupplierFilterInput>;
};


export type QueryTermsAndConditionsArgs = {
  order?: InputMaybe<Array<TermsAndConditionSortInput>>;
  where?: InputMaybe<TermsAndConditionFilterInput>;
};


export type QueryTopProductsOrderedArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTotalSalesVolumeArgs = {
  companyId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTrackingInfoArgs = {
  salesOrderNumber: Scalars['String']['input'];
};


export type QueryTransactionSummaryArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryTransportRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyIds: Array<Scalars['Int']['input']>;
  driverRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TransportRequestResponseSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransportRequestResponseFilterInput>;
};


export type QueryUnitsOfMeasureArgs = {
  order?: InputMaybe<Array<UnitOfMeasureSortInput>>;
  where?: InputMaybe<UnitOfMeasureFilterInput>;
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserMhcPermissionsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserMhcRolesArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NotificationUserSortInput>>;
  where?: InputMaybe<NotificationUserFilterInput>;
};


export type QueryUserPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PaymentSortInput>>;
  where?: InputMaybe<PaymentFilterInput>;
};


export type QueryUserTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TransactionSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryUsersByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryVehicleRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyIds: Array<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleRequestResponseSortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VehicleRequestResponseFilterInput>;
};


export type QueryVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleSortInput>>;
  where?: InputMaybe<VehicleFilterInput>;
};

export type QuotationValidationData = {
  __typename?: 'QuotationValidationData';
  customerRef?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Driver>;
  driverLicenseNumber: Scalars['String']['output'];
  isCustomerRefValid: Scalars['Boolean']['output'];
  isDriverLicenseNumberValid: Scalars['Boolean']['output'];
  isProductCodeValid: Scalars['Boolean']['output'];
  isQuantityValid: Scalars['Boolean']['output'];
  isTruckNumberValid: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  vehicle?: Maybe<Vehicle>;
  vehicleNumber: Scalars['String']['output'];
};

export type QuotationValidationInputDataInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNumber: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  vehicleNumber: Scalars['String']['input'];
};

export type ReadAllUserNotificationPayload = {
  __typename?: 'ReadAllUserNotificationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ReadUserNotificationInput = {
  notificationId: Scalars['Int']['input'];
};

export type ReadUserNotificationPayload = {
  __typename?: 'ReadUserNotificationPayload';
  notificationUser?: Maybe<NotificationUser>;
};

export type Reason = {
  __typename?: 'Reason';
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  locationId: Scalars['Int']['output'];
  reasonType: ReasonType;
  reasonTypeId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReasonFilterInput = {
  and?: InputMaybe<Array<ReasonFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  detail?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReasonFilterInput>>;
  reasonType?: InputMaybe<ReasonTypeFilterInput>;
  reasonTypeId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ReasonSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  detail?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  reasonType?: InputMaybe<ReasonTypeSortInput>;
  reasonTypeId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ReasonType = {
  __typename?: 'ReasonType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type ReasonTypeFilterInput = {
  and?: InputMaybe<Array<ReasonTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReasonTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type ReasonTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type RejectPendingDeliveryDateInput = {
  rejectionReason: Scalars['String']['input'];
  salesVoucherItemId: Scalars['Int']['input'];
};

export type RejectPendingDeliveryDatePayload = {
  __typename?: 'RejectPendingDeliveryDatePayload';
  salesVoucherItem?: Maybe<SalesVoucherItem>;
};

export type RemoveCustomerDestinationInput = {
  customerId: Scalars['Int']['input'];
  destinationId: Scalars['Int']['input'];
};

export type RemoveCustomerDestinationPayload = {
  __typename?: 'RemoveCustomerDestinationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLocationDestinationInput = {
  destinationId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};

export type RemoveLocationDestinationPayload = {
  __typename?: 'RemoveLocationDestinationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLocationMappingInput = {
  id: Scalars['Int']['input'];
};

export type RemoveLocationMappingPayload = {
  __typename?: 'RemoveLocationMappingPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLocationProductInput = {
  locationId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type RemoveLocationProductPayload = {
  __typename?: 'RemoveLocationProductPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveUserDeviceInput = {
  token: Scalars['String']['input'];
};

export type RemoveUserDevicePayload = {
  __typename?: 'RemoveUserDevicePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveUserFromMailingGroupInput = {
  id: Scalars['Int']['input'];
};

export type RemoveUserFromMailingGroupPayload = {
  __typename?: 'RemoveUserFromMailingGroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportType = {
  __typename?: 'ReportType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type ReportTypeFilterInput = {
  and?: InputMaybe<Array<ReportTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReportTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type ReportTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type RequestAccountDeletionPayload = {
  __typename?: 'RequestAccountDeletionPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestAccountDeletionWhenLoggedOutInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['Long']['input']>;
};

export type RequestAccountDeletionWhenLoggedOutPayload = {
  __typename?: 'RequestAccountDeletionWhenLoggedOutPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendCustomerOtpData = {
  __typename?: 'ResendCustomerOtpData';
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ResendCustomerOtpResponse = {
  __typename?: 'ResendCustomerOtpResponse';
  data?: Maybe<ResendCustomerOtpData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type ResendEcobankDirectDebitCustomerOnboardingOtpInput = {
  accountNumber: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type ResendEcobankDirectDebitCustomerOnboardingOtpPayload = {
  __typename?: 'ResendEcobankDirectDebitCustomerOnboardingOtpPayload';
  resendCustomerOtpResponse?: Maybe<ResendCustomerOtpResponse>;
};

export type ResolveSalesOrderAmendmentInput = {
  decision: SalesOrderModificationRequestDecisionEnum;
  itemIds: Array<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  salesVoucherId: Scalars['Int']['input'];
};

export type ResolveSalesOrderAmendmentPayload = {
  __typename?: 'ResolveSalesOrderAmendmentPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type ResolveVoidOrderRequestInput = {
  decision: SalesOrderModificationRequestDecisionEnum;
  reason?: InputMaybe<Scalars['String']['input']>;
  salesVoucherId: Scalars['Int']['input'];
  voucherItems: Array<Scalars['Int']['input']>;
};

export type ResolveVoidOrderRequestPayload = {
  __typename?: 'ResolveVoidOrderRequestPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type RetractAccountDeletionPayload = {
  __typename?: 'RetractAccountDeletionPayload';
  user?: Maybe<User>;
};

export type RetryPaymentJournalPostingBodGenerationInput = {
  paymentId: Scalars['Int']['input'];
};

export type RetryPaymentJournalPostingBodGenerationPayload = {
  __typename?: 'RetryPaymentJournalPostingBodGenerationPayload';
  bodRetryResult?: Maybe<BodRetryResult>;
};

export type RetryQuotationBodGenerationInput = {
  salesVoucherId: Scalars['Int']['input'];
  salesVoucherItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RetryQuotationBodGenerationPayload = {
  __typename?: 'RetryQuotationBodGenerationPayload';
  bodRetryResult?: Maybe<BodRetryResult>;
};

export type RetrySalesOrderBodGenerationInput = {
  salesVoucherId: Scalars['Int']['input'];
  salesVoucherItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RetrySalesOrderBodGenerationPayload = {
  __typename?: 'RetrySalesOrderBodGenerationPayload';
  bodRetryResult?: Maybe<BodRetryResult>;
};

export type RetryVoidSalesOrderBodGenerationInput = {
  salesVoucherId: Scalars['Int']['input'];
  salesVoucherItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RetryVoidSalesOrderBodGenerationPayload = {
  __typename?: 'RetryVoidSalesOrderBodGenerationPayload';
  bodRetryResult?: Maybe<BodRetryResult>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isInternal: Scalars['Boolean']['output'];
  mhcIdentifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  translationKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};

export type RoleFilterInput = {
  and?: InputMaybe<Array<RoleFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInternal?: InputMaybe<BooleanOperationFilterInput>;
  mhcIdentifier?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
};

export type RoleSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isInternal?: InputMaybe<SortEnumType>;
  mhcIdentifier?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type S2bCheckTransactionStatusResponse = {
  __typename?: 'S2bCheckTransactionStatusResponse';
  status: Scalars['String']['output'];
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type SalesOrderAmendmentRequests = {
  __typename?: 'SalesOrderAmendmentRequests';
  amendmentRequest: AmendmentRequest;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  decision: SalesOrderModificationRequestDecision;
  decisionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  previousStatusId: Scalars['Int']['output'];
  salesVoucher: SalesVoucher;
  salesVoucherId: Scalars['Int']['output'];
  salesVoucherItem: SalesVoucherItem;
  salesVoucherItemId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesOrderAmendmentRequestsFilterInput = {
  amendmentRequest?: InputMaybe<AmendmentRequestFilterInput>;
  and?: InputMaybe<Array<SalesOrderAmendmentRequestsFilterInput>>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  decision?: InputMaybe<SalesOrderModificationRequestDecisionFilterInput>;
  decisionId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesOrderAmendmentRequestsFilterInput>>;
  previousStatusId?: InputMaybe<IntOperationFilterInput>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemFilterInput>;
  salesVoucherItemId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SalesOrderBackLogReport = {
  __typename?: 'SalesOrderBackLogReport';
  totalAmount: Scalars['Float']['output'];
  totalQuantity: Scalars['Decimal']['output'];
  unitOfMeasure: Scalars['String']['output'];
};

export type SalesOrderModificationRequestDecision = {
  __typename?: 'SalesOrderModificationRequestDecision';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export enum SalesOrderModificationRequestDecisionEnum {
  Approve = 'APPROVE',
  Decline = 'DECLINE',
  Pending = 'PENDING'
}

export type SalesOrderModificationRequestDecisionFilterInput = {
  and?: InputMaybe<Array<SalesOrderModificationRequestDecisionFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesOrderModificationRequestDecisionFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVolumeReport = {
  __typename?: 'SalesVolumeReport';
  unitVolumes: Array<KeyValuePairOfUnitOfMeasureEnumAndDecimal>;
};

export type SalesVoucher = {
  __typename?: 'SalesVoucher';
  basket?: Maybe<Basket>;
  basketId?: Maybe<Scalars['Int']['output']>;
  bodGenerationHistories: Array<BodGenerationHistory>;
  comments?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['Int']['output'];
  customOrderNumber?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  customerReference?: Maybe<Scalars['String']['output']>;
  deliveryContact?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  destinationId?: Maybe<Scalars['Int']['output']>;
  featuredImageUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  localPurchaseOrder?: Maybe<Scalars['String']['output']>;
  orderQuote?: Maybe<Scalars['Decimal']['output']>;
  payments: Array<Payment>;
  quotationGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  salesOrderGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  salesVoucherDocuments: Array<SalesVoucherDocument>;
  salesVoucherHistories: Array<SalesVoucherHistory>;
  salesVoucherItems: Array<SalesVoucherItem>;
  salesVoucherOrders: Array<SalesVoucherOrder>;
  salesVoucherStatus: SalesVoucherStatus;
  salesVoucherStatusId: Scalars['Int']['output'];
  sourceLocation: Location;
  sourceLocationId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voucherNumber: Scalars['String']['output'];
};

export type SalesVoucherDocument = {
  __typename?: 'SalesVoucherDocument';
  createdAt: Scalars['DateTime']['output'];
  documentName?: Maybe<Scalars['String']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  salesVoucher: SalesVoucher;
  salesVoucherId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesVoucherDocumentFilterInput = {
  and?: InputMaybe<Array<SalesVoucherDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentName?: InputMaybe<StringOperationFilterInput>;
  documentUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherDocumentFilterInput>>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SalesVoucherFilterInput = {
  and?: InputMaybe<Array<SalesVoucherFilterInput>>;
  basket?: InputMaybe<BasketFilterInput>;
  basketId?: InputMaybe<IntOperationFilterInput>;
  bodGenerationHistories?: InputMaybe<ListFilterInputTypeOfBodGenerationHistoryFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  customOrderNumber?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerReference?: InputMaybe<StringOperationFilterInput>;
  deliveryContact?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  destination?: InputMaybe<DestinationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  featuredImageUrl?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  localPurchaseOrder?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherFilterInput>>;
  orderQuote?: InputMaybe<DecimalOperationFilterInput>;
  payments?: InputMaybe<ListFilterInputTypeOfPaymentFilterInput>;
  quotationGeneratedAt?: InputMaybe<DateTimeOperationFilterInput>;
  salesOrderGeneratedAt?: InputMaybe<DateTimeOperationFilterInput>;
  salesVoucherDocuments?: InputMaybe<ListFilterInputTypeOfSalesVoucherDocumentFilterInput>;
  salesVoucherHistories?: InputMaybe<ListFilterInputTypeOfSalesVoucherHistoryFilterInput>;
  salesVoucherItems?: InputMaybe<ListFilterInputTypeOfSalesVoucherItemFilterInput>;
  salesVoucherOrders?: InputMaybe<ListFilterInputTypeOfSalesVoucherOrderFilterInput>;
  salesVoucherStatus?: InputMaybe<SalesVoucherStatusFilterInput>;
  salesVoucherStatusId?: InputMaybe<IntOperationFilterInput>;
  sourceLocation?: InputMaybe<LocationFilterInput>;
  sourceLocationId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  voucherNumber?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherHistory = {
  __typename?: 'SalesVoucherHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  salesVoucherId: Scalars['Int']['output'];
  salesVoucherStatus: SalesVoucherStatus;
  salesVoucherStatusId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type SalesVoucherHistoryFilterInput = {
  and?: InputMaybe<Array<SalesVoucherHistoryFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherHistoryFilterInput>>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherStatus?: InputMaybe<SalesVoucherStatusFilterInput>;
  salesVoucherStatusId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type SalesVoucherItem = {
  __typename?: 'SalesVoucherItem';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerRef?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Destination>;
  destinationId?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['Int']['output']>;
  driverRequest?: Maybe<DriverRequest>;
  id: Scalars['Int']['output'];
  isDeliveryInclusive: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  project?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Decimal']['output'];
  quotationId?: Maybe<Scalars['String']['output']>;
  salesOrderAmendmentRequests: Array<SalesOrderAmendmentRequests>;
  salesVoucher: SalesVoucher;
  salesVoucherId: Scalars['Int']['output'];
  salesVoucherItemHistories: Array<SalesVoucherItemHistory>;
  salesVoucherItemStatus: SalesVoucherItemStatus;
  salesVoucherItemStatusId: Scalars['Int']['output'];
  salesVoucherOrders: Array<SalesVoucherOrder>;
  salesVoucherStatus: SalesVoucherStatus;
  salesVoucherStatusId: Scalars['Int']['output'];
  sourceLocation?: Maybe<Location>;
  sourceLocationId?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<Scalars['Decimal']['output']>;
  transitionalSalesVoucherItems: Array<TransitionalSalesVoucherItem>;
  trucksCount: Scalars['Int']['output'];
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vatCode?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
  vehicleRequest?: Maybe<VehicleRequest>;
};

export type SalesVoucherItemChangeType = {
  __typename?: 'SalesVoucherItemChangeType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type SalesVoucherItemChangeTypeFilterInput = {
  and?: InputMaybe<Array<SalesVoucherItemChangeTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherItemChangeTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherItemFilterInput = {
  and?: InputMaybe<Array<SalesVoucherItemFilterInput>>;
  cancellationReason?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  destination?: InputMaybe<DestinationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  discount?: InputMaybe<DecimalOperationFilterInput>;
  driver?: InputMaybe<DriverFilterInput>;
  driverId?: InputMaybe<IntOperationFilterInput>;
  driverRequest?: InputMaybe<DriverRequestFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDeliveryInclusive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherItemFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  project?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  quotationId?: InputMaybe<StringOperationFilterInput>;
  salesOrderAmendmentRequests?: InputMaybe<ListFilterInputTypeOfSalesOrderAmendmentRequestsFilterInput>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherItemHistories?: InputMaybe<ListFilterInputTypeOfSalesVoucherItemHistoryFilterInput>;
  salesVoucherItemStatus?: InputMaybe<SalesVoucherItemStatusFilterInput>;
  salesVoucherItemStatusId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherOrders?: InputMaybe<ListFilterInputTypeOfSalesVoucherOrderFilterInput>;
  salesVoucherStatus?: InputMaybe<SalesVoucherStatusFilterInput>;
  salesVoucherStatusId?: InputMaybe<IntOperationFilterInput>;
  sourceLocation?: InputMaybe<LocationFilterInput>;
  sourceLocationId?: InputMaybe<IntOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierId?: InputMaybe<IntOperationFilterInput>;
  tax?: InputMaybe<DecimalOperationFilterInput>;
  totalPrice?: InputMaybe<DecimalOperationFilterInput>;
  transitionalSalesVoucherItems?: InputMaybe<ListFilterInputTypeOfTransitionalSalesVoucherItemFilterInput>;
  trucksCount?: InputMaybe<IntOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  vatCode?: InputMaybe<StringOperationFilterInput>;
  vehicle?: InputMaybe<VehicleFilterInput>;
  vehicleId?: InputMaybe<IntOperationFilterInput>;
  vehicleRequest?: InputMaybe<VehicleRequestFilterInput>;
};

export type SalesVoucherItemHistory = {
  __typename?: 'SalesVoucherItemHistory';
  changeType: SalesVoucherItemChangeType;
  changeTypeId: Scalars['Int']['output'];
  changedByUser: User;
  changedByUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isCustomerInitiated: Scalars['Boolean']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  salesVoucherItem: SalesVoucherItem;
  salesVoucherItemId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesVoucherItemHistoryFilterInput = {
  and?: InputMaybe<Array<SalesVoucherItemHistoryFilterInput>>;
  changeType?: InputMaybe<SalesVoucherItemChangeTypeFilterInput>;
  changeTypeId?: InputMaybe<IntOperationFilterInput>;
  changedByUser?: InputMaybe<UserFilterInput>;
  changedByUserId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isCustomerInitiated?: InputMaybe<BooleanOperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherItemHistoryFilterInput>>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemFilterInput>;
  salesVoucherItemId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SalesVoucherItemInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['Int']['input']>;
  driverRequestInput?: InputMaybe<DriverRequestInput>;
  isDeliveryInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Decimal']['input'];
  sourceLocationId?: InputMaybe<Scalars['Int']['input']>;
  trucksCount: Scalars['Int']['input'];
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vehicleRequestInput?: InputMaybe<VehicleRequestInput>;
};

export type SalesVoucherItemSortInput = {
  cancellationReason?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<DestinationSortInput>;
  destinationId?: InputMaybe<SortEnumType>;
  discount?: InputMaybe<SortEnumType>;
  driver?: InputMaybe<DriverSortInput>;
  driverId?: InputMaybe<SortEnumType>;
  driverRequest?: InputMaybe<DriverRequestSortInput>;
  id?: InputMaybe<SortEnumType>;
  isDeliveryInclusive?: InputMaybe<SortEnumType>;
  product?: InputMaybe<ProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  project?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  quotationId?: InputMaybe<SortEnumType>;
  salesVoucher?: InputMaybe<SalesVoucherSortInput>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  salesVoucherItemStatus?: InputMaybe<SalesVoucherItemStatusSortInput>;
  salesVoucherItemStatusId?: InputMaybe<SortEnumType>;
  salesVoucherStatus?: InputMaybe<SalesVoucherStatusSortInput>;
  salesVoucherStatusId?: InputMaybe<SortEnumType>;
  sourceLocation?: InputMaybe<LocationSortInput>;
  sourceLocationId?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierId?: InputMaybe<SortEnumType>;
  tax?: InputMaybe<SortEnumType>;
  totalPrice?: InputMaybe<SortEnumType>;
  trucksCount?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  vatCode?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<VehicleSortInput>;
  vehicleId?: InputMaybe<SortEnumType>;
  vehicleRequest?: InputMaybe<VehicleRequestSortInput>;
};

export type SalesVoucherItemStatus = {
  __typename?: 'SalesVoucherItemStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type SalesVoucherItemStatusFilterInput = {
  and?: InputMaybe<Array<SalesVoucherItemStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherItemStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherItemStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SalesVoucherItemsConnection = {
  __typename?: 'SalesVoucherItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesVoucherItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucherItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesVoucherItemsEdge = {
  __typename?: 'SalesVoucherItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucherItem;
};

export type SalesVoucherOrder = {
  __typename?: 'SalesVoucherOrder';
  amountTotal?: Maybe<Scalars['Decimal']['output']>;
  amountUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  amountVAT?: Maybe<Scalars['Decimal']['output']>;
  bankRef?: Maybe<Scalars['String']['output']>;
  businessUnitLine?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  costCentre?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  customerRef?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  destinationId?: Maybe<Scalars['Int']['output']>;
  driverLicenseNo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoicePostingDate?: Maybe<Scalars['DateTime']['output']>;
  location: Location;
  locationId: Scalars['Int']['output'];
  mizaniTicket?: Maybe<Scalars['String']['output']>;
  orderStatus: OrderStatus;
  orderStatusId: Scalars['Int']['output'];
  paymentRef?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Decimal']['output'];
  quotationId?: Maybe<Scalars['String']['output']>;
  salesInvoiceCreated?: Maybe<Scalars['DateTime']['output']>;
  salesInvoiceNumber?: Maybe<Scalars['String']['output']>;
  salesOrderCreated?: Maybe<Scalars['DateTime']['output']>;
  salesOrderLineNum?: Maybe<Scalars['Int']['output']>;
  salesOrderNumber: Scalars['String']['output'];
  salesType?: Maybe<Scalars['String']['output']>;
  salesVoucher?: Maybe<SalesVoucher>;
  salesVoucherId?: Maybe<Scalars['Int']['output']>;
  salesVoucherItem?: Maybe<SalesVoucherItem>;
  salesVoucherItemId?: Maybe<Scalars['Int']['output']>;
  salesVoucherOrderStatus: SalesVoucherOrderStatus;
  salesVoucherOrderStatusId: Scalars['Int']['output'];
  transporterCode?: Maybe<Scalars['String']['output']>;
  uoS?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicleNumber?: Maybe<Scalars['String']['output']>;
};

export type SalesVoucherOrderFilterInput = {
  amountTotal?: InputMaybe<DecimalOperationFilterInput>;
  amountUnitPrice?: InputMaybe<DecimalOperationFilterInput>;
  amountVAT?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<SalesVoucherOrderFilterInput>>;
  bankRef?: InputMaybe<StringOperationFilterInput>;
  businessUnitLine?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  costCentre?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  deliveryType?: InputMaybe<StringOperationFilterInput>;
  destination?: InputMaybe<DestinationFilterInput>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  driverLicenseNo?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  invoicePostingDate?: InputMaybe<DateTimeOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  mizaniTicket?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherOrderFilterInput>>;
  orderStatus?: InputMaybe<OrderStatusFilterInput>;
  orderStatusId?: InputMaybe<IntOperationFilterInput>;
  paymentRef?: InputMaybe<StringOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  quotationId?: InputMaybe<StringOperationFilterInput>;
  salesInvoiceCreated?: InputMaybe<DateTimeOperationFilterInput>;
  salesInvoiceNumber?: InputMaybe<StringOperationFilterInput>;
  salesOrderCreated?: InputMaybe<DateTimeOperationFilterInput>;
  salesOrderLineNum?: InputMaybe<IntOperationFilterInput>;
  salesOrderNumber?: InputMaybe<StringOperationFilterInput>;
  salesType?: InputMaybe<StringOperationFilterInput>;
  salesVoucher?: InputMaybe<SalesVoucherFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemFilterInput>;
  salesVoucherItemId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherOrderStatus?: InputMaybe<SalesVoucherOrderStatusFilterInput>;
  salesVoucherOrderStatusId?: InputMaybe<IntOperationFilterInput>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  uoS?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  vehicleNumber?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherOrderSortInput = {
  amountTotal?: InputMaybe<SortEnumType>;
  amountUnitPrice?: InputMaybe<SortEnumType>;
  amountVAT?: InputMaybe<SortEnumType>;
  bankRef?: InputMaybe<SortEnumType>;
  businessUnitLine?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  costCentre?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  deliveryType?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<DestinationSortInput>;
  destinationId?: InputMaybe<SortEnumType>;
  driverLicenseNo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoicePostingDate?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  mizaniTicket?: InputMaybe<SortEnumType>;
  orderStatus?: InputMaybe<OrderStatusSortInput>;
  orderStatusId?: InputMaybe<SortEnumType>;
  paymentRef?: InputMaybe<SortEnumType>;
  product?: InputMaybe<ProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  quotationId?: InputMaybe<SortEnumType>;
  salesInvoiceCreated?: InputMaybe<SortEnumType>;
  salesInvoiceNumber?: InputMaybe<SortEnumType>;
  salesOrderCreated?: InputMaybe<SortEnumType>;
  salesOrderLineNum?: InputMaybe<SortEnumType>;
  salesOrderNumber?: InputMaybe<SortEnumType>;
  salesType?: InputMaybe<SortEnumType>;
  salesVoucher?: InputMaybe<SalesVoucherSortInput>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemSortInput>;
  salesVoucherItemId?: InputMaybe<SortEnumType>;
  salesVoucherOrderStatus?: InputMaybe<SalesVoucherOrderStatusSortInput>;
  salesVoucherOrderStatusId?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  uoS?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  vehicleNumber?: InputMaybe<SortEnumType>;
};

export type SalesVoucherOrderStatus = {
  __typename?: 'SalesVoucherOrderStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type SalesVoucherOrderStatusFilterInput = {
  and?: InputMaybe<Array<SalesVoucherOrderStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherOrderStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherOrderStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SalesVoucherOrdersConnection = {
  __typename?: 'SalesVoucherOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesVoucherOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucherOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesVoucherOrdersEdge = {
  __typename?: 'SalesVoucherOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucherOrder;
};

export type SalesVoucherSortInput = {
  basket?: InputMaybe<BasketSortInput>;
  basketId?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  customOrderNumber?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerReference?: InputMaybe<SortEnumType>;
  deliveryContact?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<DestinationSortInput>;
  destinationId?: InputMaybe<SortEnumType>;
  featuredImageUrl?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  localPurchaseOrder?: InputMaybe<SortEnumType>;
  orderQuote?: InputMaybe<SortEnumType>;
  quotationGeneratedAt?: InputMaybe<SortEnumType>;
  salesOrderGeneratedAt?: InputMaybe<SortEnumType>;
  salesVoucherStatus?: InputMaybe<SalesVoucherStatusSortInput>;
  salesVoucherStatusId?: InputMaybe<SortEnumType>;
  sourceLocation?: InputMaybe<LocationSortInput>;
  sourceLocationId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  voucherNumber?: InputMaybe<SortEnumType>;
};

export type SalesVoucherStatus = {
  __typename?: 'SalesVoucherStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type SalesVoucherStatusFilterInput = {
  and?: InputMaybe<Array<SalesVoucherStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesVoucherStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SalesVoucherStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SalesVouchersByCompanyConnection = {
  __typename?: 'SalesVouchersByCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesVouchersByCompanyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucher>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesVouchersByCompanyEdge = {
  __typename?: 'SalesVouchersByCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucher;
};

/** A connection to a list of items. */
export type SalesVouchersConnection = {
  __typename?: 'SalesVouchersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesVouchersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucher>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesVouchersEdge = {
  __typename?: 'SalesVouchersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucher;
};

/** A connection to a list of items. */
export type SalesVouchersInBasketConnection = {
  __typename?: 'SalesVouchersInBasketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesVouchersInBasketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SalesVoucher>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesVouchersInBasketEdge = {
  __typename?: 'SalesVouchersInBasketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SalesVoucher;
};

export type SendCustomerOtpData = {
  __typename?: 'SendCustomerOtpData';
  data?: Maybe<SendCustomerOtpDataDetail>;
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SendCustomerOtpDataDetail = {
  __typename?: 'SendCustomerOtpDataDetail';
  recipient?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
};

export type SendCustomerOtpResponse = {
  __typename?: 'SendCustomerOtpResponse';
  data?: Maybe<SendCustomerOtpData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type SendEcobankDirectDebitCustomerOnboardingOtpInput = {
  accountNumber: Scalars['String']['input'];
};

export type SendEcobankDirectDebitCustomerOnboardingOtpPayload = {
  __typename?: 'SendEcobankDirectDebitCustomerOnboardingOtpPayload';
  sendCustomerOtpResponse?: Maybe<SendCustomerOtpResponse>;
};

export type SetDeliveryDateInput = {
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  salesVoucherItemId: Scalars['Int']['input'];
};

export type SetDeliveryDatePayload = {
  __typename?: 'SetDeliveryDatePayload';
  salesVoucherItem?: Maybe<SalesVoucherItem>;
};

export type SettlementBank = {
  __typename?: 'SettlementBank';
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isIncoming: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sunAccountCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SettlementBankFilterInput = {
  and?: InputMaybe<Array<SettlementBankFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isIncoming?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SettlementBankFilterInput>>;
  sunAccountCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SettlementBankSortInput = {
  code?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isIncoming?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sunAccountCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SettlementBanksConnection = {
  __typename?: 'SettlementBanksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SettlementBanksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SettlementBank>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SettlementBanksEdge = {
  __typename?: 'SettlementBanksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SettlementBank;
};

export type ShortOperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']['input']>;
  gt?: InputMaybe<Scalars['Short']['input']>;
  gte?: InputMaybe<Scalars['Short']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  lt?: InputMaybe<Scalars['Short']['input']>;
  lte?: InputMaybe<Scalars['Short']['input']>;
  neq?: InputMaybe<Scalars['Short']['input']>;
  ngt?: InputMaybe<Scalars['Short']['input']>;
  ngte?: InputMaybe<Scalars['Short']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  nlt?: InputMaybe<Scalars['Short']['input']>;
  nlte?: InputMaybe<Scalars['Short']['input']>;
};

export type SocialMediaType = {
  __typename?: 'SocialMediaType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type SocialMediaTypeFilterInput = {
  and?: InputMaybe<Array<SocialMediaTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SocialMediaTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type SocialMediaTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatementRequestInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type StatementRequestPayload = {
  __typename?: 'StatementRequestPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  active: Scalars['Boolean']['output'];
  altPhoneNumber?: Maybe<Scalars['Long']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['Long']['output']>;
  supplierCode: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  transporter: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vehicles: Array<Vehicle>;
};

export type SupplierFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  altPhoneNumber?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<SupplierFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SupplierFilterInput>>;
  phoneNumber?: InputMaybe<LongOperationFilterInput>;
  supplierCode?: InputMaybe<StringOperationFilterInput>;
  supplierName?: InputMaybe<StringOperationFilterInput>;
  transporter?: InputMaybe<BooleanOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  vehicles?: InputMaybe<ListFilterInputTypeOfVehicleFilterInput>;
};

export type SupplierSortInput = {
  active?: InputMaybe<SortEnumType>;
  altPhoneNumber?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  supplierCode?: InputMaybe<SortEnumType>;
  supplierName?: InputMaybe<SortEnumType>;
  transporter?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SuppliersConnection = {
  __typename?: 'SuppliersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SuppliersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Supplier>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SuppliersEdge = {
  __typename?: 'SuppliersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Supplier;
};

export type TermsAndCondition = {
  __typename?: 'TermsAndCondition';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  termsContent: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['String']['output'];
};

export type TermsAndConditionFilterInput = {
  and?: InputMaybe<Array<TermsAndConditionFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TermsAndConditionFilterInput>>;
  termsContent?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  versionId?: InputMaybe<StringOperationFilterInput>;
};

export type TermsAndConditionSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  termsContent?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  versionId?: InputMaybe<SortEnumType>;
};

export type TopProductOrderedReport = {
  __typename?: 'TopProductOrderedReport';
  productTitle: Scalars['String']['output'];
  totalQuantity: Scalars['Decimal']['output'];
};

export type TrackingResponse = {
  __typename?: 'TrackingResponse';
  trackingProvider: Scalars['String']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Decimal']['output'];
  bankRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  debitCredit: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  journalLine: Scalars['Int']['output'];
  journalNumber: Scalars['Int']['output'];
  journalType: Scalars['String']['output'];
  ledgerAccount: Scalars['String']['output'];
  rowLastChange: Scalars['DateTime']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionReference?: Maybe<Scalars['String']['output']>;
  uniqueCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TransactionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<TransactionFilterInput>>;
  bankRef?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  debitCredit?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  journalLine?: InputMaybe<IntOperationFilterInput>;
  journalNumber?: InputMaybe<IntOperationFilterInput>;
  journalType?: InputMaybe<StringOperationFilterInput>;
  ledgerAccount?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransactionFilterInput>>;
  rowLastChange?: InputMaybe<DateTimeOperationFilterInput>;
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  transactionReference?: InputMaybe<StringOperationFilterInput>;
  uniqueCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type TransactionSortInput = {
  amount?: InputMaybe<SortEnumType>;
  bankRef?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  debitCredit?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  journalLine?: InputMaybe<SortEnumType>;
  journalNumber?: InputMaybe<SortEnumType>;
  journalType?: InputMaybe<SortEnumType>;
  ledgerAccount?: InputMaybe<SortEnumType>;
  rowLastChange?: InputMaybe<SortEnumType>;
  transactionDate?: InputMaybe<SortEnumType>;
  transactionReference?: InputMaybe<SortEnumType>;
  uniqueCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type TransactionSummaryReport = {
  __typename?: 'TransactionSummaryReport';
  totalPayments: Scalars['Decimal']['output'];
  totalTransactionVolume: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TransactionsEdge = {
  __typename?: 'TransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Transaction;
};

export type TransitionalSalesVoucherItem = {
  __typename?: 'TransitionalSalesVoucherItem';
  changeType: SalesVoucherItemChangeType;
  changeTypeId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  requestedByUser: User;
  requestedByUserId: Scalars['Int']['output'];
  salesVoucherItem: SalesVoucherItem;
  salesVoucherItemId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TransitionalSalesVoucherItemFilterInput = {
  and?: InputMaybe<Array<TransitionalSalesVoucherItemFilterInput>>;
  changeType?: InputMaybe<SalesVoucherItemChangeTypeFilterInput>;
  changeTypeId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransitionalSalesVoucherItemFilterInput>>;
  requestedByUser?: InputMaybe<UserFilterInput>;
  requestedByUserId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherItem?: InputMaybe<SalesVoucherItemFilterInput>;
  salesVoucherItemId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type TransportDriverRequest = {
  __typename?: 'TransportDriverRequest';
  createdAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  customerRef?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  licenseNo: Scalars['String']['output'];
  requestId: Scalars['Int']['output'];
  salesVoucherId: Scalars['Int']['output'];
  status: DriverRequestStatusEnum;
  voucherNumber: Scalars['String']['output'];
};

export type TransportDriverRequestFilterInput = {
  and?: InputMaybe<Array<TransportDriverRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  licenseNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransportDriverRequestFilterInput>>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<DriverRequestStatusEnumOperationFilterInput>;
  voucherNumber?: InputMaybe<StringOperationFilterInput>;
};

export type TransportDriverRequestSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  licenseNo?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  voucherNumber?: InputMaybe<SortEnumType>;
};

export type TransportRequestResponse = {
  __typename?: 'TransportRequestResponse';
  driver?: Maybe<TransportDriverRequest>;
  vehicle?: Maybe<TransportVehicleRequest>;
};

export type TransportRequestResponseFilterInput = {
  and?: InputMaybe<Array<TransportRequestResponseFilterInput>>;
  driver?: InputMaybe<TransportDriverRequestFilterInput>;
  or?: InputMaybe<Array<TransportRequestResponseFilterInput>>;
  vehicle?: InputMaybe<TransportVehicleRequestFilterInput>;
};

export type TransportRequestResponseSortInput = {
  driver?: InputMaybe<TransportDriverRequestSortInput>;
  vehicle?: InputMaybe<TransportVehicleRequestSortInput>;
};

/** A connection to a list of items. */
export type TransportRequestsConnection = {
  __typename?: 'TransportRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TransportRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TransportRequestResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TransportRequestsEdge = {
  __typename?: 'TransportRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TransportRequestResponse;
};

export type TransportVehicleRequest = {
  __typename?: 'TransportVehicleRequest';
  createdAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  customerRef?: Maybe<Scalars['String']['output']>;
  licensePlate: Scalars['String']['output'];
  requestId: Scalars['Int']['output'];
  salesVoucherId: Scalars['Int']['output'];
  status: VehicleRequestStatusEnum;
  transporterCode?: Maybe<Scalars['String']['output']>;
  voucherNumber: Scalars['String']['output'];
};

export type TransportVehicleRequestFilterInput = {
  and?: InputMaybe<Array<TransportVehicleRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  licensePlate?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransportVehicleRequestFilterInput>>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<VehicleRequestStatusEnumOperationFilterInput>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  voucherNumber?: InputMaybe<StringOperationFilterInput>;
};

export type TransportVehicleRequestSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  licensePlate?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  voucherNumber?: InputMaybe<SortEnumType>;
};

export type TriggerDirectDebitPaymentData = {
  __typename?: 'TriggerDirectDebitPaymentData';
  externalRefNo?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<Scalars['String']['output']>;
};

export type TriggerDirectDebitPaymentResponse = {
  __typename?: 'TriggerDirectDebitPaymentResponse';
  data?: Maybe<TriggerDirectDebitPaymentData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
  paymentId?: Maybe<Scalars['Int']['output']>;
};

export type TriggerEcobankDirectDebitPaymentInput = {
  accountNumber: Scalars['String']['input'];
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  salesVoucherId?: InputMaybe<Scalars['Int']['input']>;
};

export type TriggerEcobankDirectDebitPaymentPayload = {
  __typename?: 'TriggerEcobankDirectDebitPaymentPayload';
  triggerDirectDebitPaymentResponse?: Maybe<TriggerDirectDebitPaymentResponse>;
};

export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export enum UnitOfMeasureEnum {
  Kg = 'KG',
  M3 = 'M3',
  Pcs = 'PCS',
  Tons = 'TONS'
}

export type UnitOfMeasureFilterInput = {
  and?: InputMaybe<Array<UnitOfMeasureFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UnitOfMeasureFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type UnitOfMeasureSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type UnlinkUserAccountInput = {
  customerId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type UnlinkUserAccountPayload = {
  __typename?: 'UnlinkUserAccountPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomerLocationsInput = {
  customerId: Scalars['Int']['input'];
  locationIds: Array<Scalars['Int']['input']>;
};

export type UpdateCustomerLocationsPayload = {
  __typename?: 'UpdateCustomerLocationsPayload';
  customer?: Maybe<Customer>;
};

export type UpdateDriverRequestStatusInput = {
  driverRequestId: Scalars['Int']['input'];
  driverRequestStatus: DriverRequestStatusEnum;
};

export type UpdateDriverRequestStatusPayload = {
  __typename?: 'UpdateDriverRequestStatusPayload';
  driverRequest?: Maybe<DriverRequest>;
};

export type UpdateLocationMappingInput = {
  costCentre: Scalars['String']['input'];
  destinationId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  sourceLocationId: Scalars['Int']['input'];
};

export type UpdateLocationMappingPayload = {
  __typename?: 'UpdateLocationMappingPayload';
  depoDestinationMapping?: Maybe<DepoDestinationMapping>;
};

export type UpdateSalesVoucherItemInput = {
  customerRef?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  project?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSalesVoucherItemsInput = {
  existingItems: Array<UpdateSalesVoucherItemInput>;
  newItems?: InputMaybe<Array<AddSalesVoucherItemsInput>>;
};

export type UpdateSalesVoucherItemsPayload = {
  __typename?: 'UpdateSalesVoucherItemsPayload';
  salesVoucherItem?: Maybe<Array<SalesVoucherItem>>;
};

export type UpdateUserActiveInput = {
  active: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateUserActivePayload = {
  __typename?: 'UpdateUserActivePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserDefaultAccountInput = {
  customerId: Scalars['Int']['input'];
};

export type UpdateUserDefaultAccountPayload = {
  __typename?: 'UpdateUserDefaultAccountPayload';
  user?: Maybe<User>;
};

export type UpdateUserDefaultLanguageInput = {
  languageId: Scalars['Int']['input'];
};

export type UpdateUserDefaultLanguagePayload = {
  __typename?: 'UpdateUserDefaultLanguagePayload';
  user?: Maybe<User>;
};

export type UpdateUserDefaultLocationInput = {
  locationId: Scalars['Int']['input'];
};

export type UpdateUserDefaultLocationPayload = {
  __typename?: 'UpdateUserDefaultLocationPayload';
  user?: Maybe<User>;
};

export type UpdateUserInput = {
  companyId: Scalars['Int']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
  fullName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  languageId: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserLocationsInput = {
  locationIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateUserLocationsPayload = {
  __typename?: 'UpdateUserLocationsPayload';
  user?: Maybe<User>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user?: Maybe<User>;
};

export type UpdateUserProfileInput = {
  languageId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  user?: Maybe<User>;
};

export type UpdateUserTermsAndConditionPayload = {
  __typename?: 'UpdateUserTermsAndConditionPayload';
  user?: Maybe<User>;
};

export type UpdateVehicleRequestStatusInput = {
  vehicleRequestId: Scalars['Int']['input'];
  vehicleRequestStatus: VehicleRequestStatusEnum;
};

export type UpdateVehicleRequestStatusPayload = {
  __typename?: 'UpdateVehicleRequestStatusPayload';
  vehicleRequest?: Maybe<VehicleRequest>;
};

export type UpsertBankBranchInput = {
  bankId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpsertBankBranchPayload = {
  __typename?: 'UpsertBankBranchPayload';
  bankBranch?: Maybe<BankBranch>;
};

export type UpsertBankGuaranteeInput = {
  bankGuarantyRef: Scalars['String']['input'];
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditLimit: Scalars['Decimal']['input'];
  customerId: Scalars['Int']['input'];
  expiryDate: Scalars['DateTime']['input'];
  guaranteeBankId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  issuedDate: Scalars['DateTime']['input'];
  salesOfficeId: Scalars['Int']['input'];
};

export type UpsertBankGuaranteePayload = {
  __typename?: 'UpsertBankGuaranteePayload';
  bankGuarantee?: Maybe<BankGuarantee>;
};

export type UpsertBankInput = {
  code: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpsertBankPayload = {
  __typename?: 'UpsertBankPayload';
  bank?: Maybe<Bank>;
};

export type UpsertBasketOrderInput = {
  input: CreateBasketOrderInput;
};

export type UpsertBasketOrderPayload = {
  __typename?: 'UpsertBasketOrderPayload';
  basket?: Maybe<Basket>;
};

export type UpsertChequeInput = {
  actionDate: Scalars['DateTime']['input'];
  chequeNumber: Scalars['String']['input'];
  chequeStatusId?: InputMaybe<Scalars['Int']['input']>;
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['Int']['input'];
  settlementBankId: Scalars['Int']['input'];
};

export type UpsertChequePayload = {
  __typename?: 'UpsertChequePayload';
  cheque?: Maybe<Cheque>;
};

export type UpsertCompanyCurrencyInput = {
  companyId: Scalars['Int']['input'];
  currencies: Array<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCompanyCurrencyPayload = {
  __typename?: 'UpsertCompanyCurrencyPayload';
  company?: Maybe<Company>;
};

export type UpsertCompanyInput = {
  allowDepotSelection?: InputMaybe<Scalars['Boolean']['input']>;
  allowNewDriverAndVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderAmendment?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  defaultCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  defaultCurrencySymbol?: InputMaybe<Scalars['String']['input']>;
  eamOrganization: Scalars['String']['input'];
  enableInvoicesReportPage?: InputMaybe<Scalars['Boolean']['input']>;
  enableSalesOrderReportPage?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransactionReportPage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sunBusinessUnit: Scalars['String']['input'];
  useBundledBOD?: InputMaybe<Scalars['Boolean']['input']>;
  useMAPaymentInJournalPostingsBOD?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertCompanyPayload = {
  __typename?: 'UpsertCompanyPayload';
  company?: Maybe<Company>;
};

export type UpsertCompanySocialMediaInput = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  socialMediaLink: Scalars['String']['input'];
  socialMediaTypeId: Scalars['Int']['input'];
};

export type UpsertCompanySocialMediaPayload = {
  __typename?: 'UpsertCompanySocialMediaPayload';
  companySocialMedia?: Maybe<CompanySocialMedia>;
};

export type UpsertContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  physicalAddress: Scalars['String']['input'];
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  telephone: Scalars['String']['input'];
};

export type UpsertContactPayload = {
  __typename?: 'UpsertContactPayload';
  contact?: Maybe<Contact>;
};

export type UpsertContentInput = {
  contentType: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  featuredImage?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublished: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type UpsertContentPayload = {
  __typename?: 'UpsertContentPayload';
  content?: Maybe<Content>;
};

export type UpsertCurrencyInput = {
  currencyCode: Scalars['String']['input'];
  currencyName: Scalars['String']['input'];
  currencySymbol: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCurrencyPayload = {
  __typename?: 'UpsertCurrencyPayload';
  currency?: Maybe<Currency>;
};

export type UpsertCustomerInput = {
  active: Scalars['Boolean']['input'];
  altPhoneNumber?: InputMaybe<Scalars['Long']['input']>;
  code: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['Long']['input']>;
};

export type UpsertCustomerPayload = {
  __typename?: 'UpsertCustomerPayload';
  customer?: Maybe<Customer>;
};

export type UpsertCustomerVehicleInput = {
  customerId: Scalars['Int']['input'];
  vehicles?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpsertCustomerVehiclePayload = {
  __typename?: 'UpsertCustomerVehiclePayload';
  customer?: Maybe<Customer>;
};

export type UpsertDriverInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  dispatch: Scalars['Boolean']['input'];
  eamId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  isBanned: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  licenseExpDate?: InputMaybe<Scalars['Date']['input']>;
  licenseNo: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  receiving: Scalars['Boolean']['input'];
  transporterCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDriverPayload = {
  __typename?: 'UpsertDriverPayload';
  driver?: Maybe<Driver>;
};

export type UpsertDriverSyncDataInput = {
  drivers: Array<IlDriverInput>;
};

export type UpsertDriverSyncDataPayload = {
  __typename?: 'UpsertDriverSyncDataPayload';
  driver?: Maybe<Array<Driver>>;
};

export type UpsertEPaymentAccountNumberInput = {
  accountId: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  epaymentProvider: Scalars['Int']['input'];
};

export type UpsertEPaymentAccountNumberPayload = {
  __typename?: 'UpsertEPaymentAccountNumberPayload';
  ePaymentAccountNumbers?: Maybe<EPaymentAccountNumbers>;
};

export type UpsertEPaymentProviderSettlementBankMappingInput = {
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ePaymentProviderId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  settlementBankId: Scalars['Int']['input'];
};

export type UpsertEPaymentProviderSettlementBankMappingPayload = {
  __typename?: 'UpsertEPaymentProviderSettlementBankMappingPayload';
  ePaymentProviderSettlementBankMapping?: Maybe<EPaymentProviderSettlementBankMapping>;
};

export type UpsertLocationInput = {
  allowBasketOrders: Scalars['Boolean']['input'];
  allowBulkOrder?: InputMaybe<Scalars['Boolean']['input']>;
  allowDeliveryTypeSelection?: InputMaybe<Scalars['Boolean']['input']>;
  allowDestinationSelectionFromMasterData: Scalars['Boolean']['input'];
  allowDriverSelection?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverSelectionForDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderReference?: InputMaybe<Scalars['Boolean']['input']>;
  allowStandAlonePayment?: InputMaybe<Scalars['Boolean']['input']>;
  allowTruckSelection?: InputMaybe<Scalars['Boolean']['input']>;
  allowTruckSelectionForDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmNewSOs?: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitLine?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  costCentre?: InputMaybe<Scalars['String']['input']>;
  defaultDeliveryType?: InputMaybe<Scalars['String']['input']>;
  defaultTransporter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  parentLocationId?: InputMaybe<Scalars['Int']['input']>;
  pmEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  quotationRentionDuration?: InputMaybe<Scalars['Int']['input']>;
  requireDestinationSelectionForExworks: Scalars['Boolean']['input'];
  requireFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  truckSelectionAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  truckSelectionFromMasterAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  useComments?: InputMaybe<Scalars['Boolean']['input']>;
  useConfirmQuotation?: InputMaybe<Scalars['Boolean']['input']>;
  useDeliveredOrderManagement: Scalars['Boolean']['input'];
  useDeliveryContact?: InputMaybe<Scalars['Boolean']['input']>;
  useDescription?: InputMaybe<Scalars['Boolean']['input']>;
  useFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  useLocalPoNumber?: InputMaybe<Scalars['Boolean']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertLocationPayload = {
  __typename?: 'UpsertLocationPayload';
  location?: Maybe<Location>;
};

export type UpsertLocationProductInput = {
  costCentre: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type UpsertLocationProductPayload = {
  __typename?: 'UpsertLocationProductPayload';
  locationProduct?: Maybe<LocationProduct>;
};

export type UpsertPaymentApprovalInput = {
  amountApproved: Scalars['Decimal']['input'];
  approvalComment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentApprovalStatusId: Scalars['Int']['input'];
  paymentApprovalTypeId: Scalars['Int']['input'];
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['Int']['input'];
  reasonId?: InputMaybe<Scalars['Int']['input']>;
  rejectionComment?: InputMaybe<Scalars['String']['input']>;
  settlementBankId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPaymentApprovalPayload = {
  __typename?: 'UpsertPaymentApprovalPayload';
  paymentApproval?: Maybe<PaymentApproval>;
};

export type UpsertPaymentInput = {
  amount: Scalars['Decimal']['input'];
  availableBalanceRef?: InputMaybe<Scalars['String']['input']>;
  customReference?: InputMaybe<Scalars['String']['input']>;
  customerTranscriptionItemInput?: InputMaybe<CustomerTranscriptionItemInput>;
  documentStatusId?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentModeId: Scalars['Int']['input'];
  paymentStatusId?: InputMaybe<Scalars['Int']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  salesVoucherId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPaymentPayload = {
  __typename?: 'UpsertPaymentPayload';
  payment?: Maybe<Payment>;
};

export type UpsertPaymentTranscriptionInput = {
  amount: Scalars['Decimal']['input'];
  availableBalanceRef?: InputMaybe<Scalars['String']['input']>;
  bankBranchId?: InputMaybe<Scalars['Int']['input']>;
  bankId?: InputMaybe<Scalars['Int']['input']>;
  depositorContact?: InputMaybe<Scalars['String']['input']>;
  depositorName?: InputMaybe<Scalars['String']['input']>;
  documentDate: Scalars['DateTime']['input'];
  documentReference?: InputMaybe<Scalars['String']['input']>;
  documentTypeId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['Int']['input'];
  paymentTranscriptionStatusId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPaymentTranscriptionPayload = {
  __typename?: 'UpsertPaymentTranscriptionPayload';
  paymentTranscription?: Maybe<PaymentTranscription>;
};

export type UpsertPredefinedReportFilterInput = {
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  reportTypeId: Scalars['Int']['input'];
};

export type UpsertPredefinedReportFilterPayload = {
  __typename?: 'UpsertPredefinedReportFilterPayload';
  predefinedReportFilter?: Maybe<PredefinedReportFilter>;
};

export type UpsertProductConstraintInput = {
  companyId: Scalars['Int']['input'];
  customerSegmentId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxProductQuantity: Scalars['Long']['input'];
  maxTruckQuantity: Scalars['Long']['input'];
  minProductQuantity: Scalars['Long']['input'];
  minTruckQuantity: Scalars['Long']['input'];
  productId: Scalars['Int']['input'];
};

export type UpsertProductConstraintPayload = {
  __typename?: 'UpsertProductConstraintPayload';
  productConstraint?: Maybe<ProductConstraint>;
};

export type UpsertProductInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['Upload']['input']>;
  featuredImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  productMeasurementId: Scalars['Int']['input'];
  sunItemCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
  titleColor?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId: Scalars['Int']['input'];
  uos?: InputMaybe<Scalars['String']['input']>;
  weighPiece: Scalars['Decimal']['input'];
};

export type UpsertProductPayload = {
  __typename?: 'UpsertProductPayload';
  product?: Maybe<Product>;
};

export type UpsertSmsConfigurationInput = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  login: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  url: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type UpsertSmsConfigurationPayload = {
  __typename?: 'UpsertSMSConfigurationPayload';
  companySMS?: Maybe<CompanySms>;
};

export type UpsertSalesVoucherInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  customerReference?: InputMaybe<Scalars['String']['input']>;
  deliveryContact?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  featuredImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeliveryInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  localPurchaseOrder?: InputMaybe<Scalars['String']['input']>;
  salesVoucherItemInputs: Array<SalesVoucherItemInput>;
  sourceLocationId: Scalars['Int']['input'];
};

export type UpsertSalesVoucherPayload = {
  __typename?: 'UpsertSalesVoucherPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type UpsertSettlementBankInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  isIncoming: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sunAccountCode: Scalars['String']['input'];
};

export type UpsertSettlementBankPayload = {
  __typename?: 'UpsertSettlementBankPayload';
  settlementBank?: Maybe<SettlementBank>;
};

export type UpsertSupplierInput = {
  active: Scalars['Boolean']['input'];
  altPhoneNumber?: InputMaybe<Scalars['Long']['input']>;
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['Long']['input']>;
  supplierCode: Scalars['String']['input'];
  supplierName: Scalars['String']['input'];
  transporter: Scalars['Boolean']['input'];
};

export type UpsertSupplierPayload = {
  __typename?: 'UpsertSupplierPayload';
  supplier?: Maybe<Supplier>;
};

export type UpsertSupplierSyncDataInput = {
  suppliers: Array<IlSupplierInput>;
};

export type UpsertSupplierSyncDataPayload = {
  __typename?: 'UpsertSupplierSyncDataPayload';
  supplier?: Maybe<Array<Supplier>>;
};

export type UpsertTermsAndConditionInput = {
  companyId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
};

export type UpsertTermsAndConditionPayload = {
  __typename?: 'UpsertTermsAndConditionPayload';
  termsAndCondition?: Maybe<TermsAndCondition>;
};

export type UpsertUserDeviceInput = {
  token: Scalars['String']['input'];
  userDeviceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserDevicePayload = {
  __typename?: 'UpsertUserDevicePayload';
  userDevice?: Maybe<UserDevice>;
};

export type UpsertUserNotificationPreferenceInput = {
  notificationPreferenceTypes: Array<Scalars['Int']['input']>;
};

export type UpsertUserNotificationPreferencePayload = {
  __typename?: 'UpsertUserNotificationPreferencePayload';
  user?: Maybe<User>;
};

export type UpsertVehicleInput = {
  capacity?: InputMaybe<Scalars['Decimal']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  dispatch: Scalars['Boolean']['input'];
  eamId?: InputMaybe<Scalars['String']['input']>;
  forHire?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  insurancePolicyNo?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isBanned: Scalars['Boolean']['input'];
  maxWeight?: InputMaybe<Scalars['Decimal']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  receiving: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  tare?: InputMaybe<Scalars['Decimal']['input']>;
  trackingPhoneNo?: InputMaybe<Scalars['String']['input']>;
  trackingRefNo?: InputMaybe<Scalars['String']['input']>;
  transporterCode?: InputMaybe<Scalars['String']['input']>;
  vehicleNo: Scalars['String']['input'];
  vehicleTypeId: Scalars['Int']['input'];
};

export type UpsertVehiclePayload = {
  __typename?: 'UpsertVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type UpsertVehicleSupplierInput = {
  suppliers?: InputMaybe<Array<Scalars['Int']['input']>>;
  vehicleId: Scalars['Int']['input'];
};

export type UpsertVehicleSupplierPayload = {
  __typename?: 'UpsertVehicleSupplierPayload';
  vehicle?: Maybe<Vehicle>;
};

export type UpsertVehicleSyncDataInput = {
  vehicles: Array<IlVehicleInput>;
};

export type UpsertVehicleSyncDataPayload = {
  __typename?: 'UpsertVehicleSyncDataPayload';
  vehicle?: Maybe<Array<Vehicle>>;
};

export type User = {
  __typename?: 'User';
  companies: Array<Company>;
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerRoles?: Maybe<Array<CustomerUserRole>>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  language: Language;
  languageId: Scalars['Int']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locations: Array<Location>;
  notificationPreferenceTypes: Array<NotificationPreferenceType>;
  notificationUsers: Array<NotificationUser>;
  permissions: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['Long']['output']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['Int']['output']>;
  roles: Array<Role>;
  termsAndCondition?: Maybe<TermsAndCondition>;
  termsAndConditionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAccountDeletionHistory: Array<UserAccountDeletionHistory>;
  userAccountDeletionStatus: UserAccountDeletionStatus;
  userAccountDeletionStatusId: Scalars['Int']['output'];
  userDevices: Array<UserDevice>;
  userName: Scalars['String']['output'];
};

export type UserAccountDeletionHistory = {
  __typename?: 'UserAccountDeletionHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userAccountDeletionStatus: UserAccountDeletionStatus;
  userAccountDeletionStatusId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserAccountDeletionHistoryFilterInput = {
  and?: InputMaybe<Array<UserAccountDeletionHistoryFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UserAccountDeletionHistoryFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userAccountDeletionStatus?: InputMaybe<UserAccountDeletionStatusFilterInput>;
  userAccountDeletionStatusId?: InputMaybe<IntOperationFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type UserAccountDeletionStatus = {
  __typename?: 'UserAccountDeletionStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type UserAccountDeletionStatusFilterInput = {
  and?: InputMaybe<Array<UserAccountDeletionStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UserAccountDeletionStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type UserAccountDeletionStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  createdAt: Scalars['DateTime']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UserDeviceFilterInput = {
  and?: InputMaybe<Array<UserDeviceFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UserDeviceFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerRoles?: InputMaybe<ListFilterInputTypeOfCustomerUserRoleFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<LanguageFilterInput>;
  languageId?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  notificationPreferenceTypes?: InputMaybe<ListFilterInputTypeOfNotificationPreferenceTypeFilterInput>;
  notificationUsers?: InputMaybe<ListFilterInputTypeOfNotificationUserFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  permissions?: InputMaybe<ListStringOperationFilterInput>;
  phoneNumber?: InputMaybe<LongOperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<IntOperationFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  termsAndCondition?: InputMaybe<TermsAndConditionFilterInput>;
  termsAndConditionId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  userAccountDeletionHistory?: InputMaybe<ListFilterInputTypeOfUserAccountDeletionHistoryFilterInput>;
  userAccountDeletionStatus?: InputMaybe<UserAccountDeletionStatusFilterInput>;
  userAccountDeletionStatusId?: InputMaybe<IntOperationFilterInput>;
  userDevices?: InputMaybe<ListFilterInputTypeOfUserDeviceFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type UserNotificationsConnection = {
  __typename?: 'UserNotificationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserNotificationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NotificationUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserNotificationsEdge = {
  __typename?: 'UserNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NotificationUser;
};

/** A connection to a list of items. */
export type UserPaymentsConnection = {
  __typename?: 'UserPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserPaymentsEdge = {
  __typename?: 'UserPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

export type UserSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  language?: InputMaybe<LanguageSortInput>;
  languageId?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
  termsAndCondition?: InputMaybe<TermsAndConditionSortInput>;
  termsAndConditionId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  userAccountDeletionStatus?: InputMaybe<UserAccountDeletionStatusSortInput>;
  userAccountDeletionStatusId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UserTransactionsConnection = {
  __typename?: 'UserTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserTransactionsEdge = {
  __typename?: 'UserTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Transaction;
};

/** A connection to a list of items. */
export type UsersByCompanyConnection = {
  __typename?: 'UsersByCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersByCompanyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersByCompanyEdge = {
  __typename?: 'UsersByCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValidateCustomerOtpData = {
  __typename?: 'ValidateCustomerOtpData';
  data?: Maybe<ValidateCustomerOtpDataDetail>;
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  otpValidationStatus?: Maybe<Scalars['String']['output']>;
};

export type ValidateCustomerOtpDataDetail = {
  __typename?: 'ValidateCustomerOtpDataDetail';
  affiliateCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  objectId?: Maybe<Scalars['String']['output']>;
  registrationChannelCode?: Maybe<Scalars['String']['output']>;
  registrationChannelName?: Maybe<Scalars['String']['output']>;
  setupData?: Maybe<ValidateCustomerOtpSetupData>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ValidateCustomerOtpResponse = {
  __typename?: 'ValidateCustomerOtpResponse';
  data?: Maybe<ValidateCustomerOtpData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type ValidateCustomerOtpSetupData = {
  __typename?: 'ValidateCustomerOtpSetupData';
  qrCodeImageUrl?: Maybe<Scalars['String']['output']>;
  setupCode?: Maybe<Scalars['String']['output']>;
};

export type ValidateDeliveredOrderItemsInput = {
  items: Array<DeliveredItemValidationInput>;
};

export type ValidateDeliveredOrderItemsPayload = {
  __typename?: 'ValidateDeliveredOrderItemsPayload';
  deliveredItemValidationResult?: Maybe<Array<DeliveredItemValidationResult>>;
};

export type ValidateDirectDebitPaymentData = {
  __typename?: 'ValidateDirectDebitPaymentData';
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidateDirectDebitPaymentResponse = {
  __typename?: 'ValidateDirectDebitPaymentResponse';
  data?: Maybe<ValidateDirectDebitPaymentData>;
  headerResponse?: Maybe<EcobankHeaderResponse>;
};

export type ValidateEcobankDirectDebitCustomerOnboardingOtpInput = {
  accountNumber: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type ValidateEcobankDirectDebitCustomerOnboardingOtpPayload = {
  __typename?: 'ValidateEcobankDirectDebitCustomerOnboardingOtpPayload';
  validateCustomerOtpResponse?: Maybe<ValidateCustomerOtpResponse>;
};

export type ValidateEcobankDirectDebitPaymentInput = {
  paymentId: Scalars['Int']['input'];
  totp: Scalars['String']['input'];
};

export type ValidateEcobankDirectDebitPaymentPayload = {
  __typename?: 'ValidateEcobankDirectDebitPaymentPayload';
  validateDirectDebitPaymentResponse?: Maybe<ValidateDirectDebitPaymentResponse>;
};

export type ValidateQuotationDataInput = {
  quotationValidationInputData: Array<QuotationValidationInputDataInput>;
};

export type ValidateQuotationDataPayload = {
  __typename?: 'ValidateQuotationDataPayload';
  quotationValidationData?: Maybe<Array<QuotationValidationData>>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  capacity?: Maybe<Scalars['Decimal']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customers: Array<Customer>;
  dispatch: Scalars['Boolean']['output'];
  eamId?: Maybe<Scalars['String']['output']>;
  forHire?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  insuranceExpiryDate?: Maybe<Scalars['Date']['output']>;
  insurancePolicyNo?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isBanned: Scalars['Boolean']['output'];
  maxWeight?: Maybe<Scalars['Decimal']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  receiving: Scalars['Boolean']['output'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['Int']['output']>;
  suppliers: Array<Supplier>;
  tare?: Maybe<Scalars['Decimal']['output']>;
  trackingPhoneNo?: Maybe<Scalars['String']['output']>;
  trackingRefNo?: Maybe<Scalars['String']['output']>;
  transporterCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicleNo: Scalars['String']['output'];
  vehicleType: VehicleType;
  vehicleTypeId: Scalars['Int']['output'];
};

export type VehicleFilterInput = {
  and?: InputMaybe<Array<VehicleFilterInput>>;
  capacity?: InputMaybe<DecimalOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customers?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  dispatch?: InputMaybe<BooleanOperationFilterInput>;
  eamId?: InputMaybe<StringOperationFilterInput>;
  forHire?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  insuranceCompany?: InputMaybe<StringOperationFilterInput>;
  insuranceExpiryDate?: InputMaybe<DateOperationFilterInput>;
  insurancePolicyNo?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isBanned?: InputMaybe<BooleanOperationFilterInput>;
  maxWeight?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<VehicleFilterInput>>;
  owner?: InputMaybe<StringOperationFilterInput>;
  receiving?: InputMaybe<BooleanOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierId?: InputMaybe<IntOperationFilterInput>;
  suppliers?: InputMaybe<ListFilterInputTypeOfSupplierFilterInput>;
  tare?: InputMaybe<DecimalOperationFilterInput>;
  trackingPhoneNo?: InputMaybe<StringOperationFilterInput>;
  trackingRefNo?: InputMaybe<StringOperationFilterInput>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  vehicleNo?: InputMaybe<StringOperationFilterInput>;
  vehicleType?: InputMaybe<VehicleTypeFilterInput>;
  vehicleTypeId?: InputMaybe<IntOperationFilterInput>;
};

export type VehicleRequest = {
  __typename?: 'VehicleRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  licensePlate: Scalars['String']['output'];
  transporterCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicleRequestStatus: VehicleRequestStatus;
  vehicleRequestStatusId: Scalars['Int']['output'];
  vehicleType: VehicleType;
  vehicleTypeId?: Maybe<Scalars['Int']['output']>;
};

export type VehicleRequestFilterInput = {
  and?: InputMaybe<Array<VehicleRequestFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  licensePlate?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleRequestFilterInput>>;
  transporterCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  vehicleRequestStatus?: InputMaybe<VehicleRequestStatusFilterInput>;
  vehicleRequestStatusId?: InputMaybe<IntOperationFilterInput>;
  vehicleType?: InputMaybe<VehicleTypeFilterInput>;
  vehicleTypeId?: InputMaybe<IntOperationFilterInput>;
};

export type VehicleRequestInput = {
  licensePlate: Scalars['String']['input'];
  transporterCode?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleRequestResponse = {
  __typename?: 'VehicleRequestResponse';
  createdAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  customerRef?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['Int']['output'];
  salesVoucherId: Scalars['Int']['output'];
  vehicleRequestLicensePlate: Scalars['String']['output'];
  vehicleRequestStatus: VehicleRequestStatusEnum;
  vehicleRequestTransporterCode?: Maybe<Scalars['String']['output']>;
  voucherNumber: Scalars['String']['output'];
};

export type VehicleRequestResponseFilterInput = {
  and?: InputMaybe<Array<VehicleRequestResponseFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  customerRef?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleRequestResponseFilterInput>>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  salesVoucherId?: InputMaybe<IntOperationFilterInput>;
  vehicleRequestLicensePlate?: InputMaybe<StringOperationFilterInput>;
  vehicleRequestStatus?: InputMaybe<VehicleRequestStatusEnumOperationFilterInput>;
  vehicleRequestTransporterCode?: InputMaybe<StringOperationFilterInput>;
  voucherNumber?: InputMaybe<StringOperationFilterInput>;
};

export type VehicleRequestResponseSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  customerRef?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  salesVoucherId?: InputMaybe<SortEnumType>;
  vehicleRequestLicensePlate?: InputMaybe<SortEnumType>;
  vehicleRequestStatus?: InputMaybe<SortEnumType>;
  vehicleRequestTransporterCode?: InputMaybe<SortEnumType>;
  voucherNumber?: InputMaybe<SortEnumType>;
};

export type VehicleRequestSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  licensePlate?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  vehicleRequestStatus?: InputMaybe<VehicleRequestStatusSortInput>;
  vehicleRequestStatusId?: InputMaybe<SortEnumType>;
  vehicleType?: InputMaybe<VehicleTypeSortInput>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

export type VehicleRequestStatus = {
  __typename?: 'VehicleRequestStatus';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export enum VehicleRequestStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type VehicleRequestStatusEnumOperationFilterInput = {
  eq?: InputMaybe<VehicleRequestStatusEnum>;
  in?: InputMaybe<Array<VehicleRequestStatusEnum>>;
  neq?: InputMaybe<VehicleRequestStatusEnum>;
  nin?: InputMaybe<Array<VehicleRequestStatusEnum>>;
};

export type VehicleRequestStatusFilterInput = {
  and?: InputMaybe<Array<VehicleRequestStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<VehicleRequestStatusFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type VehicleRequestStatusSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VehicleRequestsConnection = {
  __typename?: 'VehicleRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VehicleRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VehicleRequestResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VehicleRequestsEdge = {
  __typename?: 'VehicleRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VehicleRequestResponse;
};

export type VehicleSortInput = {
  capacity?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  dispatch?: InputMaybe<SortEnumType>;
  eamId?: InputMaybe<SortEnumType>;
  forHire?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  insuranceCompany?: InputMaybe<SortEnumType>;
  insuranceExpiryDate?: InputMaybe<SortEnumType>;
  insurancePolicyNo?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isBanned?: InputMaybe<SortEnumType>;
  maxWeight?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<SortEnumType>;
  receiving?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierId?: InputMaybe<SortEnumType>;
  tare?: InputMaybe<SortEnumType>;
  trackingPhoneNo?: InputMaybe<SortEnumType>;
  trackingRefNo?: InputMaybe<SortEnumType>;
  transporterCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  vehicleNo?: InputMaybe<SortEnumType>;
  vehicleType?: InputMaybe<VehicleTypeSortInput>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type VehicleTypeFilterInput = {
  and?: InputMaybe<Array<VehicleTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<VehicleTypeFilterInput>>;
  translationKey?: InputMaybe<StringOperationFilterInput>;
};

export type VehicleTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  translationKey?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VehiclesConnection = {
  __typename?: 'VehiclesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VehiclesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Vehicle>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VehiclesEdge = {
  __typename?: 'VehiclesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Vehicle;
};

export type VerifyOtpInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  oTP: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['Long']['input']>;
};

export type VerifyOtpPayload = {
  __typename?: 'VerifyOTPPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type VoidCustomerSalesVouchersInput = {
  customerId: Scalars['Int']['input'];
};

export type VoidCustomerSalesVouchersPayload = {
  __typename?: 'VoidCustomerSalesVouchersPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type VoidDeliveredOrdersSalesVoucherInput = {
  salesVoucherId: Scalars['Int']['input'];
  salesVoucherItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VoidDeliveredOrdersSalesVoucherPayload = {
  __typename?: 'VoidDeliveredOrdersSalesVoucherPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type VoidSalesVoucherInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  itemCancellations?: InputMaybe<Array<VoucherItemCancellationInput>>;
  salesVoucherId: Scalars['Int']['input'];
};

export type VoidSalesVoucherPayload = {
  __typename?: 'VoidSalesVoucherPayload';
  salesVoucher?: Maybe<SalesVoucher>;
};

export type VolumeBalanceReport = {
  __typename?: 'VolumeBalanceReport';
  productId?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Decimal']['output'];
  unitOfMeasureId?: Maybe<Scalars['Int']['output']>;
};

export type VoucherItemCancellationInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  voucherItemId: Scalars['Int']['input'];
};

export type PermissionStateQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionStateQuery = { __typename?: 'Query', permissionState: { __typename?: 'PermissionState', permissions: string } };

export type NavigationStateQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationStateQuery = { __typename?: 'Query', navigateState: { __typename?: 'NavigationState', hasGoBackRequest: boolean, apparentDataLoss: boolean } };

export type GetDashboardApprovedPaymentsGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardApprovedPaymentsGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }> } };

export type GetDashboardTotalConfirmedOrdersGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  previousStartDate: Scalars['DateTime']['input'];
  previousEndDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardTotalConfirmedOrdersGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }>, quantity: Array<{ __typename?: 'KeyValuePairOfUnitOfMeasureEnumAndDecimal', key: UnitOfMeasureEnum, value: any }> } };

export type GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  previousStartDate: Scalars['DateTime']['input'];
  previousEndDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardTotalUnconfirmedOrdersGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }>, quantity: Array<{ __typename?: 'KeyValuePairOfUnitOfMeasureEnumAndDecimal', key: UnitOfMeasureEnum, value: any }> } };

export type GetDashboardTotalCompletedOrdersGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  previousStartDate: Scalars['DateTime']['input'];
  previousEndDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardTotalCompletedOrdersGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }>, quantity: Array<{ __typename?: 'KeyValuePairOfUnitOfMeasureEnumAndDecimal', key: UnitOfMeasureEnum, value: any }> } };

export type GetDashboardManualPaymentsGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardManualPaymentsGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }> } };

export type GetDashboardTotalOrderRequestGraphDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetDashboardTotalOrderRequestGraphDataQuery = { __typename?: 'Query', dashboard: { __typename?: 'DashboardReport', dashboardReportTypeEnumId: number, difference: any, total: any, percentage: any, dataPoints: Array<{ __typename?: 'KeyValuePairOfDateTimeAndDecimal', key: any, value: any }> } };

export type GetCompanyRevenueQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetCompanyRevenueQuery = { __typename?: 'Query', revenueGraph: Array<{ __typename?: 'AdminDashboardGraph', date: any, totalAmountApproved: any }> };

export type GetCompanySummaryReportsQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetCompanySummaryReportsQuery = { __typename?: 'Query', adminSummaryReport: Array<{ __typename?: 'AdminSummaryReport', count: number, reportType: string, total: any }> };

export type GetCompanySoldProductsQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetCompanySoldProductsQuery = { __typename?: 'Query', soldProducts: Array<{ __typename?: 'VolumeBalanceReport', productId?: number | null, productTitle?: string | null, totalQuantity: any, unitOfMeasureId?: number | null }> };

export type GetCustomerGuaranteeBanksQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  order?: InputMaybe<SortEnumType>;
  where?: InputMaybe<BankGuaranteeFilterInput>;
}>;


export type GetCustomerGuaranteeBanksQuery = { __typename?: 'Query', bankGuarantees: Array<{ __typename?: 'BankGuarantee', bankGuaranteeRef: string, certificateUrl: string, fileName: string, createdAt: any, creditLimit: any, creditUsed: any, creditRemaining: any, expiryDate: any, id: number, issuedDate: any, salesOfficeId: number, updatedAt: any, reference: string, customer: { __typename?: 'Customer', id: number, customerName: string, email?: string | null, customerCode: string }, guaranteeBank: { __typename?: 'Bank', id: number, name: string }, createdBy: { __typename?: 'User', userName: string, id: number, email: string, fullName: string }, bankGuaranteeActivityLogs: Array<{ __typename?: 'BankGuaranteeActivityLog', id: number, activityTypeId: number, previousCreditLimit?: any | null, creditLimit: any, bankGuaranteeReference: string, issuedDate: any, expiryDate: any, createdAt: any, certificateUrl: string, previousCertificateUrl?: string | null, comment: string, createdBy: { __typename?: 'User', id: number, userName: string, fullName: string, email: string } }> }> };

export type GetCustomerGuaranteeBanksByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type GetCustomerGuaranteeBanksByIdQuery = { __typename?: 'Query', bankGuarantees: Array<{ __typename?: 'BankGuarantee', bankGuaranteeRef: string, certificateUrl: string, fileName: string, createdAt: any, creditLimit: any, creditUsed: any, creditRemaining: any, expiryDate: any, id: number, issuedDate: any, salesOfficeId: number, updatedAt: any, reference: string, customer: { __typename?: 'Customer', id: number, customerName: string, email?: string | null, customerCode: string }, guaranteeBank: { __typename?: 'Bank', id: number, name: string }, salesOffice: { __typename?: 'Location', name: string }, createdBy: { __typename?: 'User', userName: string, id: number, fullName: string, email: string }, bankGuaranteeActivityLogs: Array<{ __typename?: 'BankGuaranteeActivityLog', id: number, activityTypeId: number, previousCreditLimit?: any | null, creditLimit: any, bankGuaranteeReference: string, issuedDate: any, expiryDate: any, createdAt: any, certificateUrl: string, previousCertificateUrl?: string | null, comment: string, createdBy: { __typename?: 'User', id: number, userName: string, email: string, fullName: string } }> }> };

export type BankGuaranteesMutationVariables = Exact<{
  bankGuarantyRef: Scalars['String']['input'];
  certificate: Scalars['Upload']['input'];
  creditLimit: Scalars['Decimal']['input'];
  customerId: Scalars['Int']['input'];
  expiryDate: Scalars['DateTime']['input'];
  guaranteeBankId: Scalars['Int']['input'];
  issuedDate: Scalars['DateTime']['input'];
  salesOfficeId: Scalars['Int']['input'];
}>;


export type BankGuaranteesMutation = { __typename?: 'Mutation', upsertBankGuarantee: { __typename?: 'UpsertBankGuaranteePayload', bankGuarantee?: { __typename?: 'BankGuarantee', id: number, customerId: number, expiryDate: any } | null } };

export type UpdateCustomerGuaranteeBanksMutationVariables = Exact<{
  bankGuarantyRef: Scalars['String']['input'];
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  creditLimit: Scalars['Decimal']['input'];
  customerId: Scalars['Int']['input'];
  expiryDate: Scalars['DateTime']['input'];
  guaranteeBankId: Scalars['Int']['input'];
  issuedDate: Scalars['DateTime']['input'];
  salesOfficeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerGuaranteeBanksMutation = { __typename?: 'Mutation', upsertBankGuarantee: { __typename?: 'UpsertBankGuaranteePayload', bankGuarantee?: { __typename?: 'BankGuarantee', id: number, customerId: number, expiryDate: any } | null } };

export type GetDfsChequeSummaryQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetDfsChequeSummaryQuery = { __typename?: 'Query', chequeDashboard: { __typename?: 'ChequeDashboardReport', totalAmount: Array<{ __typename?: 'KeyValuePairOfChequeStatusEnumAndDecimal', key: ChequeStatusEnum, value: any }> } };

export type GetDfsPaymentQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ChequeFilterInput>;
}>;


export type GetDfsPaymentQuery = { __typename?: 'Query', dfsPayments?: { __typename?: 'DfsPaymentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null }, nodes?: Array<{ __typename?: 'Cheque', id: number, chequeNumber: string, chequeStatus: { __typename?: 'ChequeStatus', id: number, description: string }, payment: { __typename?: 'Payment', id: number, paymentReference: string, paymentTranscriptions: Array<{ __typename?: 'PaymentTranscription', id: number, documentDate: any }>, customer: { __typename?: 'Customer', id: number, companyId: number, customerName: string, customerCode: string }, paymentApprovals: Array<{ __typename?: 'PaymentApproval', id: number, paymentId: number, bankGuarantee?: { __typename?: 'BankGuarantee', id: number, bankGuaranteeRef: string } | null, settlementBank?: { __typename?: 'SettlementBank', id: number, name: string, code: string } | null }> } }> | null } | null };

export type GetDfsPaymentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDfsPaymentByIdQuery = { __typename?: 'Query', dfsPayments?: { __typename?: 'DfsPaymentsConnection', nodes?: Array<{ __typename?: 'Cheque', id: number, chequeNumber: string, chequeStatus: { __typename?: 'ChequeStatus', id: number, description: string }, payment: { __typename?: 'Payment', id: number, paymentReference: string, paymentTranscriptions: Array<{ __typename?: 'PaymentTranscription', id: number, documentDate: any }>, customer: { __typename?: 'Customer', companyId: number, customerName: string, customerCode: string }, paymentApprovals: Array<{ __typename?: 'PaymentApproval', paymentId: number, bankGuarantee?: { __typename?: 'BankGuarantee', bankGuaranteeRef: string, creditLimit: any, expiryDate: any, issuedDate: any, guaranteeBank: { __typename?: 'Bank', name: string } } | null, settlementBank?: { __typename?: 'SettlementBank', id: number, name: string, code: string } | null }> }, chequeTrackerHistories: Array<{ __typename?: 'ChequeTrackerHistory', id: number, activityDate: any, createdAt: any, updatedAt: any, chequeId: number, comments: string, processedBy: { __typename?: 'User', id: number, userName: string, fullName: string, email: string }, cheque: { __typename?: 'Cheque', chequeNumber: string, chequeStatusId: number, chequeStatus: { __typename?: 'ChequeStatus', description: string } }, chequeStatus: { __typename?: 'ChequeStatus', description: string } }> }> | null } | null };

export type SubmitChequeActivityMutationVariables = Exact<{
  input: UpsertChequeInput;
}>;


export type SubmitChequeActivityMutation = { __typename?: 'Mutation', upsertCheque: { __typename?: 'UpsertChequePayload', cheque?: { __typename?: 'Cheque', id: number } | null } };

export type GenerateDfsPaymentReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateDfsPaymentReportQuery = { __typename?: 'Query', generateDfsReportExcel: string };

export type GetBasketOrdersByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  where?: InputMaybe<BasketFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetBasketOrdersByCompanyQuery = { __typename?: 'Query', basketOrdersByCompany?: { __typename?: 'BasketOrdersByCompanyConnection', totalCount: number, edges?: Array<{ __typename?: 'BasketOrdersByCompanyEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Basket', id: number, basketOrderNumber: string, totalQuantity: any, quantityUsed: any, quantityLeft: any, salesVoucherCount: number, createdAt: any, updatedAt: any, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, companyId: number }, basketOrderStatus: { __typename?: 'BasketOrderStatus', id: number, description: string, translationKey: string }, basketItems: Array<{ __typename?: 'BasketItems', id: number, productId: number, quantity: any, quantityUsed: any, product?: { __typename?: 'Product', id: number, itemCode: string, title: string, featuredImageUrl?: string | null, uoS?: string | null } | null }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetBasketOrderDetailQueryVariables = Exact<{
  basketOrderId: Scalars['Int']['input'];
}>;


export type GetBasketOrderDetailQuery = { __typename?: 'Query', basketOrders?: { __typename?: 'BasketOrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Basket', id: number, basketOrderNumber: string, totalQuantity: any, quantityUsed: any, quantityLeft: any, salesVoucherCount: number, createdAt: any, updatedAt: any, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, companyId: number }, company: { __typename?: 'Company', id: number, name: string, defaultCurrencyCode: string }, basketOrderStatus: { __typename?: 'BasketOrderStatus', id: number, description: string, translationKey: string }, basketItems: Array<{ __typename?: 'BasketItems', id: number, productId: number, quantity: any, quantityUsed: any, product?: { __typename?: 'Product', id: number, itemCode: string, title: string, featuredImageUrl?: string | null, uoS?: string | null } | null }>, salesVouchers: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, createdAt: any, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, destinationId?: number | null, destination?: { __typename?: 'Destination', id: number, code: string, name?: string | null } | null, product: { __typename?: 'Product', id: number, title: string, uoS?: string | null }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string }> }>, sourceLocation: { __typename?: 'Location', id: number, name: string } }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', userByEmail?: { __typename?: 'User', id: number, fullName: string, userName: string, email: string, companyId: number, locationId?: number | null, permissions: Array<string>, company: { __typename?: 'Company', countryId: number, code: string, customerTranscription: boolean }, location?: { __typename?: 'Location', id: number, name: string, code: string, type: string, companyId: number, allowBankGuarantee: boolean, useDeliveredOrderManagement: boolean, company: { __typename?: 'Company', id: number, code: string, countryId: number, name: string, customerTranscription: boolean, defaultCurrencyCode: string, allowOrderCancellation: boolean, country: { __typename?: 'Country', name: string, alpha2?: string | null, alpha3?: string | null } } } | null, language: { __typename?: 'Language', lang: string, code: string, id: number }, companies: Array<{ __typename?: 'Company', id: number, code: string, name: string, countryId: number }>, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string, companyId: number, type: string }> } | null };

export type GetUserPermissionsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserPermissionsQuery = { __typename?: 'Query', userMHCPermissions: Array<string> };

export type GetUserMhcRolesQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserMhcRolesQuery = { __typename?: 'Query', userMHCRoles: Array<string> };

export type GetDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentTypesQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocumentType', id: number, description: string, translationKey: string }> };

export type GetPaymentApprovalStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentApprovalStatusesQuery = { __typename?: 'Query', paymentApprovalStatus: Array<{ __typename?: 'PaymentApprovalStatus', id: number, description: string, translationKey: string }> };

export type GetPaymentApprovalTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentApprovalTypesQuery = { __typename?: 'Query', paymentApprovalType: Array<{ __typename?: 'PaymentApprovalType', id: number, description: string, translationKey: string }> };

export type GetCustomerRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerRolesQuery = { __typename?: 'Query', customerRoles: Array<{ __typename?: 'Role', id: number, description?: string | null, isInternal: boolean }> };

export type GetActiveBanksQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type GetActiveBanksQuery = { __typename?: 'Query', banks?: { __typename?: 'BanksConnection', nodes?: Array<{ __typename?: 'Bank', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean, country: { __typename?: 'Country', id: number, name: string } }> | null } | null };

export type GetActiveBankBranchesQueryVariables = Exact<{
  bankId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type GetActiveBankBranchesQuery = { __typename?: 'Query', bankBranches?: { __typename?: 'BankBranchesConnection', nodes?: Array<{ __typename?: 'BankBranch', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean }> | null } | null };

export type UpsertUserDefaultLanguagemutationMutationVariables = Exact<{
  langId: UpdateUserDefaultLanguageInput;
}>;


export type UpsertUserDefaultLanguagemutationMutation = { __typename?: 'Mutation', updateUserDefaultLanguage: { __typename?: 'UpdateUserDefaultLanguagePayload', user?: { __typename?: 'User', languageId: number, id: number, userName: string, email: string } | null } };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', lang: string, code: string, id: number }> };

export type GetVehiclesLookupByVehicleNumberQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  countryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  vehcileTypeId: Scalars['Int']['input'];
}>;


export type GetVehiclesLookupByVehicleNumberQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesConnection', nodes?: Array<{ __typename?: 'Vehicle', id: number, vehicleNo: string, insuranceExpiryDate?: any | null, insurancePolicyNo?: string | null, trackingRefNo?: string | null, trackingPhoneNo?: string | null, transporterCode?: string | null, owner?: string | null, isBanned: boolean, isActive: boolean, tare?: any | null, maxWeight?: any | null, createdAt: any, supplier?: { __typename?: 'Supplier', supplierName: string, supplierCode: string } | null }> | null } | null };

export type UpsertUserDeviceTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UpsertUserDeviceTokenMutation = { __typename?: 'Mutation', upsertUserDevice: { __typename?: 'UpsertUserDevicePayload', userDevice?: { __typename?: 'UserDevice', user: { __typename?: 'User', id: number, userName: string } } | null } };

export type GetUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationsQuery = { __typename?: 'Query', userNotifications?: { __typename?: 'UserNotificationsConnection', nodes?: Array<{ __typename?: 'NotificationUser', id: number, notificationStatusId: number, createdAt: any, updatedAt: any, notificationStatus: { __typename?: 'NotificationStatus', id: number, description: string, translationKey: string }, notification: { __typename?: 'Notification', id: number, title: string, body: string, componentId?: string | null, componentName?: string | null, notificationTypeId: number, createdAt: any, notificationType: { __typename?: 'NotificationType', id: number, description: string, translationKey: string } } }> | null } | null };

export type GetPaymentIdByPaymentNumberQueryVariables = Exact<{
  paymentNumber: Scalars['String']['input'];
}>;


export type GetPaymentIdByPaymentNumberQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', nodes?: Array<{ __typename?: 'Payment', id: number }> | null } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', readUserNotification: { __typename?: 'ReadUserNotificationPayload', notificationUser?: { __typename?: 'NotificationUser', userId: number } | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', readAllUserNotification: { __typename?: 'ReadAllUserNotificationPayload', boolean?: boolean | null } };

export type GetRecentOrdersQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetRecentOrdersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', id: number, customerReference?: string | null, createdAt: any, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, totalPrice?: any | null }>, sourceLocation: { __typename?: 'Location', id: number, code: string, name: string }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string } }> | null } | null };

export type UpdateUserDefaultLocationMutationVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type UpdateUserDefaultLocationMutation = { __typename?: 'Mutation', updateUserDefaultLocation: { __typename?: 'UpdateUserDefaultLocationPayload', user?: { __typename?: 'User', id: number, userName: string, locationId?: number | null } | null } };

export type GetBanksQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type GetBanksQuery = { __typename?: 'Query', activeBanks: Array<{ __typename?: 'Bank', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean, country: { __typename?: 'Country', id: number, name: string } }> };

export type GetBankQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBankQuery = { __typename?: 'Query', activeBanks: Array<{ __typename?: 'Bank', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean, country: { __typename?: 'Country', id: number, name: string } }> };

export type GetBankBranchesQueryVariables = Exact<{
  bankId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type GetBankBranchesQuery = { __typename?: 'Query', activeBankBranches: Array<{ __typename?: 'BankBranch', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean }> };

export type GetBankBranchQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBankBranchQuery = { __typename?: 'Query', activeBankBranches: Array<{ __typename?: 'BankBranch', id: number, name: string, description?: string | null, createdAt: any, updatedAt: any, code: string, isActive: boolean }> };

export type GetUserAccountsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserAccountsByCompanyIdQuery = { __typename?: 'Query', usersByCompany?: { __typename?: 'UsersByCompanyConnection', totalCount: number, nodes?: Array<{ __typename?: 'User', createdAt: any, customerId?: number | null, email: string, fullName: string, id: number, isActive: boolean, languageId: number, locationId?: number | null, permissions: Array<string>, phoneNumber?: any | null, termsAndConditionId?: number | null, updatedAt: any, userName: string, company: { __typename?: 'Company', id: number, name: string, country: { __typename?: 'Country', id: number, name: string } }, location?: { __typename?: 'Location', id: number, name: string } | null, customer?: { __typename?: 'Customer', id: number, customerName: string, active: boolean, customerCode: string } | null, role?: { __typename?: 'Role', id: number, description?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CompaniesCountQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
}>;


export type CompaniesCountQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', totalCount: number } | null };

export type UpdateUserActiveMutationVariables = Exact<{
  input: UpdateUserActiveInput;
}>;


export type UpdateUserActiveMutation = { __typename?: 'Mutation', updateUserActive: { __typename?: 'UpdateUserActivePayload', boolean?: boolean | null } };

export type GetUserLocationsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type GetUserLocationsQuery = { __typename?: 'Query', usersByCompany?: { __typename?: 'UsersByCompanyConnection', nodes?: Array<{ __typename?: 'User', id: number, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string, companyId: number }> }> | null } | null };

export type UpdateUserLocationsMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  locationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateUserLocationsMutation = { __typename?: 'Mutation', updateUserLocations: { __typename?: 'UpdateUserLocationsPayload', user?: { __typename?: 'User', id: number, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string, companyId: number }> } | null } };

export type UpsertBankDataMutationVariables = Exact<{
  input: UpsertBankInput;
}>;


export type UpsertBankDataMutation = { __typename?: 'Mutation', upsertBank: { __typename?: 'UpsertBankPayload', bank?: { __typename?: 'Bank', id: number } | null } };

export type GetPaginatedBanksByCountryIdQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedBanksByCountryIdQuery = { __typename?: 'Query', banks?: { __typename?: 'BanksConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'BanksEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Bank', id: number, code: string, name: string, isActive: boolean, countryId: number, description?: string | null, bankBranches: Array<{ __typename?: 'BankBranch', id: number, description?: string | null, name: string, code: string }>, country: { __typename?: 'Country', id: number, name: string } }> | null } | null };

export type UpsertBankBranchMutationVariables = Exact<{
  input: UpsertBankBranchInput;
}>;


export type UpsertBankBranchMutation = { __typename?: 'Mutation', upsertBankBranch: { __typename?: 'UpsertBankBranchPayload', bankBranch?: { __typename?: 'BankBranch', id: number, code: string, description?: string | null, name: string } | null } };

export type GetPaginatedCompaniesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  countryId: Scalars['Int']['input'];
}>;


export type GetPaginatedCompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', totalCount: number, edges?: Array<{ __typename?: 'CompaniesEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Company', id: number, name: string, code: string, eamOrganization: string, sunBusinessUnit: string, countryId: number, allowDepotSelection: boolean, useBundledBOD: boolean, useMAPaymentInJournalPostingsBOD: boolean, enableInvoicesReportPage: boolean, enableSalesOrderReportPage: boolean, enableTransactionReportPage: boolean, allowOrderCancellation: boolean, allowOrderAmendment: boolean, allowNewDriverAndVehicle: boolean, updatedAt: any, createdAt: any, country: { __typename?: 'Country', id: number, name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCompaniesQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
}>;


export type GetCompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', nodes?: Array<{ __typename?: 'Company', id: number, name: string }> | null } | null };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', nodes?: Array<{ __typename?: 'Company', id: number, name: string, code: string, eamOrganization: string, sunBusinessUnit: string, countryId: number, customerTranscription: boolean, enableSalesOfficerLocationScope: boolean, allowDepotSelection: boolean, useBundledBOD: boolean, useMAPaymentInJournalPostingsBOD: boolean, enableInvoicesReportPage: boolean, enableSalesOrderReportPage: boolean, enableTransactionReportPage: boolean, allowOrderCancellation: boolean, allowOrderAmendment: boolean, allowNewDriverAndVehicle: boolean, updatedAt: any, createdAt: any, country: { __typename?: 'Country', id: number, name: string } }> | null } | null };

export type ConfigureSalesOfficerLocationScopeMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ConfigureSalesOfficerLocationScopeMutation = { __typename?: 'Mutation', configureSalesOfficerLocationScope: { __typename?: 'ConfigureSalesOfficerLocationScopePayload', company?: { __typename?: 'Company', id: number, enableSalesOfficerLocationScope: boolean } | null } };

export type UpsertCompanyMutationVariables = Exact<{
  input: UpsertCompanyInput;
}>;


export type UpsertCompanyMutation = { __typename?: 'Mutation', upsertCompany: { __typename?: 'UpsertCompanyPayload', company?: { __typename?: 'Company', id: number } | null } };

export type GetCustomersByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  customerName?: Scalars['String']['input'];
  customerCode?: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomersByCompanyQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Customer', id: number, customerCode: string, customerName: string, phoneNumber?: any | null, customerVATCode?: string | null, customerDeliveryType?: string | null, active: boolean, altPhoneNumber?: any | null, customerSegment?: { __typename?: 'CustomerSegment', name: string } | null, company: { __typename?: 'Company', id: number, name: string, code: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCustomersByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomersByCompanyIdQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Customer', id: number, customerCode: string, customerName: string, phoneNumber?: any | null, customerVATCode?: string | null, customerDeliveryType?: string | null, active: boolean, email?: string | null, altPhoneNumber?: any | null, customerSegment?: { __typename?: 'CustomerSegment', name: string } | null, company: { __typename?: 'Company', id: number, name: string, code: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'Customer', active: boolean, altPhoneNumber?: any | null, companyId: number, createdAt: any, customerCode: string, customerName: string, customerCurrency?: string | null, customerSegmentId?: number | null, customerAccountBalance?: any | null, customerAvailableCredit?: any | null, customerCrLimitExpDate?: any | null, customerCrLimit?: any | null, customerOverdueInvoiceAmt?: any | null, customerOnOrderBalance?: any | null, email?: string | null, id: number, phoneNumber?: any | null, updatedAt: any, customerSegment?: { __typename?: 'CustomerSegment', name: string, id: number } | null, company: { __typename?: 'Company', name: string, countryId: number }, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string }>, vehicles: Array<{ __typename?: 'Vehicle', id: number, vehicleNo: string, isActive: boolean, isBanned: boolean, owner?: string | null, tare?: any | null, capacity?: any | null, maxWeight?: any | null, eamId?: string | null, trackingRefNo?: string | null, supplierId?: number | null }>, destinations: Array<{ __typename?: 'Destination', id: number, name?: string | null, code: string }> }> | null } | null };

export type CustomersWithLinkedAccountsQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CustomersWithLinkedAccountsQuery = { __typename?: 'Query', customerUserRoles?: { __typename?: 'CustomerUserRolesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'CustomerUserRole', id: number, userId: number, roleId: number, customerId: number, createdAt: any, user: { __typename?: 'User', id: number, userName: string, fullName: string, email: string, phoneNumber?: any | null, createdAt: any, company: { __typename?: 'Company', country: { __typename?: 'Country', name: string } }, location?: { __typename?: 'Location', name: string } | null }, role: { __typename?: 'Role', description?: string | null }, customer: { __typename?: 'Customer', customerName: string } }> | null } | null };

export type GetUsersByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersByCompanyIdQuery = { __typename?: 'Query', usersByCompany?: { __typename?: 'UsersByCompanyConnection', totalCount: number, nodes?: Array<{ __typename?: 'User', companyId: number, createdAt: any, customerId?: number | null, email: string, fullName: string, id: number, isActive: boolean, languageId: number, locationId?: number | null, permissions: Array<string>, phoneNumber?: any | null, termsAndConditionId?: number | null, updatedAt: any, userName: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type LinkUserAccountMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  customerId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
}>;


export type LinkUserAccountMutation = { __typename?: 'Mutation', linkUserAccount: { __typename?: 'LinkUserAccountPayload', customerUserRole?: { __typename?: 'CustomerUserRole', roleId: number, customerId: number, userId: number } | null } };

export type UnlinkUserAccountMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
}>;


export type UnlinkUserAccountMutation = { __typename?: 'Mutation', unlinkUserAccount: { __typename?: 'UnlinkUserAccountPayload', boolean?: boolean | null } };

export type GetTrucksByCustomerQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrucksByCustomerQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesConnection', totalCount: number, nodes?: Array<{ __typename?: 'Vehicle', id: number, vehicleNo: string, isActive: boolean, isBanned: boolean, owner?: string | null, tare?: any | null, capacity?: any | null, maxWeight?: any | null, eamId?: string | null, trackingRefNo?: string | null, supplierId?: number | null, vehicleTypeId: number, transporterCode?: string | null, vehicleType: { __typename?: 'VehicleType', id: number, description: string }, supplier?: { __typename?: 'Supplier', supplierName: string, supplierCode: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type UpdateCustomerTrucksMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  vehicles?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UpdateCustomerTrucksMutation = { __typename?: 'Mutation', upsertCustomerVehicle: { __typename?: 'UpsertCustomerVehiclePayload', customer?: { __typename?: 'Customer', id: number } | null } };

export type GetCustomerLocationOptionsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
}>;


export type GetCustomerLocationOptionsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', nodes?: Array<{ __typename?: 'Location', id: number, name: string, code: string }> | null } | null };

export type UpdateCustomerLocationsMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  locationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateCustomerLocationsMutation = { __typename?: 'Mutation', updateCustomerLocations: { __typename?: 'UpdateCustomerLocationsPayload', customer?: { __typename?: 'Customer', id: number, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string }> } | null } };

export type CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CustomerOrderBalancesByBusinessUnitLineForAdminQuery = { __typename?: 'Query', customerOrderBalancesByBusinessUnitLineForAdmin: Array<{ __typename?: 'OrderBalanceByBusinessUnitLine', businessUnitLine: string, name: string, amountTotal: any }> };

export type GetDestinationsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDestinationsQuery = { __typename?: 'Query', destinations?: { __typename?: 'DestinationsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Destination', id: number, name?: string | null }> | null } | null };

export type PaginatedLocationDestinationQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortEnumType>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedLocationDestinationQuery = { __typename?: 'Query', locationDestinations?: { __typename?: 'LocationDestinationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'LocationDestination', id: number, locationId: number, destinationId: number, destination: { __typename?: 'Destination', id: number, code: string, name?: string | null, lookup?: string | null, region?: string | null, country?: string | null, companyId: number, company: { __typename?: 'Company', name: string, country: { __typename?: 'Country', name: string } } } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type UpsertLocationDestinationMutationVariables = Exact<{
  locationId: Scalars['Int']['input'];
  destinationId: Scalars['Int']['input'];
}>;


export type UpsertLocationDestinationMutation = { __typename?: 'Mutation', addLocationDestination: { __typename?: 'AddLocationDestinationPayload', locationDestination?: { __typename?: 'LocationDestination', createdAt: any, id: number } | null } };

export type DeleteLocationDestinationMutationVariables = Exact<{
  locationId: Scalars['Int']['input'];
  destinationId: Scalars['Int']['input'];
}>;


export type DeleteLocationDestinationMutation = { __typename?: 'Mutation', removeLocationDestination: { __typename?: 'RemoveLocationDestinationPayload', boolean?: boolean | null } };

export type AddCustomerDestinationMutationVariables = Exact<{
  input: AddCustomerDestinationInput;
}>;


export type AddCustomerDestinationMutation = { __typename?: 'Mutation', addCustomerDestination: { __typename?: 'AddCustomerDestinationPayload', boolean?: boolean | null } };

export type RemoveCustomerDestinationMutationVariables = Exact<{
  input: RemoveCustomerDestinationInput;
}>;


export type RemoveCustomerDestinationMutation = { __typename?: 'Mutation', removeCustomerDestination: { __typename?: 'RemoveCustomerDestinationPayload', boolean?: boolean | null } };

export type GetCompanyDestinationsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCompanyDestinationsQuery = { __typename?: 'Query', destinations?: { __typename?: 'DestinationsConnection', nodes?: Array<{ __typename?: 'Destination', id: number, name?: string | null, code: string }> | null } | null };

export type GetPaginatedLocationsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  countryId: Scalars['Int']['input'];
}>;


export type GetPaginatedLocationsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Location', id: number, code: string, name: string, type: string, costCentre?: string | null, pmEmployee: boolean, businessUnitLine?: string | null, vatCode?: string | null, companyId: number, updatedAt: any, defaultDeliveryType?: string | null, defaultTransporter?: string | null, allowDeliveryTypeSelection: boolean, allowDriverSelection: boolean, truckSelectionAllowed?: boolean | null, requireFileUpload: boolean, useFileUpload: boolean, useDescription: boolean, useComments: boolean, useLocalPoNumber: boolean, useDeliveryContact: boolean, requireDestinationSelectionForExworks: boolean, allowDestinationSelectionFromMasterData: boolean, truckSelectionFromMasterAllowed: boolean, allowOrderReference: boolean, allowTruckSelectionForDelivered: boolean, allowDriverSelectionForDelivered: boolean, company: { __typename?: 'Company', name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetPaginatedLocationsByCompanyQueryVariables = Exact<{
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  countryId: Scalars['Int']['input'];
}>;


export type GetPaginatedLocationsByCompanyQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Location', id: number, code: string, type: string, name: string, companyId: number, updatedAt: any, costCentre?: string | null, pmEmployee: boolean, businessUnitLine?: string | null, vatCode?: string | null, defaultDeliveryType?: string | null, defaultTransporter?: string | null, allowDeliveryTypeSelection: boolean, allowDriverSelection: boolean, truckSelectionAllowed?: boolean | null, requireFileUpload: boolean, useFileUpload: boolean, useDescription: boolean, useComments: boolean, useLocalPoNumber: boolean, useDeliveryContact: boolean, useConfirmQuotation: boolean, allowBulkOrder: boolean, allowBasketOrders: boolean, allowStandAlonePayment: boolean, requireDestinationSelectionForExworks: boolean, allowDestinationSelectionFromMasterData: boolean, truckSelectionFromMasterAllowed: boolean, allowOrderReference: boolean, allowTruckSelectionForDelivered: boolean, allowDriverSelectionForDelivered: boolean, useDeliveredOrderManagement: boolean, company: { __typename?: 'Company', name: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type UpsertLocationMutationVariables = Exact<{
  input: UpsertLocationInput;
}>;


export type UpsertLocationMutation = { __typename?: 'Mutation', upsertLocation: { __typename?: 'UpsertLocationPayload', location?: { __typename?: 'Location', id: number } | null } };

export type UpsertProductConstraintMutationVariables = Exact<{
  input: UpsertProductConstraintInput;
}>;


export type UpsertProductConstraintMutation = { __typename?: 'Mutation', upsertProductConstraint: { __typename?: 'UpsertProductConstraintPayload', productConstraint?: { __typename?: 'ProductConstraint', id: number } | null } };

export type GetPaginatedProductConstraintsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedProductConstraintsQuery = { __typename?: 'Query', productConstraints?: { __typename?: 'ProductConstraintsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, nodes?: Array<{ __typename?: 'ProductConstraint', id: number, customerSegmentId: number, productId: number, minProductQuantity: any, maxProductQuantity: any, maxTruckQuantity: any, minTruckQuantity: any, companyId: number, customerSegment: { __typename?: 'CustomerSegment', name: string, companyId: number, company: { __typename?: 'Company', countryId: number, id: number } }, product: { __typename?: 'Product', title: string, uoS?: string | null, productMeasurementId?: number | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', description: string, id: number } | null } }> | null } | null };

export type GetCustmerSegmentQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetCustmerSegmentQuery = { __typename?: 'Query', customerSegments?: { __typename?: 'CustomerSegmentsConnection', nodes?: Array<{ __typename?: 'CustomerSegment', name: string, companyId: number, id: number }> | null } | null };

export type GetProductsByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsByCompanyQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Product', companyId: number, id: number, title: string, lookup?: string | null }> | null } | null };

export type DeleteProductConstraintMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProductConstraintMutation = { __typename?: 'Mutation', deleteProductConstraint: { __typename?: 'DeleteProductConstraintPayload', boolean?: boolean | null } };

export type GetPaginatedLocationProductQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  costCentre?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedLocationProductQuery = { __typename?: 'Query', locationProduct?: { __typename?: 'LocationProductConnection', totalCount: number, nodes?: Array<{ __typename?: 'LocationProduct', costCentre?: string | null, createdAt: any, id: number, isPublished: boolean, locationId: number, productId: number, updatedAt: any, product: { __typename?: 'Product', companyId: number, createdAt: any, description: string, isPublished: boolean, itemCode: string, title: string, unitOfMeasureId?: number | null, uoS?: string | null, updatedAt: any, weighPiece: any }, location: { __typename?: 'Location', code: string, costCentre?: string | null, createdAt: any, name: string, truckSelectionFromMasterAllowed: boolean, type: string, updatedAt: any, company: { __typename?: 'Company', name: string } } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type UpsertLocationProductMutationVariables = Exact<{
  input: UpsertLocationProductInput;
}>;


export type UpsertLocationProductMutation = { __typename?: 'Mutation', upsertLocationProduct: { __typename?: 'UpsertLocationProductPayload', locationProduct?: { __typename?: 'LocationProduct', createdAt: any, id: number } | null } };

export type DeleteLocationProductMutationVariables = Exact<{
  input: RemoveLocationProductInput;
}>;


export type DeleteLocationProductMutation = { __typename?: 'Mutation', removeLocationProduct: { __typename?: 'RemoveLocationProductPayload', boolean?: boolean | null } };

export type UpsertSettlementBankMutationVariables = Exact<{
  input: UpsertSettlementBankInput;
}>;


export type UpsertSettlementBankMutation = { __typename?: 'Mutation', upsertSettlementBank: { __typename?: 'UpsertSettlementBankPayload', settlementBank?: { __typename?: 'SettlementBank', id: number } | null } };

export type GetSettlementBanksByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSettlementBanksByCompanyQuery = { __typename?: 'Query', settlementBanks?: { __typename?: 'SettlementBanksConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'SettlementBanksEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SettlementBank', name: string, isIncoming: boolean, isActive: boolean, sunAccountCode: string, id: number, description?: string | null, code: string, companyId: number }> | null } | null };

export type GetPaginatedSettlementBanksByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedSettlementBanksByCompanyIdQuery = { __typename?: 'Query', settlementBanks?: { __typename?: 'SettlementBanksConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'SettlementBanksEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SettlementBank', name: string, isIncoming: boolean, isActive: boolean, sunAccountCode: string, id: number, description?: string | null, code: string, companyId: number, company: { __typename?: 'Company', id: number, name: string, code: string, countryId: number } }> | null } | null };

export type GetVehicleRequestsQueryVariables = Exact<{
  where?: InputMaybe<VehicleRequestResponseFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  companyIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetVehicleRequestsQuery = { __typename?: 'Query', vehicleRequests?: { __typename?: 'VehicleRequestsConnection', totalCount: number, edges?: Array<{ __typename?: 'VehicleRequestsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'VehicleRequestResponse', salesVoucherId: number, voucherNumber: string, customerRef?: string | null, customerCode: string, createdAt: any, vehicleRequestLicensePlate: string, vehicleRequestTransporterCode?: string | null, vehicleRequestStatus: VehicleRequestStatusEnum }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetDriverRequestsQueryVariables = Exact<{
  where?: InputMaybe<DriverRequestResponseFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  companyIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetDriverRequestsQuery = { __typename?: 'Query', driverRequests?: { __typename?: 'DriverRequestsConnection', totalCount: number, edges?: Array<{ __typename?: 'DriverRequestsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'DriverRequestResponse', salesVoucherId: number, voucherNumber: string, customerRef?: string | null, customerCode: string, createdAt: any, driverRequestLicenseNo: string, driverRequestFirstName: string, driverRequestLastName: string, driverRequestStatus: DriverRequestStatusEnum }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetTransportRequestsQueryVariables = Exact<{
  where?: InputMaybe<TransportRequestResponseFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  driverRequestStatus?: InputMaybe<Scalars['Int']['input']>;
  companyIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetTransportRequestsQuery = { __typename?: 'Query', transportRequests?: { __typename?: 'TransportRequestsConnection', totalCount: number, edges?: Array<{ __typename?: 'TransportRequestsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'TransportRequestResponse', vehicle?: { __typename?: 'TransportVehicleRequest', requestId: number, salesVoucherId: number, voucherNumber: string, customerRef?: string | null, customerCode: string, createdAt: any, licensePlate: string, transporterCode?: string | null } | null, driver?: { __typename?: 'TransportDriverRequest', requestId: number, salesVoucherId: number, voucherNumber: string, customerRef?: string | null, customerCode: string, createdAt: any, licenseNo: string, firstName: string, lastName: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type UpsertContentManagementRecordMutationVariables = Exact<{
  input: UpsertContentInput;
}>;


export type UpsertContentManagementRecordMutation = { __typename?: 'Mutation', upsertContent: { __typename?: 'UpsertContentPayload', content?: { __typename?: 'Content', id: number } | null } };

export type GetAllContentManagementByTypeQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  contentType: Scalars['Int']['input'];
}>;


export type GetAllContentManagementByTypeQuery = { __typename?: 'Query', contents?: { __typename?: 'ContentsConnection', nodes?: Array<{ __typename?: 'Content', id: number, title: string, description: string, featuredImageUrl?: string | null, fileName?: string | null, createdAt: any }> | null } | null };

export type GePaginatedContentRecordsByTypeQueryVariables = Exact<{
  contentType: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GePaginatedContentRecordsByTypeQuery = { __typename?: 'Query', contents?: { __typename?: 'ContentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ContentsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Content', id: number, title: string, description: string, featuredImageUrl?: string | null, fileName?: string | null, createdAt: any }> | null } | null };

export type DeleteContentManagementRecordMutationVariables = Exact<{
  input: DeleteContentInput;
}>;


export type DeleteContentManagementRecordMutation = { __typename?: 'Mutation', deleteContent: { __typename?: 'DeleteContentPayload', boolean?: boolean | null } };

export type GePaginatedProductsQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GePaginatedProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ProductsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Product', id: number, title: string, description: string, featuredImageUrl?: string | null, fileName?: string | null, companyId: number, productMeasurementId?: number | null, unitOfMeasureId?: number | null, itemCode: string, createdAt: any, isPublished: boolean, titleColor?: string | null, backgroundColor?: string | null, weighPiece: any }> | null } | null };

export type UpsertProductMutationVariables = Exact<{
  input: UpsertProductInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'UpsertProductPayload', product?: { __typename?: 'Product', id: number } | null } };

export type DeleteProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: { __typename?: 'DeleteProductPayload', boolean?: boolean | null } };

export type GetUnitOfMeasureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitOfMeasureQuery = { __typename?: 'Query', unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: number, description: string }> };

export type GetProductMeasurementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductMeasurementsQuery = { __typename?: 'Query', productMeasurements: Array<{ __typename?: 'ProductMeasurement', id: number, description: string }> };

export type GetPaginatedContactsQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ContactsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Contact', id: number, locationId: number, telephoneNumber: string, physicalAddress: string, postalAddress?: string | null, email?: string | null, createdAt: any, location: { __typename?: 'Location', name: string, latitude: any, longitude: any } }> | null } | null };

export type UpsertContactMutationVariables = Exact<{
  input: UpsertContactInput;
}>;


export type UpsertContactMutation = { __typename?: 'Mutation', upsertContact: { __typename?: 'UpsertContactPayload', contact?: { __typename?: 'Contact', id: number } | null } };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'DeleteContactPayload', boolean?: boolean | null } };

export type GetQuotationBodItemsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherItemFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetQuotationBodItemsQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVoucherItemsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quotationId?: string | null, customerRef?: string | null, totalPrice?: any | null, createdAt: any, updatedAt: any, salesVoucher: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string, sunBusinessUnit: string } } } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetQuotationBodsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetQuotationBodsQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVouchersEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, createdAt: any, updatedAt: any, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string } }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, quotationId?: string | null, customerRef?: string | null, totalPrice?: any | null, createdAt: any, updatedAt: any }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetSalesOrderBodItemsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherItemFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetSalesOrderBodItemsQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVoucherItemsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quotationId?: string | null, customerRef?: string | null, totalPrice?: any | null, createdAt: any, updatedAt: any, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string }>, salesVoucher: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, orderQuote?: any | null, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string, sunBusinessUnit: string } } } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetQuotationBodVouchersQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetQuotationBodVouchersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVouchersEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, createdAt: any, updatedAt: any, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string } }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, totalPrice?: any | null }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetSalesOrderBodVouchersQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetSalesOrderBodVouchersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, orderQuote?: any | null, createdAt: any, updatedAt: any, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, translationKey: string }, payments: Array<{ __typename?: 'Payment', id: number, updatedAt: any, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }> }>, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string } }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, totalPrice?: any | null, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number }> }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type RetryQuotationBodGenerationMutationVariables = Exact<{
  input: RetryQuotationBodGenerationInput;
}>;


export type RetryQuotationBodGenerationMutation = { __typename?: 'Mutation', retryQuotationBodGeneration: { __typename?: 'RetryQuotationBodGenerationPayload', bodRetryResult?: { __typename?: 'BodRetryResult', success: boolean, message: string, itemsQueued: number, salesVoucherId?: number | null, paymentId?: number | null } | null } };

export type GetAllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompaniesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', companies: Array<{ __typename?: 'Company', id: number, sunBusinessUnit: string, name: string }> }> };

export type RetrySalesOrderBodGenerationMutationVariables = Exact<{
  input: RetrySalesOrderBodGenerationInput;
}>;


export type RetrySalesOrderBodGenerationMutation = { __typename?: 'Mutation', retrySalesOrderBodGeneration: { __typename?: 'RetrySalesOrderBodGenerationPayload', bodRetryResult?: { __typename?: 'BodRetryResult', success: boolean, message: string, itemsQueued: number, salesVoucherId?: number | null, paymentId?: number | null } | null } };

export type GetPaymentBodItemsQueryVariables = Exact<{
  where?: InputMaybe<PaymentFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetPaymentBodItemsQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number, edges?: Array<{ __typename?: 'PaymentsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Payment', id: number, paymentReference: string, amount: any, amountApproved?: any | null, createdAt: any, updatedAt: any, transactionId?: string | null, postedToJournal: boolean, paymentMode: { __typename?: 'PaymentMode', id: number, name: string, documentType: { __typename?: 'DocumentType', id: number, description: string } }, paymentStatus: { __typename?: 'PaymentStatus', id: number, description: string, translationKey: string }, cheque?: { __typename?: 'Cheque', id: number, chequeNumber: string, chequeStatus: { __typename?: 'ChequeStatus', id: number, description: string, translationKey: string } } | null, salesVoucher?: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, sourceLocation: { __typename?: 'Location', id: number, name: string, company: { __typename?: 'Company', id: number, name: string, sunBusinessUnit: string } } } | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', id: number, journalReference?: string | null, paymentApprovalStatus: { __typename?: 'PaymentApprovalStatus', id: number, description: string } }>, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, company: { __typename?: 'Company', id: number, name: string, sunBusinessUnit: string } } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type RetryPaymentBodGenerationMutationVariables = Exact<{
  input: RetryPaymentJournalPostingBodGenerationInput;
}>;


export type RetryPaymentBodGenerationMutation = { __typename?: 'Mutation', retryPaymentJournalPostingBodGeneration: { __typename?: 'RetryPaymentJournalPostingBodGenerationPayload', bodRetryResult?: { __typename?: 'BodRetryResult', success: boolean, message: string, itemsQueued: number, salesVoucherId?: number | null, paymentId?: number | null } | null } };

export type GetUsersForLocationLinkQueryVariables = Exact<{
  search: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersForLocationLinkQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes?: Array<{ __typename?: 'User', id: number, fullName: string, email: string, userName: string, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string }> }> | null } | null };

export type GetUserForLocationLinkQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetUserForLocationLinkQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes?: Array<{ __typename?: 'User', id: number, fullName: string, email: string, userName: string, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string }> }> | null } | null };

export type AllLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllLocationsQuery = { __typename?: 'Query', allLocations?: { __typename?: 'AllLocationsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Location', code: string, name: string, companyId: number, id: number }> | null } | null };

export type AddUserToLocationMutationVariables = Exact<{
  input: AddUserToLocationInput;
}>;


export type AddUserToLocationMutation = { __typename?: 'Mutation', addUserToLocation: { __typename?: 'AddUserToLocationPayload', user?: { __typename?: 'User', id: number, fullName: string, email: string, userName: string, locations: Array<{ __typename?: 'Location', id: number, name: string, code: string }> } | null } };

export type GetLogisticsSalesVouchersQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetLogisticsSalesVouchersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVouchersEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, updatedAt: any, createdAt: any, orderQuote?: any | null, basket?: { __typename?: 'Basket', basketOrderNumber: string } | null, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, customerVATCode?: string | null, companyId: number }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, isDeliveryInclusive: boolean, quantity: any, destinationId?: number | null, vehicleId?: number | null, driverId?: number | null, vatCode?: string | null, project?: string | null, product: { __typename?: 'Product', uoS?: string | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', description: string } | null }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string }>, transitionalSalesVoucherItems: Array<{ __typename?: 'TransitionalSalesVoucherItem', id: number, changeTypeId: number, oldValue?: string | null, newValue?: string | null, createdAt: any, changeType: { __typename?: 'SalesVoucherItemChangeType', id: number, description: string }, requestedByUser: { __typename?: 'User', id: number, fullName: string } }> }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetSalesVoucherDetailQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
}>;


export type GetSalesVoucherDetailQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, customerVATCode?: string | null, companyId: number }, sourceLocation: { __typename?: 'Location', id: number, name: string, costCentre?: string | null, vatCode?: string | null }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, salesVoucherItemStatusId: number, customerRef?: string | null, deliveryDate?: any | null, quantity: any, vatCode?: string | null, project?: string | null, isDeliveryInclusive: boolean, destinationId?: number | null, vehicleId?: number | null, driverId?: number | null, supplierId?: number | null, product: { __typename?: 'Product', id: number, itemCode: string, title: string, uoS?: string | null }, destination?: { __typename?: 'Destination', id: number, code: string, name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: number, vehicleNo: string, transporterCode?: string | null } | null, driver?: { __typename?: 'Driver', id: number, licenseNo: string, firstName: string, lastName: string } | null, supplier?: { __typename?: 'Supplier', id: number, supplierCode: string, supplierName: string } | null, sourceLocation?: { __typename?: 'Location', id: number, costCentre?: string | null } | null, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string }>, transitionalSalesVoucherItems: Array<{ __typename?: 'TransitionalSalesVoucherItem', id: number, changeTypeId: number, oldValue?: string | null, newValue?: string | null, createdAt: any, changeType: { __typename?: 'SalesVoucherItemChangeType', id: number, description: string }, requestedByUser: { __typename?: 'User', id: number, fullName: string } }> }> }> | null } | null };

export type GetPendingDeliveryDateChangesCountQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
}>;


export type GetPendingDeliveryDateChangesCountQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number } | null };

export type GetPendingDeliveryDateChangeItemsCountQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherItemFilterInput>;
}>;


export type GetPendingDeliveryDateChangeItemsCountQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number } | null };

export type GetLogisticsPendingChangeRequestItemsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherItemFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherItemSortInput> | SalesVoucherItemSortInput>;
}>;


export type GetLogisticsPendingChangeRequestItemsQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, deliveryDate?: any | null, destinationId?: number | null, vatCode?: string | null, isDeliveryInclusive: boolean, createdAt: any, updatedAt: any, product: { __typename?: 'Product', title: string, itemCode: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: number, description: string } | null }, destination?: { __typename?: 'Destination', id: number, code: string, name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: number, vehicleNo: string, transporterCode?: string | null } | null, driver?: { __typename?: 'Driver', id: number, firstName: string, lastName: string } | null, supplier?: { __typename?: 'Supplier', id: number, supplierName: string } | null, salesVoucher: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, createdAt: any, updatedAt: any, sourceLocationId: number, orderQuote?: any | null, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, companyId: number } }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string }>, transitionalSalesVoucherItems: Array<{ __typename?: 'TransitionalSalesVoucherItem', id: number, changeTypeId: number, oldValue?: string | null, newValue?: string | null, createdAt: any, changeType: { __typename?: 'SalesVoucherItemChangeType', id: number, description: string }, requestedByUser: { __typename?: 'User', id: number, userName: string, fullName: string } }> }> | null } | null };

export type ApprovePendingDeliveryDateMutationVariables = Exact<{
  input: ApprovePendingDeliveryDateInput;
}>;


export type ApprovePendingDeliveryDateMutation = { __typename?: 'Mutation', approvePendingDeliveryDate: { __typename?: 'ApprovePendingDeliveryDatePayload', salesVoucherItem?: { __typename?: 'SalesVoucherItem', id: number, deliveryDate?: any | null, transitionalSalesVoucherItems: Array<{ __typename?: 'TransitionalSalesVoucherItem', id: number, changeTypeId: number, oldValue?: string | null, newValue?: string | null }> } | null } };

export type RejectPendingDeliveryDateMutationVariables = Exact<{
  input: RejectPendingDeliveryDateInput;
}>;


export type RejectPendingDeliveryDateMutation = { __typename?: 'Mutation', rejectPendingDeliveryDate: { __typename?: 'RejectPendingDeliveryDatePayload', salesVoucherItem?: { __typename?: 'SalesVoucherItem', id: number, deliveryDate?: any | null, transitionalSalesVoucherItems: Array<{ __typename?: 'TransitionalSalesVoucherItem', id: number, changeTypeId: number, oldValue?: string | null, newValue?: string | null }> } | null } };

export type GetDistinctVatCodesQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetDistinctVatCodesQuery = { __typename?: 'Query', distinctVatCodes: Array<string> };

export type SearchDestinationsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  where?: InputMaybe<DestinationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDestinationsQuery = { __typename?: 'Query', destinations?: { __typename?: 'DestinationsConnection', nodes?: Array<{ __typename?: 'Destination', id: number, code: string, name?: string | null }> | null } | null };

export type SearchVehiclesQueryVariables = Exact<{
  where: VehicleFilterInput;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchVehiclesQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesConnection', nodes?: Array<{ __typename?: 'Vehicle', id: number, vehicleNo: string, transporterCode?: string | null, isActive: boolean, isBanned: boolean }> | null } | null };

export type SearchDriversQueryVariables = Exact<{
  where: DriverFilterInput;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDriversQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriversConnection', nodes?: Array<{ __typename?: 'Driver', id: number, licenseNo: string, firstName: string, lastName: string, isActive: boolean, isBanned: boolean }> | null } | null };

export type UpdateSalesVoucherItemsMutationVariables = Exact<{
  input: UpdateSalesVoucherItemsInput;
}>;


export type UpdateSalesVoucherItemsMutation = { __typename?: 'Mutation', updateSalesVoucherItems: { __typename?: 'UpdateSalesVoucherItemsPayload', salesVoucherItem?: Array<{ __typename?: 'SalesVoucherItem', id: number, customerRef?: string | null, deliveryDate?: any | null, quantity: any, vatCode?: string | null, project?: string | null, destinationId?: number | null, supplierId?: number | null, vehicleId?: number | null, driverId?: number | null, destination?: { __typename?: 'Destination', id: number, code: string, name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: number, vehicleNo: string, transporterCode?: string | null } | null, driver?: { __typename?: 'Driver', id: number, licenseNo: string, firstName: string, lastName: string } | null, supplier?: { __typename?: 'Supplier', id: number, supplierCode: string, supplierName: string } | null }> | null } };

export type VoidDeliveredOrdersSalesVoucherMutationVariables = Exact<{
  input: VoidDeliveredOrdersSalesVoucherInput;
}>;


export type VoidDeliveredOrdersSalesVoucherMutation = { __typename?: 'Mutation', voidDeliveredOrdersSalesVoucher: { __typename?: 'VoidDeliveredOrdersSalesVoucherPayload', boolean?: boolean | null } };

export type BulkVoidDeliveredOrdersSalesVouchersMutationVariables = Exact<{
  input: BulkVoidDeliveredOrdersSalesVouchersInput;
}>;


export type BulkVoidDeliveredOrdersSalesVouchersMutation = { __typename?: 'Mutation', bulkVoidDeliveredOrdersSalesVouchers: { __typename?: 'BulkVoidDeliveredOrdersSalesVouchersPayload', boolean?: boolean | null } };

export type ConfirmDeliveredOrdersMutationVariables = Exact<{
  input: ConfirmDeliveredOrdersInput;
}>;


export type ConfirmDeliveredOrdersMutation = { __typename?: 'Mutation', confirmDeliveredOrders: { __typename?: 'ConfirmDeliveredOrdersPayload', salesVoucher?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string } }> | null } };

export type ValidateDeliveredOrderItemsMutationVariables = Exact<{
  input: ValidateDeliveredOrderItemsInput;
}>;


export type ValidateDeliveredOrderItemsMutation = { __typename?: 'Mutation', validateDeliveredOrderItems: { __typename?: 'ValidateDeliveredOrderItemsPayload', deliveredItemValidationResult?: Array<{ __typename?: 'DeliveredItemValidationResult', rowIndex: number, destinationCode?: string | null, isDestinationValid: boolean, destinationError?: string | null, resolvedDestinationId?: number | null, vehicleNo?: string | null, isVehicleValid: boolean, vehicleError?: string | null, resolvedVehicleId?: number | null, driverLicenseNo?: string | null, isDriverValid: boolean, driverError?: string | null, resolvedDriverId?: number | null, vatCode?: string | null, isVATCodeValid: boolean, vatCodeError?: string | null, quantity?: any | null, isQuantityValid: boolean, quantityError?: string | null, customerRef?: string | null, isCustomerRefValid: boolean, customerRefError?: string | null, project?: string | null, isProjectValid: boolean, isRowValid: boolean, destination?: { __typename?: 'Destination', id: number, code: string, name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: number, vehicleNo: string, transporterCode?: string | null, isActive: boolean, isBanned: boolean } | null, driver?: { __typename?: 'Driver', id: number, licenseNo: string, firstName: string, lastName: string, isActive: boolean, isBanned: boolean } | null }> | null } };

export type GetActiveTransportersByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetActiveTransportersByCompanyQuery = { __typename?: 'Query', suppliers?: { __typename?: 'SuppliersConnection', totalCount: number, nodes?: Array<{ __typename?: 'Supplier', id: number, supplierName: string, supplierCode: string, companyId: number }> | null } | null };

export type SearchProductsForVoucherQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchProductsForVoucherQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsConnection', nodes?: Array<{ __typename?: 'Product', id: number, itemCode: string, title: string, uoS?: string | null }> | null } | null };

export type UpsertPaymentApprovalMutationVariables = Exact<{
  input: UpsertPaymentApprovalInput;
}>;


export type UpsertPaymentApprovalMutation = { __typename?: 'Mutation', upsertPaymentApproval: { __typename?: 'UpsertPaymentApprovalPayload', paymentApproval?: { __typename?: 'PaymentApproval', id: number, paymentApprovalStatusId: number } | null } };

export type ApprovePaymentMutationVariables = Exact<{
  input: ApprovePaymentInput;
}>;


export type ApprovePaymentMutation = { __typename?: 'Mutation', approvePayment: { __typename?: 'ApprovePaymentPayload', payment?: { __typename?: 'Payment', id: number, paymentStatusId: number, createdAt: any } | null } };

export type UpsertPaymentTranscriptionMutationVariables = Exact<{
  input: UpsertPaymentTranscriptionInput;
}>;


export type UpsertPaymentTranscriptionMutation = { __typename?: 'Mutation', upsertPaymentTranscription: { __typename?: 'UpsertPaymentTranscriptionPayload', paymentTranscription?: { __typename?: 'PaymentTranscription', id: number } | null } };

export type UpsertPaymentMutationVariables = Exact<{
  input: UpsertPaymentInput;
}>;


export type UpsertPaymentMutation = { __typename?: 'Mutation', upsertPayment: { __typename?: 'UpsertPaymentPayload', payment?: { __typename?: 'Payment', id: number } | null } };

export type GetManualPaymentQueryVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type GetManualPaymentQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', nodes?: Array<{ __typename?: 'Payment', id: number, createdAt: any, amount: any, availableBalanceRef?: string | null, paymentModeId: number, paymentReference: string, transactionId?: string | null, updatedAt: any, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, customerCurrency?: string | null, businessUnitCurrency?: string | null, companyId: number, locations: Array<{ __typename?: 'Location', id: number }> }, paymentApprovals: Array<{ __typename?: 'PaymentApproval', id: number, amountApproved: any, settlementBankId?: number | null, reasonId?: number | null, paymentApprovalStatusId: number, journalReference?: string | null }>, salesVoucher?: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, orderQuote?: any | null, createdAt: any, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, trucksCount: number, unitPrice?: any | null, quantity: any, product: { __typename?: 'Product', description: string, title: string, itemCode: string, featuredImageUrl?: string | null, uoS?: string | null }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', salesOrderNumber: string }> }>, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, email?: string | null, phoneNumber?: any | null, createdAt: any, customerCurrency?: string | null, businessUnitCurrency?: string | null } } | null, paymentMode: { __typename?: 'PaymentMode', id: number, name: string, paymentModeTypeId: number, documentType: { __typename?: 'DocumentType', id: number, description: string, translationKey: string } }, paymentStatus: { __typename?: 'PaymentStatus', id: number, description: string }, paymentTranscriptions: Array<{ __typename?: 'PaymentTranscription', id: number, amount: any, bankId?: number | null, bankBranchId?: number | null, createdAt: any, documentTypeId: number, depositorContact?: string | null, depositorName?: string | null, documentDate: any, documentReference?: string | null, notes?: string | null, paymentId: number, paymentTranscriptionStatusId: number, updatedAt: any, bank?: { __typename?: 'Bank', id: number, name: string } | null, bankBranch?: { __typename?: 'BankBranch', id: number, name: string } | null, documentType: { __typename?: 'DocumentType', id: number, description: string, translationKey: string }, payment: { __typename?: 'Payment', id: number, customer: { __typename?: 'Customer', customerName: string, customerCurrency?: string | null, businessUnitCurrency?: string | null }, salesVoucher?: { __typename?: 'SalesVoucher', orderQuote?: any | null } | null }, paymentTranscriptionStatus: { __typename?: 'PaymentTranscriptionStatus', id: number, description: string }, createdBy?: { __typename?: 'User', id: number, email: string, fullName: string, userName: string } | null }>, paymentDocuments: Array<{ __typename?: 'PaymentDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, paymentId: number, updatedAt: any }> }> | null } | null };

export type GetPaymentTranscriptionsQueryVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type GetPaymentTranscriptionsQuery = { __typename?: 'Query', paymentTranscriptions?: { __typename?: 'PaymentTranscriptionsConnection', nodes?: Array<{ __typename?: 'PaymentTranscription', id: number, amount: any, bankId?: number | null, bankBranchId?: number | null, createdAt: any, depositorContact?: string | null, depositorName?: string | null, documentDate: any, documentReference?: string | null, documentTypeId: number, notes?: string | null, paymentId: number, paymentTranscriptionStatusId: number, updatedAt: any, bank?: { __typename?: 'Bank', id: number, name: string } | null, bankBranch?: { __typename?: 'BankBranch', id: number, name: string } | null, documentType: { __typename?: 'DocumentType', id: number, description: string, translationKey: string }, payment: { __typename?: 'Payment', id: number, availableBalanceRef?: string | null, paymentModeId: number, amount: any, salesVoucher?: { __typename?: 'SalesVoucher', orderQuote?: any | null } | null, customer: { __typename?: 'Customer', customerName: string, customerCurrency?: string | null, businessUnitCurrency?: string | null } }, paymentTranscriptionStatus: { __typename?: 'PaymentTranscriptionStatus', id: number, description: string }, createdBy?: { __typename?: 'User', id: number, email: string, fullName: string, userName: string } | null }> | null } | null };

export type GetPaymentApprovalsQueryVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type GetPaymentApprovalsQuery = { __typename?: 'Query', paymentApprovals?: { __typename?: 'PaymentApprovalsConnection', nodes?: Array<{ __typename?: 'PaymentApproval', id: number, createdAt: any, approvalComment?: string | null, amountApproved: any, settlementBankId?: number | null, paymentApprovalStatusId: number, paymentApprovalTypeId: number, rejectionComment?: string | null, settlementBank?: { __typename?: 'SettlementBank', id: number, name: string } | null, paymentApprovalStatus: { __typename?: 'PaymentApprovalStatus', id: number, description: string }, createdBy?: { __typename?: 'User', id: number, email: string, fullName: string, userName: string } | null }> | null } | null };

export type GetCustomerBankGuaranteeQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
  bankid: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type GetCustomerBankGuaranteeQuery = { __typename?: 'Query', bankGuarantees: Array<{ __typename?: 'BankGuarantee', id: number, customerId: number, expiryDate: any, reference: string, issuedDate: any, customer: { __typename?: 'Customer', customerName: string, customerCode: string }, salesOffice: { __typename?: 'Location', name: string }, guaranteeBank: { __typename?: 'Bank', name: string, code: string } }> };

export type GetPaymentAccessQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetPaymentAccessQuery = { __typename?: 'Query', paymentAccess: { __typename?: 'PaymentAccess', kind: PaymentAccessKind, companyId: number, locationIds: Array<number>, sessionLocationId?: number | null } };

export type GetPaymentLocationScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentLocationScopesQuery = { __typename?: 'Query', paymentLocationScopes: Array<{ __typename?: 'PaymentLocationScope', companyId: number, companyName: string, kind: PaymentAccessKind, sessionLocationId?: number | null, locations: Array<{ __typename?: 'PaymentScopeLocation', id: number, name: string, code: string }> }> };

export type GetPaymentsDataQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  where?: InputMaybe<PaymentFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetPaymentsDataQuery = { __typename?: 'Query', backOfficePayments?: { __typename?: 'BackOfficePaymentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'BackOfficePaymentsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Payment', id: number, amount: any, createdAt: any, postedToJournal: boolean, paymentModeId: number, paymentReference: string, amountApproved?: any | null, transactionId?: string | null, updatedAt: any, paymentMode: { __typename?: 'PaymentMode', name: string, id: number }, customer: { __typename?: 'Customer', customerName: string, customerCode: string, companyId: number, customerCurrency?: string | null, businessUnitCurrency?: string | null }, salesVoucher?: { __typename?: 'SalesVoucher', id: number, orderQuote?: any | null, voucherNumber: string, sourceLocationId: number, createdAt: any, customer: { __typename?: 'Customer', customerName: string, customerCode: string } } | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null, updatedAt: any }>, paymentStatus: { __typename?: 'PaymentStatus', id: number, translationKey: string, description: string }, paymentDocuments: Array<{ __typename?: 'PaymentDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, paymentId: number, updatedAt: any }> }> | null } | null };

export type GetSalesVoucherPaymentsQueryVariables = Exact<{
  salesVoucherId: Scalars['Int']['input'];
}>;


export type GetSalesVoucherPaymentsQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', nodes?: Array<{ __typename?: 'Payment', id: number, amount: any, paymentModeId: number, paymentReference: string, transactionId?: string | null, updatedAt: any, paymentMode: { __typename?: 'PaymentMode', name: string, id: number }, salesVoucher?: { __typename?: 'SalesVoucher', id: number } | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }>, paymentStatus: { __typename?: 'PaymentStatus', id: number, translationKey: string, description: string }, paymentDocuments: Array<{ __typename?: 'PaymentDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, paymentId: number, updatedAt: any }> }> | null } | null };

export type GetPaymentByIdQueryVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type GetPaymentByIdQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', nodes?: Array<{ __typename?: 'Payment', id: number, amount: any, paymentModeId: number, paymentReference: string, transactionId?: string | null, updatedAt: any, paymentMode: { __typename?: 'PaymentMode', name: string, id: number }, salesVoucher?: { __typename?: 'SalesVoucher', id: number } | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }>, paymentStatus: { __typename?: 'PaymentStatus', id: number, translationKey: string, description: string }, paymentDocuments: Array<{ __typename?: 'PaymentDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, paymentId: number, updatedAt: any }> }> | null } | null };

export type GetPendingPaymentsSummaryQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPendingPaymentsSummaryQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'PaymentsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'Payment', id: number, amount: any, paymentMode: { __typename?: 'PaymentMode', name: string }, customer: { __typename?: 'Customer', customerName: string, customerCode: string, companyId: number, customerCurrency?: string | null, businessUnitCurrency?: string | null }, salesVoucher?: { __typename?: 'SalesVoucher', voucherNumber: string, sourceLocationId: number, customer: { __typename?: 'Customer', customerName: string } } | null, paymentStatus: { __typename?: 'PaymentStatus', translationKey: string, description: string } }> | null } | null };

export type GetCheckIfBankReferenceIsReusedQueryVariables = Exact<{
  bankReference: Scalars['String']['input'];
  bankId: Scalars['Int']['input'];
  paymentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCheckIfBankReferenceIsReusedQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number } | null };

export type GetPaymentImageDownloadUrlQueryVariables = Exact<{
  blobName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type GetPaymentImageDownloadUrlQuery = { __typename?: 'Query', paymentImageDownloadUrl: string };

export type GetAvailableBalancePaymentDetailsQueryVariables = Exact<{
  documentRef: Scalars['String']['input'];
}>;


export type GetAvailableBalancePaymentDetailsQuery = { __typename?: 'Query', remainingBalanceForPaymentReference: { __typename?: 'AvailableBalanceResponse', amountPendingApproval: any, remainingBalance: any, totalAmount: any, amountUsed: any, cashDepositSlipNumber: string, depositorName: string, chequeDate?: any | null, paymentMode: string, bank: string } };

export type GetPaymentModesQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetPaymentModesQuery = { __typename?: 'Query', paymentModes: Array<{ __typename?: 'PaymentMode', name: string, id: number }> };

export type GetPlannerSalesVoucherItemsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherItemFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesVoucherItemSortInput> | SalesVoucherItemSortInput>;
}>;


export type GetPlannerSalesVoucherItemsQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, unitPrice?: any | null, totalPrice?: any | null, createdAt: any, updatedAt: any, deliveryDate?: any | null, productId: number, salesVoucherId: number, salesVoucherStatusId: number, customerRef?: string | null, trucksCount: number, destinationId?: number | null, quotationId?: string | null, currency?: string | null, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, product: { __typename?: 'Product', id: number, title: string, itemCode: string, uoS?: string | null }, destination?: { __typename?: 'Destination', id: number, name?: string | null, code: string } | null, salesVoucher: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, orderQuote?: any | null, customerId: number, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, phoneNumber?: any | null }, sourceLocation: { __typename?: 'Location', id: number, name: string, code: string } }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string, quantity: any, amountTotal?: any | null, currency?: string | null, vehicleNumber?: string | null, driverLicenseNo?: string | null, transporterCode?: string | null, salesVoucherOrderStatusId: number, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', id: number, description: string, translationKey: string }, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string }, product?: { __typename?: 'Product', id: number, title: string, itemCode: string } | null, destination?: { __typename?: 'Destination', id: number, name?: string | null } | null }> }> | null } | null };

export type GetPlannerSalesVoucherItemByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPlannerSalesVoucherItemByIdQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, unitPrice?: any | null, totalPrice?: any | null, createdAt: any, updatedAt: any, deliveryDate?: any | null, productId: number, salesVoucherId: number, salesVoucherStatusId: number, customerRef?: string | null, trucksCount: number, destinationId?: number | null, quotationId?: string | null, currency?: string | null, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, product: { __typename?: 'Product', id: number, title: string, itemCode: string, uoS?: string | null }, destination?: { __typename?: 'Destination', id: number, name?: string | null, code: string } | null, salesVoucher: { __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, orderQuote?: any | null, customerId: number, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string, phoneNumber?: any | null }, sourceLocation: { __typename?: 'Location', id: number, name: string, code: string } }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string, quantity: any, amountTotal?: any | null, currency?: string | null, vehicleNumber?: string | null, driverLicenseNo?: string | null, transporterCode?: string | null, salesVoucherOrderStatusId: number, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', id: number, description: string, translationKey: string }, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string }, product?: { __typename?: 'Product', id: number, title: string, itemCode: string } | null, destination?: { __typename?: 'Destination', id: number, name?: string | null } | null }> }> | null } | null };

export type UpdateSalesVoucherDeliveryDateMutationVariables = Exact<{
  input: SetDeliveryDateInput;
}>;


export type UpdateSalesVoucherDeliveryDateMutation = { __typename?: 'Mutation', setDeliveryDate: { __typename?: 'SetDeliveryDatePayload', salesVoucherItem?: { __typename?: 'SalesVoucherItem', id: number, deliveryDate?: any | null } | null } };

export type UpsertQuickFilterMutationVariables = Exact<{
  input: UpsertPredefinedReportFilterInput;
}>;


export type UpsertQuickFilterMutation = { __typename?: 'Mutation', upsertPredefinedReportFilter: { __typename?: 'UpsertPredefinedReportFilterPayload', predefinedReportFilter?: { __typename?: 'PredefinedReportFilter', id: number, name: string } | null } };

export type GetQuickFiltersQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  reportTypeId: Scalars['Int']['input'];
}>;


export type GetQuickFiltersQuery = { __typename?: 'Query', predefinedReportFilters: Array<{ __typename?: 'PredefinedReportFilter', id: number, name: string, data: string, locationId: number, reportTypeId: number, reportType: { __typename?: 'ReportType', description: string } }> };

export type DeleteQuickFilterMutationVariables = Exact<{
  input: DeletePredefinedReportFilterInput;
}>;


export type DeleteQuickFilterMutation = { __typename?: 'Mutation', deletePredefinedReportFilter: { __typename?: 'DeletePredefinedReportFilterPayload', boolean?: boolean | null } };

export type GetSalesVouchersByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<SortEnumType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSalesVouchersByCompanyQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, createdAt: any, voucherNumber: string, orderQuote?: any | null, salesVoucherStatusId: number, destinationId?: number | null, companyId: number, destination?: { __typename?: 'Destination', id: number, name?: string | null } | null, createdBy: { __typename?: 'User', id: number, email: string, fullName: string, userName: string }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string }, sourceLocation: { __typename?: 'Location', id: number, name: string }, customer: { __typename?: 'Customer', id: number, customerName: string, customerCode: string }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, trucksCount: number, isDeliveryInclusive: boolean, destination?: { __typename?: 'Destination', id: number, name?: string | null } | null, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', salesOrderNumber: string, quotationId?: string | null, salesInvoiceNumber?: string | null, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', description: string } }>, product: { __typename?: 'Product', id: number, title: string, description: string, itemCode: string } }>, payments: Array<{ __typename?: 'Payment', id: number, paymentReference: string, paymentStatusId: number, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }>, paymentStatus: { __typename?: 'PaymentStatus', id: number } }> }> | null } | null };

export type GetEPaymentsByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<SortEnumType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEPaymentsByCompanyQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Payment', amount: any, amountApproved?: any | null, createdAt: any, customReference?: string | null, id: number, paymentReference: string, paymentStatusId: number, rejectionComment?: string | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', approvalComment?: string | null, journalReference?: string | null, createdBy?: { __typename?: 'User', id: number, email: string, fullName: string, userName: string } | null }>, paymentMode: { __typename?: 'PaymentMode', id: number, name: string, documentType: { __typename?: 'DocumentType', id: number, description: string } }, paymentStatus: { __typename?: 'PaymentStatus', id: number, description: string }, reason?: { __typename?: 'Reason', detail: string } | null }> | null } | null };

export type GetManualPaymentsByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<SortEnumType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManualPaymentsByCompanyQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Payment', amount: any, amountApproved?: any | null, createdAt: any, updatedAt: any, customReference?: string | null, id: number, paymentReference: string, paymentStatusId: number, rejectionComment?: string | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null, approvalComment?: string | null, createdAt: any, paymentApprovalStatus: { __typename?: 'PaymentApprovalStatus', id: number, description: string }, createdBy?: { __typename?: 'User', id: number, email: string, fullName: string, userName: string } | null }>, paymentMode: { __typename?: 'PaymentMode', id: number, name: string, documentType: { __typename?: 'DocumentType', id: number, description: string } }, paymentStatus: { __typename?: 'PaymentStatus', id: number, description: string }, reason?: { __typename?: 'Reason', detail: string } | null, customer: { __typename?: 'Customer', customerCode: string, customerName: string }, salesVoucher?: { __typename?: 'SalesVoucher', voucherNumber: string, sourceLocationId: number, customer: { __typename?: 'Customer', customerCode: string, customerName: string } } | null, paymentTranscriptions: Array<{ __typename?: 'PaymentTranscription', createdAt: any, createdBy?: { __typename?: 'User', id: number, email: string, userName: string, fullName: string } | null }> }> | null } | null };

export type GetSalesVoucherOrdersByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<SortEnumType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSalesVoucherOrdersByCompanyQuery = { __typename?: 'Query', salesVoucherOrders?: { __typename?: 'SalesVoucherOrdersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'SalesVoucherOrder', id: number, companyId: number, salesOrderNumber: string, customerRef?: string | null, paymentRef?: string | null, createdAt: any, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', description: string, translationKey: string }, salesVoucher?: { __typename?: 'SalesVoucher', voucherNumber: string, orderQuote?: any | null, sourceLocationId: number, payments: Array<{ __typename?: 'Payment', paymentReference: string, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }> }> } | null, customer: { __typename?: 'Customer', customerName: string, customerCode: string }, salesVoucherItem?: { __typename?: 'SalesVoucherItem', quotationId?: string | null, quantity: any, totalPrice?: any | null, product: { __typename?: 'Product', itemCode: string } } | null }> | null } | null };

export type GetUserReportQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
}>;


export type GetUserReportQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'User', id: number, userName: string, fullName: string, email: string, locationId?: number | null, companyId: number, phoneNumber?: any | null, createdAt: any, companies: Array<{ __typename?: 'Company', id: number, name: string, code: string }>, location?: { __typename?: 'Location', id: number, name: string, code: string, type: string } | null, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type DfsChequeManagementDetailsReportQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DfsChequeManagementDetailsReportQuery = { __typename?: 'Query', payments?: { __typename?: 'PaymentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Payment', paymentReference: string, amountApproved?: any | null, amount: any, customer: { __typename?: 'Customer', customerName: string, customerCode: string }, cheque?: { __typename?: 'Cheque', chequeNumber: string, chequeStatus: { __typename?: 'ChequeStatus', translationKey: string, description: string } } | null, paymentApprovals: Array<{ __typename?: 'PaymentApproval', paymentApprovalStatusId: number, createdAt: any, bankGuarantee?: { __typename?: 'BankGuarantee', expiryDate: any, guaranteeBank: { __typename?: 'Bank', name: string } } | null }>, salesVoucher?: { __typename?: 'SalesVoucher', sourceLocationId: number } | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetActiveUserSalesReportQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetActiveUserSalesReportQuery = { __typename?: 'Query', customerSalesActivityReport: Array<{ __typename?: 'CustomerSalesActivityReport', customerName: string, customerCode: string, lastActivityDate: any, salesVolume: any, totalSalesAmount: any }> };

export type GetActiveUserOrdersReportQueryVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
}>;


export type GetActiveUserOrdersReportQuery = { __typename?: 'Query', customerOrdersActivityReport: Array<{ __typename?: 'CustomerActivityReport', customerName: string, customerCode: string, lastActivityDate: any, orderVolume: any, totalOrderAmount: any }> };

export type GetPendingCancellationRequestsQueryVariables = Exact<{
  where?: InputMaybe<SalesVoucherFilterInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPendingCancellationRequestsQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, createdAt: any, updatedAt: any, orderQuote?: any | null, customer: { __typename?: 'Customer', customerName: string, customerCode: string, customerCurrency?: string | null, businessUnitCurrency?: string | null, companyId: number }, createdBy: { __typename?: 'User', id: number, userName: string, fullName: string }, sourceLocation: { __typename?: 'Location', name: string }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, salesVoucherStatusId: number, isDeliveryInclusive: boolean, product: { __typename?: 'Product', uoS?: string | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', description: string } | null } }> }> | null } | null };

export type GetCancellationVoucherDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCancellationVoucherDetailQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, createdAt: any, updatedAt: any, comments?: string | null, description?: string | null, localPurchaseOrder?: string | null, customerReference?: string | null, orderQuote?: any | null, customer: { __typename?: 'Customer', customerName: string, customerCode: string, customerCurrency?: string | null, businessUnitCurrency?: string | null, companyId: number }, createdBy: { __typename?: 'User', id: number, userName: string, fullName: string }, sourceLocation: { __typename?: 'Location', name: string }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, salesVoucherDocuments: Array<{ __typename?: 'SalesVoucherDocument', documentName?: string | null, documentUrl: string }>, payments: Array<{ __typename?: 'Payment', paymentReference: string, paymentMode: { __typename?: 'PaymentMode', name: string } }>, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, quantity: any, cancellationReason?: string | null, salesVoucherStatusId: number, isDeliveryInclusive: boolean, customerRef?: string | null, product: { __typename?: 'Product', title: string, uoS?: string | null }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', salesOrderNumber: string, customerRef?: string | null, quantity: any, uoS?: string | null, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', id: number, description: string, translationKey: string } }> }> }> | null } | null };

export type ResolveVoidOrderRequestMutationVariables = Exact<{
  input: ResolveVoidOrderRequestInput;
}>;


export type ResolveVoidOrderRequestMutation = { __typename?: 'Mutation', resolveVoidOrderRequest: { __typename?: 'ResolveVoidOrderRequestPayload', salesVoucher?: { __typename?: 'SalesVoucher', id: number } | null } };

export type GetPaginatedSalesVouchersQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  locationIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  where?: InputMaybe<SalesVoucherFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortEnumType>;
}>;


export type GetPaginatedSalesVouchersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'BackOfficeSalesVouchersConnection', totalCount: number, edges?: Array<{ __typename?: 'BackOfficeSalesVouchersEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, customOrderNumber?: string | null, customerId: number, orderQuote?: any | null, updatedAt: any, createdAt: any, customer: { __typename?: 'Customer', customerName: string, customerCode: string, companyId: number, customerCurrency?: string | null, businessUnitCurrency?: string | null }, createdBy: { __typename?: 'User', id: number, userName: string, email: string, fullName: string }, sourceLocation: { __typename?: 'Location', id: number, name: string }, destination?: { __typename?: 'Destination', name?: string | null } | null, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string }, payments: Array<{ __typename?: 'Payment', amount: any, id: number, paymentMode: { __typename?: 'PaymentMode', name: string } }>, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', id: number, isDeliveryInclusive: boolean, quantity: any, product: { __typename?: 'Product', unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: number, description: string } | null, productMeasurement?: { __typename?: 'ProductMeasurement', id: number, description: string } | null } }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type SalesVouchersCountQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type SalesVouchersCountQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', totalCount: number } | null };

export type GetSalesVouchersQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetSalesVouchersQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string }> | null } | null };

export type GetSalesVoucherQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type GetSalesVoucherQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'SalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', id: number, voucherNumber: string, customerReference?: string | null, customOrderNumber?: string | null, customerId: number, orderQuote?: any | null, updatedAt: any, createdAt: any, customer: { __typename?: 'Customer', customerName: string, customerCode: string } }> | null } | null };

export type UpsertSalesVoucherMutationVariables = Exact<{
  input: UpsertSalesVoucherInput;
}>;


export type UpsertSalesVoucherMutation = { __typename?: 'Mutation', upsertSalesVoucher: { __typename?: 'UpsertSalesVoucherPayload', salesVoucher?: { __typename?: 'SalesVoucher', id: number } | null } };

export type GetSalesVoucherDatailsByOrderIdQueryVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type GetSalesVoucherDatailsByOrderIdQuery = { __typename?: 'Query', salesVouchers?: { __typename?: 'BackOfficeSalesVouchersConnection', nodes?: Array<{ __typename?: 'SalesVoucher', voucherNumber: string, createdAt: any, comments?: string | null, deliveryContact?: string | null, description?: string | null, orderQuote?: any | null, salesVoucherItems: Array<{ __typename?: 'SalesVoucherItem', createdAt: any, deliveryDate?: any | null, quotationId?: string | null, customerRef?: string | null, id: number, trucksCount: number, quantity: any, totalPrice?: any | null, destination?: { __typename?: 'Destination', code: string, name?: string | null } | null, driver?: { __typename?: 'Driver', fullName: string, firstName: string, lastName: string } | null, vehicle?: { __typename?: 'Vehicle', vehicleNo: string } | null, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', salesOrderNumber: string, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', description: string, translationKey: string } }>, product: { __typename?: 'Product', itemCode: string, title: string, uoS?: string | null }, vehicleRequest?: { __typename?: 'VehicleRequest', licensePlate: string, transporterCode?: string | null, vehicleTypeId?: number | null, id: number, vehicleRequestStatusId: number, vehicleType: { __typename?: 'VehicleType', description: string, translationKey: string, id: number }, vehicleRequestStatus: { __typename?: 'VehicleRequestStatus', description: string, translationKey: string, id: number } } | null, driverRequest?: { __typename?: 'DriverRequest', id: number, licenseNo: string, firstName: string, lastName: string, transporterCode?: string | null, licenseExpDate: any, driverRequestStatusId: number, driverRequestStatus: { __typename?: 'DriverRequestStatus', description: string, translationKey: string, id: number } } | null }>, customer: { __typename?: 'Customer', customerName: string, customerCode: string, phoneNumber?: any | null, active: boolean, customerCurrency?: string | null, businessUnitCurrency?: string | null }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', description: string, translationKey: string }, payments: Array<{ __typename?: 'Payment', id: number, amount: any, amountApproved?: any | null, salesVoucherId?: number | null, transactionId?: string | null, createdAt: any, paymentReference: string, paymentStatus: { __typename?: 'PaymentStatus', description: string, translationKey: string, id: number }, paymentMode: { __typename?: 'PaymentMode', name: string }, paymentDocuments: Array<{ __typename?: 'PaymentDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, updatedAt: any }>, paymentApprovals: Array<{ __typename?: 'PaymentApproval', journalReference?: string | null }> }>, sourceLocation: { __typename?: 'Location', code: string, pmEmployee: boolean, contact?: { __typename?: 'Contact', telephoneNumber: string, email?: string | null } | null }, salesVoucherDocuments: Array<{ __typename?: 'SalesVoucherDocument', createdAt: any, documentName?: string | null, documentUrl: string, id: number, updatedAt: any }> }> | null } | null };

export type GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables = Exact<{
  salesVoucherItemId: Scalars['Int']['input'];
}>;


export type GetSalesVoucherOrdersBySalesVoucherItemIdQuery = { __typename?: 'Query', salesVoucherOrders?: { __typename?: 'SalesVoucherOrdersConnection', nodes?: Array<{ __typename?: 'SalesVoucherOrder', id: number, salesOrderNumber: string, paymentRef?: string | null, quantity: any, uoS?: string | null, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', description: string, translationKey: string }, destination?: { __typename?: 'Destination', name?: string | null } | null, salesVoucherItem?: { __typename?: 'SalesVoucherItem', id: number, trucksCount: number, quantity: any, createdAt: any, destination?: { __typename?: 'Destination', name?: string | null } | null, product: { __typename?: 'Product', itemCode: string, title: string, uoS?: string | null } } | null }> | null } | null };

export type GetPaginatedSalesOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  salesVoucher?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedSalesOrdersQuery = { __typename?: 'Query', salesVoucherOrders?: { __typename?: 'SalesVoucherOrdersConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVoucherOrdersEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucherOrder', quotationId?: string | null, salesOrderNumber: string, createdAt: any, updatedAt: any, salesVoucherItem?: { __typename?: 'SalesVoucherItem', salesVoucher: { __typename?: 'SalesVoucher', orderQuote?: any | null, voucherNumber: string, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', description: string, translationKey: string }, customer: { __typename?: 'Customer', customerCode: string, customerName: string } }, product: { __typename?: 'Product', itemCode: string } } | null, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', description: string, translationKey: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetPaginatedSalesVoucherItemsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedSalesVoucherItemsQuery = { __typename?: 'Query', salesVoucherItems?: { __typename?: 'SalesVoucherItemsConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesVoucherItemsEdge', cursor: string }> | null, nodes?: Array<{ __typename?: 'SalesVoucherItem', id: number, quotationId?: string | null, updatedAt: any, createdAt: any, salesVoucher: { __typename?: 'SalesVoucher', voucherNumber: string, orderQuote?: any | null, customer: { __typename?: 'Customer', customerName: string, customerCode: string }, createdBy: { __typename?: 'User', id: number, email: string, fullName: string, userName: string }, salesVoucherStatus: { __typename?: 'SalesVoucherStatus', id: number, description: string, translationKey: string } }, salesVoucherOrders: Array<{ __typename?: 'SalesVoucherOrder', salesOrderNumber: string, salesVoucherOrderStatus: { __typename?: 'SalesVoucherOrderStatus', id: number, description: string } }>, product: { __typename?: 'Product', itemCode: string } }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };


export const PermissionStateDocument = gql`
    query PermissionState {
  permissionState @client {
    permissions
  }
}
    `;

/**
 * __usePermissionStateQuery__
 *
 * To run a query within a React component, call `usePermissionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionStateQuery(baseOptions?: Apollo.QueryHookOptions<PermissionStateQuery, PermissionStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionStateQuery, PermissionStateQueryVariables>(PermissionStateDocument, options);
      }
export function usePermissionStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionStateQuery, PermissionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionStateQuery, PermissionStateQueryVariables>(PermissionStateDocument, options);
        }
export function usePermissionStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionStateQuery, PermissionStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionStateQuery, PermissionStateQueryVariables>(PermissionStateDocument, options);
        }
export type PermissionStateQueryHookResult = ReturnType<typeof usePermissionStateQuery>;
export type PermissionStateLazyQueryHookResult = ReturnType<typeof usePermissionStateLazyQuery>;
export type PermissionStateSuspenseQueryHookResult = ReturnType<typeof usePermissionStateSuspenseQuery>;
export type PermissionStateQueryResult = Apollo.QueryResult<PermissionStateQuery, PermissionStateQueryVariables>;
export const NavigationStateDocument = gql`
    query NavigationState {
  navigateState @client {
    hasGoBackRequest
    apparentDataLoss
  }
}
    `;

/**
 * __useNavigationStateQuery__
 *
 * To run a query within a React component, call `useNavigationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationStateQuery(baseOptions?: Apollo.QueryHookOptions<NavigationStateQuery, NavigationStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationStateQuery, NavigationStateQueryVariables>(NavigationStateDocument, options);
      }
export function useNavigationStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationStateQuery, NavigationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationStateQuery, NavigationStateQueryVariables>(NavigationStateDocument, options);
        }
export function useNavigationStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationStateQuery, NavigationStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationStateQuery, NavigationStateQueryVariables>(NavigationStateDocument, options);
        }
export type NavigationStateQueryHookResult = ReturnType<typeof useNavigationStateQuery>;
export type NavigationStateLazyQueryHookResult = ReturnType<typeof useNavigationStateLazyQuery>;
export type NavigationStateSuspenseQueryHookResult = ReturnType<typeof useNavigationStateSuspenseQuery>;
export type NavigationStateQueryResult = Apollo.QueryResult<NavigationStateQuery, NavigationStateQueryVariables>;
export const GetDashboardApprovedPaymentsGraphDataDocument = gql`
    query getDashboardApprovedPaymentsGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    reportType: 1
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardApprovedPaymentsGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardApprovedPaymentsGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardApprovedPaymentsGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardApprovedPaymentsGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDashboardApprovedPaymentsGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables> & ({ variables: GetDashboardApprovedPaymentsGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>(GetDashboardApprovedPaymentsGraphDataDocument, options);
      }
export function useGetDashboardApprovedPaymentsGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>(GetDashboardApprovedPaymentsGraphDataDocument, options);
        }
export function useGetDashboardApprovedPaymentsGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>(GetDashboardApprovedPaymentsGraphDataDocument, options);
        }
export type GetDashboardApprovedPaymentsGraphDataQueryHookResult = ReturnType<typeof useGetDashboardApprovedPaymentsGraphDataQuery>;
export type GetDashboardApprovedPaymentsGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardApprovedPaymentsGraphDataLazyQuery>;
export type GetDashboardApprovedPaymentsGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardApprovedPaymentsGraphDataSuspenseQuery>;
export type GetDashboardApprovedPaymentsGraphDataQueryResult = Apollo.QueryResult<GetDashboardApprovedPaymentsGraphDataQuery, GetDashboardApprovedPaymentsGraphDataQueryVariables>;
export const GetDashboardTotalConfirmedOrdersGraphDataDocument = gql`
    query getDashboardTotalConfirmedOrdersGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!, $previousStartDate: DateTime!, $previousEndDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    previousStartDate: $previousStartDate
    previousEndDate: $previousEndDate
    reportType: 8
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    quantity {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardTotalConfirmedOrdersGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardTotalConfirmedOrdersGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTotalConfirmedOrdersGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTotalConfirmedOrdersGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *   },
 * });
 */
export function useGetDashboardTotalConfirmedOrdersGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables> & ({ variables: GetDashboardTotalConfirmedOrdersGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalConfirmedOrdersGraphDataDocument, options);
      }
export function useGetDashboardTotalConfirmedOrdersGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalConfirmedOrdersGraphDataDocument, options);
        }
export function useGetDashboardTotalConfirmedOrdersGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalConfirmedOrdersGraphDataDocument, options);
        }
export type GetDashboardTotalConfirmedOrdersGraphDataQueryHookResult = ReturnType<typeof useGetDashboardTotalConfirmedOrdersGraphDataQuery>;
export type GetDashboardTotalConfirmedOrdersGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardTotalConfirmedOrdersGraphDataLazyQuery>;
export type GetDashboardTotalConfirmedOrdersGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardTotalConfirmedOrdersGraphDataSuspenseQuery>;
export type GetDashboardTotalConfirmedOrdersGraphDataQueryResult = Apollo.QueryResult<GetDashboardTotalConfirmedOrdersGraphDataQuery, GetDashboardTotalConfirmedOrdersGraphDataQueryVariables>;
export const GetDashboardTotalUnconfirmedOrdersGraphDataDocument = gql`
    query getDashboardTotalUnconfirmedOrdersGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!, $previousStartDate: DateTime!, $previousEndDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    previousStartDate: $previousStartDate
    previousEndDate: $previousEndDate
    reportType: 14
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    quantity {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardTotalUnconfirmedOrdersGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardTotalUnconfirmedOrdersGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTotalUnconfirmedOrdersGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTotalUnconfirmedOrdersGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *   },
 * });
 */
export function useGetDashboardTotalUnconfirmedOrdersGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables> & ({ variables: GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalUnconfirmedOrdersGraphDataDocument, options);
      }
export function useGetDashboardTotalUnconfirmedOrdersGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalUnconfirmedOrdersGraphDataDocument, options);
        }
export function useGetDashboardTotalUnconfirmedOrdersGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>(GetDashboardTotalUnconfirmedOrdersGraphDataDocument, options);
        }
export type GetDashboardTotalUnconfirmedOrdersGraphDataQueryHookResult = ReturnType<typeof useGetDashboardTotalUnconfirmedOrdersGraphDataQuery>;
export type GetDashboardTotalUnconfirmedOrdersGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardTotalUnconfirmedOrdersGraphDataLazyQuery>;
export type GetDashboardTotalUnconfirmedOrdersGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardTotalUnconfirmedOrdersGraphDataSuspenseQuery>;
export type GetDashboardTotalUnconfirmedOrdersGraphDataQueryResult = Apollo.QueryResult<GetDashboardTotalUnconfirmedOrdersGraphDataQuery, GetDashboardTotalUnconfirmedOrdersGraphDataQueryVariables>;
export const GetDashboardTotalCompletedOrdersGraphDataDocument = gql`
    query getDashboardTotalCompletedOrdersGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!, $previousStartDate: DateTime!, $previousEndDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    previousStartDate: $previousStartDate
    previousEndDate: $previousEndDate
    reportType: 6
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    quantity {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardTotalCompletedOrdersGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardTotalCompletedOrdersGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTotalCompletedOrdersGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTotalCompletedOrdersGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *   },
 * });
 */
export function useGetDashboardTotalCompletedOrdersGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables> & ({ variables: GetDashboardTotalCompletedOrdersGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>(GetDashboardTotalCompletedOrdersGraphDataDocument, options);
      }
export function useGetDashboardTotalCompletedOrdersGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>(GetDashboardTotalCompletedOrdersGraphDataDocument, options);
        }
export function useGetDashboardTotalCompletedOrdersGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>(GetDashboardTotalCompletedOrdersGraphDataDocument, options);
        }
export type GetDashboardTotalCompletedOrdersGraphDataQueryHookResult = ReturnType<typeof useGetDashboardTotalCompletedOrdersGraphDataQuery>;
export type GetDashboardTotalCompletedOrdersGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardTotalCompletedOrdersGraphDataLazyQuery>;
export type GetDashboardTotalCompletedOrdersGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardTotalCompletedOrdersGraphDataSuspenseQuery>;
export type GetDashboardTotalCompletedOrdersGraphDataQueryResult = Apollo.QueryResult<GetDashboardTotalCompletedOrdersGraphDataQuery, GetDashboardTotalCompletedOrdersGraphDataQueryVariables>;
export const GetDashboardManualPaymentsGraphDataDocument = gql`
    query getDashboardManualPaymentsGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    reportType: 3
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardManualPaymentsGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardManualPaymentsGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardManualPaymentsGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardManualPaymentsGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDashboardManualPaymentsGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables> & ({ variables: GetDashboardManualPaymentsGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>(GetDashboardManualPaymentsGraphDataDocument, options);
      }
export function useGetDashboardManualPaymentsGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>(GetDashboardManualPaymentsGraphDataDocument, options);
        }
export function useGetDashboardManualPaymentsGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>(GetDashboardManualPaymentsGraphDataDocument, options);
        }
export type GetDashboardManualPaymentsGraphDataQueryHookResult = ReturnType<typeof useGetDashboardManualPaymentsGraphDataQuery>;
export type GetDashboardManualPaymentsGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardManualPaymentsGraphDataLazyQuery>;
export type GetDashboardManualPaymentsGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardManualPaymentsGraphDataSuspenseQuery>;
export type GetDashboardManualPaymentsGraphDataQueryResult = Apollo.QueryResult<GetDashboardManualPaymentsGraphDataQuery, GetDashboardManualPaymentsGraphDataQueryVariables>;
export const GetDashboardTotalOrderRequestGraphDataDocument = gql`
    query getDashboardTotalOrderRequestGraphData($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!) {
  dashboard(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
    reportType: 4
  ) {
    dashboardReportTypeEnumId
    dataPoints {
      key
      value
    }
    difference
    total
    percentage
  }
}
    `;

/**
 * __useGetDashboardTotalOrderRequestGraphDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardTotalOrderRequestGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTotalOrderRequestGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTotalOrderRequestGraphDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDashboardTotalOrderRequestGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables> & ({ variables: GetDashboardTotalOrderRequestGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>(GetDashboardTotalOrderRequestGraphDataDocument, options);
      }
export function useGetDashboardTotalOrderRequestGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>(GetDashboardTotalOrderRequestGraphDataDocument, options);
        }
export function useGetDashboardTotalOrderRequestGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>(GetDashboardTotalOrderRequestGraphDataDocument, options);
        }
export type GetDashboardTotalOrderRequestGraphDataQueryHookResult = ReturnType<typeof useGetDashboardTotalOrderRequestGraphDataQuery>;
export type GetDashboardTotalOrderRequestGraphDataLazyQueryHookResult = ReturnType<typeof useGetDashboardTotalOrderRequestGraphDataLazyQuery>;
export type GetDashboardTotalOrderRequestGraphDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardTotalOrderRequestGraphDataSuspenseQuery>;
export type GetDashboardTotalOrderRequestGraphDataQueryResult = Apollo.QueryResult<GetDashboardTotalOrderRequestGraphDataQuery, GetDashboardTotalOrderRequestGraphDataQueryVariables>;
export const GetCompanyRevenueDocument = gql`
    query getCompanyRevenue($startDate: DateTime!, $endDate: DateTime!) {
  revenueGraph(endDate: $endDate, startDate: $startDate) {
    date
    totalAmountApproved
  }
}
    `;

/**
 * __useGetCompanyRevenueQuery__
 *
 * To run a query within a React component, call `useGetCompanyRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRevenueQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCompanyRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables> & ({ variables: GetCompanyRevenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>(GetCompanyRevenueDocument, options);
      }
export function useGetCompanyRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>(GetCompanyRevenueDocument, options);
        }
export function useGetCompanyRevenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>(GetCompanyRevenueDocument, options);
        }
export type GetCompanyRevenueQueryHookResult = ReturnType<typeof useGetCompanyRevenueQuery>;
export type GetCompanyRevenueLazyQueryHookResult = ReturnType<typeof useGetCompanyRevenueLazyQuery>;
export type GetCompanyRevenueSuspenseQueryHookResult = ReturnType<typeof useGetCompanyRevenueSuspenseQuery>;
export type GetCompanyRevenueQueryResult = Apollo.QueryResult<GetCompanyRevenueQuery, GetCompanyRevenueQueryVariables>;
export const GetCompanySummaryReportsDocument = gql`
    query getCompanySummaryReports($startDate: DateTime!, $endDate: DateTime!) {
  adminSummaryReport(endDate: $endDate, startDate: $startDate) {
    count
    reportType
    total
  }
}
    `;

/**
 * __useGetCompanySummaryReportsQuery__
 *
 * To run a query within a React component, call `useGetCompanySummaryReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySummaryReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySummaryReportsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCompanySummaryReportsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables> & ({ variables: GetCompanySummaryReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>(GetCompanySummaryReportsDocument, options);
      }
export function useGetCompanySummaryReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>(GetCompanySummaryReportsDocument, options);
        }
export function useGetCompanySummaryReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>(GetCompanySummaryReportsDocument, options);
        }
export type GetCompanySummaryReportsQueryHookResult = ReturnType<typeof useGetCompanySummaryReportsQuery>;
export type GetCompanySummaryReportsLazyQueryHookResult = ReturnType<typeof useGetCompanySummaryReportsLazyQuery>;
export type GetCompanySummaryReportsSuspenseQueryHookResult = ReturnType<typeof useGetCompanySummaryReportsSuspenseQuery>;
export type GetCompanySummaryReportsQueryResult = Apollo.QueryResult<GetCompanySummaryReportsQuery, GetCompanySummaryReportsQueryVariables>;
export const GetCompanySoldProductsDocument = gql`
    query getCompanySoldProducts($startDate: DateTime!, $endDate: DateTime!) {
  soldProducts(endDate: $endDate, startDate: $startDate) {
    productId
    productTitle
    totalQuantity
    unitOfMeasureId
  }
}
    `;

/**
 * __useGetCompanySoldProductsQuery__
 *
 * To run a query within a React component, call `useGetCompanySoldProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySoldProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySoldProductsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCompanySoldProductsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables> & ({ variables: GetCompanySoldProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>(GetCompanySoldProductsDocument, options);
      }
export function useGetCompanySoldProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>(GetCompanySoldProductsDocument, options);
        }
export function useGetCompanySoldProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>(GetCompanySoldProductsDocument, options);
        }
export type GetCompanySoldProductsQueryHookResult = ReturnType<typeof useGetCompanySoldProductsQuery>;
export type GetCompanySoldProductsLazyQueryHookResult = ReturnType<typeof useGetCompanySoldProductsLazyQuery>;
export type GetCompanySoldProductsSuspenseQueryHookResult = ReturnType<typeof useGetCompanySoldProductsSuspenseQuery>;
export type GetCompanySoldProductsQueryResult = Apollo.QueryResult<GetCompanySoldProductsQuery, GetCompanySoldProductsQueryVariables>;
export const GetCustomerGuaranteeBanksDocument = gql`
    query getCustomerGuaranteeBanks($companyId: Int!, $order: SortEnumType = DESC, $where: BankGuaranteeFilterInput) {
  bankGuarantees(companyId: $companyId, order: {id: $order}, where: $where) {
    bankGuaranteeRef
    certificateUrl
    fileName
    createdAt
    creditLimit
    creditUsed
    creditRemaining
    expiryDate
    id
    issuedDate
    salesOfficeId
    updatedAt
    reference
    customer {
      id
      customerName
      email
      customerCode
    }
    guaranteeBank {
      id
      name
    }
    createdBy {
      userName
      id
      email
      fullName
    }
    bankGuaranteeActivityLogs {
      id
      activityTypeId
      previousCreditLimit
      creditLimit
      bankGuaranteeReference
      issuedDate
      expiryDate
      createdBy {
        id
        userName
        fullName
        email
      }
      createdAt
      certificateUrl
      previousCertificateUrl
      comment
    }
  }
}
    `;

/**
 * __useGetCustomerGuaranteeBanksQuery__
 *
 * To run a query within a React component, call `useGetCustomerGuaranteeBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerGuaranteeBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerGuaranteeBanksQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCustomerGuaranteeBanksQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables> & ({ variables: GetCustomerGuaranteeBanksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>(GetCustomerGuaranteeBanksDocument, options);
      }
export function useGetCustomerGuaranteeBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>(GetCustomerGuaranteeBanksDocument, options);
        }
export function useGetCustomerGuaranteeBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>(GetCustomerGuaranteeBanksDocument, options);
        }
export type GetCustomerGuaranteeBanksQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksQuery>;
export type GetCustomerGuaranteeBanksLazyQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksLazyQuery>;
export type GetCustomerGuaranteeBanksSuspenseQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksSuspenseQuery>;
export type GetCustomerGuaranteeBanksQueryResult = Apollo.QueryResult<GetCustomerGuaranteeBanksQuery, GetCustomerGuaranteeBanksQueryVariables>;
export const GetCustomerGuaranteeBanksByIdDocument = gql`
    query getCustomerGuaranteeBanksById($id: Int!, $companyId: Int!) {
  bankGuarantees(companyId: $companyId, order: {id: DESC}, where: {id: {eq: $id}}) {
    bankGuaranteeRef
    certificateUrl
    fileName
    createdAt
    creditLimit
    creditUsed
    creditRemaining
    expiryDate
    id
    issuedDate
    salesOfficeId
    updatedAt
    reference
    customer {
      id
      customerName
      email
      customerCode
    }
    guaranteeBank {
      id
      name
    }
    salesOffice {
      name
    }
    createdBy {
      userName
      id
      fullName
      email
    }
    bankGuaranteeActivityLogs {
      id
      activityTypeId
      previousCreditLimit
      creditLimit
      bankGuaranteeReference
      issuedDate
      expiryDate
      createdBy {
        id
        userName
        email
        fullName
      }
      createdAt
      certificateUrl
      previousCertificateUrl
      comment
    }
  }
}
    `;

/**
 * __useGetCustomerGuaranteeBanksByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerGuaranteeBanksByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerGuaranteeBanksByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerGuaranteeBanksByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCustomerGuaranteeBanksByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables> & ({ variables: GetCustomerGuaranteeBanksByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>(GetCustomerGuaranteeBanksByIdDocument, options);
      }
export function useGetCustomerGuaranteeBanksByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>(GetCustomerGuaranteeBanksByIdDocument, options);
        }
export function useGetCustomerGuaranteeBanksByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>(GetCustomerGuaranteeBanksByIdDocument, options);
        }
export type GetCustomerGuaranteeBanksByIdQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksByIdQuery>;
export type GetCustomerGuaranteeBanksByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksByIdLazyQuery>;
export type GetCustomerGuaranteeBanksByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerGuaranteeBanksByIdSuspenseQuery>;
export type GetCustomerGuaranteeBanksByIdQueryResult = Apollo.QueryResult<GetCustomerGuaranteeBanksByIdQuery, GetCustomerGuaranteeBanksByIdQueryVariables>;
export const BankGuaranteesDocument = gql`
    mutation bankGuarantees($bankGuarantyRef: String!, $certificate: Upload!, $creditLimit: Decimal!, $customerId: Int!, $expiryDate: DateTime!, $guaranteeBankId: Int!, $issuedDate: DateTime!, $salesOfficeId: Int!) {
  upsertBankGuarantee(
    input: {bankGuarantyRef: $bankGuarantyRef, certificate: $certificate, creditLimit: $creditLimit, customerId: $customerId, expiryDate: $expiryDate, guaranteeBankId: $guaranteeBankId, issuedDate: $issuedDate, salesOfficeId: $salesOfficeId}
  ) {
    bankGuarantee {
      id
      customerId
      expiryDate
    }
  }
}
    `;
export type BankGuaranteesMutationFn = Apollo.MutationFunction<BankGuaranteesMutation, BankGuaranteesMutationVariables>;

/**
 * __useBankGuaranteesMutation__
 *
 * To run a mutation, you first call `useBankGuaranteesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankGuaranteesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankGuaranteesMutation, { data, loading, error }] = useBankGuaranteesMutation({
 *   variables: {
 *      bankGuarantyRef: // value for 'bankGuarantyRef'
 *      certificate: // value for 'certificate'
 *      creditLimit: // value for 'creditLimit'
 *      customerId: // value for 'customerId'
 *      expiryDate: // value for 'expiryDate'
 *      guaranteeBankId: // value for 'guaranteeBankId'
 *      issuedDate: // value for 'issuedDate'
 *      salesOfficeId: // value for 'salesOfficeId'
 *   },
 * });
 */
export function useBankGuaranteesMutation(baseOptions?: Apollo.MutationHookOptions<BankGuaranteesMutation, BankGuaranteesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankGuaranteesMutation, BankGuaranteesMutationVariables>(BankGuaranteesDocument, options);
      }
export type BankGuaranteesMutationHookResult = ReturnType<typeof useBankGuaranteesMutation>;
export type BankGuaranteesMutationResult = Apollo.MutationResult<BankGuaranteesMutation>;
export type BankGuaranteesMutationOptions = Apollo.BaseMutationOptions<BankGuaranteesMutation, BankGuaranteesMutationVariables>;
export const UpdateCustomerGuaranteeBanksDocument = gql`
    mutation updateCustomerGuaranteeBanks($bankGuarantyRef: String!, $certificate: Upload, $creditLimit: Decimal!, $customerId: Int!, $expiryDate: DateTime!, $guaranteeBankId: Int!, $issuedDate: DateTime!, $salesOfficeId: Int!, $id: Int!, $comment: String) {
  upsertBankGuarantee(
    input: {id: $id, bankGuarantyRef: $bankGuarantyRef, certificate: $certificate, creditLimit: $creditLimit, customerId: $customerId, expiryDate: $expiryDate, guaranteeBankId: $guaranteeBankId, issuedDate: $issuedDate, salesOfficeId: $salesOfficeId, comment: $comment}
  ) {
    bankGuarantee {
      id
      customerId
      expiryDate
    }
  }
}
    `;
export type UpdateCustomerGuaranteeBanksMutationFn = Apollo.MutationFunction<UpdateCustomerGuaranteeBanksMutation, UpdateCustomerGuaranteeBanksMutationVariables>;

/**
 * __useUpdateCustomerGuaranteeBanksMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerGuaranteeBanksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerGuaranteeBanksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerGuaranteeBanksMutation, { data, loading, error }] = useUpdateCustomerGuaranteeBanksMutation({
 *   variables: {
 *      bankGuarantyRef: // value for 'bankGuarantyRef'
 *      certificate: // value for 'certificate'
 *      creditLimit: // value for 'creditLimit'
 *      customerId: // value for 'customerId'
 *      expiryDate: // value for 'expiryDate'
 *      guaranteeBankId: // value for 'guaranteeBankId'
 *      issuedDate: // value for 'issuedDate'
 *      salesOfficeId: // value for 'salesOfficeId'
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCustomerGuaranteeBanksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerGuaranteeBanksMutation, UpdateCustomerGuaranteeBanksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerGuaranteeBanksMutation, UpdateCustomerGuaranteeBanksMutationVariables>(UpdateCustomerGuaranteeBanksDocument, options);
      }
export type UpdateCustomerGuaranteeBanksMutationHookResult = ReturnType<typeof useUpdateCustomerGuaranteeBanksMutation>;
export type UpdateCustomerGuaranteeBanksMutationResult = Apollo.MutationResult<UpdateCustomerGuaranteeBanksMutation>;
export type UpdateCustomerGuaranteeBanksMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerGuaranteeBanksMutation, UpdateCustomerGuaranteeBanksMutationVariables>;
export const GetDfsChequeSummaryDocument = gql`
    query getDFSChequeSummary($startDate: DateTime!, $endDate: DateTime!) {
  chequeDashboard(endDate: $endDate, startDate: $startDate) {
    totalAmount {
      key
      value
    }
  }
}
    `;

/**
 * __useGetDfsChequeSummaryQuery__
 *
 * To run a query within a React component, call `useGetDfsChequeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDfsChequeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDfsChequeSummaryQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDfsChequeSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables> & ({ variables: GetDfsChequeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>(GetDfsChequeSummaryDocument, options);
      }
export function useGetDfsChequeSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>(GetDfsChequeSummaryDocument, options);
        }
export function useGetDfsChequeSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>(GetDfsChequeSummaryDocument, options);
        }
export type GetDfsChequeSummaryQueryHookResult = ReturnType<typeof useGetDfsChequeSummaryQuery>;
export type GetDfsChequeSummaryLazyQueryHookResult = ReturnType<typeof useGetDfsChequeSummaryLazyQuery>;
export type GetDfsChequeSummarySuspenseQueryHookResult = ReturnType<typeof useGetDfsChequeSummarySuspenseQuery>;
export type GetDfsChequeSummaryQueryResult = Apollo.QueryResult<GetDfsChequeSummaryQuery, GetDfsChequeSummaryQueryVariables>;
export const GetDfsPaymentDocument = gql`
    query getDFSPayment($take: Int!, $cursor: String, $where: ChequeFilterInput) {
  dfsPayments(first: $take, after: $cursor, where: $where) {
    pageInfo {
      endCursor
    }
    totalCount
    nodes {
      id
      chequeStatus {
        id
        description
      }
      chequeNumber
      payment {
        id
        paymentReference
        paymentTranscriptions {
          id
          documentDate
        }
        customer {
          id
          companyId
          customerName
          customerCode
        }
        paymentApprovals {
          id
          bankGuarantee {
            id
            bankGuaranteeRef
          }
          settlementBank {
            id
            name
            code
          }
          paymentId
        }
      }
    }
  }
}
    `;

/**
 * __useGetDfsPaymentQuery__
 *
 * To run a query within a React component, call `useGetDfsPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDfsPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDfsPaymentQuery({
 *   variables: {
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDfsPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetDfsPaymentQuery, GetDfsPaymentQueryVariables> & ({ variables: GetDfsPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>(GetDfsPaymentDocument, options);
      }
export function useGetDfsPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>(GetDfsPaymentDocument, options);
        }
export function useGetDfsPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>(GetDfsPaymentDocument, options);
        }
export type GetDfsPaymentQueryHookResult = ReturnType<typeof useGetDfsPaymentQuery>;
export type GetDfsPaymentLazyQueryHookResult = ReturnType<typeof useGetDfsPaymentLazyQuery>;
export type GetDfsPaymentSuspenseQueryHookResult = ReturnType<typeof useGetDfsPaymentSuspenseQuery>;
export type GetDfsPaymentQueryResult = Apollo.QueryResult<GetDfsPaymentQuery, GetDfsPaymentQueryVariables>;
export const GetDfsPaymentByIdDocument = gql`
    query getDFSPaymentById($id: Int!) {
  dfsPayments(where: {id: {eq: $id}}) {
    nodes {
      id
      chequeStatus {
        id
        description
      }
      chequeNumber
      payment {
        id
        paymentReference
        paymentTranscriptions {
          id
          documentDate
        }
        customer {
          companyId
          customerName
          customerCode
        }
        paymentApprovals {
          bankGuarantee {
            bankGuaranteeRef
            guaranteeBank {
              name
            }
            creditLimit
            expiryDate
            issuedDate
          }
          settlementBank {
            id
            name
            code
          }
          paymentId
        }
      }
      chequeTrackerHistories {
        id
        activityDate
        createdAt
        updatedAt
        processedBy {
          id
          userName
          fullName
          email
        }
        chequeId
        cheque {
          chequeNumber
          chequeStatus {
            description
          }
          chequeStatusId
        }
        chequeStatus {
          description
        }
        comments
      }
    }
  }
}
    `;

/**
 * __useGetDfsPaymentByIdQuery__
 *
 * To run a query within a React component, call `useGetDfsPaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDfsPaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDfsPaymentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDfsPaymentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables> & ({ variables: GetDfsPaymentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>(GetDfsPaymentByIdDocument, options);
      }
export function useGetDfsPaymentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>(GetDfsPaymentByIdDocument, options);
        }
export function useGetDfsPaymentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>(GetDfsPaymentByIdDocument, options);
        }
export type GetDfsPaymentByIdQueryHookResult = ReturnType<typeof useGetDfsPaymentByIdQuery>;
export type GetDfsPaymentByIdLazyQueryHookResult = ReturnType<typeof useGetDfsPaymentByIdLazyQuery>;
export type GetDfsPaymentByIdSuspenseQueryHookResult = ReturnType<typeof useGetDfsPaymentByIdSuspenseQuery>;
export type GetDfsPaymentByIdQueryResult = Apollo.QueryResult<GetDfsPaymentByIdQuery, GetDfsPaymentByIdQueryVariables>;
export const SubmitChequeActivityDocument = gql`
    mutation submitChequeActivity($input: UpsertChequeInput!) {
  upsertCheque(input: $input) {
    cheque {
      id
    }
  }
}
    `;
export type SubmitChequeActivityMutationFn = Apollo.MutationFunction<SubmitChequeActivityMutation, SubmitChequeActivityMutationVariables>;

/**
 * __useSubmitChequeActivityMutation__
 *
 * To run a mutation, you first call `useSubmitChequeActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChequeActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChequeActivityMutation, { data, loading, error }] = useSubmitChequeActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitChequeActivityMutation(baseOptions?: Apollo.MutationHookOptions<SubmitChequeActivityMutation, SubmitChequeActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitChequeActivityMutation, SubmitChequeActivityMutationVariables>(SubmitChequeActivityDocument, options);
      }
export type SubmitChequeActivityMutationHookResult = ReturnType<typeof useSubmitChequeActivityMutation>;
export type SubmitChequeActivityMutationResult = Apollo.MutationResult<SubmitChequeActivityMutation>;
export type SubmitChequeActivityMutationOptions = Apollo.BaseMutationOptions<SubmitChequeActivityMutation, SubmitChequeActivityMutationVariables>;
export const GenerateDfsPaymentReportDocument = gql`
    query generateDFSPaymentReport {
  generateDfsReportExcel
}
    `;

/**
 * __useGenerateDfsPaymentReportQuery__
 *
 * To run a query within a React component, call `useGenerateDfsPaymentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDfsPaymentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDfsPaymentReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateDfsPaymentReportQuery(baseOptions?: Apollo.QueryHookOptions<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>(GenerateDfsPaymentReportDocument, options);
      }
export function useGenerateDfsPaymentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>(GenerateDfsPaymentReportDocument, options);
        }
export function useGenerateDfsPaymentReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>(GenerateDfsPaymentReportDocument, options);
        }
export type GenerateDfsPaymentReportQueryHookResult = ReturnType<typeof useGenerateDfsPaymentReportQuery>;
export type GenerateDfsPaymentReportLazyQueryHookResult = ReturnType<typeof useGenerateDfsPaymentReportLazyQuery>;
export type GenerateDfsPaymentReportSuspenseQueryHookResult = ReturnType<typeof useGenerateDfsPaymentReportSuspenseQuery>;
export type GenerateDfsPaymentReportQueryResult = Apollo.QueryResult<GenerateDfsPaymentReportQuery, GenerateDfsPaymentReportQueryVariables>;
export const GetBasketOrdersByCompanyDocument = gql`
    query GetBasketOrdersByCompany($companyId: Int!, $where: BasketFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  basketOrdersByCompany(
    companyId: $companyId
    where: $where
    after: $cursor
    first: $take
    order: {id: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      basketOrderNumber
      totalQuantity
      quantityUsed
      quantityLeft
      salesVoucherCount
      createdAt
      updatedAt
      customer {
        id
        customerName
        customerCode
        companyId
      }
      basketOrderStatus {
        id
        description
        translationKey
      }
      basketItems {
        id
        productId
        quantity
        quantityUsed
        product {
          id
          itemCode
          title
          featuredImageUrl
          uoS
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetBasketOrdersByCompanyQuery__
 *
 * To run a query within a React component, call `useGetBasketOrdersByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasketOrdersByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasketOrdersByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetBasketOrdersByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables> & ({ variables: GetBasketOrdersByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>(GetBasketOrdersByCompanyDocument, options);
      }
export function useGetBasketOrdersByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>(GetBasketOrdersByCompanyDocument, options);
        }
export function useGetBasketOrdersByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>(GetBasketOrdersByCompanyDocument, options);
        }
export type GetBasketOrdersByCompanyQueryHookResult = ReturnType<typeof useGetBasketOrdersByCompanyQuery>;
export type GetBasketOrdersByCompanyLazyQueryHookResult = ReturnType<typeof useGetBasketOrdersByCompanyLazyQuery>;
export type GetBasketOrdersByCompanySuspenseQueryHookResult = ReturnType<typeof useGetBasketOrdersByCompanySuspenseQuery>;
export type GetBasketOrdersByCompanyQueryResult = Apollo.QueryResult<GetBasketOrdersByCompanyQuery, GetBasketOrdersByCompanyQueryVariables>;
export const GetBasketOrderDetailDocument = gql`
    query GetBasketOrderDetail($basketOrderId: Int!) {
  basketOrders(where: {id: {eq: $basketOrderId}}) {
    nodes {
      id
      basketOrderNumber
      totalQuantity
      quantityUsed
      quantityLeft
      salesVoucherCount
      createdAt
      updatedAt
      customer {
        id
        customerName
        customerCode
        companyId
      }
      company {
        id
        name
        defaultCurrencyCode
      }
      basketOrderStatus {
        id
        description
        translationKey
      }
      basketItems {
        id
        productId
        quantity
        quantityUsed
        product {
          id
          itemCode
          title
          featuredImageUrl
          uoS
        }
      }
      salesVouchers {
        id
        voucherNumber
        createdAt
        salesVoucherStatus {
          id
          description
          translationKey
        }
        salesVoucherItems {
          id
          quantity
          destinationId
          destination {
            id
            code
            name
          }
          product {
            id
            title
            uoS
          }
          salesVoucherOrders {
            id
            salesOrderNumber
          }
        }
        sourceLocation {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

/**
 * __useGetBasketOrderDetailQuery__
 *
 * To run a query within a React component, call `useGetBasketOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasketOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasketOrderDetailQuery({
 *   variables: {
 *      basketOrderId: // value for 'basketOrderId'
 *   },
 * });
 */
export function useGetBasketOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables> & ({ variables: GetBasketOrderDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>(GetBasketOrderDetailDocument, options);
      }
export function useGetBasketOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>(GetBasketOrderDetailDocument, options);
        }
export function useGetBasketOrderDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>(GetBasketOrderDetailDocument, options);
        }
export type GetBasketOrderDetailQueryHookResult = ReturnType<typeof useGetBasketOrderDetailQuery>;
export type GetBasketOrderDetailLazyQueryHookResult = ReturnType<typeof useGetBasketOrderDetailLazyQuery>;
export type GetBasketOrderDetailSuspenseQueryHookResult = ReturnType<typeof useGetBasketOrderDetailSuspenseQuery>;
export type GetBasketOrderDetailQueryResult = Apollo.QueryResult<GetBasketOrderDetailQuery, GetBasketOrderDetailQueryVariables>;
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: String!) {
  userByEmail(email: $email) {
    id
    fullName
    userName
    email
    companyId
    locationId
    company {
      countryId
      code
      customerTranscription
    }
    locationId
    location {
      id
      name
      code
      type
      companyId
      allowBankGuarantee
      useDeliveredOrderManagement
      company {
        id
        code
        countryId
        name
        customerTranscription
        defaultCurrencyCode
        allowOrderCancellation
        country {
          name
          alpha2
          alpha3
        }
      }
    }
    language {
      lang
      code
      id
    }
    companies {
      id
      code
      name
      countryId
    }
    locations {
      id
      name
      code
      companyId
      type
    }
    permissions
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables> & ({ variables: GetUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserByEmailSuspenseQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const GetUserPermissionsDocument = gql`
    query getUserPermissions($userId: Int!) {
  userMHCPermissions(userId: $userId)
}
    `;

/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables> & ({ variables: GetUserPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
      }
export function useGetUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export type GetUserPermissionsQueryHookResult = ReturnType<typeof useGetUserPermissionsQuery>;
export type GetUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsLazyQuery>;
export type GetUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsSuspenseQuery>;
export type GetUserPermissionsQueryResult = Apollo.QueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export const GetUserMhcRolesDocument = gql`
    query getUserMHCRoles($userId: Int!) {
  userMHCRoles(userId: $userId)
}
    `;

/**
 * __useGetUserMhcRolesQuery__
 *
 * To run a query within a React component, call `useGetUserMhcRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMhcRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMhcRolesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserMhcRolesQuery(baseOptions: Apollo.QueryHookOptions<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables> & ({ variables: GetUserMhcRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>(GetUserMhcRolesDocument, options);
      }
export function useGetUserMhcRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>(GetUserMhcRolesDocument, options);
        }
export function useGetUserMhcRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>(GetUserMhcRolesDocument, options);
        }
export type GetUserMhcRolesQueryHookResult = ReturnType<typeof useGetUserMhcRolesQuery>;
export type GetUserMhcRolesLazyQueryHookResult = ReturnType<typeof useGetUserMhcRolesLazyQuery>;
export type GetUserMhcRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserMhcRolesSuspenseQuery>;
export type GetUserMhcRolesQueryResult = Apollo.QueryResult<GetUserMhcRolesQuery, GetUserMhcRolesQueryVariables>;
export const GetDocumentTypesDocument = gql`
    query getDocumentTypes {
  documentTypes {
    id
    description
    translationKey
  }
}
    `;

/**
 * __useGetDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>(GetDocumentTypesDocument, options);
      }
export function useGetDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>(GetDocumentTypesDocument, options);
        }
export function useGetDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>(GetDocumentTypesDocument, options);
        }
export type GetDocumentTypesQueryHookResult = ReturnType<typeof useGetDocumentTypesQuery>;
export type GetDocumentTypesLazyQueryHookResult = ReturnType<typeof useGetDocumentTypesLazyQuery>;
export type GetDocumentTypesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentTypesSuspenseQuery>;
export type GetDocumentTypesQueryResult = Apollo.QueryResult<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>;
export const GetPaymentApprovalStatusesDocument = gql`
    query getPaymentApprovalStatuses {
  paymentApprovalStatus {
    id
    description
    translationKey
  }
}
    `;

/**
 * __useGetPaymentApprovalStatusesQuery__
 *
 * To run a query within a React component, call `useGetPaymentApprovalStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApprovalStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApprovalStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentApprovalStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>(GetPaymentApprovalStatusesDocument, options);
      }
export function useGetPaymentApprovalStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>(GetPaymentApprovalStatusesDocument, options);
        }
export function useGetPaymentApprovalStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>(GetPaymentApprovalStatusesDocument, options);
        }
export type GetPaymentApprovalStatusesQueryHookResult = ReturnType<typeof useGetPaymentApprovalStatusesQuery>;
export type GetPaymentApprovalStatusesLazyQueryHookResult = ReturnType<typeof useGetPaymentApprovalStatusesLazyQuery>;
export type GetPaymentApprovalStatusesSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApprovalStatusesSuspenseQuery>;
export type GetPaymentApprovalStatusesQueryResult = Apollo.QueryResult<GetPaymentApprovalStatusesQuery, GetPaymentApprovalStatusesQueryVariables>;
export const GetPaymentApprovalTypesDocument = gql`
    query getPaymentApprovalTypes {
  paymentApprovalType {
    id
    description
    translationKey
  }
}
    `;

/**
 * __useGetPaymentApprovalTypesQuery__
 *
 * To run a query within a React component, call `useGetPaymentApprovalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApprovalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApprovalTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentApprovalTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>(GetPaymentApprovalTypesDocument, options);
      }
export function useGetPaymentApprovalTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>(GetPaymentApprovalTypesDocument, options);
        }
export function useGetPaymentApprovalTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>(GetPaymentApprovalTypesDocument, options);
        }
export type GetPaymentApprovalTypesQueryHookResult = ReturnType<typeof useGetPaymentApprovalTypesQuery>;
export type GetPaymentApprovalTypesLazyQueryHookResult = ReturnType<typeof useGetPaymentApprovalTypesLazyQuery>;
export type GetPaymentApprovalTypesSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApprovalTypesSuspenseQuery>;
export type GetPaymentApprovalTypesQueryResult = Apollo.QueryResult<GetPaymentApprovalTypesQuery, GetPaymentApprovalTypesQueryVariables>;
export const GetCustomerRolesDocument = gql`
    query getCustomerRoles {
  customerRoles {
    id
    description
    isInternal
  }
}
    `;

/**
 * __useGetCustomerRolesQuery__
 *
 * To run a query within a React component, call `useGetCustomerRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>(GetCustomerRolesDocument, options);
      }
export function useGetCustomerRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>(GetCustomerRolesDocument, options);
        }
export function useGetCustomerRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>(GetCustomerRolesDocument, options);
        }
export type GetCustomerRolesQueryHookResult = ReturnType<typeof useGetCustomerRolesQuery>;
export type GetCustomerRolesLazyQueryHookResult = ReturnType<typeof useGetCustomerRolesLazyQuery>;
export type GetCustomerRolesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerRolesSuspenseQuery>;
export type GetCustomerRolesQueryResult = Apollo.QueryResult<GetCustomerRolesQuery, GetCustomerRolesQueryVariables>;
export const GetActiveBanksDocument = gql`
    query getActiveBanks($countryId: Int!, $name: String!) {
  banks(
    where: {and: [{countryId: {eq: $countryId}}, {isActive: {eq: true}}, {name: {contains: $name}}]}
  ) {
    nodes {
      id
      name
      description
      country {
        id
        name
      }
      createdAt
      updatedAt
      code
      isActive
    }
  }
}
    `;

/**
 * __useGetActiveBanksQuery__
 *
 * To run a query within a React component, call `useGetActiveBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveBanksQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetActiveBanksQuery(baseOptions: Apollo.QueryHookOptions<GetActiveBanksQuery, GetActiveBanksQueryVariables> & ({ variables: GetActiveBanksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveBanksQuery, GetActiveBanksQueryVariables>(GetActiveBanksDocument, options);
      }
export function useGetActiveBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveBanksQuery, GetActiveBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveBanksQuery, GetActiveBanksQueryVariables>(GetActiveBanksDocument, options);
        }
export function useGetActiveBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveBanksQuery, GetActiveBanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveBanksQuery, GetActiveBanksQueryVariables>(GetActiveBanksDocument, options);
        }
export type GetActiveBanksQueryHookResult = ReturnType<typeof useGetActiveBanksQuery>;
export type GetActiveBanksLazyQueryHookResult = ReturnType<typeof useGetActiveBanksLazyQuery>;
export type GetActiveBanksSuspenseQueryHookResult = ReturnType<typeof useGetActiveBanksSuspenseQuery>;
export type GetActiveBanksQueryResult = Apollo.QueryResult<GetActiveBanksQuery, GetActiveBanksQueryVariables>;
export const GetActiveBankBranchesDocument = gql`
    query getActiveBankBranches($bankId: Int!, $name: String!) {
  bankBranches(
    where: {and: [{bankId: {eq: $bankId}}, {isActive: {eq: true}}, {name: {contains: $name}}]}
  ) {
    nodes {
      id
      name
      description
      createdAt
      updatedAt
      code
      isActive
    }
  }
}
    `;

/**
 * __useGetActiveBankBranchesQuery__
 *
 * To run a query within a React component, call `useGetActiveBankBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveBankBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveBankBranchesQuery({
 *   variables: {
 *      bankId: // value for 'bankId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetActiveBankBranchesQuery(baseOptions: Apollo.QueryHookOptions<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables> & ({ variables: GetActiveBankBranchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>(GetActiveBankBranchesDocument, options);
      }
export function useGetActiveBankBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>(GetActiveBankBranchesDocument, options);
        }
export function useGetActiveBankBranchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>(GetActiveBankBranchesDocument, options);
        }
export type GetActiveBankBranchesQueryHookResult = ReturnType<typeof useGetActiveBankBranchesQuery>;
export type GetActiveBankBranchesLazyQueryHookResult = ReturnType<typeof useGetActiveBankBranchesLazyQuery>;
export type GetActiveBankBranchesSuspenseQueryHookResult = ReturnType<typeof useGetActiveBankBranchesSuspenseQuery>;
export type GetActiveBankBranchesQueryResult = Apollo.QueryResult<GetActiveBankBranchesQuery, GetActiveBankBranchesQueryVariables>;
export const UpsertUserDefaultLanguagemutationDocument = gql`
    mutation upsertUserDefaultLanguagemutation($langId: UpdateUserDefaultLanguageInput!) {
  updateUserDefaultLanguage(input: $langId) {
    user {
      languageId
      id
      userName
      email
    }
  }
}
    `;
export type UpsertUserDefaultLanguagemutationMutationFn = Apollo.MutationFunction<UpsertUserDefaultLanguagemutationMutation, UpsertUserDefaultLanguagemutationMutationVariables>;

/**
 * __useUpsertUserDefaultLanguagemutationMutation__
 *
 * To run a mutation, you first call `useUpsertUserDefaultLanguagemutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserDefaultLanguagemutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserDefaultLanguagemutationMutation, { data, loading, error }] = useUpsertUserDefaultLanguagemutationMutation({
 *   variables: {
 *      langId: // value for 'langId'
 *   },
 * });
 */
export function useUpsertUserDefaultLanguagemutationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserDefaultLanguagemutationMutation, UpsertUserDefaultLanguagemutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserDefaultLanguagemutationMutation, UpsertUserDefaultLanguagemutationMutationVariables>(UpsertUserDefaultLanguagemutationDocument, options);
      }
export type UpsertUserDefaultLanguagemutationMutationHookResult = ReturnType<typeof useUpsertUserDefaultLanguagemutationMutation>;
export type UpsertUserDefaultLanguagemutationMutationResult = Apollo.MutationResult<UpsertUserDefaultLanguagemutationMutation>;
export type UpsertUserDefaultLanguagemutationMutationOptions = Apollo.BaseMutationOptions<UpsertUserDefaultLanguagemutationMutation, UpsertUserDefaultLanguagemutationMutationVariables>;
export const GetLanguagesDocument = gql`
    query getLanguages {
  languages {
    lang
    code
    id
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetVehiclesLookupByVehicleNumberDocument = gql`
    query getVehiclesLookupByVehicleNumber($searchString: String!, $countryIds: [Int!]!, $vehcileTypeId: Int!) {
  vehicles(
    where: {countryId: {in: $countryIds}, vehicleTypeId: {eq: $vehcileTypeId}, or: [{vehicleNo: {contains: $searchString}}, {supplier: {or: [{supplierName: {contains: $searchString}}, {supplierCode: {contains: $searchString}}]}}], isActive: {eq: true}}
    first: 20
  ) {
    nodes {
      id
      vehicleNo
      insuranceExpiryDate
      insurancePolicyNo
      trackingRefNo
      trackingPhoneNo
      transporterCode
      owner
      isBanned
      isActive
      tare
      maxWeight
      createdAt
      supplier {
        supplierName
        supplierCode
      }
    }
  }
}
    `;

/**
 * __useGetVehiclesLookupByVehicleNumberQuery__
 *
 * To run a query within a React component, call `useGetVehiclesLookupByVehicleNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesLookupByVehicleNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesLookupByVehicleNumberQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      countryIds: // value for 'countryIds'
 *      vehcileTypeId: // value for 'vehcileTypeId'
 *   },
 * });
 */
export function useGetVehiclesLookupByVehicleNumberQuery(baseOptions: Apollo.QueryHookOptions<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables> & ({ variables: GetVehiclesLookupByVehicleNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>(GetVehiclesLookupByVehicleNumberDocument, options);
      }
export function useGetVehiclesLookupByVehicleNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>(GetVehiclesLookupByVehicleNumberDocument, options);
        }
export function useGetVehiclesLookupByVehicleNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>(GetVehiclesLookupByVehicleNumberDocument, options);
        }
export type GetVehiclesLookupByVehicleNumberQueryHookResult = ReturnType<typeof useGetVehiclesLookupByVehicleNumberQuery>;
export type GetVehiclesLookupByVehicleNumberLazyQueryHookResult = ReturnType<typeof useGetVehiclesLookupByVehicleNumberLazyQuery>;
export type GetVehiclesLookupByVehicleNumberSuspenseQueryHookResult = ReturnType<typeof useGetVehiclesLookupByVehicleNumberSuspenseQuery>;
export type GetVehiclesLookupByVehicleNumberQueryResult = Apollo.QueryResult<GetVehiclesLookupByVehicleNumberQuery, GetVehiclesLookupByVehicleNumberQueryVariables>;
export const UpsertUserDeviceTokenDocument = gql`
    mutation upsertUserDeviceToken($token: String!) {
  upsertUserDevice(input: {token: $token, userDeviceId: $token}) {
    userDevice {
      user {
        id
        userName
      }
    }
  }
}
    `;
export type UpsertUserDeviceTokenMutationFn = Apollo.MutationFunction<UpsertUserDeviceTokenMutation, UpsertUserDeviceTokenMutationVariables>;

/**
 * __useUpsertUserDeviceTokenMutation__
 *
 * To run a mutation, you first call `useUpsertUserDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserDeviceTokenMutation, { data, loading, error }] = useUpsertUserDeviceTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpsertUserDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserDeviceTokenMutation, UpsertUserDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserDeviceTokenMutation, UpsertUserDeviceTokenMutationVariables>(UpsertUserDeviceTokenDocument, options);
      }
export type UpsertUserDeviceTokenMutationHookResult = ReturnType<typeof useUpsertUserDeviceTokenMutation>;
export type UpsertUserDeviceTokenMutationResult = Apollo.MutationResult<UpsertUserDeviceTokenMutation>;
export type UpsertUserDeviceTokenMutationOptions = Apollo.BaseMutationOptions<UpsertUserDeviceTokenMutation, UpsertUserDeviceTokenMutationVariables>;
export const GetUserNotificationsDocument = gql`
    query getUserNotifications {
  userNotifications(where: {notificationStatusId: {lte: 2}}) {
    nodes {
      id
      notificationStatusId
      notificationStatus {
        id
        description
        translationKey
      }
      notification {
        id
        title
        body
        componentId
        componentName
        notificationTypeId
        notificationType {
          id
          description
          translationKey
        }
        createdAt
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationsSuspenseQuery>;
export type GetUserNotificationsQueryResult = Apollo.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetPaymentIdByPaymentNumberDocument = gql`
    query getPaymentIdByPaymentNumber($paymentNumber: String!) {
  payments(where: {paymentReference: {eq: $paymentNumber}}) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useGetPaymentIdByPaymentNumberQuery__
 *
 * To run a query within a React component, call `useGetPaymentIdByPaymentNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentIdByPaymentNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentIdByPaymentNumberQuery({
 *   variables: {
 *      paymentNumber: // value for 'paymentNumber'
 *   },
 * });
 */
export function useGetPaymentIdByPaymentNumberQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables> & ({ variables: GetPaymentIdByPaymentNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>(GetPaymentIdByPaymentNumberDocument, options);
      }
export function useGetPaymentIdByPaymentNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>(GetPaymentIdByPaymentNumberDocument, options);
        }
export function useGetPaymentIdByPaymentNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>(GetPaymentIdByPaymentNumberDocument, options);
        }
export type GetPaymentIdByPaymentNumberQueryHookResult = ReturnType<typeof useGetPaymentIdByPaymentNumberQuery>;
export type GetPaymentIdByPaymentNumberLazyQueryHookResult = ReturnType<typeof useGetPaymentIdByPaymentNumberLazyQuery>;
export type GetPaymentIdByPaymentNumberSuspenseQueryHookResult = ReturnType<typeof useGetPaymentIdByPaymentNumberSuspenseQuery>;
export type GetPaymentIdByPaymentNumberQueryResult = Apollo.QueryResult<GetPaymentIdByPaymentNumberQuery, GetPaymentIdByPaymentNumberQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($notificationId: Int!) {
  readUserNotification(input: {notificationId: $notificationId}) {
    notificationUser {
      userId
    }
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  readAllUserNotification {
    boolean
  }
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const GetRecentOrdersDocument = gql`
    query getRecentOrders($customerId: Int!, $take: Int!) {
  salesVouchers(where: {customerId: {eq: $customerId}}, first: $take) {
    nodes {
      id
      customerReference
      createdAt
      salesVoucherItems {
        id
        totalPrice
      }
      sourceLocation {
        id
        code
        name
      }
      salesVoucherStatus {
        id
        description
      }
    }
  }
}
    `;

/**
 * __useGetRecentOrdersQuery__
 *
 * To run a query within a React component, call `useGetRecentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentOrdersQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetRecentOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables> & ({ variables: GetRecentOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(GetRecentOrdersDocument, options);
      }
export function useGetRecentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(GetRecentOrdersDocument, options);
        }
export function useGetRecentOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>(GetRecentOrdersDocument, options);
        }
export type GetRecentOrdersQueryHookResult = ReturnType<typeof useGetRecentOrdersQuery>;
export type GetRecentOrdersLazyQueryHookResult = ReturnType<typeof useGetRecentOrdersLazyQuery>;
export type GetRecentOrdersSuspenseQueryHookResult = ReturnType<typeof useGetRecentOrdersSuspenseQuery>;
export type GetRecentOrdersQueryResult = Apollo.QueryResult<GetRecentOrdersQuery, GetRecentOrdersQueryVariables>;
export const UpdateUserDefaultLocationDocument = gql`
    mutation UpdateUserDefaultLocation($locationId: Int!) {
  updateUserDefaultLocation(input: {locationId: $locationId}) {
    user {
      id
      userName
      locationId
    }
  }
}
    `;
export type UpdateUserDefaultLocationMutationFn = Apollo.MutationFunction<UpdateUserDefaultLocationMutation, UpdateUserDefaultLocationMutationVariables>;

/**
 * __useUpdateUserDefaultLocationMutation__
 *
 * To run a mutation, you first call `useUpdateUserDefaultLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDefaultLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDefaultLocationMutation, { data, loading, error }] = useUpdateUserDefaultLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUpdateUserDefaultLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDefaultLocationMutation, UpdateUserDefaultLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDefaultLocationMutation, UpdateUserDefaultLocationMutationVariables>(UpdateUserDefaultLocationDocument, options);
      }
export type UpdateUserDefaultLocationMutationHookResult = ReturnType<typeof useUpdateUserDefaultLocationMutation>;
export type UpdateUserDefaultLocationMutationResult = Apollo.MutationResult<UpdateUserDefaultLocationMutation>;
export type UpdateUserDefaultLocationMutationOptions = Apollo.BaseMutationOptions<UpdateUserDefaultLocationMutation, UpdateUserDefaultLocationMutationVariables>;
export const GetBanksDocument = gql`
    query getBanks($countryId: Int!, $name: String!) {
  activeBanks(
    where: {and: [{countryId: {eq: $countryId}}, {isActive: {eq: true}}, {name: {contains: $name}}]}
  ) {
    id
    name
    description
    country {
      id
      name
    }
    createdAt
    updatedAt
    code
    isActive
  }
}
    `;

/**
 * __useGetBanksQuery__
 *
 * To run a query within a React component, call `useGetBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanksQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetBanksQuery(baseOptions: Apollo.QueryHookOptions<GetBanksQuery, GetBanksQueryVariables> & ({ variables: GetBanksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
      }
export function useGetBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export function useGetBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export type GetBanksQueryHookResult = ReturnType<typeof useGetBanksQuery>;
export type GetBanksLazyQueryHookResult = ReturnType<typeof useGetBanksLazyQuery>;
export type GetBanksSuspenseQueryHookResult = ReturnType<typeof useGetBanksSuspenseQuery>;
export type GetBanksQueryResult = Apollo.QueryResult<GetBanksQuery, GetBanksQueryVariables>;
export const GetBankDocument = gql`
    query getBank($id: Int!) {
  activeBanks(where: {id: {eq: $id}}) {
    id
    name
    description
    country {
      id
      name
    }
    createdAt
    updatedAt
    code
    isActive
  }
}
    `;

/**
 * __useGetBankQuery__
 *
 * To run a query within a React component, call `useGetBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankQuery(baseOptions: Apollo.QueryHookOptions<GetBankQuery, GetBankQueryVariables> & ({ variables: GetBankQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankQuery, GetBankQueryVariables>(GetBankDocument, options);
      }
export function useGetBankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankQuery, GetBankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankQuery, GetBankQueryVariables>(GetBankDocument, options);
        }
export function useGetBankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankQuery, GetBankQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankQuery, GetBankQueryVariables>(GetBankDocument, options);
        }
export type GetBankQueryHookResult = ReturnType<typeof useGetBankQuery>;
export type GetBankLazyQueryHookResult = ReturnType<typeof useGetBankLazyQuery>;
export type GetBankSuspenseQueryHookResult = ReturnType<typeof useGetBankSuspenseQuery>;
export type GetBankQueryResult = Apollo.QueryResult<GetBankQuery, GetBankQueryVariables>;
export const GetBankBranchesDocument = gql`
    query getBankBranches($bankId: Int!, $name: String!) {
  activeBankBranches(
    where: {and: [{bankId: {eq: $bankId}}, {isActive: {eq: true}}, {name: {contains: $name}}]}
  ) {
    id
    name
    description
    createdAt
    updatedAt
    code
    isActive
  }
}
    `;

/**
 * __useGetBankBranchesQuery__
 *
 * To run a query within a React component, call `useGetBankBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankBranchesQuery({
 *   variables: {
 *      bankId: // value for 'bankId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetBankBranchesQuery(baseOptions: Apollo.QueryHookOptions<GetBankBranchesQuery, GetBankBranchesQueryVariables> & ({ variables: GetBankBranchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankBranchesQuery, GetBankBranchesQueryVariables>(GetBankBranchesDocument, options);
      }
export function useGetBankBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankBranchesQuery, GetBankBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankBranchesQuery, GetBankBranchesQueryVariables>(GetBankBranchesDocument, options);
        }
export function useGetBankBranchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankBranchesQuery, GetBankBranchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankBranchesQuery, GetBankBranchesQueryVariables>(GetBankBranchesDocument, options);
        }
export type GetBankBranchesQueryHookResult = ReturnType<typeof useGetBankBranchesQuery>;
export type GetBankBranchesLazyQueryHookResult = ReturnType<typeof useGetBankBranchesLazyQuery>;
export type GetBankBranchesSuspenseQueryHookResult = ReturnType<typeof useGetBankBranchesSuspenseQuery>;
export type GetBankBranchesQueryResult = Apollo.QueryResult<GetBankBranchesQuery, GetBankBranchesQueryVariables>;
export const GetBankBranchDocument = gql`
    query getBankBranch($id: Int!) {
  activeBankBranches(where: {id: {eq: $id}}) {
    id
    name
    description
    createdAt
    updatedAt
    code
    isActive
  }
}
    `;

/**
 * __useGetBankBranchQuery__
 *
 * To run a query within a React component, call `useGetBankBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankBranchQuery(baseOptions: Apollo.QueryHookOptions<GetBankBranchQuery, GetBankBranchQueryVariables> & ({ variables: GetBankBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankBranchQuery, GetBankBranchQueryVariables>(GetBankBranchDocument, options);
      }
export function useGetBankBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankBranchQuery, GetBankBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankBranchQuery, GetBankBranchQueryVariables>(GetBankBranchDocument, options);
        }
export function useGetBankBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankBranchQuery, GetBankBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankBranchQuery, GetBankBranchQueryVariables>(GetBankBranchDocument, options);
        }
export type GetBankBranchQueryHookResult = ReturnType<typeof useGetBankBranchQuery>;
export type GetBankBranchLazyQueryHookResult = ReturnType<typeof useGetBankBranchLazyQuery>;
export type GetBankBranchSuspenseQueryHookResult = ReturnType<typeof useGetBankBranchSuspenseQuery>;
export type GetBankBranchQueryResult = Apollo.QueryResult<GetBankBranchQuery, GetBankBranchQueryVariables>;
export const GetUserAccountsByCompanyIdDocument = gql`
    query GetUserAccountsByCompanyId($companyId: Int!, $fullName: String, $email: String, $cursor: String, $take: Int = 10) {
  usersByCompany(
    companyId: $companyId
    where: {and: [{fullName: {contains: $fullName}}, {email: {contains: $email}}]}
    after: $cursor
    first: $take
    order: {updatedAt: DESC}
  ) {
    totalCount
    nodes {
      company {
        id
        name
        country {
          id
          name
        }
      }
      location {
        id
        name
      }
      createdAt
      customerId
      customer {
        id
        customerName
        active
        customerCode
      }
      role {
        id
        description
      }
      email
      fullName
      id
      isActive
      languageId
      locationId
      permissions
      phoneNumber
      termsAndConditionId
      updatedAt
      userName
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetUserAccountsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetUserAccountsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetUserAccountsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables> & ({ variables: GetUserAccountsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>(GetUserAccountsByCompanyIdDocument, options);
      }
export function useGetUserAccountsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>(GetUserAccountsByCompanyIdDocument, options);
        }
export function useGetUserAccountsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>(GetUserAccountsByCompanyIdDocument, options);
        }
export type GetUserAccountsByCompanyIdQueryHookResult = ReturnType<typeof useGetUserAccountsByCompanyIdQuery>;
export type GetUserAccountsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetUserAccountsByCompanyIdLazyQuery>;
export type GetUserAccountsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetUserAccountsByCompanyIdSuspenseQuery>;
export type GetUserAccountsByCompanyIdQueryResult = Apollo.QueryResult<GetUserAccountsByCompanyIdQuery, GetUserAccountsByCompanyIdQueryVariables>;
export const CompaniesCountDocument = gql`
    query companiesCount($countryId: Int!) {
  companies(countryId: $countryId) {
    totalCount
  }
}
    `;

/**
 * __useCompaniesCountQuery__
 *
 * To run a query within a React component, call `useCompaniesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesCountQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useCompaniesCountQuery(baseOptions: Apollo.QueryHookOptions<CompaniesCountQuery, CompaniesCountQueryVariables> & ({ variables: CompaniesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesCountQuery, CompaniesCountQueryVariables>(CompaniesCountDocument, options);
      }
export function useCompaniesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesCountQuery, CompaniesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesCountQuery, CompaniesCountQueryVariables>(CompaniesCountDocument, options);
        }
export function useCompaniesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesCountQuery, CompaniesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesCountQuery, CompaniesCountQueryVariables>(CompaniesCountDocument, options);
        }
export type CompaniesCountQueryHookResult = ReturnType<typeof useCompaniesCountQuery>;
export type CompaniesCountLazyQueryHookResult = ReturnType<typeof useCompaniesCountLazyQuery>;
export type CompaniesCountSuspenseQueryHookResult = ReturnType<typeof useCompaniesCountSuspenseQuery>;
export type CompaniesCountQueryResult = Apollo.QueryResult<CompaniesCountQuery, CompaniesCountQueryVariables>;
export const UpdateUserActiveDocument = gql`
    mutation updateUserActive($input: UpdateUserActiveInput!) {
  updateUserActive(input: $input) {
    boolean
  }
}
    `;
export type UpdateUserActiveMutationFn = Apollo.MutationFunction<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>;

/**
 * __useUpdateUserActiveMutation__
 *
 * To run a mutation, you first call `useUpdateUserActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActiveMutation, { data, loading, error }] = useUpdateUserActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>(UpdateUserActiveDocument, options);
      }
export type UpdateUserActiveMutationHookResult = ReturnType<typeof useUpdateUserActiveMutation>;
export type UpdateUserActiveMutationResult = Apollo.MutationResult<UpdateUserActiveMutation>;
export type UpdateUserActiveMutationOptions = Apollo.BaseMutationOptions<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>;
export const GetUserLocationsDocument = gql`
    query GetUserLocations($companyId: Int!, $userId: Int!) {
  usersByCompany(companyId: $companyId, where: {id: {eq: $userId}}) {
    nodes {
      id
      locations {
        id
        name
        code
        companyId
      }
    }
  }
}
    `;

/**
 * __useGetUserLocationsQuery__
 *
 * To run a query within a React component, call `useGetUserLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserLocationsQuery, GetUserLocationsQueryVariables> & ({ variables: GetUserLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLocationsQuery, GetUserLocationsQueryVariables>(GetUserLocationsDocument, options);
      }
export function useGetUserLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLocationsQuery, GetUserLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLocationsQuery, GetUserLocationsQueryVariables>(GetUserLocationsDocument, options);
        }
export function useGetUserLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserLocationsQuery, GetUserLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserLocationsQuery, GetUserLocationsQueryVariables>(GetUserLocationsDocument, options);
        }
export type GetUserLocationsQueryHookResult = ReturnType<typeof useGetUserLocationsQuery>;
export type GetUserLocationsLazyQueryHookResult = ReturnType<typeof useGetUserLocationsLazyQuery>;
export type GetUserLocationsSuspenseQueryHookResult = ReturnType<typeof useGetUserLocationsSuspenseQuery>;
export type GetUserLocationsQueryResult = Apollo.QueryResult<GetUserLocationsQuery, GetUserLocationsQueryVariables>;
export const UpdateUserLocationsDocument = gql`
    mutation UpdateUserLocations($userId: Int!, $locationIds: [Int!]!) {
  updateUserLocations(input: {userId: $userId, locationIds: $locationIds}) {
    user {
      id
      locations {
        id
        name
        code
        companyId
      }
    }
  }
}
    `;
export type UpdateUserLocationsMutationFn = Apollo.MutationFunction<UpdateUserLocationsMutation, UpdateUserLocationsMutationVariables>;

/**
 * __useUpdateUserLocationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLocationsMutation, { data, loading, error }] = useUpdateUserLocationsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useUpdateUserLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLocationsMutation, UpdateUserLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLocationsMutation, UpdateUserLocationsMutationVariables>(UpdateUserLocationsDocument, options);
      }
export type UpdateUserLocationsMutationHookResult = ReturnType<typeof useUpdateUserLocationsMutation>;
export type UpdateUserLocationsMutationResult = Apollo.MutationResult<UpdateUserLocationsMutation>;
export type UpdateUserLocationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserLocationsMutation, UpdateUserLocationsMutationVariables>;
export const UpsertBankDataDocument = gql`
    mutation upsertBankData($input: UpsertBankInput!) {
  upsertBank(input: $input) {
    bank {
      id
    }
  }
}
    `;
export type UpsertBankDataMutationFn = Apollo.MutationFunction<UpsertBankDataMutation, UpsertBankDataMutationVariables>;

/**
 * __useUpsertBankDataMutation__
 *
 * To run a mutation, you first call `useUpsertBankDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBankDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBankDataMutation, { data, loading, error }] = useUpsertBankDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBankDataMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBankDataMutation, UpsertBankDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBankDataMutation, UpsertBankDataMutationVariables>(UpsertBankDataDocument, options);
      }
export type UpsertBankDataMutationHookResult = ReturnType<typeof useUpsertBankDataMutation>;
export type UpsertBankDataMutationResult = Apollo.MutationResult<UpsertBankDataMutation>;
export type UpsertBankDataMutationOptions = Apollo.BaseMutationOptions<UpsertBankDataMutation, UpsertBankDataMutationVariables>;
export const GetPaginatedBanksByCountryIdDocument = gql`
    query getPaginatedBanksByCountryId($countryId: Int!, $name: String!, $code: String!, $cursor: Int, $take: Int = 50) {
  banks(
    where: {countryId: {eq: $countryId}, or: [{code: {startsWith: $code}}, {name: {startsWith: $name}}]}
    first: $take
    last: $cursor
    order: {name: ASC}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      code
      name
      isActive
      countryId
      description
      bankBranches {
        id
        description
        name
        code
      }
      country {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedBanksByCountryIdQuery__
 *
 * To run a query within a React component, call `useGetPaginatedBanksByCountryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedBanksByCountryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedBanksByCountryIdQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedBanksByCountryIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables> & ({ variables: GetPaginatedBanksByCountryIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>(GetPaginatedBanksByCountryIdDocument, options);
      }
export function useGetPaginatedBanksByCountryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>(GetPaginatedBanksByCountryIdDocument, options);
        }
export function useGetPaginatedBanksByCountryIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>(GetPaginatedBanksByCountryIdDocument, options);
        }
export type GetPaginatedBanksByCountryIdQueryHookResult = ReturnType<typeof useGetPaginatedBanksByCountryIdQuery>;
export type GetPaginatedBanksByCountryIdLazyQueryHookResult = ReturnType<typeof useGetPaginatedBanksByCountryIdLazyQuery>;
export type GetPaginatedBanksByCountryIdSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedBanksByCountryIdSuspenseQuery>;
export type GetPaginatedBanksByCountryIdQueryResult = Apollo.QueryResult<GetPaginatedBanksByCountryIdQuery, GetPaginatedBanksByCountryIdQueryVariables>;
export const UpsertBankBranchDocument = gql`
    mutation upsertBankBranch($input: UpsertBankBranchInput!) {
  upsertBankBranch(input: $input) {
    bankBranch {
      id
      code
      description
      name
    }
  }
}
    `;
export type UpsertBankBranchMutationFn = Apollo.MutationFunction<UpsertBankBranchMutation, UpsertBankBranchMutationVariables>;

/**
 * __useUpsertBankBranchMutation__
 *
 * To run a mutation, you first call `useUpsertBankBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBankBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBankBranchMutation, { data, loading, error }] = useUpsertBankBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBankBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBankBranchMutation, UpsertBankBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBankBranchMutation, UpsertBankBranchMutationVariables>(UpsertBankBranchDocument, options);
      }
export type UpsertBankBranchMutationHookResult = ReturnType<typeof useUpsertBankBranchMutation>;
export type UpsertBankBranchMutationResult = Apollo.MutationResult<UpsertBankBranchMutation>;
export type UpsertBankBranchMutationOptions = Apollo.BaseMutationOptions<UpsertBankBranchMutation, UpsertBankBranchMutationVariables>;
export const GetPaginatedCompaniesDocument = gql`
    query getPaginatedCompanies($name: String!, $code: String!, $cursor: String, $take: Int = 10, $countryId: Int!) {
  companies(
    countryId: $countryId
    where: {and: [{name: {startsWith: $name}}, {code: {startsWith: $code}}]}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      name
      code
      eamOrganization
      sunBusinessUnit
      countryId
      country {
        id
        name
      }
      allowDepotSelection
      useBundledBOD
      useMAPaymentInJournalPostingsBOD
      enableInvoicesReportPage
      enableSalesOrderReportPage
      enableTransactionReportPage
      allowOrderCancellation
      allowOrderAmendment
      allowNewDriverAndVehicle
      updatedAt
      createdAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetPaginatedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables> & ({ variables: GetPaginatedCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
      }
export function useGetPaginatedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
        }
export function useGetPaginatedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
        }
export type GetPaginatedCompaniesQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesQuery>;
export type GetPaginatedCompaniesLazyQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesLazyQuery>;
export type GetPaginatedCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesSuspenseQuery>;
export type GetPaginatedCompaniesQueryResult = Apollo.QueryResult<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies($countryId: Int!) {
  companies(first: 20, countryId: $countryId) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables> & ({ variables: GetCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export function useGetCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetCompaniesSuspenseQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: Int!, $countryId: Int!) {
  companies(countryId: $countryId, where: {id: {eq: $id}}) {
    nodes {
      id
      name
      code
      eamOrganization
      sunBusinessUnit
      countryId
      country {
        id
        name
      }
      customerTranscription
      enableSalesOfficerLocationScope
      allowDepotSelection
      useBundledBOD
      useMAPaymentInJournalPostingsBOD
      enableInvoicesReportPage
      enableSalesOrderReportPage
      enableTransactionReportPage
      allowOrderCancellation
      allowOrderAmendment
      allowNewDriverAndVehicle
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const ConfigureSalesOfficerLocationScopeDocument = gql`
    mutation ConfigureSalesOfficerLocationScope($companyId: Int!, $enabled: Boolean!) {
  configureSalesOfficerLocationScope(
    input: {companyId: $companyId, enabled: $enabled}
  ) {
    company {
      id
      enableSalesOfficerLocationScope
    }
  }
}
    `;
export type ConfigureSalesOfficerLocationScopeMutationFn = Apollo.MutationFunction<ConfigureSalesOfficerLocationScopeMutation, ConfigureSalesOfficerLocationScopeMutationVariables>;

/**
 * __useConfigureSalesOfficerLocationScopeMutation__
 *
 * To run a mutation, you first call `useConfigureSalesOfficerLocationScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSalesOfficerLocationScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSalesOfficerLocationScopeMutation, { data, loading, error }] = useConfigureSalesOfficerLocationScopeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useConfigureSalesOfficerLocationScopeMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureSalesOfficerLocationScopeMutation, ConfigureSalesOfficerLocationScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureSalesOfficerLocationScopeMutation, ConfigureSalesOfficerLocationScopeMutationVariables>(ConfigureSalesOfficerLocationScopeDocument, options);
      }
export type ConfigureSalesOfficerLocationScopeMutationHookResult = ReturnType<typeof useConfigureSalesOfficerLocationScopeMutation>;
export type ConfigureSalesOfficerLocationScopeMutationResult = Apollo.MutationResult<ConfigureSalesOfficerLocationScopeMutation>;
export type ConfigureSalesOfficerLocationScopeMutationOptions = Apollo.BaseMutationOptions<ConfigureSalesOfficerLocationScopeMutation, ConfigureSalesOfficerLocationScopeMutationVariables>;
export const UpsertCompanyDocument = gql`
    mutation UpsertCompany($input: UpsertCompanyInput!) {
  upsertCompany(input: $input) {
    company {
      id
    }
  }
}
    `;
export type UpsertCompanyMutationFn = Apollo.MutationFunction<UpsertCompanyMutation, UpsertCompanyMutationVariables>;

/**
 * __useUpsertCompanyMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyMutation, { data, loading, error }] = useUpsertCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyMutation, UpsertCompanyMutationVariables>(UpsertCompanyDocument, options);
      }
export type UpsertCompanyMutationHookResult = ReturnType<typeof useUpsertCompanyMutation>;
export type UpsertCompanyMutationResult = Apollo.MutationResult<UpsertCompanyMutation>;
export type UpsertCompanyMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>;
export const GetCustomersByCompanyDocument = gql`
    query getCustomersByCompany($companyId: Int!, $customerName: String! = "", $customerCode: String! = "", $cursor: String, $take: Int = 10) {
  customers(
    where: {and: [{companyId: {eq: $companyId}}, {customerName: {startsWith: $customerName}}, {customerCode: {startsWith: $customerCode}}]}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    nodes {
      id
      customerCode
      customerName
      phoneNumber
      customerVATCode
      customerDeliveryType
      customerSegment {
        name
      }
      active
      altPhoneNumber
      company {
        id
        name
        code
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetCustomersByCompanyQuery__
 *
 * To run a query within a React component, call `useGetCustomersByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      customerName: // value for 'customerName'
 *      customerCode: // value for 'customerCode'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetCustomersByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables> & ({ variables: GetCustomersByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>(GetCustomersByCompanyDocument, options);
      }
export function useGetCustomersByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>(GetCustomersByCompanyDocument, options);
        }
export function useGetCustomersByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>(GetCustomersByCompanyDocument, options);
        }
export type GetCustomersByCompanyQueryHookResult = ReturnType<typeof useGetCustomersByCompanyQuery>;
export type GetCustomersByCompanyLazyQueryHookResult = ReturnType<typeof useGetCustomersByCompanyLazyQuery>;
export type GetCustomersByCompanySuspenseQueryHookResult = ReturnType<typeof useGetCustomersByCompanySuspenseQuery>;
export type GetCustomersByCompanyQueryResult = Apollo.QueryResult<GetCustomersByCompanyQuery, GetCustomersByCompanyQueryVariables>;
export const GetCustomersByCompanyIdDocument = gql`
    query getCustomersByCompanyId($companyId: Int!, $search: String, $cursor: String, $take: Int = 10) {
  customers(
    where: {companyId: {eq: $companyId}, or: [{customerName: {startsWith: $search}}, {customerCode: {startsWith: $search}}]}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    nodes {
      id
      customerCode
      customerName
      phoneNumber
      customerVATCode
      customerDeliveryType
      customerSegment {
        name
      }
      active
      email
      altPhoneNumber
      company {
        id
        name
        code
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetCustomersByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetCustomersByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetCustomersByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables> & ({ variables: GetCustomersByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>(GetCustomersByCompanyIdDocument, options);
      }
export function useGetCustomersByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>(GetCustomersByCompanyIdDocument, options);
        }
export function useGetCustomersByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>(GetCustomersByCompanyIdDocument, options);
        }
export type GetCustomersByCompanyIdQueryHookResult = ReturnType<typeof useGetCustomersByCompanyIdQuery>;
export type GetCustomersByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetCustomersByCompanyIdLazyQuery>;
export type GetCustomersByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomersByCompanyIdSuspenseQuery>;
export type GetCustomersByCompanyIdQueryResult = Apollo.QueryResult<GetCustomersByCompanyIdQuery, GetCustomersByCompanyIdQueryVariables>;
export const GetCustomerByIdDocument = gql`
    query GetCustomerById($customerId: Int!) {
  customers(where: {id: {eq: $customerId}}) {
    nodes {
      active
      altPhoneNumber
      companyId
      createdAt
      customerCode
      customerName
      customerCurrency
      customerSegmentId
      customerAccountBalance
      customerAvailableCredit
      customerCrLimitExpDate
      customerCrLimit
      customerOverdueInvoiceAmt
      customerOnOrderBalance
      customerSegment {
        name
        id
        name
      }
      email
      id
      phoneNumber
      updatedAt
      company {
        name
        countryId
      }
      locations {
        id
        name
        code
      }
      vehicles {
        id
        vehicleNo
        isActive
        isBanned
        owner
        tare
        capacity
        maxWeight
        eamId
        trackingRefNo
        supplierId
      }
      destinations {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetCustomerByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables> & ({ variables: GetCustomerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
      }
export function useGetCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export function useGetCustomerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export type GetCustomerByIdQueryHookResult = ReturnType<typeof useGetCustomerByIdQuery>;
export type GetCustomerByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerByIdLazyQuery>;
export type GetCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByIdSuspenseQuery>;
export type GetCustomerByIdQueryResult = Apollo.QueryResult<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const CustomersWithLinkedAccountsDocument = gql`
    query CustomersWithLinkedAccounts($customerId: Int!) {
  customerUserRoles(where: {customerId: {eq: $customerId}}) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    nodes {
      id
      userId
      user {
        id
        userName
        fullName
        email
        phoneNumber
        createdAt
        company {
          country {
            name
          }
        }
        location {
          name
        }
      }
      roleId
      role {
        description
      }
      customerId
      customer {
        customerName
      }
      createdAt
    }
  }
}
    `;

/**
 * __useCustomersWithLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useCustomersWithLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersWithLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersWithLinkedAccountsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomersWithLinkedAccountsQuery(baseOptions: Apollo.QueryHookOptions<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables> & ({ variables: CustomersWithLinkedAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>(CustomersWithLinkedAccountsDocument, options);
      }
export function useCustomersWithLinkedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>(CustomersWithLinkedAccountsDocument, options);
        }
export function useCustomersWithLinkedAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>(CustomersWithLinkedAccountsDocument, options);
        }
export type CustomersWithLinkedAccountsQueryHookResult = ReturnType<typeof useCustomersWithLinkedAccountsQuery>;
export type CustomersWithLinkedAccountsLazyQueryHookResult = ReturnType<typeof useCustomersWithLinkedAccountsLazyQuery>;
export type CustomersWithLinkedAccountsSuspenseQueryHookResult = ReturnType<typeof useCustomersWithLinkedAccountsSuspenseQuery>;
export type CustomersWithLinkedAccountsQueryResult = Apollo.QueryResult<CustomersWithLinkedAccountsQuery, CustomersWithLinkedAccountsQueryVariables>;
export const GetUsersByCompanyIdDocument = gql`
    query GetUsersByCompanyId($companyId: Int!, $search: String, $cursor: String, $take: Int = 10) {
  usersByCompany(
    companyId: $companyId
    where: {fullName: {contains: $search}}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    totalCount
    nodes {
      companyId
      createdAt
      customerId
      email
      fullName
      id
      isActive
      languageId
      locationId
      permissions
      phoneNumber
      termsAndConditionId
      updatedAt
      userName
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetUsersByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetUsersByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetUsersByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables> & ({ variables: GetUsersByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>(GetUsersByCompanyIdDocument, options);
      }
export function useGetUsersByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>(GetUsersByCompanyIdDocument, options);
        }
export function useGetUsersByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>(GetUsersByCompanyIdDocument, options);
        }
export type GetUsersByCompanyIdQueryHookResult = ReturnType<typeof useGetUsersByCompanyIdQuery>;
export type GetUsersByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetUsersByCompanyIdLazyQuery>;
export type GetUsersByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetUsersByCompanyIdSuspenseQuery>;
export type GetUsersByCompanyIdQueryResult = Apollo.QueryResult<GetUsersByCompanyIdQuery, GetUsersByCompanyIdQueryVariables>;
export const LinkUserAccountDocument = gql`
    mutation LinkUserAccount($id: Int, $customerId: Int!, $userId: Int!, $roleId: Int!) {
  linkUserAccount(
    input: {id: $id, customerId: $customerId, userId: $userId, roleId: $roleId}
  ) {
    customerUserRole {
      roleId
      customerId
      userId
    }
  }
}
    `;
export type LinkUserAccountMutationFn = Apollo.MutationFunction<LinkUserAccountMutation, LinkUserAccountMutationVariables>;

/**
 * __useLinkUserAccountMutation__
 *
 * To run a mutation, you first call `useLinkUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUserAccountMutation, { data, loading, error }] = useLinkUserAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useLinkUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkUserAccountMutation, LinkUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUserAccountMutation, LinkUserAccountMutationVariables>(LinkUserAccountDocument, options);
      }
export type LinkUserAccountMutationHookResult = ReturnType<typeof useLinkUserAccountMutation>;
export type LinkUserAccountMutationResult = Apollo.MutationResult<LinkUserAccountMutation>;
export type LinkUserAccountMutationOptions = Apollo.BaseMutationOptions<LinkUserAccountMutation, LinkUserAccountMutationVariables>;
export const UnlinkUserAccountDocument = gql`
    mutation UnlinkUserAccount($customerId: Int!, $userId: Int!, $roleId: Int!) {
  unlinkUserAccount(
    input: {customerId: $customerId, userId: $userId, roleId: $roleId}
  ) {
    boolean
  }
}
    `;
export type UnlinkUserAccountMutationFn = Apollo.MutationFunction<UnlinkUserAccountMutation, UnlinkUserAccountMutationVariables>;

/**
 * __useUnlinkUserAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkUserAccountMutation, { data, loading, error }] = useUnlinkUserAccountMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUnlinkUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkUserAccountMutation, UnlinkUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkUserAccountMutation, UnlinkUserAccountMutationVariables>(UnlinkUserAccountDocument, options);
      }
export type UnlinkUserAccountMutationHookResult = ReturnType<typeof useUnlinkUserAccountMutation>;
export type UnlinkUserAccountMutationResult = Apollo.MutationResult<UnlinkUserAccountMutation>;
export type UnlinkUserAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkUserAccountMutation, UnlinkUserAccountMutationVariables>;
export const GetTrucksByCustomerDocument = gql`
    query GetTrucksByCustomer($customerId: Int!, $cursor: String, $take: Int = 10) {
  vehicles(
    where: {customers: {some: {id: {eq: $customerId}}}}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    nodes {
      id
      vehicleNo
      isActive
      isBanned
      owner
      tare
      capacity
      maxWeight
      eamId
      trackingRefNo
      supplierId
      vehicleType {
        id
        description
      }
      supplier {
        supplierName
        supplierCode
      }
      vehicleTypeId
      transporterCode
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetTrucksByCustomerQuery__
 *
 * To run a query within a React component, call `useGetTrucksByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrucksByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrucksByCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetTrucksByCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables> & ({ variables: GetTrucksByCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>(GetTrucksByCustomerDocument, options);
      }
export function useGetTrucksByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>(GetTrucksByCustomerDocument, options);
        }
export function useGetTrucksByCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>(GetTrucksByCustomerDocument, options);
        }
export type GetTrucksByCustomerQueryHookResult = ReturnType<typeof useGetTrucksByCustomerQuery>;
export type GetTrucksByCustomerLazyQueryHookResult = ReturnType<typeof useGetTrucksByCustomerLazyQuery>;
export type GetTrucksByCustomerSuspenseQueryHookResult = ReturnType<typeof useGetTrucksByCustomerSuspenseQuery>;
export type GetTrucksByCustomerQueryResult = Apollo.QueryResult<GetTrucksByCustomerQuery, GetTrucksByCustomerQueryVariables>;
export const UpdateCustomerTrucksDocument = gql`
    mutation UpdateCustomerTrucks($customerId: Int!, $vehicles: [Int!]) {
  upsertCustomerVehicle(input: {customerId: $customerId, vehicles: $vehicles}) {
    customer {
      id
    }
  }
}
    `;
export type UpdateCustomerTrucksMutationFn = Apollo.MutationFunction<UpdateCustomerTrucksMutation, UpdateCustomerTrucksMutationVariables>;

/**
 * __useUpdateCustomerTrucksMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerTrucksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerTrucksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerTrucksMutation, { data, loading, error }] = useUpdateCustomerTrucksMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      vehicles: // value for 'vehicles'
 *   },
 * });
 */
export function useUpdateCustomerTrucksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerTrucksMutation, UpdateCustomerTrucksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerTrucksMutation, UpdateCustomerTrucksMutationVariables>(UpdateCustomerTrucksDocument, options);
      }
export type UpdateCustomerTrucksMutationHookResult = ReturnType<typeof useUpdateCustomerTrucksMutation>;
export type UpdateCustomerTrucksMutationResult = Apollo.MutationResult<UpdateCustomerTrucksMutation>;
export type UpdateCustomerTrucksMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerTrucksMutation, UpdateCustomerTrucksMutationVariables>;
export const GetCustomerLocationOptionsDocument = gql`
    query GetCustomerLocationOptions($companyId: Int!, $countryId: Int!) {
  locations(
    countryId: $countryId
    where: {companyId: {eq: $companyId}}
    first: 500
    order: {name: ASC}
  ) {
    nodes {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useGetCustomerLocationOptionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerLocationOptionsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCustomerLocationOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables> & ({ variables: GetCustomerLocationOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>(GetCustomerLocationOptionsDocument, options);
      }
export function useGetCustomerLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>(GetCustomerLocationOptionsDocument, options);
        }
export function useGetCustomerLocationOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>(GetCustomerLocationOptionsDocument, options);
        }
export type GetCustomerLocationOptionsQueryHookResult = ReturnType<typeof useGetCustomerLocationOptionsQuery>;
export type GetCustomerLocationOptionsLazyQueryHookResult = ReturnType<typeof useGetCustomerLocationOptionsLazyQuery>;
export type GetCustomerLocationOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerLocationOptionsSuspenseQuery>;
export type GetCustomerLocationOptionsQueryResult = Apollo.QueryResult<GetCustomerLocationOptionsQuery, GetCustomerLocationOptionsQueryVariables>;
export const UpdateCustomerLocationsDocument = gql`
    mutation UpdateCustomerLocations($customerId: Int!, $locationIds: [Int!]!) {
  updateCustomerLocations(
    input: {customerId: $customerId, locationIds: $locationIds}
  ) {
    customer {
      id
      locations {
        id
        name
        code
      }
    }
  }
}
    `;
export type UpdateCustomerLocationsMutationFn = Apollo.MutationFunction<UpdateCustomerLocationsMutation, UpdateCustomerLocationsMutationVariables>;

/**
 * __useUpdateCustomerLocationsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerLocationsMutation, { data, loading, error }] = useUpdateCustomerLocationsMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useUpdateCustomerLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerLocationsMutation, UpdateCustomerLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerLocationsMutation, UpdateCustomerLocationsMutationVariables>(UpdateCustomerLocationsDocument, options);
      }
export type UpdateCustomerLocationsMutationHookResult = ReturnType<typeof useUpdateCustomerLocationsMutation>;
export type UpdateCustomerLocationsMutationResult = Apollo.MutationResult<UpdateCustomerLocationsMutation>;
export type UpdateCustomerLocationsMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerLocationsMutation, UpdateCustomerLocationsMutationVariables>;
export const CustomerOrderBalancesByBusinessUnitLineForAdminDocument = gql`
    query CustomerOrderBalancesByBusinessUnitLineForAdmin($customerId: Int!) {
  customerOrderBalancesByBusinessUnitLineForAdmin(customerId: $customerId) {
    businessUnitLine
    name
    amountTotal
  }
}
    `;

/**
 * __useCustomerOrderBalancesByBusinessUnitLineForAdminQuery__
 *
 * To run a query within a React component, call `useCustomerOrderBalancesByBusinessUnitLineForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrderBalancesByBusinessUnitLineForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrderBalancesByBusinessUnitLineForAdminQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerOrderBalancesByBusinessUnitLineForAdminQuery(baseOptions: Apollo.QueryHookOptions<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables> & ({ variables: CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>(CustomerOrderBalancesByBusinessUnitLineForAdminDocument, options);
      }
export function useCustomerOrderBalancesByBusinessUnitLineForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>(CustomerOrderBalancesByBusinessUnitLineForAdminDocument, options);
        }
export function useCustomerOrderBalancesByBusinessUnitLineForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>(CustomerOrderBalancesByBusinessUnitLineForAdminDocument, options);
        }
export type CustomerOrderBalancesByBusinessUnitLineForAdminQueryHookResult = ReturnType<typeof useCustomerOrderBalancesByBusinessUnitLineForAdminQuery>;
export type CustomerOrderBalancesByBusinessUnitLineForAdminLazyQueryHookResult = ReturnType<typeof useCustomerOrderBalancesByBusinessUnitLineForAdminLazyQuery>;
export type CustomerOrderBalancesByBusinessUnitLineForAdminSuspenseQueryHookResult = ReturnType<typeof useCustomerOrderBalancesByBusinessUnitLineForAdminSuspenseQuery>;
export type CustomerOrderBalancesByBusinessUnitLineForAdminQueryResult = Apollo.QueryResult<CustomerOrderBalancesByBusinessUnitLineForAdminQuery, CustomerOrderBalancesByBusinessUnitLineForAdminQueryVariables>;
export const GetDestinationsDocument = gql`
    query getDestinations($companyId: Int!, $take: Int = 20, $cursor: String, $search: String) {
  destinations(
    companyId: $companyId
    first: $take
    after: $cursor
    order: {name: ASC}
    where: {or: [{name: {contains: $search}}, {code: {contains: $search}}, {lookup: {contains: $search}}]}
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDestinationsQuery__
 *
 * To run a query within a React component, call `useGetDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDestinationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDestinationsQuery(baseOptions: Apollo.QueryHookOptions<GetDestinationsQuery, GetDestinationsQueryVariables> & ({ variables: GetDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDestinationsQuery, GetDestinationsQueryVariables>(GetDestinationsDocument, options);
      }
export function useGetDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDestinationsQuery, GetDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDestinationsQuery, GetDestinationsQueryVariables>(GetDestinationsDocument, options);
        }
export function useGetDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDestinationsQuery, GetDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDestinationsQuery, GetDestinationsQueryVariables>(GetDestinationsDocument, options);
        }
export type GetDestinationsQueryHookResult = ReturnType<typeof useGetDestinationsQuery>;
export type GetDestinationsLazyQueryHookResult = ReturnType<typeof useGetDestinationsLazyQuery>;
export type GetDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetDestinationsSuspenseQuery>;
export type GetDestinationsQueryResult = Apollo.QueryResult<GetDestinationsQuery, GetDestinationsQueryVariables>;
export const PaginatedLocationDestinationDocument = gql`
    query paginatedLocationDestination($locationId: Int!, $take: Int = 10, $cursor: String, $order: SortEnumType = DESC, $search: String) {
  locationDestinations(
    first: $take
    after: $cursor
    order: {id: $order}
    where: {locationId: {eq: $locationId}, or: [{destination: {name: {contains: $search}}}, {destination: {region: {contains: $search}}}, {destination: {code: {contains: $search}}}, {destination: {lookup: {contains: $search}}}, {destination: {company: {name: {contains: $search}}}}]}
  ) {
    nodes {
      id
      locationId
      destinationId
      destination {
        id
        code
        name
        lookup
        region
        country
        companyId
        company {
          name
          country {
            name
          }
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __usePaginatedLocationDestinationQuery__
 *
 * To run a query within a React component, call `usePaginatedLocationDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLocationDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLocationDestinationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *      order: // value for 'order'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaginatedLocationDestinationQuery(baseOptions: Apollo.QueryHookOptions<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables> & ({ variables: PaginatedLocationDestinationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>(PaginatedLocationDestinationDocument, options);
      }
export function usePaginatedLocationDestinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>(PaginatedLocationDestinationDocument, options);
        }
export function usePaginatedLocationDestinationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>(PaginatedLocationDestinationDocument, options);
        }
export type PaginatedLocationDestinationQueryHookResult = ReturnType<typeof usePaginatedLocationDestinationQuery>;
export type PaginatedLocationDestinationLazyQueryHookResult = ReturnType<typeof usePaginatedLocationDestinationLazyQuery>;
export type PaginatedLocationDestinationSuspenseQueryHookResult = ReturnType<typeof usePaginatedLocationDestinationSuspenseQuery>;
export type PaginatedLocationDestinationQueryResult = Apollo.QueryResult<PaginatedLocationDestinationQuery, PaginatedLocationDestinationQueryVariables>;
export const UpsertLocationDestinationDocument = gql`
    mutation upsertLocationDestination($locationId: Int!, $destinationId: Int!) {
  addLocationDestination(
    input: {destinationId: $destinationId, locationId: $locationId}
  ) {
    locationDestination {
      createdAt
      id
    }
  }
}
    `;
export type UpsertLocationDestinationMutationFn = Apollo.MutationFunction<UpsertLocationDestinationMutation, UpsertLocationDestinationMutationVariables>;

/**
 * __useUpsertLocationDestinationMutation__
 *
 * To run a mutation, you first call `useUpsertLocationDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLocationDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLocationDestinationMutation, { data, loading, error }] = useUpsertLocationDestinationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useUpsertLocationDestinationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLocationDestinationMutation, UpsertLocationDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLocationDestinationMutation, UpsertLocationDestinationMutationVariables>(UpsertLocationDestinationDocument, options);
      }
export type UpsertLocationDestinationMutationHookResult = ReturnType<typeof useUpsertLocationDestinationMutation>;
export type UpsertLocationDestinationMutationResult = Apollo.MutationResult<UpsertLocationDestinationMutation>;
export type UpsertLocationDestinationMutationOptions = Apollo.BaseMutationOptions<UpsertLocationDestinationMutation, UpsertLocationDestinationMutationVariables>;
export const DeleteLocationDestinationDocument = gql`
    mutation deleteLocationDestination($locationId: Int!, $destinationId: Int!) {
  removeLocationDestination(
    input: {destinationId: $destinationId, locationId: $locationId}
  ) {
    boolean
  }
}
    `;
export type DeleteLocationDestinationMutationFn = Apollo.MutationFunction<DeleteLocationDestinationMutation, DeleteLocationDestinationMutationVariables>;

/**
 * __useDeleteLocationDestinationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationDestinationMutation, { data, loading, error }] = useDeleteLocationDestinationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useDeleteLocationDestinationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationDestinationMutation, DeleteLocationDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationDestinationMutation, DeleteLocationDestinationMutationVariables>(DeleteLocationDestinationDocument, options);
      }
export type DeleteLocationDestinationMutationHookResult = ReturnType<typeof useDeleteLocationDestinationMutation>;
export type DeleteLocationDestinationMutationResult = Apollo.MutationResult<DeleteLocationDestinationMutation>;
export type DeleteLocationDestinationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationDestinationMutation, DeleteLocationDestinationMutationVariables>;
export const AddCustomerDestinationDocument = gql`
    mutation AddCustomerDestination($input: AddCustomerDestinationInput!) {
  addCustomerDestination(input: $input) {
    boolean
  }
}
    `;
export type AddCustomerDestinationMutationFn = Apollo.MutationFunction<AddCustomerDestinationMutation, AddCustomerDestinationMutationVariables>;

/**
 * __useAddCustomerDestinationMutation__
 *
 * To run a mutation, you first call `useAddCustomerDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerDestinationMutation, { data, loading, error }] = useAddCustomerDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCustomerDestinationMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerDestinationMutation, AddCustomerDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerDestinationMutation, AddCustomerDestinationMutationVariables>(AddCustomerDestinationDocument, options);
      }
export type AddCustomerDestinationMutationHookResult = ReturnType<typeof useAddCustomerDestinationMutation>;
export type AddCustomerDestinationMutationResult = Apollo.MutationResult<AddCustomerDestinationMutation>;
export type AddCustomerDestinationMutationOptions = Apollo.BaseMutationOptions<AddCustomerDestinationMutation, AddCustomerDestinationMutationVariables>;
export const RemoveCustomerDestinationDocument = gql`
    mutation RemoveCustomerDestination($input: RemoveCustomerDestinationInput!) {
  removeCustomerDestination(input: $input) {
    boolean
  }
}
    `;
export type RemoveCustomerDestinationMutationFn = Apollo.MutationFunction<RemoveCustomerDestinationMutation, RemoveCustomerDestinationMutationVariables>;

/**
 * __useRemoveCustomerDestinationMutation__
 *
 * To run a mutation, you first call `useRemoveCustomerDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomerDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomerDestinationMutation, { data, loading, error }] = useRemoveCustomerDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCustomerDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomerDestinationMutation, RemoveCustomerDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomerDestinationMutation, RemoveCustomerDestinationMutationVariables>(RemoveCustomerDestinationDocument, options);
      }
export type RemoveCustomerDestinationMutationHookResult = ReturnType<typeof useRemoveCustomerDestinationMutation>;
export type RemoveCustomerDestinationMutationResult = Apollo.MutationResult<RemoveCustomerDestinationMutation>;
export type RemoveCustomerDestinationMutationOptions = Apollo.BaseMutationOptions<RemoveCustomerDestinationMutation, RemoveCustomerDestinationMutationVariables>;
export const GetCompanyDestinationsDocument = gql`
    query getCompanyDestinations($companyId: Int!) {
  destinations(companyId: $companyId) {
    nodes {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useGetCompanyDestinationsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDestinationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyDestinationsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables> & ({ variables: GetCompanyDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>(GetCompanyDestinationsDocument, options);
      }
export function useGetCompanyDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>(GetCompanyDestinationsDocument, options);
        }
export function useGetCompanyDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>(GetCompanyDestinationsDocument, options);
        }
export type GetCompanyDestinationsQueryHookResult = ReturnType<typeof useGetCompanyDestinationsQuery>;
export type GetCompanyDestinationsLazyQueryHookResult = ReturnType<typeof useGetCompanyDestinationsLazyQuery>;
export type GetCompanyDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDestinationsSuspenseQuery>;
export type GetCompanyDestinationsQueryResult = Apollo.QueryResult<GetCompanyDestinationsQuery, GetCompanyDestinationsQueryVariables>;
export const GetPaginatedLocationsDocument = gql`
    query getPaginatedLocations($name: String!, $code: String!, $cursor: String, $take: Int = 10, $countryId: Int!) {
  locations(
    where: {or: [{name: {startsWith: $name}}, {code: {startsWith: $code}}]}
    after: $cursor
    first: $take
    order: {id: ASC}
    countryId: $countryId
  ) {
    totalCount
    nodes {
      id
      code
      company {
        name
      }
      name
      type
      costCentre
      pmEmployee
      businessUnitLine
      vatCode
      companyId
      updatedAt
      defaultDeliveryType
      defaultTransporter
      allowDeliveryTypeSelection
      allowDriverSelection
      truckSelectionAllowed
      requireFileUpload
      useFileUpload
      useDescription
      useComments
      useLocalPoNumber
      useDeliveryContact
      requireDestinationSelectionForExworks
      allowDestinationSelectionFromMasterData
      truckSelectionFromMasterAllowed
      allowOrderReference
      allowTruckSelectionForDelivered
      allowDriverSelectionForDelivered
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedLocationsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedLocationsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetPaginatedLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables> & ({ variables: GetPaginatedLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>(GetPaginatedLocationsDocument, options);
      }
export function useGetPaginatedLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>(GetPaginatedLocationsDocument, options);
        }
export function useGetPaginatedLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>(GetPaginatedLocationsDocument, options);
        }
export type GetPaginatedLocationsQueryHookResult = ReturnType<typeof useGetPaginatedLocationsQuery>;
export type GetPaginatedLocationsLazyQueryHookResult = ReturnType<typeof useGetPaginatedLocationsLazyQuery>;
export type GetPaginatedLocationsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedLocationsSuspenseQuery>;
export type GetPaginatedLocationsQueryResult = Apollo.QueryResult<GetPaginatedLocationsQuery, GetPaginatedLocationsQueryVariables>;
export const GetPaginatedLocationsByCompanyDocument = gql`
    query getPaginatedLocationsByCompany($name: String!, $code: String!, $companyId: Int!, $cursor: String, $take: Int = 10, $countryId: Int!) {
  locations(
    where: {and: [{name: {startsWith: $name}}, {code: {startsWith: $code}}, {companyId: {eq: $companyId}}]}
    countryId: $countryId
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    totalCount
    nodes {
      id
      code
      company {
        name
      }
      type
      name
      companyId
      updatedAt
      costCentre
      pmEmployee
      businessUnitLine
      vatCode
      defaultDeliveryType
      defaultTransporter
      allowDeliveryTypeSelection
      allowDriverSelection
      truckSelectionAllowed
      requireFileUpload
      useFileUpload
      useDescription
      useComments
      useLocalPoNumber
      useDeliveryContact
      useConfirmQuotation
      allowBulkOrder
      allowBasketOrders
      allowStandAlonePayment
      requireDestinationSelectionForExworks
      allowDestinationSelectionFromMasterData
      truckSelectionFromMasterAllowed
      allowOrderReference
      allowTruckSelectionForDelivered
      allowDriverSelectionForDelivered
      useDeliveredOrderManagement
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedLocationsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetPaginatedLocationsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedLocationsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedLocationsByCompanyQuery({
 *   variables: {
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      companyId: // value for 'companyId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetPaginatedLocationsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables> & ({ variables: GetPaginatedLocationsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>(GetPaginatedLocationsByCompanyDocument, options);
      }
export function useGetPaginatedLocationsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>(GetPaginatedLocationsByCompanyDocument, options);
        }
export function useGetPaginatedLocationsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>(GetPaginatedLocationsByCompanyDocument, options);
        }
export type GetPaginatedLocationsByCompanyQueryHookResult = ReturnType<typeof useGetPaginatedLocationsByCompanyQuery>;
export type GetPaginatedLocationsByCompanyLazyQueryHookResult = ReturnType<typeof useGetPaginatedLocationsByCompanyLazyQuery>;
export type GetPaginatedLocationsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetPaginatedLocationsByCompanySuspenseQuery>;
export type GetPaginatedLocationsByCompanyQueryResult = Apollo.QueryResult<GetPaginatedLocationsByCompanyQuery, GetPaginatedLocationsByCompanyQueryVariables>;
export const UpsertLocationDocument = gql`
    mutation UpsertLocation($input: UpsertLocationInput!) {
  upsertLocation(input: $input) {
    location {
      id
    }
  }
}
    `;
export type UpsertLocationMutationFn = Apollo.MutationFunction<UpsertLocationMutation, UpsertLocationMutationVariables>;

/**
 * __useUpsertLocationMutation__
 *
 * To run a mutation, you first call `useUpsertLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLocationMutation, { data, loading, error }] = useUpsertLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLocationMutation, UpsertLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLocationMutation, UpsertLocationMutationVariables>(UpsertLocationDocument, options);
      }
export type UpsertLocationMutationHookResult = ReturnType<typeof useUpsertLocationMutation>;
export type UpsertLocationMutationResult = Apollo.MutationResult<UpsertLocationMutation>;
export type UpsertLocationMutationOptions = Apollo.BaseMutationOptions<UpsertLocationMutation, UpsertLocationMutationVariables>;
export const UpsertProductConstraintDocument = gql`
    mutation upsertProductConstraint($input: UpsertProductConstraintInput!) {
  upsertProductConstraint(input: $input) {
    productConstraint {
      id
    }
  }
}
    `;
export type UpsertProductConstraintMutationFn = Apollo.MutationFunction<UpsertProductConstraintMutation, UpsertProductConstraintMutationVariables>;

/**
 * __useUpsertProductConstraintMutation__
 *
 * To run a mutation, you first call `useUpsertProductConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductConstraintMutation, { data, loading, error }] = useUpsertProductConstraintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertProductConstraintMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductConstraintMutation, UpsertProductConstraintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductConstraintMutation, UpsertProductConstraintMutationVariables>(UpsertProductConstraintDocument, options);
      }
export type UpsertProductConstraintMutationHookResult = ReturnType<typeof useUpsertProductConstraintMutation>;
export type UpsertProductConstraintMutationResult = Apollo.MutationResult<UpsertProductConstraintMutation>;
export type UpsertProductConstraintMutationOptions = Apollo.BaseMutationOptions<UpsertProductConstraintMutation, UpsertProductConstraintMutationVariables>;
export const GetPaginatedProductConstraintsDocument = gql`
    query getPaginatedProductConstraints($companyId: Int!, $take: Int = 50, $cursor: String) {
  productConstraints(
    where: {companyId: {eq: $companyId}}
    first: $take
    after: $cursor
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
    nodes {
      id
      customerSegmentId
      customerSegment {
        name
        companyId
        company {
          countryId
          id
        }
      }
      productId
      product {
        title
        uoS
        unitOfMeasure {
          description
          id
        }
        productMeasurementId
      }
      minProductQuantity
      maxProductQuantity
      maxTruckQuantity
      minTruckQuantity
      companyId
    }
  }
}
    `;

/**
 * __useGetPaginatedProductConstraintsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedProductConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedProductConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedProductConstraintsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetPaginatedProductConstraintsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables> & ({ variables: GetPaginatedProductConstraintsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>(GetPaginatedProductConstraintsDocument, options);
      }
export function useGetPaginatedProductConstraintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>(GetPaginatedProductConstraintsDocument, options);
        }
export function useGetPaginatedProductConstraintsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>(GetPaginatedProductConstraintsDocument, options);
        }
export type GetPaginatedProductConstraintsQueryHookResult = ReturnType<typeof useGetPaginatedProductConstraintsQuery>;
export type GetPaginatedProductConstraintsLazyQueryHookResult = ReturnType<typeof useGetPaginatedProductConstraintsLazyQuery>;
export type GetPaginatedProductConstraintsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedProductConstraintsSuspenseQuery>;
export type GetPaginatedProductConstraintsQueryResult = Apollo.QueryResult<GetPaginatedProductConstraintsQuery, GetPaginatedProductConstraintsQueryVariables>;
export const GetCustmerSegmentDocument = gql`
    query getCustmerSegment($companyId: Int!) {
  customerSegments(where: {companyId: {eq: $companyId}}) {
    nodes {
      name
      companyId
      id
    }
  }
}
    `;

/**
 * __useGetCustmerSegmentQuery__
 *
 * To run a query within a React component, call `useGetCustmerSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustmerSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustmerSegmentQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCustmerSegmentQuery(baseOptions: Apollo.QueryHookOptions<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables> & ({ variables: GetCustmerSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>(GetCustmerSegmentDocument, options);
      }
export function useGetCustmerSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>(GetCustmerSegmentDocument, options);
        }
export function useGetCustmerSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>(GetCustmerSegmentDocument, options);
        }
export type GetCustmerSegmentQueryHookResult = ReturnType<typeof useGetCustmerSegmentQuery>;
export type GetCustmerSegmentLazyQueryHookResult = ReturnType<typeof useGetCustmerSegmentLazyQuery>;
export type GetCustmerSegmentSuspenseQueryHookResult = ReturnType<typeof useGetCustmerSegmentSuspenseQuery>;
export type GetCustmerSegmentQueryResult = Apollo.QueryResult<GetCustmerSegmentQuery, GetCustmerSegmentQueryVariables>;
export const GetProductsByCompanyDocument = gql`
    query getProductsByCompany($companyId: Int!, $countryId: Int!, $take: Int = 15, $cursor: String, $search: String) {
  products(
    countryId: $countryId
    first: $take
    after: $cursor
    order: {title: ASC}
    where: {companyId: {eq: $companyId}, title: {contains: $search}}
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      companyId
      id
      title
      lookup
    }
  }
}
    `;

/**
 * __useGetProductsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetProductsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      countryId: // value for 'countryId'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProductsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables> & ({ variables: GetProductsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>(GetProductsByCompanyDocument, options);
      }
export function useGetProductsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>(GetProductsByCompanyDocument, options);
        }
export function useGetProductsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>(GetProductsByCompanyDocument, options);
        }
export type GetProductsByCompanyQueryHookResult = ReturnType<typeof useGetProductsByCompanyQuery>;
export type GetProductsByCompanyLazyQueryHookResult = ReturnType<typeof useGetProductsByCompanyLazyQuery>;
export type GetProductsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetProductsByCompanySuspenseQuery>;
export type GetProductsByCompanyQueryResult = Apollo.QueryResult<GetProductsByCompanyQuery, GetProductsByCompanyQueryVariables>;
export const DeleteProductConstraintDocument = gql`
    mutation DeleteProductConstraint($id: Int!) {
  deleteProductConstraint(input: {id: $id}) {
    boolean
  }
}
    `;
export type DeleteProductConstraintMutationFn = Apollo.MutationFunction<DeleteProductConstraintMutation, DeleteProductConstraintMutationVariables>;

/**
 * __useDeleteProductConstraintMutation__
 *
 * To run a mutation, you first call `useDeleteProductConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductConstraintMutation, { data, loading, error }] = useDeleteProductConstraintMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductConstraintMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductConstraintMutation, DeleteProductConstraintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductConstraintMutation, DeleteProductConstraintMutationVariables>(DeleteProductConstraintDocument, options);
      }
export type DeleteProductConstraintMutationHookResult = ReturnType<typeof useDeleteProductConstraintMutation>;
export type DeleteProductConstraintMutationResult = Apollo.MutationResult<DeleteProductConstraintMutation>;
export type DeleteProductConstraintMutationOptions = Apollo.BaseMutationOptions<DeleteProductConstraintMutation, DeleteProductConstraintMutationVariables>;
export const GetPaginatedLocationProductDocument = gql`
    query getPaginatedLocationProduct($locationId: Int!, $take: Int = 50, $cursor: String, $title: String, $costCentre: String) {
  locationProduct(
    locationId: $locationId
    first: $take
    after: $cursor
    where: {and: [{product: {title: {contains: $title}}}, {costCentre: {contains: $costCentre}}]}
  ) {
    totalCount
    nodes {
      costCentre
      createdAt
      id
      isPublished
      locationId
      productId
      updatedAt
      product {
        companyId
        createdAt
        description
        isPublished
        itemCode
        title
        unitOfMeasureId
        uoS
        updatedAt
        weighPiece
      }
      location {
        code
        costCentre
        createdAt
        name
        truckSelectionFromMasterAllowed
        type
        updatedAt
        company {
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetPaginatedLocationProductQuery__
 *
 * To run a query within a React component, call `useGetPaginatedLocationProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedLocationProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedLocationProductQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *      title: // value for 'title'
 *      costCentre: // value for 'costCentre'
 *   },
 * });
 */
export function useGetPaginatedLocationProductQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables> & ({ variables: GetPaginatedLocationProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>(GetPaginatedLocationProductDocument, options);
      }
export function useGetPaginatedLocationProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>(GetPaginatedLocationProductDocument, options);
        }
export function useGetPaginatedLocationProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>(GetPaginatedLocationProductDocument, options);
        }
export type GetPaginatedLocationProductQueryHookResult = ReturnType<typeof useGetPaginatedLocationProductQuery>;
export type GetPaginatedLocationProductLazyQueryHookResult = ReturnType<typeof useGetPaginatedLocationProductLazyQuery>;
export type GetPaginatedLocationProductSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedLocationProductSuspenseQuery>;
export type GetPaginatedLocationProductQueryResult = Apollo.QueryResult<GetPaginatedLocationProductQuery, GetPaginatedLocationProductQueryVariables>;
export const UpsertLocationProductDocument = gql`
    mutation upsertLocationProduct($input: UpsertLocationProductInput!) {
  upsertLocationProduct(input: $input) {
    locationProduct {
      createdAt
      id
    }
  }
}
    `;
export type UpsertLocationProductMutationFn = Apollo.MutationFunction<UpsertLocationProductMutation, UpsertLocationProductMutationVariables>;

/**
 * __useUpsertLocationProductMutation__
 *
 * To run a mutation, you first call `useUpsertLocationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLocationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLocationProductMutation, { data, loading, error }] = useUpsertLocationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLocationProductMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLocationProductMutation, UpsertLocationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLocationProductMutation, UpsertLocationProductMutationVariables>(UpsertLocationProductDocument, options);
      }
export type UpsertLocationProductMutationHookResult = ReturnType<typeof useUpsertLocationProductMutation>;
export type UpsertLocationProductMutationResult = Apollo.MutationResult<UpsertLocationProductMutation>;
export type UpsertLocationProductMutationOptions = Apollo.BaseMutationOptions<UpsertLocationProductMutation, UpsertLocationProductMutationVariables>;
export const DeleteLocationProductDocument = gql`
    mutation deleteLocationProduct($input: RemoveLocationProductInput!) {
  removeLocationProduct(input: $input) {
    boolean
  }
}
    `;
export type DeleteLocationProductMutationFn = Apollo.MutationFunction<DeleteLocationProductMutation, DeleteLocationProductMutationVariables>;

/**
 * __useDeleteLocationProductMutation__
 *
 * To run a mutation, you first call `useDeleteLocationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationProductMutation, { data, loading, error }] = useDeleteLocationProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationProductMutation, DeleteLocationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationProductMutation, DeleteLocationProductMutationVariables>(DeleteLocationProductDocument, options);
      }
export type DeleteLocationProductMutationHookResult = ReturnType<typeof useDeleteLocationProductMutation>;
export type DeleteLocationProductMutationResult = Apollo.MutationResult<DeleteLocationProductMutation>;
export type DeleteLocationProductMutationOptions = Apollo.BaseMutationOptions<DeleteLocationProductMutation, DeleteLocationProductMutationVariables>;
export const UpsertSettlementBankDocument = gql`
    mutation upsertSettlementBank($input: UpsertSettlementBankInput!) {
  upsertSettlementBank(input: $input) {
    settlementBank {
      id
    }
  }
}
    `;
export type UpsertSettlementBankMutationFn = Apollo.MutationFunction<UpsertSettlementBankMutation, UpsertSettlementBankMutationVariables>;

/**
 * __useUpsertSettlementBankMutation__
 *
 * To run a mutation, you first call `useUpsertSettlementBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSettlementBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSettlementBankMutation, { data, loading, error }] = useUpsertSettlementBankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSettlementBankMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSettlementBankMutation, UpsertSettlementBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSettlementBankMutation, UpsertSettlementBankMutationVariables>(UpsertSettlementBankDocument, options);
      }
export type UpsertSettlementBankMutationHookResult = ReturnType<typeof useUpsertSettlementBankMutation>;
export type UpsertSettlementBankMutationResult = Apollo.MutationResult<UpsertSettlementBankMutation>;
export type UpsertSettlementBankMutationOptions = Apollo.BaseMutationOptions<UpsertSettlementBankMutation, UpsertSettlementBankMutationVariables>;
export const GetSettlementBanksByCompanyDocument = gql`
    query getSettlementBanksByCompany($companyId: Int!, $cursor: Int, $take: Int = 50) {
  settlementBanks(
    where: {companyId: {eq: $companyId}}
    first: $take
    last: $cursor
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      name
      isIncoming
      isActive
      sunAccountCode
      id
      description
      code
      companyId
    }
  }
}
    `;

/**
 * __useGetSettlementBanksByCompanyQuery__
 *
 * To run a query within a React component, call `useGetSettlementBanksByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettlementBanksByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettlementBanksByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetSettlementBanksByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables> & ({ variables: GetSettlementBanksByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>(GetSettlementBanksByCompanyDocument, options);
      }
export function useGetSettlementBanksByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>(GetSettlementBanksByCompanyDocument, options);
        }
export function useGetSettlementBanksByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>(GetSettlementBanksByCompanyDocument, options);
        }
export type GetSettlementBanksByCompanyQueryHookResult = ReturnType<typeof useGetSettlementBanksByCompanyQuery>;
export type GetSettlementBanksByCompanyLazyQueryHookResult = ReturnType<typeof useGetSettlementBanksByCompanyLazyQuery>;
export type GetSettlementBanksByCompanySuspenseQueryHookResult = ReturnType<typeof useGetSettlementBanksByCompanySuspenseQuery>;
export type GetSettlementBanksByCompanyQueryResult = Apollo.QueryResult<GetSettlementBanksByCompanyQuery, GetSettlementBanksByCompanyQueryVariables>;
export const GetPaginatedSettlementBanksByCompanyIdDocument = gql`
    query getPaginatedSettlementBanksByCompanyId($companyId: Int!, $name: String!, $code: String!, $cursor: Int, $take: Int = 50) {
  settlementBanks(
    where: {or: [{name: {startsWith: $name}}, {code: {startsWith: $code}}], companyId: {eq: $companyId}}
    first: $take
    last: $cursor
    order: {name: ASC}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      name
      isIncoming
      isActive
      sunAccountCode
      id
      description
      code
      companyId
      company {
        id
        name
        code
        countryId
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedSettlementBanksByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSettlementBanksByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSettlementBanksByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSettlementBanksByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedSettlementBanksByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables> & ({ variables: GetPaginatedSettlementBanksByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>(GetPaginatedSettlementBanksByCompanyIdDocument, options);
      }
export function useGetPaginatedSettlementBanksByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>(GetPaginatedSettlementBanksByCompanyIdDocument, options);
        }
export function useGetPaginatedSettlementBanksByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>(GetPaginatedSettlementBanksByCompanyIdDocument, options);
        }
export type GetPaginatedSettlementBanksByCompanyIdQueryHookResult = ReturnType<typeof useGetPaginatedSettlementBanksByCompanyIdQuery>;
export type GetPaginatedSettlementBanksByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetPaginatedSettlementBanksByCompanyIdLazyQuery>;
export type GetPaginatedSettlementBanksByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedSettlementBanksByCompanyIdSuspenseQuery>;
export type GetPaginatedSettlementBanksByCompanyIdQueryResult = Apollo.QueryResult<GetPaginatedSettlementBanksByCompanyIdQuery, GetPaginatedSettlementBanksByCompanyIdQueryVariables>;
export const GetVehicleRequestsDocument = gql`
    query GetVehicleRequests($where: VehicleRequestResponseFilterInput, $cursor: String, $take: Int = 20, $startDate: DateTime, $endDate: DateTime, $vehicleRequestStatus: Int, $companyIds: [Int!]!) {
  vehicleRequests(
    where: $where
    after: $cursor
    first: $take
    startDate: $startDate
    endDate: $endDate
    vehicleRequestStatus: $vehicleRequestStatus
    companyIds: $companyIds
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      salesVoucherId
      voucherNumber
      customerRef
      customerCode
      createdAt
      vehicleRequestLicensePlate
      vehicleRequestTransporterCode
      vehicleRequestStatus
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetVehicleRequestsQuery__
 *
 * To run a query within a React component, call `useGetVehicleRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      vehicleRequestStatus: // value for 'vehicleRequestStatus'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetVehicleRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables> & ({ variables: GetVehicleRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>(GetVehicleRequestsDocument, options);
      }
export function useGetVehicleRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>(GetVehicleRequestsDocument, options);
        }
export function useGetVehicleRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>(GetVehicleRequestsDocument, options);
        }
export type GetVehicleRequestsQueryHookResult = ReturnType<typeof useGetVehicleRequestsQuery>;
export type GetVehicleRequestsLazyQueryHookResult = ReturnType<typeof useGetVehicleRequestsLazyQuery>;
export type GetVehicleRequestsSuspenseQueryHookResult = ReturnType<typeof useGetVehicleRequestsSuspenseQuery>;
export type GetVehicleRequestsQueryResult = Apollo.QueryResult<GetVehicleRequestsQuery, GetVehicleRequestsQueryVariables>;
export const GetDriverRequestsDocument = gql`
    query GetDriverRequests($where: DriverRequestResponseFilterInput, $cursor: String, $take: Int = 20, $startDate: DateTime, $endDate: DateTime, $driverRequestStatus: Int, $companyIds: [Int!]!) {
  driverRequests(
    where: $where
    after: $cursor
    first: $take
    startDate: $startDate
    endDate: $endDate
    driverRequestStatus: $driverRequestStatus
    companyIds: $companyIds
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      salesVoucherId
      voucherNumber
      customerRef
      customerCode
      createdAt
      driverRequestLicenseNo
      driverRequestFirstName
      driverRequestLastName
      driverRequestStatus
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetDriverRequestsQuery__
 *
 * To run a query within a React component, call `useGetDriverRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      driverRequestStatus: // value for 'driverRequestStatus'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetDriverRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverRequestsQuery, GetDriverRequestsQueryVariables> & ({ variables: GetDriverRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>(GetDriverRequestsDocument, options);
      }
export function useGetDriverRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>(GetDriverRequestsDocument, options);
        }
export function useGetDriverRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>(GetDriverRequestsDocument, options);
        }
export type GetDriverRequestsQueryHookResult = ReturnType<typeof useGetDriverRequestsQuery>;
export type GetDriverRequestsLazyQueryHookResult = ReturnType<typeof useGetDriverRequestsLazyQuery>;
export type GetDriverRequestsSuspenseQueryHookResult = ReturnType<typeof useGetDriverRequestsSuspenseQuery>;
export type GetDriverRequestsQueryResult = Apollo.QueryResult<GetDriverRequestsQuery, GetDriverRequestsQueryVariables>;
export const GetTransportRequestsDocument = gql`
    query GetTransportRequests($where: TransportRequestResponseFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC, $startDate: DateTime, $endDate: DateTime, $vehicleRequestStatus: Int, $driverRequestStatus: Int, $companyIds: [Int!]!) {
  transportRequests(
    where: $where
    after: $cursor
    first: $take
    order: {vehicle: {createdAt: $order}}
    startDate: $startDate
    endDate: $endDate
    vehicleRequestStatus: $vehicleRequestStatus
    driverRequestStatus: $driverRequestStatus
    companyIds: $companyIds
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      vehicle {
        requestId
        salesVoucherId
        voucherNumber
        customerRef
        customerCode
        createdAt
        licensePlate
        transporterCode
      }
      driver {
        requestId
        salesVoucherId
        voucherNumber
        customerRef
        customerCode
        createdAt
        licenseNo
        firstName
        lastName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetTransportRequestsQuery__
 *
 * To run a query within a React component, call `useGetTransportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransportRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      vehicleRequestStatus: // value for 'vehicleRequestStatus'
 *      driverRequestStatus: // value for 'driverRequestStatus'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetTransportRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetTransportRequestsQuery, GetTransportRequestsQueryVariables> & ({ variables: GetTransportRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>(GetTransportRequestsDocument, options);
      }
export function useGetTransportRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>(GetTransportRequestsDocument, options);
        }
export function useGetTransportRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>(GetTransportRequestsDocument, options);
        }
export type GetTransportRequestsQueryHookResult = ReturnType<typeof useGetTransportRequestsQuery>;
export type GetTransportRequestsLazyQueryHookResult = ReturnType<typeof useGetTransportRequestsLazyQuery>;
export type GetTransportRequestsSuspenseQueryHookResult = ReturnType<typeof useGetTransportRequestsSuspenseQuery>;
export type GetTransportRequestsQueryResult = Apollo.QueryResult<GetTransportRequestsQuery, GetTransportRequestsQueryVariables>;
export const UpsertContentManagementRecordDocument = gql`
    mutation upsertContentManagementRecord($input: UpsertContentInput!) {
  upsertContent(input: $input) {
    content {
      id
    }
  }
}
    `;
export type UpsertContentManagementRecordMutationFn = Apollo.MutationFunction<UpsertContentManagementRecordMutation, UpsertContentManagementRecordMutationVariables>;

/**
 * __useUpsertContentManagementRecordMutation__
 *
 * To run a mutation, you first call `useUpsertContentManagementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContentManagementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContentManagementRecordMutation, { data, loading, error }] = useUpsertContentManagementRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertContentManagementRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContentManagementRecordMutation, UpsertContentManagementRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContentManagementRecordMutation, UpsertContentManagementRecordMutationVariables>(UpsertContentManagementRecordDocument, options);
      }
export type UpsertContentManagementRecordMutationHookResult = ReturnType<typeof useUpsertContentManagementRecordMutation>;
export type UpsertContentManagementRecordMutationResult = Apollo.MutationResult<UpsertContentManagementRecordMutation>;
export type UpsertContentManagementRecordMutationOptions = Apollo.BaseMutationOptions<UpsertContentManagementRecordMutation, UpsertContentManagementRecordMutationVariables>;
export const GetAllContentManagementByTypeDocument = gql`
    query getAllContentManagementByType($countryId: Int!, $contentType: Int!) {
  contents(
    countryId: $countryId
    contentType: $contentType
    order: {createdAt: DESC}
  ) {
    nodes {
      id
      title
      description
      featuredImageUrl
      fileName
      createdAt
    }
  }
}
    `;

/**
 * __useGetAllContentManagementByTypeQuery__
 *
 * To run a query within a React component, call `useGetAllContentManagementByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContentManagementByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContentManagementByTypeQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGetAllContentManagementByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables> & ({ variables: GetAllContentManagementByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>(GetAllContentManagementByTypeDocument, options);
      }
export function useGetAllContentManagementByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>(GetAllContentManagementByTypeDocument, options);
        }
export function useGetAllContentManagementByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>(GetAllContentManagementByTypeDocument, options);
        }
export type GetAllContentManagementByTypeQueryHookResult = ReturnType<typeof useGetAllContentManagementByTypeQuery>;
export type GetAllContentManagementByTypeLazyQueryHookResult = ReturnType<typeof useGetAllContentManagementByTypeLazyQuery>;
export type GetAllContentManagementByTypeSuspenseQueryHookResult = ReturnType<typeof useGetAllContentManagementByTypeSuspenseQuery>;
export type GetAllContentManagementByTypeQueryResult = Apollo.QueryResult<GetAllContentManagementByTypeQuery, GetAllContentManagementByTypeQueryVariables>;
export const GePaginatedContentRecordsByTypeDocument = gql`
    query gePaginatedContentRecordsByType($contentType: Int!, $countryId: Int!, $cursor: Int, $take: Int = 50) {
  contents(
    contentType: $contentType
    countryId: $countryId
    first: $take
    last: $cursor
    order: {createdAt: DESC}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      title
      description
      featuredImageUrl
      fileName
      createdAt
    }
  }
}
    `;

/**
 * __useGePaginatedContentRecordsByTypeQuery__
 *
 * To run a query within a React component, call `useGePaginatedContentRecordsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGePaginatedContentRecordsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGePaginatedContentRecordsByTypeQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      countryId: // value for 'countryId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGePaginatedContentRecordsByTypeQuery(baseOptions: Apollo.QueryHookOptions<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables> & ({ variables: GePaginatedContentRecordsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>(GePaginatedContentRecordsByTypeDocument, options);
      }
export function useGePaginatedContentRecordsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>(GePaginatedContentRecordsByTypeDocument, options);
        }
export function useGePaginatedContentRecordsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>(GePaginatedContentRecordsByTypeDocument, options);
        }
export type GePaginatedContentRecordsByTypeQueryHookResult = ReturnType<typeof useGePaginatedContentRecordsByTypeQuery>;
export type GePaginatedContentRecordsByTypeLazyQueryHookResult = ReturnType<typeof useGePaginatedContentRecordsByTypeLazyQuery>;
export type GePaginatedContentRecordsByTypeSuspenseQueryHookResult = ReturnType<typeof useGePaginatedContentRecordsByTypeSuspenseQuery>;
export type GePaginatedContentRecordsByTypeQueryResult = Apollo.QueryResult<GePaginatedContentRecordsByTypeQuery, GePaginatedContentRecordsByTypeQueryVariables>;
export const DeleteContentManagementRecordDocument = gql`
    mutation DeleteContentManagementRecord($input: DeleteContentInput!) {
  deleteContent(input: $input) {
    boolean
  }
}
    `;
export type DeleteContentManagementRecordMutationFn = Apollo.MutationFunction<DeleteContentManagementRecordMutation, DeleteContentManagementRecordMutationVariables>;

/**
 * __useDeleteContentManagementRecordMutation__
 *
 * To run a mutation, you first call `useDeleteContentManagementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentManagementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentManagementRecordMutation, { data, loading, error }] = useDeleteContentManagementRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContentManagementRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentManagementRecordMutation, DeleteContentManagementRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentManagementRecordMutation, DeleteContentManagementRecordMutationVariables>(DeleteContentManagementRecordDocument, options);
      }
export type DeleteContentManagementRecordMutationHookResult = ReturnType<typeof useDeleteContentManagementRecordMutation>;
export type DeleteContentManagementRecordMutationResult = Apollo.MutationResult<DeleteContentManagementRecordMutation>;
export type DeleteContentManagementRecordMutationOptions = Apollo.BaseMutationOptions<DeleteContentManagementRecordMutation, DeleteContentManagementRecordMutationVariables>;
export const GePaginatedProductsDocument = gql`
    query gePaginatedProducts($countryId: Int!, $companyId: Int!, $cursor: Int, $take: Int = 50) {
  products(
    countryId: $countryId
    first: $take
    last: $cursor
    order: {createdAt: DESC}
    where: {companyId: {eq: $companyId}}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      title
      description
      featuredImageUrl
      fileName
      companyId
      productMeasurementId
      unitOfMeasureId
      itemCode
      createdAt
      isPublished
      titleColor
      backgroundColor
      weighPiece
    }
  }
}
    `;

/**
 * __useGePaginatedProductsQuery__
 *
 * To run a query within a React component, call `useGePaginatedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGePaginatedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGePaginatedProductsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      companyId: // value for 'companyId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGePaginatedProductsQuery(baseOptions: Apollo.QueryHookOptions<GePaginatedProductsQuery, GePaginatedProductsQueryVariables> & ({ variables: GePaginatedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>(GePaginatedProductsDocument, options);
      }
export function useGePaginatedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>(GePaginatedProductsDocument, options);
        }
export function useGePaginatedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>(GePaginatedProductsDocument, options);
        }
export type GePaginatedProductsQueryHookResult = ReturnType<typeof useGePaginatedProductsQuery>;
export type GePaginatedProductsLazyQueryHookResult = ReturnType<typeof useGePaginatedProductsLazyQuery>;
export type GePaginatedProductsSuspenseQueryHookResult = ReturnType<typeof useGePaginatedProductsSuspenseQuery>;
export type GePaginatedProductsQueryResult = Apollo.QueryResult<GePaginatedProductsQuery, GePaginatedProductsQueryVariables>;
export const UpsertProductDocument = gql`
    mutation UpsertProduct($input: UpsertProductInput!) {
  upsertProduct(input: $input) {
    product {
      id
    }
  }
}
    `;
export type UpsertProductMutationFn = Apollo.MutationFunction<UpsertProductMutation, UpsertProductMutationVariables>;

/**
 * __useUpsertProductMutation__
 *
 * To run a mutation, you first call `useUpsertProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductMutation, { data, loading, error }] = useUpsertProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertProductMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductMutation, UpsertProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductMutation, UpsertProductMutationVariables>(UpsertProductDocument, options);
      }
export type UpsertProductMutationHookResult = ReturnType<typeof useUpsertProductMutation>;
export type UpsertProductMutationResult = Apollo.MutationResult<UpsertProductMutation>;
export type UpsertProductMutationOptions = Apollo.BaseMutationOptions<UpsertProductMutation, UpsertProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input) {
    boolean
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const GetUnitOfMeasureDocument = gql`
    query getUnitOfMeasure {
  unitsOfMeasure {
    id
    description
  }
}
    `;

/**
 * __useGetUnitOfMeasureQuery__
 *
 * To run a query within a React component, call `useGetUnitOfMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitOfMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitOfMeasureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitOfMeasureQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>(GetUnitOfMeasureDocument, options);
      }
export function useGetUnitOfMeasureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>(GetUnitOfMeasureDocument, options);
        }
export function useGetUnitOfMeasureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>(GetUnitOfMeasureDocument, options);
        }
export type GetUnitOfMeasureQueryHookResult = ReturnType<typeof useGetUnitOfMeasureQuery>;
export type GetUnitOfMeasureLazyQueryHookResult = ReturnType<typeof useGetUnitOfMeasureLazyQuery>;
export type GetUnitOfMeasureSuspenseQueryHookResult = ReturnType<typeof useGetUnitOfMeasureSuspenseQuery>;
export type GetUnitOfMeasureQueryResult = Apollo.QueryResult<GetUnitOfMeasureQuery, GetUnitOfMeasureQueryVariables>;
export const GetProductMeasurementsDocument = gql`
    query getProductMeasurements {
  productMeasurements {
    id
    description
  }
}
    `;

/**
 * __useGetProductMeasurementsQuery__
 *
 * To run a query within a React component, call `useGetProductMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductMeasurementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductMeasurementsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>(GetProductMeasurementsDocument, options);
      }
export function useGetProductMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>(GetProductMeasurementsDocument, options);
        }
export function useGetProductMeasurementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>(GetProductMeasurementsDocument, options);
        }
export type GetProductMeasurementsQueryHookResult = ReturnType<typeof useGetProductMeasurementsQuery>;
export type GetProductMeasurementsLazyQueryHookResult = ReturnType<typeof useGetProductMeasurementsLazyQuery>;
export type GetProductMeasurementsSuspenseQueryHookResult = ReturnType<typeof useGetProductMeasurementsSuspenseQuery>;
export type GetProductMeasurementsQueryResult = Apollo.QueryResult<GetProductMeasurementsQuery, GetProductMeasurementsQueryVariables>;
export const GetPaginatedContactsDocument = gql`
    query getPaginatedContacts($countryId: Int!, $cursor: Int, $take: Int = 50) {
  contacts(
    countryId: $countryId
    first: $take
    last: $cursor
    order: {createdAt: DESC}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      location {
        name
        latitude
        longitude
      }
      locationId
      telephoneNumber
      physicalAddress
      postalAddress
      email
      createdAt
    }
  }
}
    `;

/**
 * __useGetPaginatedContactsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedContactsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedContactsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables> & ({ variables: GetPaginatedContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>(GetPaginatedContactsDocument, options);
      }
export function useGetPaginatedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>(GetPaginatedContactsDocument, options);
        }
export function useGetPaginatedContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>(GetPaginatedContactsDocument, options);
        }
export type GetPaginatedContactsQueryHookResult = ReturnType<typeof useGetPaginatedContactsQuery>;
export type GetPaginatedContactsLazyQueryHookResult = ReturnType<typeof useGetPaginatedContactsLazyQuery>;
export type GetPaginatedContactsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedContactsSuspenseQuery>;
export type GetPaginatedContactsQueryResult = Apollo.QueryResult<GetPaginatedContactsQuery, GetPaginatedContactsQueryVariables>;
export const UpsertContactDocument = gql`
    mutation UpsertContact($input: UpsertContactInput!) {
  upsertContact(input: $input) {
    contact {
      id
    }
  }
}
    `;
export type UpsertContactMutationFn = Apollo.MutationFunction<UpsertContactMutation, UpsertContactMutationVariables>;

/**
 * __useUpsertContactMutation__
 *
 * To run a mutation, you first call `useUpsertContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContactMutation, { data, loading, error }] = useUpsertContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertContactMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContactMutation, UpsertContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContactMutation, UpsertContactMutationVariables>(UpsertContactDocument, options);
      }
export type UpsertContactMutationHookResult = ReturnType<typeof useUpsertContactMutation>;
export type UpsertContactMutationResult = Apollo.MutationResult<UpsertContactMutation>;
export type UpsertContactMutationOptions = Apollo.BaseMutationOptions<UpsertContactMutation, UpsertContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($input: DeleteContactInput!) {
  deleteContact(input: $input) {
    boolean
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const GetQuotationBodItemsDocument = gql`
    query GetQuotationBodItems($where: SalesVoucherItemFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  salesVoucherItems(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      quotationId
      customerRef
      totalPrice
      createdAt
      updatedAt
      salesVoucher {
        id
        voucherNumber
        customerReference
        sourceLocation {
          id
          name
          company {
            id
            name
            sunBusinessUnit
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetQuotationBodItemsQuery__
 *
 * To run a query within a React component, call `useGetQuotationBodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotationBodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotationBodItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetQuotationBodItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>(GetQuotationBodItemsDocument, options);
      }
export function useGetQuotationBodItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>(GetQuotationBodItemsDocument, options);
        }
export function useGetQuotationBodItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>(GetQuotationBodItemsDocument, options);
        }
export type GetQuotationBodItemsQueryHookResult = ReturnType<typeof useGetQuotationBodItemsQuery>;
export type GetQuotationBodItemsLazyQueryHookResult = ReturnType<typeof useGetQuotationBodItemsLazyQuery>;
export type GetQuotationBodItemsSuspenseQueryHookResult = ReturnType<typeof useGetQuotationBodItemsSuspenseQuery>;
export type GetQuotationBodItemsQueryResult = Apollo.QueryResult<GetQuotationBodItemsQuery, GetQuotationBodItemsQueryVariables>;
export const GetQuotationBodsDocument = gql`
    query GetQuotationBods($where: SalesVoucherFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  salesVouchers(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      voucherNumber
      customerReference
      createdAt
      updatedAt
      sourceLocation {
        id
        name
        company {
          id
          name
        }
      }
      salesVoucherItems {
        id
        quotationId
        customerRef
        totalPrice
        createdAt
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetQuotationBodsQuery__
 *
 * To run a query within a React component, call `useGetQuotationBodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotationBodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotationBodsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetQuotationBodsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>(GetQuotationBodsDocument, options);
      }
export function useGetQuotationBodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>(GetQuotationBodsDocument, options);
        }
export function useGetQuotationBodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>(GetQuotationBodsDocument, options);
        }
export type GetQuotationBodsQueryHookResult = ReturnType<typeof useGetQuotationBodsQuery>;
export type GetQuotationBodsLazyQueryHookResult = ReturnType<typeof useGetQuotationBodsLazyQuery>;
export type GetQuotationBodsSuspenseQueryHookResult = ReturnType<typeof useGetQuotationBodsSuspenseQuery>;
export type GetQuotationBodsQueryResult = Apollo.QueryResult<GetQuotationBodsQuery, GetQuotationBodsQueryVariables>;
export const GetSalesOrderBodItemsDocument = gql`
    query GetSalesOrderBodItems($where: SalesVoucherItemFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  salesVoucherItems(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      quotationId
      customerRef
      totalPrice
      createdAt
      updatedAt
      salesVoucherOrders {
        id
        salesOrderNumber
      }
      salesVoucher {
        id
        voucherNumber
        customerReference
        orderQuote
        sourceLocation {
          id
          name
          company {
            id
            name
            sunBusinessUnit
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetSalesOrderBodItemsQuery__
 *
 * To run a query within a React component, call `useGetSalesOrderBodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesOrderBodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesOrderBodItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetSalesOrderBodItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>(GetSalesOrderBodItemsDocument, options);
      }
export function useGetSalesOrderBodItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>(GetSalesOrderBodItemsDocument, options);
        }
export function useGetSalesOrderBodItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>(GetSalesOrderBodItemsDocument, options);
        }
export type GetSalesOrderBodItemsQueryHookResult = ReturnType<typeof useGetSalesOrderBodItemsQuery>;
export type GetSalesOrderBodItemsLazyQueryHookResult = ReturnType<typeof useGetSalesOrderBodItemsLazyQuery>;
export type GetSalesOrderBodItemsSuspenseQueryHookResult = ReturnType<typeof useGetSalesOrderBodItemsSuspenseQuery>;
export type GetSalesOrderBodItemsQueryResult = Apollo.QueryResult<GetSalesOrderBodItemsQuery, GetSalesOrderBodItemsQueryVariables>;
export const GetQuotationBodVouchersDocument = gql`
    query GetQuotationBodVouchers($where: SalesVoucherFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  salesVouchers(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      voucherNumber
      customerReference
      createdAt
      updatedAt
      sourceLocation {
        id
        name
        company {
          id
          name
        }
      }
      salesVoucherItems {
        id
        totalPrice
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetQuotationBodVouchersQuery__
 *
 * To run a query within a React component, call `useGetQuotationBodVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotationBodVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotationBodVouchersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetQuotationBodVouchersQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>(GetQuotationBodVouchersDocument, options);
      }
export function useGetQuotationBodVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>(GetQuotationBodVouchersDocument, options);
        }
export function useGetQuotationBodVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>(GetQuotationBodVouchersDocument, options);
        }
export type GetQuotationBodVouchersQueryHookResult = ReturnType<typeof useGetQuotationBodVouchersQuery>;
export type GetQuotationBodVouchersLazyQueryHookResult = ReturnType<typeof useGetQuotationBodVouchersLazyQuery>;
export type GetQuotationBodVouchersSuspenseQueryHookResult = ReturnType<typeof useGetQuotationBodVouchersSuspenseQuery>;
export type GetQuotationBodVouchersQueryResult = Apollo.QueryResult<GetQuotationBodVouchersQuery, GetQuotationBodVouchersQueryVariables>;
export const GetSalesOrderBodVouchersDocument = gql`
    query GetSalesOrderBodVouchers($where: SalesVoucherFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  salesVouchers(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    totalCount
    nodes {
      id
      voucherNumber
      customerReference
      orderQuote
      createdAt
      updatedAt
      salesVoucherStatus {
        id
        translationKey
      }
      payments {
        id
        paymentApprovals {
          journalReference
        }
        updatedAt
      }
      sourceLocation {
        id
        name
        company {
          id
          name
        }
      }
      salesVoucherItems {
        id
        totalPrice
        salesVoucherOrders {
          id
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetSalesOrderBodVouchersQuery__
 *
 * To run a query within a React component, call `useGetSalesOrderBodVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesOrderBodVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesOrderBodVouchersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetSalesOrderBodVouchersQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>(GetSalesOrderBodVouchersDocument, options);
      }
export function useGetSalesOrderBodVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>(GetSalesOrderBodVouchersDocument, options);
        }
export function useGetSalesOrderBodVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>(GetSalesOrderBodVouchersDocument, options);
        }
export type GetSalesOrderBodVouchersQueryHookResult = ReturnType<typeof useGetSalesOrderBodVouchersQuery>;
export type GetSalesOrderBodVouchersLazyQueryHookResult = ReturnType<typeof useGetSalesOrderBodVouchersLazyQuery>;
export type GetSalesOrderBodVouchersSuspenseQueryHookResult = ReturnType<typeof useGetSalesOrderBodVouchersSuspenseQuery>;
export type GetSalesOrderBodVouchersQueryResult = Apollo.QueryResult<GetSalesOrderBodVouchersQuery, GetSalesOrderBodVouchersQueryVariables>;
export const RetryQuotationBodGenerationDocument = gql`
    mutation RetryQuotationBodGeneration($input: RetryQuotationBodGenerationInput!) {
  retryQuotationBodGeneration(input: $input) {
    bodRetryResult {
      success
      message
      itemsQueued
      salesVoucherId
      paymentId
    }
  }
}
    `;
export type RetryQuotationBodGenerationMutationFn = Apollo.MutationFunction<RetryQuotationBodGenerationMutation, RetryQuotationBodGenerationMutationVariables>;

/**
 * __useRetryQuotationBodGenerationMutation__
 *
 * To run a mutation, you first call `useRetryQuotationBodGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryQuotationBodGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryQuotationBodGenerationMutation, { data, loading, error }] = useRetryQuotationBodGenerationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryQuotationBodGenerationMutation(baseOptions?: Apollo.MutationHookOptions<RetryQuotationBodGenerationMutation, RetryQuotationBodGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryQuotationBodGenerationMutation, RetryQuotationBodGenerationMutationVariables>(RetryQuotationBodGenerationDocument, options);
      }
export type RetryQuotationBodGenerationMutationHookResult = ReturnType<typeof useRetryQuotationBodGenerationMutation>;
export type RetryQuotationBodGenerationMutationResult = Apollo.MutationResult<RetryQuotationBodGenerationMutation>;
export type RetryQuotationBodGenerationMutationOptions = Apollo.BaseMutationOptions<RetryQuotationBodGenerationMutation, RetryQuotationBodGenerationMutationVariables>;
export const GetAllCompaniesDocument = gql`
    query GetAllCompanies {
  countries {
    companies {
      id
      sunBusinessUnit
      name
    }
  }
}
    `;

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
      }
export function useGetAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export function useGetAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>;
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>;
export type GetAllCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetAllCompaniesSuspenseQuery>;
export type GetAllCompaniesQueryResult = Apollo.QueryResult<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>;
export const RetrySalesOrderBodGenerationDocument = gql`
    mutation RetrySalesOrderBodGeneration($input: RetrySalesOrderBodGenerationInput!) {
  retrySalesOrderBodGeneration(input: $input) {
    bodRetryResult {
      success
      message
      itemsQueued
      salesVoucherId
      paymentId
    }
  }
}
    `;
export type RetrySalesOrderBodGenerationMutationFn = Apollo.MutationFunction<RetrySalesOrderBodGenerationMutation, RetrySalesOrderBodGenerationMutationVariables>;

/**
 * __useRetrySalesOrderBodGenerationMutation__
 *
 * To run a mutation, you first call `useRetrySalesOrderBodGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySalesOrderBodGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySalesOrderBodGenerationMutation, { data, loading, error }] = useRetrySalesOrderBodGenerationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetrySalesOrderBodGenerationMutation(baseOptions?: Apollo.MutationHookOptions<RetrySalesOrderBodGenerationMutation, RetrySalesOrderBodGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySalesOrderBodGenerationMutation, RetrySalesOrderBodGenerationMutationVariables>(RetrySalesOrderBodGenerationDocument, options);
      }
export type RetrySalesOrderBodGenerationMutationHookResult = ReturnType<typeof useRetrySalesOrderBodGenerationMutation>;
export type RetrySalesOrderBodGenerationMutationResult = Apollo.MutationResult<RetrySalesOrderBodGenerationMutation>;
export type RetrySalesOrderBodGenerationMutationOptions = Apollo.BaseMutationOptions<RetrySalesOrderBodGenerationMutation, RetrySalesOrderBodGenerationMutationVariables>;
export const GetPaymentBodItemsDocument = gql`
    query GetPaymentBodItems($where: PaymentFilterInput, $cursor: String, $take: Int = 20, $order: SortEnumType = DESC) {
  payments(
    where: $where
    after: $cursor
    first: $take
    order: {updatedAt: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      paymentReference
      amount
      amountApproved
      createdAt
      updatedAt
      transactionId
      postedToJournal
      paymentMode {
        id
        name
        documentType {
          id
          description
        }
      }
      paymentStatus {
        id
        description
        translationKey
      }
      cheque {
        id
        chequeNumber
        chequeStatus {
          id
          description
          translationKey
        }
      }
      salesVoucher {
        id
        voucherNumber
        sourceLocation {
          id
          name
          company {
            id
            name
            sunBusinessUnit
          }
        }
      }
      paymentApprovals {
        id
        journalReference
        paymentApprovalStatus {
          id
          description
        }
      }
      customer {
        id
        customerName
        customerCode
        company {
          id
          name
          sunBusinessUnit
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaymentBodItemsQuery__
 *
 * To run a query within a React component, call `useGetPaymentBodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBodItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPaymentBodItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>(GetPaymentBodItemsDocument, options);
      }
export function useGetPaymentBodItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>(GetPaymentBodItemsDocument, options);
        }
export function useGetPaymentBodItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>(GetPaymentBodItemsDocument, options);
        }
export type GetPaymentBodItemsQueryHookResult = ReturnType<typeof useGetPaymentBodItemsQuery>;
export type GetPaymentBodItemsLazyQueryHookResult = ReturnType<typeof useGetPaymentBodItemsLazyQuery>;
export type GetPaymentBodItemsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBodItemsSuspenseQuery>;
export type GetPaymentBodItemsQueryResult = Apollo.QueryResult<GetPaymentBodItemsQuery, GetPaymentBodItemsQueryVariables>;
export const RetryPaymentBodGenerationDocument = gql`
    mutation RetryPaymentBodGeneration($input: RetryPaymentJournalPostingBodGenerationInput!) {
  retryPaymentJournalPostingBodGeneration(input: $input) {
    bodRetryResult {
      success
      message
      itemsQueued
      salesVoucherId
      paymentId
    }
  }
}
    `;
export type RetryPaymentBodGenerationMutationFn = Apollo.MutationFunction<RetryPaymentBodGenerationMutation, RetryPaymentBodGenerationMutationVariables>;

/**
 * __useRetryPaymentBodGenerationMutation__
 *
 * To run a mutation, you first call `useRetryPaymentBodGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPaymentBodGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPaymentBodGenerationMutation, { data, loading, error }] = useRetryPaymentBodGenerationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryPaymentBodGenerationMutation(baseOptions?: Apollo.MutationHookOptions<RetryPaymentBodGenerationMutation, RetryPaymentBodGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryPaymentBodGenerationMutation, RetryPaymentBodGenerationMutationVariables>(RetryPaymentBodGenerationDocument, options);
      }
export type RetryPaymentBodGenerationMutationHookResult = ReturnType<typeof useRetryPaymentBodGenerationMutation>;
export type RetryPaymentBodGenerationMutationResult = Apollo.MutationResult<RetryPaymentBodGenerationMutation>;
export type RetryPaymentBodGenerationMutationOptions = Apollo.BaseMutationOptions<RetryPaymentBodGenerationMutation, RetryPaymentBodGenerationMutationVariables>;
export const GetUsersForLocationLinkDocument = gql`
    query GetUsersForLocationLink($search: String!, $take: Int = 20) {
  users(
    where: {or: [{fullName: {contains: $search}}, {email: {contains: $search}}, {userName: {contains: $search}}]}
    first: $take
    order: {fullName: ASC}
  ) {
    nodes {
      id
      fullName
      email
      userName
      locations {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetUsersForLocationLinkQuery__
 *
 * To run a query within a React component, call `useGetUsersForLocationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForLocationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForLocationLinkQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetUsersForLocationLinkQuery(baseOptions: Apollo.QueryHookOptions<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables> & ({ variables: GetUsersForLocationLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>(GetUsersForLocationLinkDocument, options);
      }
export function useGetUsersForLocationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>(GetUsersForLocationLinkDocument, options);
        }
export function useGetUsersForLocationLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>(GetUsersForLocationLinkDocument, options);
        }
export type GetUsersForLocationLinkQueryHookResult = ReturnType<typeof useGetUsersForLocationLinkQuery>;
export type GetUsersForLocationLinkLazyQueryHookResult = ReturnType<typeof useGetUsersForLocationLinkLazyQuery>;
export type GetUsersForLocationLinkSuspenseQueryHookResult = ReturnType<typeof useGetUsersForLocationLinkSuspenseQuery>;
export type GetUsersForLocationLinkQueryResult = Apollo.QueryResult<GetUsersForLocationLinkQuery, GetUsersForLocationLinkQueryVariables>;
export const GetUserForLocationLinkDocument = gql`
    query GetUserForLocationLink($id: Int!) {
  users(where: {id: {eq: $id}}, first: 1) {
    nodes {
      id
      fullName
      email
      userName
      locations {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetUserForLocationLinkQuery__
 *
 * To run a query within a React component, call `useGetUserForLocationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForLocationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForLocationLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForLocationLinkQuery(baseOptions: Apollo.QueryHookOptions<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables> & ({ variables: GetUserForLocationLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>(GetUserForLocationLinkDocument, options);
      }
export function useGetUserForLocationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>(GetUserForLocationLinkDocument, options);
        }
export function useGetUserForLocationLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>(GetUserForLocationLinkDocument, options);
        }
export type GetUserForLocationLinkQueryHookResult = ReturnType<typeof useGetUserForLocationLinkQuery>;
export type GetUserForLocationLinkLazyQueryHookResult = ReturnType<typeof useGetUserForLocationLinkLazyQuery>;
export type GetUserForLocationLinkSuspenseQueryHookResult = ReturnType<typeof useGetUserForLocationLinkSuspenseQuery>;
export type GetUserForLocationLinkQueryResult = Apollo.QueryResult<GetUserForLocationLinkQuery, GetUserForLocationLinkQueryVariables>;
export const AllLocationsDocument = gql`
    query AllLocations($first: Int = 50, $after: String) {
  allLocations(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      code
      name
      companyId
      id
    }
  }
}
    `;

/**
 * __useAllLocationsQuery__
 *
 * To run a query within a React component, call `useAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllLocationsQuery(baseOptions?: Apollo.QueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
      }
export function useAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export function useAllLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export type AllLocationsQueryHookResult = ReturnType<typeof useAllLocationsQuery>;
export type AllLocationsLazyQueryHookResult = ReturnType<typeof useAllLocationsLazyQuery>;
export type AllLocationsSuspenseQueryHookResult = ReturnType<typeof useAllLocationsSuspenseQuery>;
export type AllLocationsQueryResult = Apollo.QueryResult<AllLocationsQuery, AllLocationsQueryVariables>;
export const AddUserToLocationDocument = gql`
    mutation AddUserToLocation($input: AddUserToLocationInput!) {
  addUserToLocation(input: $input) {
    user {
      id
      fullName
      email
      userName
      locations {
        id
        name
        code
      }
    }
  }
}
    `;
export type AddUserToLocationMutationFn = Apollo.MutationFunction<AddUserToLocationMutation, AddUserToLocationMutationVariables>;

/**
 * __useAddUserToLocationMutation__
 *
 * To run a mutation, you first call `useAddUserToLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToLocationMutation, { data, loading, error }] = useAddUserToLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToLocationMutation, AddUserToLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToLocationMutation, AddUserToLocationMutationVariables>(AddUserToLocationDocument, options);
      }
export type AddUserToLocationMutationHookResult = ReturnType<typeof useAddUserToLocationMutation>;
export type AddUserToLocationMutationResult = Apollo.MutationResult<AddUserToLocationMutation>;
export type AddUserToLocationMutationOptions = Apollo.BaseMutationOptions<AddUserToLocationMutation, AddUserToLocationMutationVariables>;
export const GetLogisticsSalesVouchersDocument = gql`
    query GetLogisticsSalesVouchers($where: SalesVoucherFilterInput, $cursor: String, $take: Int = 100, $order: SortEnumType = DESC) {
  salesVouchers(where: $where, after: $cursor, first: $take, order: {id: $order}) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      voucherNumber
      basket {
        basketOrderNumber
      }
      updatedAt
      createdAt
      customer {
        id
        customerName
        customerCode
        customerVATCode
        companyId
      }
      salesVoucherStatus {
        id
        description
        translationKey
      }
      orderQuote
      salesVoucherItems {
        id
        isDeliveryInclusive
        quantity
        destinationId
        vehicleId
        driverId
        vatCode
        project
        product {
          uoS
          unitOfMeasure {
            description
          }
        }
        salesVoucherOrders {
          id
          salesOrderNumber
        }
        transitionalSalesVoucherItems {
          id
          changeTypeId
          oldValue
          newValue
          createdAt
          changeType {
            id
            description
          }
          requestedByUser {
            id
            fullName
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetLogisticsSalesVouchersQuery__
 *
 * To run a query within a React component, call `useGetLogisticsSalesVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogisticsSalesVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogisticsSalesVouchersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetLogisticsSalesVouchersQuery(baseOptions?: Apollo.QueryHookOptions<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>(GetLogisticsSalesVouchersDocument, options);
      }
export function useGetLogisticsSalesVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>(GetLogisticsSalesVouchersDocument, options);
        }
export function useGetLogisticsSalesVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>(GetLogisticsSalesVouchersDocument, options);
        }
export type GetLogisticsSalesVouchersQueryHookResult = ReturnType<typeof useGetLogisticsSalesVouchersQuery>;
export type GetLogisticsSalesVouchersLazyQueryHookResult = ReturnType<typeof useGetLogisticsSalesVouchersLazyQuery>;
export type GetLogisticsSalesVouchersSuspenseQueryHookResult = ReturnType<typeof useGetLogisticsSalesVouchersSuspenseQuery>;
export type GetLogisticsSalesVouchersQueryResult = Apollo.QueryResult<GetLogisticsSalesVouchersQuery, GetLogisticsSalesVouchersQueryVariables>;
export const GetSalesVoucherDetailDocument = gql`
    query GetSalesVoucherDetail($where: SalesVoucherFilterInput) {
  salesVouchers(where: $where) {
    nodes {
      id
      voucherNumber
      customer {
        id
        customerName
        customerCode
        customerVATCode
        companyId
      }
      sourceLocation {
        id
        name
        costCentre
        vatCode
      }
      salesVoucherStatus {
        id
        description
        translationKey
      }
      salesVoucherItems {
        id
        salesVoucherItemStatusId
        customerRef
        deliveryDate
        quantity
        vatCode
        project
        isDeliveryInclusive
        destinationId
        vehicleId
        driverId
        supplierId
        product {
          id
          itemCode
          title
          uoS
        }
        destination {
          id
          code
          name
        }
        vehicle {
          id
          vehicleNo
          transporterCode
        }
        driver {
          id
          licenseNo
          firstName
          lastName
        }
        supplier {
          id
          supplierCode
          supplierName
        }
        sourceLocation {
          id
          costCentre
        }
        salesVoucherOrders {
          id
          salesOrderNumber
        }
        transitionalSalesVoucherItems {
          id
          changeTypeId
          oldValue
          newValue
          createdAt
          changeType {
            id
            description
          }
          requestedByUser {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesVoucherDetailQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherDetailQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSalesVoucherDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>(GetSalesVoucherDetailDocument, options);
      }
export function useGetSalesVoucherDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>(GetSalesVoucherDetailDocument, options);
        }
export function useGetSalesVoucherDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>(GetSalesVoucherDetailDocument, options);
        }
export type GetSalesVoucherDetailQueryHookResult = ReturnType<typeof useGetSalesVoucherDetailQuery>;
export type GetSalesVoucherDetailLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherDetailLazyQuery>;
export type GetSalesVoucherDetailSuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherDetailSuspenseQuery>;
export type GetSalesVoucherDetailQueryResult = Apollo.QueryResult<GetSalesVoucherDetailQuery, GetSalesVoucherDetailQueryVariables>;
export const GetPendingDeliveryDateChangesCountDocument = gql`
    query GetPendingDeliveryDateChangesCount($where: SalesVoucherFilterInput) {
  salesVouchers(where: $where) {
    totalCount
  }
}
    `;

/**
 * __useGetPendingDeliveryDateChangesCountQuery__
 *
 * To run a query within a React component, call `useGetPendingDeliveryDateChangesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingDeliveryDateChangesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingDeliveryDateChangesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPendingDeliveryDateChangesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>(GetPendingDeliveryDateChangesCountDocument, options);
      }
export function useGetPendingDeliveryDateChangesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>(GetPendingDeliveryDateChangesCountDocument, options);
        }
export function useGetPendingDeliveryDateChangesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>(GetPendingDeliveryDateChangesCountDocument, options);
        }
export type GetPendingDeliveryDateChangesCountQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangesCountQuery>;
export type GetPendingDeliveryDateChangesCountLazyQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangesCountLazyQuery>;
export type GetPendingDeliveryDateChangesCountSuspenseQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangesCountSuspenseQuery>;
export type GetPendingDeliveryDateChangesCountQueryResult = Apollo.QueryResult<GetPendingDeliveryDateChangesCountQuery, GetPendingDeliveryDateChangesCountQueryVariables>;
export const GetPendingDeliveryDateChangeItemsCountDocument = gql`
    query GetPendingDeliveryDateChangeItemsCount($where: SalesVoucherItemFilterInput) {
  salesVoucherItems(where: $where, first: 1) {
    totalCount
  }
}
    `;

/**
 * __useGetPendingDeliveryDateChangeItemsCountQuery__
 *
 * To run a query within a React component, call `useGetPendingDeliveryDateChangeItemsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingDeliveryDateChangeItemsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingDeliveryDateChangeItemsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPendingDeliveryDateChangeItemsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>(GetPendingDeliveryDateChangeItemsCountDocument, options);
      }
export function useGetPendingDeliveryDateChangeItemsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>(GetPendingDeliveryDateChangeItemsCountDocument, options);
        }
export function useGetPendingDeliveryDateChangeItemsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>(GetPendingDeliveryDateChangeItemsCountDocument, options);
        }
export type GetPendingDeliveryDateChangeItemsCountQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangeItemsCountQuery>;
export type GetPendingDeliveryDateChangeItemsCountLazyQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangeItemsCountLazyQuery>;
export type GetPendingDeliveryDateChangeItemsCountSuspenseQueryHookResult = ReturnType<typeof useGetPendingDeliveryDateChangeItemsCountSuspenseQuery>;
export type GetPendingDeliveryDateChangeItemsCountQueryResult = Apollo.QueryResult<GetPendingDeliveryDateChangeItemsCountQuery, GetPendingDeliveryDateChangeItemsCountQueryVariables>;
export const GetLogisticsPendingChangeRequestItemsDocument = gql`
    query GetLogisticsPendingChangeRequestItems($where: SalesVoucherItemFilterInput, $cursor: String, $take: Int = 100, $order: [SalesVoucherItemSortInput!]) {
  salesVoucherItems(where: $where, after: $cursor, first: $take, order: $order) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      id
      quantity
      deliveryDate
      destinationId
      vatCode
      isDeliveryInclusive
      createdAt
      updatedAt
      product {
        title
        itemCode
        unitOfMeasure {
          id
          description
        }
      }
      destination {
        id
        code
        name
      }
      vehicle {
        id
        vehicleNo
        transporterCode
      }
      driver {
        id
        firstName
        lastName
      }
      supplier {
        id
        supplierName
      }
      salesVoucher {
        id
        voucherNumber
        createdAt
        updatedAt
        sourceLocationId
        orderQuote
        customer {
          id
          customerName
          customerCode
          companyId
        }
      }
      salesVoucherOrders {
        id
        salesOrderNumber
      }
      transitionalSalesVoucherItems {
        id
        changeTypeId
        oldValue
        newValue
        createdAt
        changeType {
          id
          description
        }
        requestedByUser {
          id
          userName
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetLogisticsPendingChangeRequestItemsQuery__
 *
 * To run a query within a React component, call `useGetLogisticsPendingChangeRequestItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogisticsPendingChangeRequestItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogisticsPendingChangeRequestItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetLogisticsPendingChangeRequestItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>(GetLogisticsPendingChangeRequestItemsDocument, options);
      }
export function useGetLogisticsPendingChangeRequestItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>(GetLogisticsPendingChangeRequestItemsDocument, options);
        }
export function useGetLogisticsPendingChangeRequestItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>(GetLogisticsPendingChangeRequestItemsDocument, options);
        }
export type GetLogisticsPendingChangeRequestItemsQueryHookResult = ReturnType<typeof useGetLogisticsPendingChangeRequestItemsQuery>;
export type GetLogisticsPendingChangeRequestItemsLazyQueryHookResult = ReturnType<typeof useGetLogisticsPendingChangeRequestItemsLazyQuery>;
export type GetLogisticsPendingChangeRequestItemsSuspenseQueryHookResult = ReturnType<typeof useGetLogisticsPendingChangeRequestItemsSuspenseQuery>;
export type GetLogisticsPendingChangeRequestItemsQueryResult = Apollo.QueryResult<GetLogisticsPendingChangeRequestItemsQuery, GetLogisticsPendingChangeRequestItemsQueryVariables>;
export const ApprovePendingDeliveryDateDocument = gql`
    mutation ApprovePendingDeliveryDate($input: ApprovePendingDeliveryDateInput!) {
  approvePendingDeliveryDate(input: $input) {
    salesVoucherItem {
      id
      deliveryDate
      transitionalSalesVoucherItems {
        id
        changeTypeId
        oldValue
        newValue
      }
    }
  }
}
    `;
export type ApprovePendingDeliveryDateMutationFn = Apollo.MutationFunction<ApprovePendingDeliveryDateMutation, ApprovePendingDeliveryDateMutationVariables>;

/**
 * __useApprovePendingDeliveryDateMutation__
 *
 * To run a mutation, you first call `useApprovePendingDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePendingDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePendingDeliveryDateMutation, { data, loading, error }] = useApprovePendingDeliveryDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovePendingDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePendingDeliveryDateMutation, ApprovePendingDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePendingDeliveryDateMutation, ApprovePendingDeliveryDateMutationVariables>(ApprovePendingDeliveryDateDocument, options);
      }
export type ApprovePendingDeliveryDateMutationHookResult = ReturnType<typeof useApprovePendingDeliveryDateMutation>;
export type ApprovePendingDeliveryDateMutationResult = Apollo.MutationResult<ApprovePendingDeliveryDateMutation>;
export type ApprovePendingDeliveryDateMutationOptions = Apollo.BaseMutationOptions<ApprovePendingDeliveryDateMutation, ApprovePendingDeliveryDateMutationVariables>;
export const RejectPendingDeliveryDateDocument = gql`
    mutation RejectPendingDeliveryDate($input: RejectPendingDeliveryDateInput!) {
  rejectPendingDeliveryDate(input: $input) {
    salesVoucherItem {
      id
      deliveryDate
      transitionalSalesVoucherItems {
        id
        changeTypeId
        oldValue
        newValue
      }
    }
  }
}
    `;
export type RejectPendingDeliveryDateMutationFn = Apollo.MutationFunction<RejectPendingDeliveryDateMutation, RejectPendingDeliveryDateMutationVariables>;

/**
 * __useRejectPendingDeliveryDateMutation__
 *
 * To run a mutation, you first call `useRejectPendingDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPendingDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPendingDeliveryDateMutation, { data, loading, error }] = useRejectPendingDeliveryDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectPendingDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<RejectPendingDeliveryDateMutation, RejectPendingDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPendingDeliveryDateMutation, RejectPendingDeliveryDateMutationVariables>(RejectPendingDeliveryDateDocument, options);
      }
export type RejectPendingDeliveryDateMutationHookResult = ReturnType<typeof useRejectPendingDeliveryDateMutation>;
export type RejectPendingDeliveryDateMutationResult = Apollo.MutationResult<RejectPendingDeliveryDateMutation>;
export type RejectPendingDeliveryDateMutationOptions = Apollo.BaseMutationOptions<RejectPendingDeliveryDateMutation, RejectPendingDeliveryDateMutationVariables>;
export const GetDistinctVatCodesDocument = gql`
    query GetDistinctVatCodes($companyId: Int!) {
  distinctVatCodes(companyId: $companyId)
}
    `;

/**
 * __useGetDistinctVatCodesQuery__
 *
 * To run a query within a React component, call `useGetDistinctVatCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctVatCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctVatCodesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetDistinctVatCodesQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables> & ({ variables: GetDistinctVatCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>(GetDistinctVatCodesDocument, options);
      }
export function useGetDistinctVatCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>(GetDistinctVatCodesDocument, options);
        }
export function useGetDistinctVatCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>(GetDistinctVatCodesDocument, options);
        }
export type GetDistinctVatCodesQueryHookResult = ReturnType<typeof useGetDistinctVatCodesQuery>;
export type GetDistinctVatCodesLazyQueryHookResult = ReturnType<typeof useGetDistinctVatCodesLazyQuery>;
export type GetDistinctVatCodesSuspenseQueryHookResult = ReturnType<typeof useGetDistinctVatCodesSuspenseQuery>;
export type GetDistinctVatCodesQueryResult = Apollo.QueryResult<GetDistinctVatCodesQuery, GetDistinctVatCodesQueryVariables>;
export const SearchDestinationsDocument = gql`
    query SearchDestinations($companyId: Int!, $where: DestinationFilterInput, $first: Int = 20) {
  destinations(companyId: $companyId, where: $where, first: $first) {
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useSearchDestinationsQuery__
 *
 * To run a query within a React component, call `useSearchDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDestinationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchDestinationsQuery(baseOptions: Apollo.QueryHookOptions<SearchDestinationsQuery, SearchDestinationsQueryVariables> & ({ variables: SearchDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDestinationsQuery, SearchDestinationsQueryVariables>(SearchDestinationsDocument, options);
      }
export function useSearchDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDestinationsQuery, SearchDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDestinationsQuery, SearchDestinationsQueryVariables>(SearchDestinationsDocument, options);
        }
export function useSearchDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDestinationsQuery, SearchDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDestinationsQuery, SearchDestinationsQueryVariables>(SearchDestinationsDocument, options);
        }
export type SearchDestinationsQueryHookResult = ReturnType<typeof useSearchDestinationsQuery>;
export type SearchDestinationsLazyQueryHookResult = ReturnType<typeof useSearchDestinationsLazyQuery>;
export type SearchDestinationsSuspenseQueryHookResult = ReturnType<typeof useSearchDestinationsSuspenseQuery>;
export type SearchDestinationsQueryResult = Apollo.QueryResult<SearchDestinationsQuery, SearchDestinationsQueryVariables>;
export const SearchVehiclesDocument = gql`
    query SearchVehicles($where: VehicleFilterInput!, $countryId: Int, $first: Int = 20) {
  vehicles(where: {and: [{countryId: {eq: $countryId}}, $where]}, first: $first) {
    nodes {
      id
      vehicleNo
      transporterCode
      isActive
      isBanned
    }
  }
}
    `;

/**
 * __useSearchVehiclesQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      countryId: // value for 'countryId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchVehiclesQuery(baseOptions: Apollo.QueryHookOptions<SearchVehiclesQuery, SearchVehiclesQueryVariables> & ({ variables: SearchVehiclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVehiclesQuery, SearchVehiclesQueryVariables>(SearchVehiclesDocument, options);
      }
export function useSearchVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVehiclesQuery, SearchVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVehiclesQuery, SearchVehiclesQueryVariables>(SearchVehiclesDocument, options);
        }
export function useSearchVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchVehiclesQuery, SearchVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVehiclesQuery, SearchVehiclesQueryVariables>(SearchVehiclesDocument, options);
        }
export type SearchVehiclesQueryHookResult = ReturnType<typeof useSearchVehiclesQuery>;
export type SearchVehiclesLazyQueryHookResult = ReturnType<typeof useSearchVehiclesLazyQuery>;
export type SearchVehiclesSuspenseQueryHookResult = ReturnType<typeof useSearchVehiclesSuspenseQuery>;
export type SearchVehiclesQueryResult = Apollo.QueryResult<SearchVehiclesQuery, SearchVehiclesQueryVariables>;
export const SearchDriversDocument = gql`
    query SearchDrivers($where: DriverFilterInput!, $countryId: Int, $first: Int = 20) {
  drivers(where: {and: [{countryId: {eq: $countryId}}, $where]}, first: $first) {
    nodes {
      id
      licenseNo
      firstName
      lastName
      isActive
      isBanned
    }
  }
}
    `;

/**
 * __useSearchDriversQuery__
 *
 * To run a query within a React component, call `useSearchDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriversQuery({
 *   variables: {
 *      where: // value for 'where'
 *      countryId: // value for 'countryId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchDriversQuery(baseOptions: Apollo.QueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables> & ({ variables: SearchDriversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
      }
export function useSearchDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
        }
export function useSearchDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
        }
export type SearchDriversQueryHookResult = ReturnType<typeof useSearchDriversQuery>;
export type SearchDriversLazyQueryHookResult = ReturnType<typeof useSearchDriversLazyQuery>;
export type SearchDriversSuspenseQueryHookResult = ReturnType<typeof useSearchDriversSuspenseQuery>;
export type SearchDriversQueryResult = Apollo.QueryResult<SearchDriversQuery, SearchDriversQueryVariables>;
export const UpdateSalesVoucherItemsDocument = gql`
    mutation UpdateSalesVoucherItems($input: UpdateSalesVoucherItemsInput!) {
  updateSalesVoucherItems(input: $input) {
    salesVoucherItem {
      id
      customerRef
      deliveryDate
      quantity
      vatCode
      project
      destinationId
      supplierId
      vehicleId
      driverId
      destination {
        id
        code
        name
      }
      vehicle {
        id
        vehicleNo
        transporterCode
      }
      driver {
        id
        licenseNo
        firstName
        lastName
      }
      supplier {
        id
        supplierCode
        supplierName
      }
    }
  }
}
    `;
export type UpdateSalesVoucherItemsMutationFn = Apollo.MutationFunction<UpdateSalesVoucherItemsMutation, UpdateSalesVoucherItemsMutationVariables>;

/**
 * __useUpdateSalesVoucherItemsMutation__
 *
 * To run a mutation, you first call `useUpdateSalesVoucherItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesVoucherItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesVoucherItemsMutation, { data, loading, error }] = useUpdateSalesVoucherItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesVoucherItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesVoucherItemsMutation, UpdateSalesVoucherItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesVoucherItemsMutation, UpdateSalesVoucherItemsMutationVariables>(UpdateSalesVoucherItemsDocument, options);
      }
export type UpdateSalesVoucherItemsMutationHookResult = ReturnType<typeof useUpdateSalesVoucherItemsMutation>;
export type UpdateSalesVoucherItemsMutationResult = Apollo.MutationResult<UpdateSalesVoucherItemsMutation>;
export type UpdateSalesVoucherItemsMutationOptions = Apollo.BaseMutationOptions<UpdateSalesVoucherItemsMutation, UpdateSalesVoucherItemsMutationVariables>;
export const VoidDeliveredOrdersSalesVoucherDocument = gql`
    mutation VoidDeliveredOrdersSalesVoucher($input: VoidDeliveredOrdersSalesVoucherInput!) {
  voidDeliveredOrdersSalesVoucher(input: $input) {
    boolean
  }
}
    `;
export type VoidDeliveredOrdersSalesVoucherMutationFn = Apollo.MutationFunction<VoidDeliveredOrdersSalesVoucherMutation, VoidDeliveredOrdersSalesVoucherMutationVariables>;

/**
 * __useVoidDeliveredOrdersSalesVoucherMutation__
 *
 * To run a mutation, you first call `useVoidDeliveredOrdersSalesVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidDeliveredOrdersSalesVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidDeliveredOrdersSalesVoucherMutation, { data, loading, error }] = useVoidDeliveredOrdersSalesVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidDeliveredOrdersSalesVoucherMutation(baseOptions?: Apollo.MutationHookOptions<VoidDeliveredOrdersSalesVoucherMutation, VoidDeliveredOrdersSalesVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidDeliveredOrdersSalesVoucherMutation, VoidDeliveredOrdersSalesVoucherMutationVariables>(VoidDeliveredOrdersSalesVoucherDocument, options);
      }
export type VoidDeliveredOrdersSalesVoucherMutationHookResult = ReturnType<typeof useVoidDeliveredOrdersSalesVoucherMutation>;
export type VoidDeliveredOrdersSalesVoucherMutationResult = Apollo.MutationResult<VoidDeliveredOrdersSalesVoucherMutation>;
export type VoidDeliveredOrdersSalesVoucherMutationOptions = Apollo.BaseMutationOptions<VoidDeliveredOrdersSalesVoucherMutation, VoidDeliveredOrdersSalesVoucherMutationVariables>;
export const BulkVoidDeliveredOrdersSalesVouchersDocument = gql`
    mutation BulkVoidDeliveredOrdersSalesVouchers($input: BulkVoidDeliveredOrdersSalesVouchersInput!) {
  bulkVoidDeliveredOrdersSalesVouchers(input: $input) {
    boolean
  }
}
    `;
export type BulkVoidDeliveredOrdersSalesVouchersMutationFn = Apollo.MutationFunction<BulkVoidDeliveredOrdersSalesVouchersMutation, BulkVoidDeliveredOrdersSalesVouchersMutationVariables>;

/**
 * __useBulkVoidDeliveredOrdersSalesVouchersMutation__
 *
 * To run a mutation, you first call `useBulkVoidDeliveredOrdersSalesVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkVoidDeliveredOrdersSalesVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkVoidDeliveredOrdersSalesVouchersMutation, { data, loading, error }] = useBulkVoidDeliveredOrdersSalesVouchersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkVoidDeliveredOrdersSalesVouchersMutation(baseOptions?: Apollo.MutationHookOptions<BulkVoidDeliveredOrdersSalesVouchersMutation, BulkVoidDeliveredOrdersSalesVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkVoidDeliveredOrdersSalesVouchersMutation, BulkVoidDeliveredOrdersSalesVouchersMutationVariables>(BulkVoidDeliveredOrdersSalesVouchersDocument, options);
      }
export type BulkVoidDeliveredOrdersSalesVouchersMutationHookResult = ReturnType<typeof useBulkVoidDeliveredOrdersSalesVouchersMutation>;
export type BulkVoidDeliveredOrdersSalesVouchersMutationResult = Apollo.MutationResult<BulkVoidDeliveredOrdersSalesVouchersMutation>;
export type BulkVoidDeliveredOrdersSalesVouchersMutationOptions = Apollo.BaseMutationOptions<BulkVoidDeliveredOrdersSalesVouchersMutation, BulkVoidDeliveredOrdersSalesVouchersMutationVariables>;
export const ConfirmDeliveredOrdersDocument = gql`
    mutation ConfirmDeliveredOrders($input: ConfirmDeliveredOrdersInput!) {
  confirmDeliveredOrders(input: $input) {
    salesVoucher {
      id
      voucherNumber
      salesVoucherStatus {
        id
        description
      }
    }
  }
}
    `;
export type ConfirmDeliveredOrdersMutationFn = Apollo.MutationFunction<ConfirmDeliveredOrdersMutation, ConfirmDeliveredOrdersMutationVariables>;

/**
 * __useConfirmDeliveredOrdersMutation__
 *
 * To run a mutation, you first call `useConfirmDeliveredOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDeliveredOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDeliveredOrdersMutation, { data, loading, error }] = useConfirmDeliveredOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmDeliveredOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDeliveredOrdersMutation, ConfirmDeliveredOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDeliveredOrdersMutation, ConfirmDeliveredOrdersMutationVariables>(ConfirmDeliveredOrdersDocument, options);
      }
export type ConfirmDeliveredOrdersMutationHookResult = ReturnType<typeof useConfirmDeliveredOrdersMutation>;
export type ConfirmDeliveredOrdersMutationResult = Apollo.MutationResult<ConfirmDeliveredOrdersMutation>;
export type ConfirmDeliveredOrdersMutationOptions = Apollo.BaseMutationOptions<ConfirmDeliveredOrdersMutation, ConfirmDeliveredOrdersMutationVariables>;
export const ValidateDeliveredOrderItemsDocument = gql`
    mutation ValidateDeliveredOrderItems($input: ValidateDeliveredOrderItemsInput!) {
  validateDeliveredOrderItems(input: $input) {
    deliveredItemValidationResult {
      rowIndex
      destinationCode
      isDestinationValid
      destinationError
      resolvedDestinationId
      destination {
        id
        code
        name
      }
      vehicleNo
      isVehicleValid
      vehicleError
      resolvedVehicleId
      vehicle {
        id
        vehicleNo
        transporterCode
        isActive
        isBanned
      }
      driverLicenseNo
      isDriverValid
      driverError
      resolvedDriverId
      driver {
        id
        licenseNo
        firstName
        lastName
        isActive
        isBanned
      }
      vatCode
      isVATCodeValid
      vatCodeError
      quantity
      isQuantityValid
      quantityError
      customerRef
      isCustomerRefValid
      customerRefError
      project
      isProjectValid
      isRowValid
    }
  }
}
    `;
export type ValidateDeliveredOrderItemsMutationFn = Apollo.MutationFunction<ValidateDeliveredOrderItemsMutation, ValidateDeliveredOrderItemsMutationVariables>;

/**
 * __useValidateDeliveredOrderItemsMutation__
 *
 * To run a mutation, you first call `useValidateDeliveredOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDeliveredOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDeliveredOrderItemsMutation, { data, loading, error }] = useValidateDeliveredOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateDeliveredOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDeliveredOrderItemsMutation, ValidateDeliveredOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDeliveredOrderItemsMutation, ValidateDeliveredOrderItemsMutationVariables>(ValidateDeliveredOrderItemsDocument, options);
      }
export type ValidateDeliveredOrderItemsMutationHookResult = ReturnType<typeof useValidateDeliveredOrderItemsMutation>;
export type ValidateDeliveredOrderItemsMutationResult = Apollo.MutationResult<ValidateDeliveredOrderItemsMutation>;
export type ValidateDeliveredOrderItemsMutationOptions = Apollo.BaseMutationOptions<ValidateDeliveredOrderItemsMutation, ValidateDeliveredOrderItemsMutationVariables>;
export const GetActiveTransportersByCompanyDocument = gql`
    query GetActiveTransportersByCompany($companyId: Int!, $search: String, $first: Int = 20) {
  suppliers(
    first: $first
    order: [{supplierCode: ASC}]
    where: {companyId: {eq: $companyId}, active: {eq: true}, transporter: {eq: true}, or: [{supplierCode: {contains: $search}}, {supplierName: {contains: $search}}]}
  ) {
    totalCount
    nodes {
      id
      supplierName
      supplierCode
      companyId
    }
  }
}
    `;

/**
 * __useGetActiveTransportersByCompanyQuery__
 *
 * To run a query within a React component, call `useGetActiveTransportersByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveTransportersByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveTransportersByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetActiveTransportersByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables> & ({ variables: GetActiveTransportersByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>(GetActiveTransportersByCompanyDocument, options);
      }
export function useGetActiveTransportersByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>(GetActiveTransportersByCompanyDocument, options);
        }
export function useGetActiveTransportersByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>(GetActiveTransportersByCompanyDocument, options);
        }
export type GetActiveTransportersByCompanyQueryHookResult = ReturnType<typeof useGetActiveTransportersByCompanyQuery>;
export type GetActiveTransportersByCompanyLazyQueryHookResult = ReturnType<typeof useGetActiveTransportersByCompanyLazyQuery>;
export type GetActiveTransportersByCompanySuspenseQueryHookResult = ReturnType<typeof useGetActiveTransportersByCompanySuspenseQuery>;
export type GetActiveTransportersByCompanyQueryResult = Apollo.QueryResult<GetActiveTransportersByCompanyQuery, GetActiveTransportersByCompanyQueryVariables>;
export const SearchProductsForVoucherDocument = gql`
    query SearchProductsForVoucher($countryId: Int!, $companyId: Int!, $search: String, $first: Int = 30) {
  products(
    countryId: $countryId
    first: $first
    order: [{itemCode: ASC}]
    where: {companyId: {eq: $companyId}, or: [{itemCode: {contains: $search}}, {title: {contains: $search}}]}
  ) {
    nodes {
      id
      itemCode
      title
      uoS
    }
  }
}
    `;

/**
 * __useSearchProductsForVoucherQuery__
 *
 * To run a query within a React component, call `useSearchProductsForVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsForVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsForVoucherQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchProductsForVoucherQuery(baseOptions: Apollo.QueryHookOptions<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables> & ({ variables: SearchProductsForVoucherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>(SearchProductsForVoucherDocument, options);
      }
export function useSearchProductsForVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>(SearchProductsForVoucherDocument, options);
        }
export function useSearchProductsForVoucherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>(SearchProductsForVoucherDocument, options);
        }
export type SearchProductsForVoucherQueryHookResult = ReturnType<typeof useSearchProductsForVoucherQuery>;
export type SearchProductsForVoucherLazyQueryHookResult = ReturnType<typeof useSearchProductsForVoucherLazyQuery>;
export type SearchProductsForVoucherSuspenseQueryHookResult = ReturnType<typeof useSearchProductsForVoucherSuspenseQuery>;
export type SearchProductsForVoucherQueryResult = Apollo.QueryResult<SearchProductsForVoucherQuery, SearchProductsForVoucherQueryVariables>;
export const UpsertPaymentApprovalDocument = gql`
    mutation upsertPaymentApproval($input: UpsertPaymentApprovalInput!) {
  upsertPaymentApproval(input: $input) {
    paymentApproval {
      id
      paymentApprovalStatusId
    }
  }
}
    `;
export type UpsertPaymentApprovalMutationFn = Apollo.MutationFunction<UpsertPaymentApprovalMutation, UpsertPaymentApprovalMutationVariables>;

/**
 * __useUpsertPaymentApprovalMutation__
 *
 * To run a mutation, you first call `useUpsertPaymentApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaymentApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaymentApprovalMutation, { data, loading, error }] = useUpsertPaymentApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPaymentApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaymentApprovalMutation, UpsertPaymentApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaymentApprovalMutation, UpsertPaymentApprovalMutationVariables>(UpsertPaymentApprovalDocument, options);
      }
export type UpsertPaymentApprovalMutationHookResult = ReturnType<typeof useUpsertPaymentApprovalMutation>;
export type UpsertPaymentApprovalMutationResult = Apollo.MutationResult<UpsertPaymentApprovalMutation>;
export type UpsertPaymentApprovalMutationOptions = Apollo.BaseMutationOptions<UpsertPaymentApprovalMutation, UpsertPaymentApprovalMutationVariables>;
export const ApprovePaymentDocument = gql`
    mutation approvePayment($input: ApprovePaymentInput!) {
  approvePayment(input: $input) {
    payment {
      id
      paymentStatusId
      createdAt
    }
  }
}
    `;
export type ApprovePaymentMutationFn = Apollo.MutationFunction<ApprovePaymentMutation, ApprovePaymentMutationVariables>;

/**
 * __useApprovePaymentMutation__
 *
 * To run a mutation, you first call `useApprovePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePaymentMutation, { data, loading, error }] = useApprovePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePaymentMutation, ApprovePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePaymentMutation, ApprovePaymentMutationVariables>(ApprovePaymentDocument, options);
      }
export type ApprovePaymentMutationHookResult = ReturnType<typeof useApprovePaymentMutation>;
export type ApprovePaymentMutationResult = Apollo.MutationResult<ApprovePaymentMutation>;
export type ApprovePaymentMutationOptions = Apollo.BaseMutationOptions<ApprovePaymentMutation, ApprovePaymentMutationVariables>;
export const UpsertPaymentTranscriptionDocument = gql`
    mutation upsertPaymentTranscription($input: UpsertPaymentTranscriptionInput!) {
  upsertPaymentTranscription(input: $input) {
    paymentTranscription {
      id
    }
  }
}
    `;
export type UpsertPaymentTranscriptionMutationFn = Apollo.MutationFunction<UpsertPaymentTranscriptionMutation, UpsertPaymentTranscriptionMutationVariables>;

/**
 * __useUpsertPaymentTranscriptionMutation__
 *
 * To run a mutation, you first call `useUpsertPaymentTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaymentTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaymentTranscriptionMutation, { data, loading, error }] = useUpsertPaymentTranscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPaymentTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaymentTranscriptionMutation, UpsertPaymentTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaymentTranscriptionMutation, UpsertPaymentTranscriptionMutationVariables>(UpsertPaymentTranscriptionDocument, options);
      }
export type UpsertPaymentTranscriptionMutationHookResult = ReturnType<typeof useUpsertPaymentTranscriptionMutation>;
export type UpsertPaymentTranscriptionMutationResult = Apollo.MutationResult<UpsertPaymentTranscriptionMutation>;
export type UpsertPaymentTranscriptionMutationOptions = Apollo.BaseMutationOptions<UpsertPaymentTranscriptionMutation, UpsertPaymentTranscriptionMutationVariables>;
export const UpsertPaymentDocument = gql`
    mutation upsertPayment($input: UpsertPaymentInput!) {
  upsertPayment(input: $input) {
    payment {
      id
    }
  }
}
    `;
export type UpsertPaymentMutationFn = Apollo.MutationFunction<UpsertPaymentMutation, UpsertPaymentMutationVariables>;

/**
 * __useUpsertPaymentMutation__
 *
 * To run a mutation, you first call `useUpsertPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaymentMutation, { data, loading, error }] = useUpsertPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaymentMutation, UpsertPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaymentMutation, UpsertPaymentMutationVariables>(UpsertPaymentDocument, options);
      }
export type UpsertPaymentMutationHookResult = ReturnType<typeof useUpsertPaymentMutation>;
export type UpsertPaymentMutationResult = Apollo.MutationResult<UpsertPaymentMutation>;
export type UpsertPaymentMutationOptions = Apollo.BaseMutationOptions<UpsertPaymentMutation, UpsertPaymentMutationVariables>;
export const GetManualPaymentDocument = gql`
    query getManualPayment($paymentId: Int!) {
  payments(where: {and: [{id: {eq: $paymentId}}]}) {
    nodes {
      id
      createdAt
      amount
      availableBalanceRef
      customer {
        id
        customerName
        customerCode
        customerCurrency
        businessUnitCurrency
        companyId
        locations {
          id
        }
      }
      paymentApprovals {
        id
        amountApproved
        settlementBankId
        reasonId
        paymentApprovalStatusId
      }
      salesVoucher {
        id
        voucherNumber
        orderQuote
        createdAt
        salesVoucherItems {
          id
          product {
            description
            title
            itemCode
            featuredImageUrl
            uoS
          }
          salesVoucherOrders {
            salesOrderNumber
          }
          trucksCount
          unitPrice
          quantity
        }
        customer {
          id
          customerName
          customerCode
          email
          phoneNumber
          createdAt
          customerCurrency
          businessUnitCurrency
        }
      }
      paymentModeId
      paymentMode {
        id
        name
        paymentModeTypeId
        documentType {
          id
          description
          translationKey
        }
      }
      paymentReference
      paymentApprovals {
        journalReference
      }
      paymentStatus {
        id
        description
      }
      paymentTranscriptions {
        id
        amount
        bankId
        bank {
          id
          name
        }
        bankBranchId
        bankBranch {
          id
          name
        }
        createdAt
        documentTypeId
        documentType {
          id
          description
          translationKey
        }
        documentTypeId
        amount
        depositorContact
        depositorName
        documentDate
        documentReference
        notes
        documentDate
        payment {
          id
          customer {
            customerName
            customerCurrency
            businessUnitCurrency
          }
          salesVoucher {
            orderQuote
          }
        }
        paymentId
        paymentTranscriptionStatus {
          id
          description
        }
        paymentTranscriptionStatusId
        updatedAt
        createdBy {
          id
          email
          fullName
          userName
        }
      }
      paymentDocuments {
        createdAt
        documentName
        documentUrl
        id
        paymentId
        updatedAt
      }
      transactionId
      updatedAt
    }
  }
}
    `;

/**
 * __useGetManualPaymentQuery__
 *
 * To run a query within a React component, call `useGetManualPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualPaymentQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetManualPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetManualPaymentQuery, GetManualPaymentQueryVariables> & ({ variables: GetManualPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManualPaymentQuery, GetManualPaymentQueryVariables>(GetManualPaymentDocument, options);
      }
export function useGetManualPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManualPaymentQuery, GetManualPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManualPaymentQuery, GetManualPaymentQueryVariables>(GetManualPaymentDocument, options);
        }
export function useGetManualPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualPaymentQuery, GetManualPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManualPaymentQuery, GetManualPaymentQueryVariables>(GetManualPaymentDocument, options);
        }
export type GetManualPaymentQueryHookResult = ReturnType<typeof useGetManualPaymentQuery>;
export type GetManualPaymentLazyQueryHookResult = ReturnType<typeof useGetManualPaymentLazyQuery>;
export type GetManualPaymentSuspenseQueryHookResult = ReturnType<typeof useGetManualPaymentSuspenseQuery>;
export type GetManualPaymentQueryResult = Apollo.QueryResult<GetManualPaymentQuery, GetManualPaymentQueryVariables>;
export const GetPaymentTranscriptionsDocument = gql`
    query getPaymentTranscriptions($paymentId: Int!) {
  paymentTranscriptions(where: {paymentId: {eq: $paymentId}}) {
    nodes {
      id
      amount
      bankId
      bank {
        id
        name
      }
      bankBranch {
        id
        name
      }
      bankBranchId
      bankId
      createdAt
      depositorContact
      depositorName
      documentDate
      documentReference
      documentType {
        id
        description
        translationKey
      }
      documentTypeId
      notes
      payment {
        id
        salesVoucher {
          orderQuote
        }
        customer {
          customerName
          customerCurrency
          businessUnitCurrency
        }
        availableBalanceRef
        paymentModeId
        amount
      }
      paymentId
      paymentTranscriptionStatus {
        id
        description
      }
      paymentTranscriptionStatusId
      updatedAt
      createdBy {
        id
        email
        fullName
        userName
      }
    }
  }
}
    `;

/**
 * __useGetPaymentTranscriptionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentTranscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTranscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTranscriptionsQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentTranscriptionsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables> & ({ variables: GetPaymentTranscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>(GetPaymentTranscriptionsDocument, options);
      }
export function useGetPaymentTranscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>(GetPaymentTranscriptionsDocument, options);
        }
export function useGetPaymentTranscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>(GetPaymentTranscriptionsDocument, options);
        }
export type GetPaymentTranscriptionsQueryHookResult = ReturnType<typeof useGetPaymentTranscriptionsQuery>;
export type GetPaymentTranscriptionsLazyQueryHookResult = ReturnType<typeof useGetPaymentTranscriptionsLazyQuery>;
export type GetPaymentTranscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTranscriptionsSuspenseQuery>;
export type GetPaymentTranscriptionsQueryResult = Apollo.QueryResult<GetPaymentTranscriptionsQuery, GetPaymentTranscriptionsQueryVariables>;
export const GetPaymentApprovalsDocument = gql`
    query getPaymentApprovals($paymentId: Int!) {
  paymentApprovals(where: {paymentId: {eq: $paymentId}}, order: [{id: DESC}]) {
    nodes {
      id
      createdAt
      approvalComment
      amountApproved
      settlementBankId
      settlementBank {
        id
        name
      }
      paymentApprovalStatusId
      paymentApprovalTypeId
      paymentApprovalStatus {
        id
        description
      }
      createdAt
      createdBy {
        id
        email
        fullName
        userName
      }
      rejectionComment
    }
  }
}
    `;

/**
 * __useGetPaymentApprovalsQuery__
 *
 * To run a query within a React component, call `useGetPaymentApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApprovalsQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables> & ({ variables: GetPaymentApprovalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>(GetPaymentApprovalsDocument, options);
      }
export function useGetPaymentApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>(GetPaymentApprovalsDocument, options);
        }
export function useGetPaymentApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>(GetPaymentApprovalsDocument, options);
        }
export type GetPaymentApprovalsQueryHookResult = ReturnType<typeof useGetPaymentApprovalsQuery>;
export type GetPaymentApprovalsLazyQueryHookResult = ReturnType<typeof useGetPaymentApprovalsLazyQuery>;
export type GetPaymentApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApprovalsSuspenseQuery>;
export type GetPaymentApprovalsQueryResult = Apollo.QueryResult<GetPaymentApprovalsQuery, GetPaymentApprovalsQueryVariables>;
export const GetCustomerBankGuaranteeDocument = gql`
    query getCustomerBankGuarantee($customerId: Int!, $bankid: Int!, $companyId: Int!) {
  bankGuarantees(
    companyId: $companyId
    where: {customerId: {eq: $customerId}, guaranteeBankId: {eq: $bankid}}
  ) {
    id
    customerId
    expiryDate
    reference
    customer {
      customerName
      customerCode
    }
    issuedDate
    salesOffice {
      name
    }
    guaranteeBank {
      name
      code
    }
  }
}
    `;

/**
 * __useGetCustomerBankGuaranteeQuery__
 *
 * To run a query within a React component, call `useGetCustomerBankGuaranteeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBankGuaranteeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBankGuaranteeQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      bankid: // value for 'bankid'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCustomerBankGuaranteeQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables> & ({ variables: GetCustomerBankGuaranteeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>(GetCustomerBankGuaranteeDocument, options);
      }
export function useGetCustomerBankGuaranteeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>(GetCustomerBankGuaranteeDocument, options);
        }
export function useGetCustomerBankGuaranteeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>(GetCustomerBankGuaranteeDocument, options);
        }
export type GetCustomerBankGuaranteeQueryHookResult = ReturnType<typeof useGetCustomerBankGuaranteeQuery>;
export type GetCustomerBankGuaranteeLazyQueryHookResult = ReturnType<typeof useGetCustomerBankGuaranteeLazyQuery>;
export type GetCustomerBankGuaranteeSuspenseQueryHookResult = ReturnType<typeof useGetCustomerBankGuaranteeSuspenseQuery>;
export type GetCustomerBankGuaranteeQueryResult = Apollo.QueryResult<GetCustomerBankGuaranteeQuery, GetCustomerBankGuaranteeQueryVariables>;
export const GetPaymentAccessDocument = gql`
    query getPaymentAccess($companyId: Int!) {
  paymentAccess(companyId: $companyId) {
    kind
    companyId
    locationIds
    sessionLocationId
  }
}
    `;

/**
 * __useGetPaymentAccessQuery__
 *
 * To run a query within a React component, call `useGetPaymentAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAccessQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPaymentAccessQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentAccessQuery, GetPaymentAccessQueryVariables> & ({ variables: GetPaymentAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>(GetPaymentAccessDocument, options);
      }
export function useGetPaymentAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>(GetPaymentAccessDocument, options);
        }
export function useGetPaymentAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>(GetPaymentAccessDocument, options);
        }
export type GetPaymentAccessQueryHookResult = ReturnType<typeof useGetPaymentAccessQuery>;
export type GetPaymentAccessLazyQueryHookResult = ReturnType<typeof useGetPaymentAccessLazyQuery>;
export type GetPaymentAccessSuspenseQueryHookResult = ReturnType<typeof useGetPaymentAccessSuspenseQuery>;
export type GetPaymentAccessQueryResult = Apollo.QueryResult<GetPaymentAccessQuery, GetPaymentAccessQueryVariables>;
export const GetPaymentLocationScopesDocument = gql`
    query getPaymentLocationScopes {
  paymentLocationScopes {
    companyId
    companyName
    kind
    sessionLocationId
    locations {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useGetPaymentLocationScopesQuery__
 *
 * To run a query within a React component, call `useGetPaymentLocationScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLocationScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentLocationScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentLocationScopesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>(GetPaymentLocationScopesDocument, options);
      }
export function useGetPaymentLocationScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>(GetPaymentLocationScopesDocument, options);
        }
export function useGetPaymentLocationScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>(GetPaymentLocationScopesDocument, options);
        }
export type GetPaymentLocationScopesQueryHookResult = ReturnType<typeof useGetPaymentLocationScopesQuery>;
export type GetPaymentLocationScopesLazyQueryHookResult = ReturnType<typeof useGetPaymentLocationScopesLazyQuery>;
export type GetPaymentLocationScopesSuspenseQueryHookResult = ReturnType<typeof useGetPaymentLocationScopesSuspenseQuery>;
export type GetPaymentLocationScopesQueryResult = Apollo.QueryResult<GetPaymentLocationScopesQuery, GetPaymentLocationScopesQueryVariables>;
export const GetPaymentsDataDocument = gql`
    query getPaymentsData($companyId: Int!, $locationIds: [Int!], $where: PaymentFilterInput, $cursor: String, $take: Int = 100, $order: SortEnumType = DESC) {
  backOfficePayments(
    companyId: $companyId
    locationIds: $locationIds
    where: $where
    after: $cursor
    first: $take
    order: {id: $order}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      amount
      createdAt
      postedToJournal
      paymentMode {
        name
      }
      customer {
        customerName
        customerCode
        companyId
        customerCurrency
        businessUnitCurrency
      }
      salesVoucher {
        id
        orderQuote
        voucherNumber
        sourceLocationId
        createdAt
        customer {
          customerName
          customerCode
        }
      }
      paymentModeId
      paymentMode {
        id
        name
      }
      paymentReference
      paymentApprovals {
        journalReference
        updatedAt
      }
      paymentStatus {
        id
        translationKey
        description
      }
      amountApproved
      amount
      paymentDocuments {
        createdAt
        documentName
        documentUrl
        id
        paymentId
        updatedAt
      }
      transactionId
      updatedAt
    }
  }
}
    `;

/**
 * __useGetPaymentsDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPaymentsDataQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsDataQuery, GetPaymentsDataQueryVariables> & ({ variables: GetPaymentsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>(GetPaymentsDataDocument, options);
      }
export function useGetPaymentsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>(GetPaymentsDataDocument, options);
        }
export function useGetPaymentsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>(GetPaymentsDataDocument, options);
        }
export type GetPaymentsDataQueryHookResult = ReturnType<typeof useGetPaymentsDataQuery>;
export type GetPaymentsDataLazyQueryHookResult = ReturnType<typeof useGetPaymentsDataLazyQuery>;
export type GetPaymentsDataSuspenseQueryHookResult = ReturnType<typeof useGetPaymentsDataSuspenseQuery>;
export type GetPaymentsDataQueryResult = Apollo.QueryResult<GetPaymentsDataQuery, GetPaymentsDataQueryVariables>;
export const GetSalesVoucherPaymentsDocument = gql`
    query getSalesVoucherPayments($salesVoucherId: Int!) {
  payments(where: {and: [{salesVoucher: {id: {eq: $salesVoucherId}}}]}) {
    nodes {
      id
      amount
      paymentMode {
        name
      }
      salesVoucher {
        id
      }
      paymentModeId
      paymentMode {
        id
        name
      }
      paymentReference
      paymentApprovals {
        journalReference
      }
      paymentStatus {
        id
        translationKey
        description
      }
      paymentDocuments {
        createdAt
        documentName
        documentUrl
        id
        paymentId
        updatedAt
      }
      transactionId
      updatedAt
    }
  }
}
    `;

/**
 * __useGetSalesVoucherPaymentsQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherPaymentsQuery({
 *   variables: {
 *      salesVoucherId: // value for 'salesVoucherId'
 *   },
 * });
 */
export function useGetSalesVoucherPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables> & ({ variables: GetSalesVoucherPaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>(GetSalesVoucherPaymentsDocument, options);
      }
export function useGetSalesVoucherPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>(GetSalesVoucherPaymentsDocument, options);
        }
export function useGetSalesVoucherPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>(GetSalesVoucherPaymentsDocument, options);
        }
export type GetSalesVoucherPaymentsQueryHookResult = ReturnType<typeof useGetSalesVoucherPaymentsQuery>;
export type GetSalesVoucherPaymentsLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherPaymentsLazyQuery>;
export type GetSalesVoucherPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherPaymentsSuspenseQuery>;
export type GetSalesVoucherPaymentsQueryResult = Apollo.QueryResult<GetSalesVoucherPaymentsQuery, GetSalesVoucherPaymentsQueryVariables>;
export const GetPaymentByIdDocument = gql`
    query getPaymentById($paymentId: Int!) {
  payments(where: {and: [{id: {eq: $paymentId}}]}) {
    nodes {
      id
      amount
      paymentMode {
        name
      }
      salesVoucher {
        id
      }
      paymentModeId
      paymentMode {
        id
        name
      }
      paymentReference
      paymentApprovals {
        journalReference
      }
      paymentStatus {
        id
        translationKey
        description
      }
      paymentDocuments {
        createdAt
        documentName
        documentUrl
        id
        paymentId
        updatedAt
      }
      transactionId
      updatedAt
    }
  }
}
    `;

/**
 * __useGetPaymentByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentByIdQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentByIdQuery, GetPaymentByIdQueryVariables> & ({ variables: GetPaymentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>(GetPaymentByIdDocument, options);
      }
export function useGetPaymentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>(GetPaymentByIdDocument, options);
        }
export function useGetPaymentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>(GetPaymentByIdDocument, options);
        }
export type GetPaymentByIdQueryHookResult = ReturnType<typeof useGetPaymentByIdQuery>;
export type GetPaymentByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentByIdLazyQuery>;
export type GetPaymentByIdSuspenseQueryHookResult = ReturnType<typeof useGetPaymentByIdSuspenseQuery>;
export type GetPaymentByIdQueryResult = Apollo.QueryResult<GetPaymentByIdQuery, GetPaymentByIdQueryVariables>;
export const GetPendingPaymentsSummaryDocument = gql`
    query getPendingPaymentsSummary($companyId: Int!, $locationIds: [Int]!, $cursor: String, $take: Int = 7) {
  payments(
    where: {or: [{and: [{salesVoucherId: {eq: null}}, {customer: {companyId: {eq: $companyId}}}]}, {salesVoucher: {sourceLocationId: {in: $locationIds}}}], and: [{paymentStatus: {description: {in: ["Pending", "TranscriptionRequired", "TreasurerApprovalRequired", "FinalApprovalRequired"]}}}]}
    after: $cursor
    first: $take
    order: {id: DESC}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      amount
      paymentMode {
        name
      }
      customer {
        customerName
        customerCode
        companyId
        customerCurrency
        businessUnitCurrency
      }
      salesVoucher {
        voucherNumber
        sourceLocationId
        customer {
          customerName
        }
      }
      paymentStatus {
        translationKey
        description
      }
    }
  }
}
    `;

/**
 * __useGetPendingPaymentsSummaryQuery__
 *
 * To run a query within a React component, call `useGetPendingPaymentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPaymentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPaymentsSummaryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPendingPaymentsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables> & ({ variables: GetPendingPaymentsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>(GetPendingPaymentsSummaryDocument, options);
      }
export function useGetPendingPaymentsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>(GetPendingPaymentsSummaryDocument, options);
        }
export function useGetPendingPaymentsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>(GetPendingPaymentsSummaryDocument, options);
        }
export type GetPendingPaymentsSummaryQueryHookResult = ReturnType<typeof useGetPendingPaymentsSummaryQuery>;
export type GetPendingPaymentsSummaryLazyQueryHookResult = ReturnType<typeof useGetPendingPaymentsSummaryLazyQuery>;
export type GetPendingPaymentsSummarySuspenseQueryHookResult = ReturnType<typeof useGetPendingPaymentsSummarySuspenseQuery>;
export type GetPendingPaymentsSummaryQueryResult = Apollo.QueryResult<GetPendingPaymentsSummaryQuery, GetPendingPaymentsSummaryQueryVariables>;
export const GetCheckIfBankReferenceIsReusedDocument = gql`
    query GetCheckIfBankReferenceIsReused($bankReference: String!, $bankId: Int!, $paymentId: Int) {
  payments(
    where: {and: [{paymentTranscriptions: {some: {and: [{documentReference: {eq: $bankReference}}, {bankId: {eq: $bankId}}]}}}, {paymentStatusId: {neq: 3}}, {paymentStatusId: {neq: 4}}, {id: {neq: $paymentId}}]}
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetCheckIfBankReferenceIsReusedQuery__
 *
 * To run a query within a React component, call `useGetCheckIfBankReferenceIsReusedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckIfBankReferenceIsReusedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckIfBankReferenceIsReusedQuery({
 *   variables: {
 *      bankReference: // value for 'bankReference'
 *      bankId: // value for 'bankId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetCheckIfBankReferenceIsReusedQuery(baseOptions: Apollo.QueryHookOptions<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables> & ({ variables: GetCheckIfBankReferenceIsReusedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>(GetCheckIfBankReferenceIsReusedDocument, options);
      }
export function useGetCheckIfBankReferenceIsReusedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>(GetCheckIfBankReferenceIsReusedDocument, options);
        }
export function useGetCheckIfBankReferenceIsReusedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>(GetCheckIfBankReferenceIsReusedDocument, options);
        }
export type GetCheckIfBankReferenceIsReusedQueryHookResult = ReturnType<typeof useGetCheckIfBankReferenceIsReusedQuery>;
export type GetCheckIfBankReferenceIsReusedLazyQueryHookResult = ReturnType<typeof useGetCheckIfBankReferenceIsReusedLazyQuery>;
export type GetCheckIfBankReferenceIsReusedSuspenseQueryHookResult = ReturnType<typeof useGetCheckIfBankReferenceIsReusedSuspenseQuery>;
export type GetCheckIfBankReferenceIsReusedQueryResult = Apollo.QueryResult<GetCheckIfBankReferenceIsReusedQuery, GetCheckIfBankReferenceIsReusedQueryVariables>;
export const GetPaymentImageDownloadUrlDocument = gql`
    query getPaymentImageDownloadUrl($blobName: String!, $fileName: String!) {
  paymentImageDownloadUrl(blobName: $blobName, fileName: $fileName)
}
    `;

/**
 * __useGetPaymentImageDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetPaymentImageDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentImageDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentImageDownloadUrlQuery({
 *   variables: {
 *      blobName: // value for 'blobName'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetPaymentImageDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables> & ({ variables: GetPaymentImageDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>(GetPaymentImageDownloadUrlDocument, options);
      }
export function useGetPaymentImageDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>(GetPaymentImageDownloadUrlDocument, options);
        }
export function useGetPaymentImageDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>(GetPaymentImageDownloadUrlDocument, options);
        }
export type GetPaymentImageDownloadUrlQueryHookResult = ReturnType<typeof useGetPaymentImageDownloadUrlQuery>;
export type GetPaymentImageDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetPaymentImageDownloadUrlLazyQuery>;
export type GetPaymentImageDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetPaymentImageDownloadUrlSuspenseQuery>;
export type GetPaymentImageDownloadUrlQueryResult = Apollo.QueryResult<GetPaymentImageDownloadUrlQuery, GetPaymentImageDownloadUrlQueryVariables>;
export const GetAvailableBalancePaymentDetailsDocument = gql`
    query getAvailableBalancePaymentDetails($documentRef: String!) {
  remainingBalanceForPaymentReference(documentReference: $documentRef) {
    amountPendingApproval
    remainingBalance
    totalAmount
    amountUsed
    cashDepositSlipNumber
    depositorName
    chequeDate
    paymentMode
    bank
  }
}
    `;

/**
 * __useGetAvailableBalancePaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetAvailableBalancePaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableBalancePaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableBalancePaymentDetailsQuery({
 *   variables: {
 *      documentRef: // value for 'documentRef'
 *   },
 * });
 */
export function useGetAvailableBalancePaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables> & ({ variables: GetAvailableBalancePaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>(GetAvailableBalancePaymentDetailsDocument, options);
      }
export function useGetAvailableBalancePaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>(GetAvailableBalancePaymentDetailsDocument, options);
        }
export function useGetAvailableBalancePaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>(GetAvailableBalancePaymentDetailsDocument, options);
        }
export type GetAvailableBalancePaymentDetailsQueryHookResult = ReturnType<typeof useGetAvailableBalancePaymentDetailsQuery>;
export type GetAvailableBalancePaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetAvailableBalancePaymentDetailsLazyQuery>;
export type GetAvailableBalancePaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableBalancePaymentDetailsSuspenseQuery>;
export type GetAvailableBalancePaymentDetailsQueryResult = Apollo.QueryResult<GetAvailableBalancePaymentDetailsQuery, GetAvailableBalancePaymentDetailsQueryVariables>;
export const GetPaymentModesDocument = gql`
    query getPaymentModes($companyId: Int!) {
  paymentModes(where: {companyId: {eq: $companyId}, paymentModeStatusId: {eq: 1}}) {
    name
    id
  }
}
    `;

/**
 * __useGetPaymentModesQuery__
 *
 * To run a query within a React component, call `useGetPaymentModesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentModesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentModesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPaymentModesQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentModesQuery, GetPaymentModesQueryVariables> & ({ variables: GetPaymentModesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentModesQuery, GetPaymentModesQueryVariables>(GetPaymentModesDocument, options);
      }
export function useGetPaymentModesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentModesQuery, GetPaymentModesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentModesQuery, GetPaymentModesQueryVariables>(GetPaymentModesDocument, options);
        }
export function useGetPaymentModesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentModesQuery, GetPaymentModesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentModesQuery, GetPaymentModesQueryVariables>(GetPaymentModesDocument, options);
        }
export type GetPaymentModesQueryHookResult = ReturnType<typeof useGetPaymentModesQuery>;
export type GetPaymentModesLazyQueryHookResult = ReturnType<typeof useGetPaymentModesLazyQuery>;
export type GetPaymentModesSuspenseQueryHookResult = ReturnType<typeof useGetPaymentModesSuspenseQuery>;
export type GetPaymentModesQueryResult = Apollo.QueryResult<GetPaymentModesQuery, GetPaymentModesQueryVariables>;
export const GetPlannerSalesVoucherItemsDocument = gql`
    query GetPlannerSalesVoucherItems($where: SalesVoucherItemFilterInput, $cursor: String, $take: Int = 100, $order: [SalesVoucherItemSortInput!]) {
  salesVoucherItems(where: $where, after: $cursor, first: $take, order: $order) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    nodes {
      id
      quantity
      unitPrice
      totalPrice
      createdAt
      updatedAt
      deliveryDate
      productId
      salesVoucherId
      salesVoucherStatusId
      customerRef
      trucksCount
      destinationId
      quotationId
      currency
      salesVoucherStatus {
        id
        description
        translationKey
      }
      product {
        id
        title
        itemCode
        uoS
      }
      destination {
        id
        name
        code
      }
      salesVoucher {
        id
        voucherNumber
        customerReference
        orderQuote
        customerId
        customer {
          id
          customerName
          customerCode
          phoneNumber
        }
        sourceLocation {
          id
          name
          code
        }
      }
      salesVoucherOrders {
        id
        salesOrderNumber
        quantity
        amountTotal
        currency
        vehicleNumber
        driverLicenseNo
        transporterCode
        salesVoucherOrderStatusId
        salesVoucherOrderStatus {
          id
          description
          translationKey
        }
        customer {
          id
          customerName
          customerCode
        }
        product {
          id
          title
          itemCode
        }
        destination {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlannerSalesVoucherItemsQuery__
 *
 * To run a query within a React component, call `useGetPlannerSalesVoucherItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannerSalesVoucherItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannerSalesVoucherItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPlannerSalesVoucherItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>(GetPlannerSalesVoucherItemsDocument, options);
      }
export function useGetPlannerSalesVoucherItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>(GetPlannerSalesVoucherItemsDocument, options);
        }
export function useGetPlannerSalesVoucherItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>(GetPlannerSalesVoucherItemsDocument, options);
        }
export type GetPlannerSalesVoucherItemsQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemsQuery>;
export type GetPlannerSalesVoucherItemsLazyQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemsLazyQuery>;
export type GetPlannerSalesVoucherItemsSuspenseQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemsSuspenseQuery>;
export type GetPlannerSalesVoucherItemsQueryResult = Apollo.QueryResult<GetPlannerSalesVoucherItemsQuery, GetPlannerSalesVoucherItemsQueryVariables>;
export const GetPlannerSalesVoucherItemByIdDocument = gql`
    query GetPlannerSalesVoucherItemById($id: Int!) {
  salesVoucherItems(where: {id: {eq: $id}}) {
    nodes {
      id
      quantity
      unitPrice
      totalPrice
      createdAt
      updatedAt
      deliveryDate
      productId
      salesVoucherId
      salesVoucherStatusId
      customerRef
      trucksCount
      destinationId
      quotationId
      currency
      salesVoucherStatus {
        id
        description
        translationKey
      }
      product {
        id
        title
        itemCode
        uoS
      }
      destination {
        id
        name
        code
      }
      salesVoucher {
        id
        voucherNumber
        customerReference
        orderQuote
        customerId
        customer {
          id
          customerName
          customerCode
          phoneNumber
        }
        sourceLocation {
          id
          name
          code
        }
      }
      salesVoucherOrders {
        id
        salesOrderNumber
        quantity
        amountTotal
        currency
        vehicleNumber
        driverLicenseNo
        transporterCode
        salesVoucherOrderStatusId
        salesVoucherOrderStatus {
          id
          description
          translationKey
        }
        customer {
          id
          customerName
          customerCode
        }
        product {
          id
          title
          itemCode
        }
        destination {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlannerSalesVoucherItemByIdQuery__
 *
 * To run a query within a React component, call `useGetPlannerSalesVoucherItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannerSalesVoucherItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannerSalesVoucherItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlannerSalesVoucherItemByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables> & ({ variables: GetPlannerSalesVoucherItemByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>(GetPlannerSalesVoucherItemByIdDocument, options);
      }
export function useGetPlannerSalesVoucherItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>(GetPlannerSalesVoucherItemByIdDocument, options);
        }
export function useGetPlannerSalesVoucherItemByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>(GetPlannerSalesVoucherItemByIdDocument, options);
        }
export type GetPlannerSalesVoucherItemByIdQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemByIdQuery>;
export type GetPlannerSalesVoucherItemByIdLazyQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemByIdLazyQuery>;
export type GetPlannerSalesVoucherItemByIdSuspenseQueryHookResult = ReturnType<typeof useGetPlannerSalesVoucherItemByIdSuspenseQuery>;
export type GetPlannerSalesVoucherItemByIdQueryResult = Apollo.QueryResult<GetPlannerSalesVoucherItemByIdQuery, GetPlannerSalesVoucherItemByIdQueryVariables>;
export const UpdateSalesVoucherDeliveryDateDocument = gql`
    mutation UpdateSalesVoucherDeliveryDate($input: SetDeliveryDateInput!) {
  setDeliveryDate(input: $input) {
    salesVoucherItem {
      id
      deliveryDate
    }
  }
}
    `;
export type UpdateSalesVoucherDeliveryDateMutationFn = Apollo.MutationFunction<UpdateSalesVoucherDeliveryDateMutation, UpdateSalesVoucherDeliveryDateMutationVariables>;

/**
 * __useUpdateSalesVoucherDeliveryDateMutation__
 *
 * To run a mutation, you first call `useUpdateSalesVoucherDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesVoucherDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesVoucherDeliveryDateMutation, { data, loading, error }] = useUpdateSalesVoucherDeliveryDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesVoucherDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesVoucherDeliveryDateMutation, UpdateSalesVoucherDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesVoucherDeliveryDateMutation, UpdateSalesVoucherDeliveryDateMutationVariables>(UpdateSalesVoucherDeliveryDateDocument, options);
      }
export type UpdateSalesVoucherDeliveryDateMutationHookResult = ReturnType<typeof useUpdateSalesVoucherDeliveryDateMutation>;
export type UpdateSalesVoucherDeliveryDateMutationResult = Apollo.MutationResult<UpdateSalesVoucherDeliveryDateMutation>;
export type UpdateSalesVoucherDeliveryDateMutationOptions = Apollo.BaseMutationOptions<UpdateSalesVoucherDeliveryDateMutation, UpdateSalesVoucherDeliveryDateMutationVariables>;
export const UpsertQuickFilterDocument = gql`
    mutation upsertQuickFilter($input: UpsertPredefinedReportFilterInput!) {
  upsertPredefinedReportFilter(input: $input) {
    predefinedReportFilter {
      id
      name
    }
  }
}
    `;
export type UpsertQuickFilterMutationFn = Apollo.MutationFunction<UpsertQuickFilterMutation, UpsertQuickFilterMutationVariables>;

/**
 * __useUpsertQuickFilterMutation__
 *
 * To run a mutation, you first call `useUpsertQuickFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertQuickFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertQuickFilterMutation, { data, loading, error }] = useUpsertQuickFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertQuickFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpsertQuickFilterMutation, UpsertQuickFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertQuickFilterMutation, UpsertQuickFilterMutationVariables>(UpsertQuickFilterDocument, options);
      }
export type UpsertQuickFilterMutationHookResult = ReturnType<typeof useUpsertQuickFilterMutation>;
export type UpsertQuickFilterMutationResult = Apollo.MutationResult<UpsertQuickFilterMutation>;
export type UpsertQuickFilterMutationOptions = Apollo.BaseMutationOptions<UpsertQuickFilterMutation, UpsertQuickFilterMutationVariables>;
export const GetQuickFiltersDocument = gql`
    query getQuickFilters($locationId: Int!, $reportTypeId: Int!) {
  predefinedReportFilters(
    where: {locationId: {eq: $locationId}, reportTypeId: {eq: $reportTypeId}}
  ) {
    id
    name
    data
    locationId
    reportTypeId
    reportType {
      description
    }
  }
}
    `;

/**
 * __useGetQuickFiltersQuery__
 *
 * To run a query within a React component, call `useGetQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickFiltersQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      reportTypeId: // value for 'reportTypeId'
 *   },
 * });
 */
export function useGetQuickFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables> & ({ variables: GetQuickFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>(GetQuickFiltersDocument, options);
      }
export function useGetQuickFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>(GetQuickFiltersDocument, options);
        }
export function useGetQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>(GetQuickFiltersDocument, options);
        }
export type GetQuickFiltersQueryHookResult = ReturnType<typeof useGetQuickFiltersQuery>;
export type GetQuickFiltersLazyQueryHookResult = ReturnType<typeof useGetQuickFiltersLazyQuery>;
export type GetQuickFiltersSuspenseQueryHookResult = ReturnType<typeof useGetQuickFiltersSuspenseQuery>;
export type GetQuickFiltersQueryResult = Apollo.QueryResult<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>;
export const DeleteQuickFilterDocument = gql`
    mutation deleteQuickFilter($input: DeletePredefinedReportFilterInput!) {
  deletePredefinedReportFilter(input: $input) {
    boolean
  }
}
    `;
export type DeleteQuickFilterMutationFn = Apollo.MutationFunction<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>;

/**
 * __useDeleteQuickFilterMutation__
 *
 * To run a mutation, you first call `useDeleteQuickFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuickFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuickFilterMutation, { data, loading, error }] = useDeleteQuickFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuickFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>(DeleteQuickFilterDocument, options);
      }
export type DeleteQuickFilterMutationHookResult = ReturnType<typeof useDeleteQuickFilterMutation>;
export type DeleteQuickFilterMutationResult = Apollo.MutationResult<DeleteQuickFilterMutation>;
export type DeleteQuickFilterMutationOptions = Apollo.BaseMutationOptions<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>;
export const GetSalesVouchersByCompanyDocument = gql`
    query getSalesVouchersByCompany($companyId: Int!, $locationIds: [Int]!, $startDate: DateTime!, $endDate: DateTime!, $order: SortEnumType = DESC, $take: Int = 100, $cursor: String) {
  salesVouchers(
    order: {id: $order}
    first: $take
    after: $cursor
    where: {and: [{companyId: {eq: $companyId}}, {createdAt: {gte: $startDate}}, {createdAt: {lte: $endDate}}, {sourceLocationId: {in: $locationIds}}]}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      id
      createdAt
      voucherNumber
      orderQuote
      salesVoucherStatusId
      createdAt
      destination {
        id
        name
      }
      createdBy {
        id
        email
        fullName
        userName
      }
      salesVoucherStatus {
        id
        description
      }
      sourceLocation {
        id
        name
      }
      destinationId
      companyId
      customer {
        id
        customerName
        customerCode
      }
      salesVoucherItems {
        id
        destination {
          id
          name
        }
        salesVoucherOrders {
          salesOrderNumber
          quotationId
          salesInvoiceNumber
          salesVoucherOrderStatus {
            description
          }
        }
        product {
          id
          title
          description
          itemCode
        }
        quantity
        trucksCount
        isDeliveryInclusive
      }
      payments {
        id
        paymentReference
        paymentApprovals {
          journalReference
        }
        paymentStatusId
        paymentStatus {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesVouchersByCompanyQuery__
 *
 * To run a query within a React component, call `useGetSalesVouchersByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVouchersByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVouchersByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetSalesVouchersByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables> & ({ variables: GetSalesVouchersByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>(GetSalesVouchersByCompanyDocument, options);
      }
export function useGetSalesVouchersByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>(GetSalesVouchersByCompanyDocument, options);
        }
export function useGetSalesVouchersByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>(GetSalesVouchersByCompanyDocument, options);
        }
export type GetSalesVouchersByCompanyQueryHookResult = ReturnType<typeof useGetSalesVouchersByCompanyQuery>;
export type GetSalesVouchersByCompanyLazyQueryHookResult = ReturnType<typeof useGetSalesVouchersByCompanyLazyQuery>;
export type GetSalesVouchersByCompanySuspenseQueryHookResult = ReturnType<typeof useGetSalesVouchersByCompanySuspenseQuery>;
export type GetSalesVouchersByCompanyQueryResult = Apollo.QueryResult<GetSalesVouchersByCompanyQuery, GetSalesVouchersByCompanyQueryVariables>;
export const GetEPaymentsByCompanyDocument = gql`
    query getEPaymentsByCompany($companyId: Int!, $startDate: DateTime!, $endDate: DateTime!, $order: SortEnumType = DESC, $take: Int = 100, $cursor: String) {
  payments(
    order: {id: $order}
    first: $take
    after: $cursor
    where: {and: [{salesVoucher: {companyId: {eq: $companyId}}}, {paymentMode: {documentTypeId: {eq: 1}}}, {createdAt: {gte: $startDate}}, {createdAt: {lte: $endDate}}]}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      amount
      amountApproved
      createdAt
      customReference
      id
      paymentApprovals {
        approvalComment
        createdBy {
          id
          email
          fullName
          userName
        }
      }
      paymentMode {
        id
        name
        documentType {
          id
          description
        }
      }
      paymentReference
      paymentApprovals {
        journalReference
      }
      paymentStatusId
      paymentStatus {
        id
        description
      }
      reason {
        detail
      }
      rejectionComment
    }
  }
}
    `;

/**
 * __useGetEPaymentsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetEPaymentsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEPaymentsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEPaymentsByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetEPaymentsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables> & ({ variables: GetEPaymentsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>(GetEPaymentsByCompanyDocument, options);
      }
export function useGetEPaymentsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>(GetEPaymentsByCompanyDocument, options);
        }
export function useGetEPaymentsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>(GetEPaymentsByCompanyDocument, options);
        }
export type GetEPaymentsByCompanyQueryHookResult = ReturnType<typeof useGetEPaymentsByCompanyQuery>;
export type GetEPaymentsByCompanyLazyQueryHookResult = ReturnType<typeof useGetEPaymentsByCompanyLazyQuery>;
export type GetEPaymentsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetEPaymentsByCompanySuspenseQuery>;
export type GetEPaymentsByCompanyQueryResult = Apollo.QueryResult<GetEPaymentsByCompanyQuery, GetEPaymentsByCompanyQueryVariables>;
export const GetManualPaymentsByCompanyDocument = gql`
    query getManualPaymentsByCompany($companyId: Int!, $locationIds: [Int]!, $startDate: DateTime!, $endDate: DateTime!, $order: SortEnumType = DESC, $take: Int = 100, $cursor: String) {
  payments(
    order: {id: $order}
    first: $take
    after: $cursor
    where: {and: [{customer: {companyId: {eq: $companyId}}}, {paymentMode: {documentTypeId: {neq: 1}}}, {createdAt: {gte: $startDate}}, {createdAt: {lte: $endDate}}, {or: [{and: [{salesVoucherId: {eq: null}}, {customer: {company: {locations: {some: {id: {in: $locationIds}}}}}}]}, {and: [{salesVoucherId: {neq: null}}, {salesVoucher: {sourceLocationId: {in: $locationIds}}}]}]}]}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      amount
      amountApproved
      createdAt
      updatedAt
      customReference
      id
      paymentApprovals {
        journalReference
        approvalComment
        paymentApprovalStatus {
          id
          description
        }
        createdBy {
          id
          email
          fullName
          userName
        }
        createdAt
      }
      paymentMode {
        id
        name
        documentType {
          id
          description
        }
      }
      paymentReference
      paymentStatusId
      paymentStatus {
        id
        description
      }
      reason {
        detail
      }
      rejectionComment
      customer {
        customerCode
        customerName
      }
      salesVoucher {
        voucherNumber
        customer {
          customerCode
          customerName
        }
        sourceLocationId
      }
      paymentTranscriptions {
        createdBy {
          id
          email
          userName
          fullName
        }
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetManualPaymentsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetManualPaymentsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualPaymentsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualPaymentsByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetManualPaymentsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables> & ({ variables: GetManualPaymentsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>(GetManualPaymentsByCompanyDocument, options);
      }
export function useGetManualPaymentsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>(GetManualPaymentsByCompanyDocument, options);
        }
export function useGetManualPaymentsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>(GetManualPaymentsByCompanyDocument, options);
        }
export type GetManualPaymentsByCompanyQueryHookResult = ReturnType<typeof useGetManualPaymentsByCompanyQuery>;
export type GetManualPaymentsByCompanyLazyQueryHookResult = ReturnType<typeof useGetManualPaymentsByCompanyLazyQuery>;
export type GetManualPaymentsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetManualPaymentsByCompanySuspenseQuery>;
export type GetManualPaymentsByCompanyQueryResult = Apollo.QueryResult<GetManualPaymentsByCompanyQuery, GetManualPaymentsByCompanyQueryVariables>;
export const GetSalesVoucherOrdersByCompanyDocument = gql`
    query getSalesVoucherOrdersByCompany($companyId: Int!, $locationIds: [Int]!, $startDate: DateTime!, $endDate: DateTime!, $order: SortEnumType = DESC, $take: Int = 100, $cursor: String) {
  salesVoucherOrders(
    order: {id: $order}
    first: $take
    after: $cursor
    where: {and: [{companyId: {eq: $companyId}}, {createdAt: {gte: $startDate}}, {createdAt: {lte: $endDate}}, {salesVoucher: {sourceLocationId: {in: $locationIds}}}]}
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      id
      companyId
      salesOrderNumber
      customerRef
      paymentRef
      salesVoucherOrderStatus {
        description
        translationKey
      }
      salesVoucher {
        voucherNumber
        orderQuote
        sourceLocationId
        payments {
          paymentReference
          paymentApprovals {
            journalReference
          }
        }
      }
      customer {
        customerName
        customerCode
      }
      salesVoucherItem {
        quotationId
        quantity
        totalPrice
        product {
          itemCode
        }
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetSalesVoucherOrdersByCompanyQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherOrdersByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherOrdersByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherOrdersByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetSalesVoucherOrdersByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables> & ({ variables: GetSalesVoucherOrdersByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>(GetSalesVoucherOrdersByCompanyDocument, options);
      }
export function useGetSalesVoucherOrdersByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>(GetSalesVoucherOrdersByCompanyDocument, options);
        }
export function useGetSalesVoucherOrdersByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>(GetSalesVoucherOrdersByCompanyDocument, options);
        }
export type GetSalesVoucherOrdersByCompanyQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersByCompanyQuery>;
export type GetSalesVoucherOrdersByCompanyLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersByCompanyLazyQuery>;
export type GetSalesVoucherOrdersByCompanySuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersByCompanySuspenseQuery>;
export type GetSalesVoucherOrdersByCompanyQueryResult = Apollo.QueryResult<GetSalesVoucherOrdersByCompanyQuery, GetSalesVoucherOrdersByCompanyQueryVariables>;
export const GetUserReportDocument = gql`
    query getUserReport($cursor: String, $take: Int = 100, $locationId: Int!) {
  users(
    where: {locationId: {eq: $locationId}}
    after: $cursor
    first: $take
    order: {id: ASC}
  ) {
    totalCount
    nodes {
      id
      userName
      fullName
      email
      locationId
      companyId
      companies {
        id
        name
        code
      }
      location {
        id
        name
        code
        type
      }
      phoneNumber
      createdAt
      customer {
        customerCode
        customerName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetUserReportQuery__
 *
 * To run a query within a React component, call `useGetUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserReportQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetUserReportQuery(baseOptions: Apollo.QueryHookOptions<GetUserReportQuery, GetUserReportQueryVariables> & ({ variables: GetUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserReportQuery, GetUserReportQueryVariables>(GetUserReportDocument, options);
      }
export function useGetUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserReportQuery, GetUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserReportQuery, GetUserReportQueryVariables>(GetUserReportDocument, options);
        }
export function useGetUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserReportQuery, GetUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserReportQuery, GetUserReportQueryVariables>(GetUserReportDocument, options);
        }
export type GetUserReportQueryHookResult = ReturnType<typeof useGetUserReportQuery>;
export type GetUserReportLazyQueryHookResult = ReturnType<typeof useGetUserReportLazyQuery>;
export type GetUserReportSuspenseQueryHookResult = ReturnType<typeof useGetUserReportSuspenseQuery>;
export type GetUserReportQueryResult = Apollo.QueryResult<GetUserReportQuery, GetUserReportQueryVariables>;
export const DfsChequeManagementDetailsReportDocument = gql`
    query DfsChequeManagementDetailsReport($companyId: Int!, $locationIds: [Int]!) {
  payments(
    where: {and: [{cheque: {chequeStatusId: {eq: 4}}}, {customer: {companyId: {eq: $companyId}}}, {paymentApprovals: {some: {paymentApprovalStatusId: {eq: 1}}}}, {salesVoucher: {sourceLocationId: {in: $locationIds}}}]}
  ) {
    nodes {
      customer {
        customerName
        customerCode
      }
      paymentReference
      amountApproved
      cheque {
        chequeNumber
        chequeStatus {
          translationKey
          description
        }
      }
      amount
      paymentApprovals {
        paymentApprovalStatusId
        bankGuarantee {
          guaranteeBank {
            name
          }
          expiryDate
        }
        createdAt
      }
      salesVoucher {
        sourceLocationId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    `;

/**
 * __useDfsChequeManagementDetailsReportQuery__
 *
 * To run a query within a React component, call `useDfsChequeManagementDetailsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfsChequeManagementDetailsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfsChequeManagementDetailsReportQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useDfsChequeManagementDetailsReportQuery(baseOptions: Apollo.QueryHookOptions<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables> & ({ variables: DfsChequeManagementDetailsReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>(DfsChequeManagementDetailsReportDocument, options);
      }
export function useDfsChequeManagementDetailsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>(DfsChequeManagementDetailsReportDocument, options);
        }
export function useDfsChequeManagementDetailsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>(DfsChequeManagementDetailsReportDocument, options);
        }
export type DfsChequeManagementDetailsReportQueryHookResult = ReturnType<typeof useDfsChequeManagementDetailsReportQuery>;
export type DfsChequeManagementDetailsReportLazyQueryHookResult = ReturnType<typeof useDfsChequeManagementDetailsReportLazyQuery>;
export type DfsChequeManagementDetailsReportSuspenseQueryHookResult = ReturnType<typeof useDfsChequeManagementDetailsReportSuspenseQuery>;
export type DfsChequeManagementDetailsReportQueryResult = Apollo.QueryResult<DfsChequeManagementDetailsReportQuery, DfsChequeManagementDetailsReportQueryVariables>;
export const GetActiveUserSalesReportDocument = gql`
    query getActiveUserSalesReport($startDate: DateTime!, $endDate: DateTime!) {
  customerSalesActivityReport(startDate: $startDate, endDate: $endDate) {
    customerName
    customerCode
    lastActivityDate
    salesVolume
    totalSalesAmount
  }
}
    `;

/**
 * __useGetActiveUserSalesReportQuery__
 *
 * To run a query within a React component, call `useGetActiveUserSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveUserSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveUserSalesReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetActiveUserSalesReportQuery(baseOptions: Apollo.QueryHookOptions<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables> & ({ variables: GetActiveUserSalesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>(GetActiveUserSalesReportDocument, options);
      }
export function useGetActiveUserSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>(GetActiveUserSalesReportDocument, options);
        }
export function useGetActiveUserSalesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>(GetActiveUserSalesReportDocument, options);
        }
export type GetActiveUserSalesReportQueryHookResult = ReturnType<typeof useGetActiveUserSalesReportQuery>;
export type GetActiveUserSalesReportLazyQueryHookResult = ReturnType<typeof useGetActiveUserSalesReportLazyQuery>;
export type GetActiveUserSalesReportSuspenseQueryHookResult = ReturnType<typeof useGetActiveUserSalesReportSuspenseQuery>;
export type GetActiveUserSalesReportQueryResult = Apollo.QueryResult<GetActiveUserSalesReportQuery, GetActiveUserSalesReportQueryVariables>;
export const GetActiveUserOrdersReportDocument = gql`
    query getActiveUserOrdersReport($endDate: DateTime!, $startDate: DateTime!) {
  customerOrdersActivityReport(endDate: $endDate, startDate: $startDate) {
    customerName
    customerCode
    lastActivityDate
    orderVolume
    totalOrderAmount
  }
}
    `;

/**
 * __useGetActiveUserOrdersReportQuery__
 *
 * To run a query within a React component, call `useGetActiveUserOrdersReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveUserOrdersReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveUserOrdersReportQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetActiveUserOrdersReportQuery(baseOptions: Apollo.QueryHookOptions<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables> & ({ variables: GetActiveUserOrdersReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>(GetActiveUserOrdersReportDocument, options);
      }
export function useGetActiveUserOrdersReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>(GetActiveUserOrdersReportDocument, options);
        }
export function useGetActiveUserOrdersReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>(GetActiveUserOrdersReportDocument, options);
        }
export type GetActiveUserOrdersReportQueryHookResult = ReturnType<typeof useGetActiveUserOrdersReportQuery>;
export type GetActiveUserOrdersReportLazyQueryHookResult = ReturnType<typeof useGetActiveUserOrdersReportLazyQuery>;
export type GetActiveUserOrdersReportSuspenseQueryHookResult = ReturnType<typeof useGetActiveUserOrdersReportSuspenseQuery>;
export type GetActiveUserOrdersReportQueryResult = Apollo.QueryResult<GetActiveUserOrdersReportQuery, GetActiveUserOrdersReportQueryVariables>;
export const GetPendingCancellationRequestsDocument = gql`
    query GetPendingCancellationRequests($where: SalesVoucherFilterInput, $take: Int = 50) {
  salesVouchers(where: $where, first: $take, order: {id: DESC}) {
    totalCount
    nodes {
      id
      voucherNumber
      createdAt
      updatedAt
      orderQuote
      customer {
        customerName
        customerCode
        customerCurrency
        businessUnitCurrency
        companyId
      }
      createdBy {
        id
        userName
        fullName
      }
      sourceLocation {
        name
      }
      salesVoucherStatus {
        id
        description
        translationKey
      }
      salesVoucherItems {
        id
        quantity
        salesVoucherStatusId
        isDeliveryInclusive
        product {
          uoS
          unitOfMeasure {
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPendingCancellationRequestsQuery__
 *
 * To run a query within a React component, call `useGetPendingCancellationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCancellationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCancellationRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPendingCancellationRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>(GetPendingCancellationRequestsDocument, options);
      }
export function useGetPendingCancellationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>(GetPendingCancellationRequestsDocument, options);
        }
export function useGetPendingCancellationRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>(GetPendingCancellationRequestsDocument, options);
        }
export type GetPendingCancellationRequestsQueryHookResult = ReturnType<typeof useGetPendingCancellationRequestsQuery>;
export type GetPendingCancellationRequestsLazyQueryHookResult = ReturnType<typeof useGetPendingCancellationRequestsLazyQuery>;
export type GetPendingCancellationRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPendingCancellationRequestsSuspenseQuery>;
export type GetPendingCancellationRequestsQueryResult = Apollo.QueryResult<GetPendingCancellationRequestsQuery, GetPendingCancellationRequestsQueryVariables>;
export const GetCancellationVoucherDetailDocument = gql`
    query GetCancellationVoucherDetail($id: Int!) {
  salesVouchers(where: {id: {eq: $id}}) {
    nodes {
      id
      voucherNumber
      createdAt
      updatedAt
      comments
      description
      localPurchaseOrder
      customerReference
      orderQuote
      customer {
        customerName
        customerCode
        customerCurrency
        businessUnitCurrency
        companyId
      }
      createdBy {
        id
        userName
        fullName
      }
      sourceLocation {
        name
      }
      salesVoucherStatus {
        id
        description
        translationKey
      }
      salesVoucherDocuments {
        documentName
        documentUrl
      }
      payments {
        paymentReference
        paymentMode {
          name
        }
      }
      salesVoucherItems {
        id
        quantity
        cancellationReason
        salesVoucherStatusId
        isDeliveryInclusive
        customerRef
        product {
          title
          uoS
        }
        salesVoucherOrders {
          salesOrderNumber
          customerRef
          quantity
          uoS
          salesVoucherOrderStatus {
            id
            description
            translationKey
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCancellationVoucherDetailQuery__
 *
 * To run a query within a React component, call `useGetCancellationVoucherDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationVoucherDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationVoucherDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCancellationVoucherDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables> & ({ variables: GetCancellationVoucherDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>(GetCancellationVoucherDetailDocument, options);
      }
export function useGetCancellationVoucherDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>(GetCancellationVoucherDetailDocument, options);
        }
export function useGetCancellationVoucherDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>(GetCancellationVoucherDetailDocument, options);
        }
export type GetCancellationVoucherDetailQueryHookResult = ReturnType<typeof useGetCancellationVoucherDetailQuery>;
export type GetCancellationVoucherDetailLazyQueryHookResult = ReturnType<typeof useGetCancellationVoucherDetailLazyQuery>;
export type GetCancellationVoucherDetailSuspenseQueryHookResult = ReturnType<typeof useGetCancellationVoucherDetailSuspenseQuery>;
export type GetCancellationVoucherDetailQueryResult = Apollo.QueryResult<GetCancellationVoucherDetailQuery, GetCancellationVoucherDetailQueryVariables>;
export const ResolveVoidOrderRequestDocument = gql`
    mutation ResolveVoidOrderRequest($input: ResolveVoidOrderRequestInput!) {
  resolveVoidOrderRequest(input: $input) {
    salesVoucher {
      id
    }
  }
}
    `;
export type ResolveVoidOrderRequestMutationFn = Apollo.MutationFunction<ResolveVoidOrderRequestMutation, ResolveVoidOrderRequestMutationVariables>;

/**
 * __useResolveVoidOrderRequestMutation__
 *
 * To run a mutation, you first call `useResolveVoidOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveVoidOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveVoidOrderRequestMutation, { data, loading, error }] = useResolveVoidOrderRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveVoidOrderRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveVoidOrderRequestMutation, ResolveVoidOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveVoidOrderRequestMutation, ResolveVoidOrderRequestMutationVariables>(ResolveVoidOrderRequestDocument, options);
      }
export type ResolveVoidOrderRequestMutationHookResult = ReturnType<typeof useResolveVoidOrderRequestMutation>;
export type ResolveVoidOrderRequestMutationResult = Apollo.MutationResult<ResolveVoidOrderRequestMutation>;
export type ResolveVoidOrderRequestMutationOptions = Apollo.BaseMutationOptions<ResolveVoidOrderRequestMutation, ResolveVoidOrderRequestMutationVariables>;
export const GetPaginatedSalesVouchersDocument = gql`
    query GetPaginatedSalesVouchers($companyId: Int!, $locationIds: [Int!], $where: SalesVoucherFilterInput, $cursor: String, $take: Int = 10, $order: SortEnumType = DESC) {
  salesVouchers: backOfficeSalesVouchers(
    companyId: $companyId
    locationIds: $locationIds
    where: $where
    after: $cursor
    first: $take
    order: {id: $order}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      voucherNumber
      customer {
        customerName
        customerCode
        companyId
        customerCurrency
        businessUnitCurrency
      }
      customerReference
      customOrderNumber
      customerId
      orderQuote
      updatedAt
      createdAt
      createdBy {
        id
        userName
        email
        fullName
      }
      sourceLocation {
        id
        name
      }
      destination {
        name
      }
      salesVoucherStatus {
        id
        description
        translationKey
      }
      payments {
        paymentMode {
          name
        }
        amount
        id
      }
      salesVoucherItems {
        id
        isDeliveryInclusive
        quantity
        product {
          unitOfMeasure {
            id
            description
          }
          productMeasurement {
            id
            description
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedSalesVouchersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSalesVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSalesVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSalesVouchersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationIds: // value for 'locationIds'
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPaginatedSalesVouchersQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables> & ({ variables: GetPaginatedSalesVouchersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>(GetPaginatedSalesVouchersDocument, options);
      }
export function useGetPaginatedSalesVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>(GetPaginatedSalesVouchersDocument, options);
        }
export function useGetPaginatedSalesVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>(GetPaginatedSalesVouchersDocument, options);
        }
export type GetPaginatedSalesVouchersQueryHookResult = ReturnType<typeof useGetPaginatedSalesVouchersQuery>;
export type GetPaginatedSalesVouchersLazyQueryHookResult = ReturnType<typeof useGetPaginatedSalesVouchersLazyQuery>;
export type GetPaginatedSalesVouchersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedSalesVouchersSuspenseQuery>;
export type GetPaginatedSalesVouchersQueryResult = Apollo.QueryResult<GetPaginatedSalesVouchersQuery, GetPaginatedSalesVouchersQueryVariables>;
export const SalesVouchersCountDocument = gql`
    query salesVouchersCount($companyId: Int!) {
  salesVouchers(where: {companyId: {eq: $companyId}}) {
    totalCount
  }
}
    `;

/**
 * __useSalesVouchersCountQuery__
 *
 * To run a query within a React component, call `useSalesVouchersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesVouchersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesVouchersCountQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSalesVouchersCountQuery(baseOptions: Apollo.QueryHookOptions<SalesVouchersCountQuery, SalesVouchersCountQueryVariables> & ({ variables: SalesVouchersCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>(SalesVouchersCountDocument, options);
      }
export function useSalesVouchersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>(SalesVouchersCountDocument, options);
        }
export function useSalesVouchersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>(SalesVouchersCountDocument, options);
        }
export type SalesVouchersCountQueryHookResult = ReturnType<typeof useSalesVouchersCountQuery>;
export type SalesVouchersCountLazyQueryHookResult = ReturnType<typeof useSalesVouchersCountLazyQuery>;
export type SalesVouchersCountSuspenseQueryHookResult = ReturnType<typeof useSalesVouchersCountSuspenseQuery>;
export type SalesVouchersCountQueryResult = Apollo.QueryResult<SalesVouchersCountQuery, SalesVouchersCountQueryVariables>;
export const GetSalesVouchersDocument = gql`
    query getSalesVouchers($companyId: Int!) {
  salesVouchers(where: {companyId: {eq: $companyId}}, first: 20) {
    nodes {
      id
      voucherNumber
    }
  }
}
    `;

/**
 * __useGetSalesVouchersQuery__
 *
 * To run a query within a React component, call `useGetSalesVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVouchersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSalesVouchersQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVouchersQuery, GetSalesVouchersQueryVariables> & ({ variables: GetSalesVouchersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>(GetSalesVouchersDocument, options);
      }
export function useGetSalesVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>(GetSalesVouchersDocument, options);
        }
export function useGetSalesVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>(GetSalesVouchersDocument, options);
        }
export type GetSalesVouchersQueryHookResult = ReturnType<typeof useGetSalesVouchersQuery>;
export type GetSalesVouchersLazyQueryHookResult = ReturnType<typeof useGetSalesVouchersLazyQuery>;
export type GetSalesVouchersSuspenseQueryHookResult = ReturnType<typeof useGetSalesVouchersSuspenseQuery>;
export type GetSalesVouchersQueryResult = Apollo.QueryResult<GetSalesVouchersQuery, GetSalesVouchersQueryVariables>;
export const GetSalesVoucherDocument = gql`
    query getSalesVoucher($id: Int!, $companyId: Int!) {
  salesVouchers(where: {and: [{id: {eq: $id}}, {companyId: {eq: $companyId}}]}) {
    nodes {
      id
      voucherNumber
      customer {
        customerName
        customerCode
      }
      customerReference
      customOrderNumber
      customerId
      orderQuote
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useGetSalesVoucherQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSalesVoucherQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVoucherQuery, GetSalesVoucherQueryVariables> & ({ variables: GetSalesVoucherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>(GetSalesVoucherDocument, options);
      }
export function useGetSalesVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>(GetSalesVoucherDocument, options);
        }
export function useGetSalesVoucherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>(GetSalesVoucherDocument, options);
        }
export type GetSalesVoucherQueryHookResult = ReturnType<typeof useGetSalesVoucherQuery>;
export type GetSalesVoucherLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherLazyQuery>;
export type GetSalesVoucherSuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherSuspenseQuery>;
export type GetSalesVoucherQueryResult = Apollo.QueryResult<GetSalesVoucherQuery, GetSalesVoucherQueryVariables>;
export const UpsertSalesVoucherDocument = gql`
    mutation UpsertSalesVoucher($input: UpsertSalesVoucherInput!) {
  upsertSalesVoucher(input: $input) {
    salesVoucher {
      id
    }
  }
}
    `;
export type UpsertSalesVoucherMutationFn = Apollo.MutationFunction<UpsertSalesVoucherMutation, UpsertSalesVoucherMutationVariables>;

/**
 * __useUpsertSalesVoucherMutation__
 *
 * To run a mutation, you first call `useUpsertSalesVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSalesVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSalesVoucherMutation, { data, loading, error }] = useUpsertSalesVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSalesVoucherMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSalesVoucherMutation, UpsertSalesVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSalesVoucherMutation, UpsertSalesVoucherMutationVariables>(UpsertSalesVoucherDocument, options);
      }
export type UpsertSalesVoucherMutationHookResult = ReturnType<typeof useUpsertSalesVoucherMutation>;
export type UpsertSalesVoucherMutationResult = Apollo.MutationResult<UpsertSalesVoucherMutation>;
export type UpsertSalesVoucherMutationOptions = Apollo.BaseMutationOptions<UpsertSalesVoucherMutation, UpsertSalesVoucherMutationVariables>;
export const GetSalesVoucherDatailsByOrderIdDocument = gql`
    query getSalesVoucherDatailsByOrderId($orderNumber: String!, $companyId: Int!) {
  salesVouchers: backOfficeSalesVouchers(
    companyId: $companyId
    where: {voucherNumber: {eq: $orderNumber}}
  ) {
    nodes {
      voucherNumber
      createdAt
      comments
      deliveryContact
      description
      salesVoucherItems {
        createdAt
        deliveryDate
        quotationId
        customerRef
        destination {
          code
        }
        id
        trucksCount
        quantity
        totalPrice
        driver {
          fullName
          firstName
          lastName
        }
        vehicle {
          vehicleNo
        }
        salesVoucherOrders {
          salesOrderNumber
          salesVoucherOrderStatus {
            description
            translationKey
          }
        }
        destination {
          name
        }
        product {
          itemCode
          title
          uoS
        }
        vehicleRequest {
          licensePlate
          transporterCode
          vehicleTypeId
          id
          vehicleRequestStatusId
          vehicleType {
            description
            translationKey
            id
          }
          vehicleRequestStatus {
            description
            translationKey
            id
          }
        }
        driverRequest {
          id
          licenseNo
          firstName
          lastName
          transporterCode
          licenseExpDate
          driverRequestStatusId
          driverRequestStatus {
            description
            translationKey
            id
          }
        }
      }
      customer {
        customerName
        customerCode
        phoneNumber
        active
        customerCurrency
        businessUnitCurrency
      }
      salesVoucherStatus {
        description
        translationKey
      }
      payments {
        paymentStatus {
          description
          translationKey
          id
        }
        id
        amount
        amountApproved
        salesVoucherId
        transactionId
        paymentMode {
          name
        }
        createdAt
        paymentReference
        paymentDocuments {
          createdAt
          documentName
          documentUrl
          id
          updatedAt
        }
        paymentApprovals {
          journalReference
        }
      }
      orderQuote
      sourceLocation {
        code
        pmEmployee
        contact {
          telephoneNumber
          email
        }
      }
      salesVoucherDocuments {
        createdAt
        documentName
        documentUrl
        id
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetSalesVoucherDatailsByOrderIdQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherDatailsByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherDatailsByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherDatailsByOrderIdQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSalesVoucherDatailsByOrderIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables> & ({ variables: GetSalesVoucherDatailsByOrderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>(GetSalesVoucherDatailsByOrderIdDocument, options);
      }
export function useGetSalesVoucherDatailsByOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>(GetSalesVoucherDatailsByOrderIdDocument, options);
        }
export function useGetSalesVoucherDatailsByOrderIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>(GetSalesVoucherDatailsByOrderIdDocument, options);
        }
export type GetSalesVoucherDatailsByOrderIdQueryHookResult = ReturnType<typeof useGetSalesVoucherDatailsByOrderIdQuery>;
export type GetSalesVoucherDatailsByOrderIdLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherDatailsByOrderIdLazyQuery>;
export type GetSalesVoucherDatailsByOrderIdSuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherDatailsByOrderIdSuspenseQuery>;
export type GetSalesVoucherDatailsByOrderIdQueryResult = Apollo.QueryResult<GetSalesVoucherDatailsByOrderIdQuery, GetSalesVoucherDatailsByOrderIdQueryVariables>;
export const GetSalesVoucherOrdersBySalesVoucherItemIdDocument = gql`
    query getSalesVoucherOrdersBySalesVoucherItemId($salesVoucherItemId: Int!) {
  salesVoucherOrders(where: {salesVoucherItemId: {eq: $salesVoucherItemId}}) {
    nodes {
      id
      salesOrderNumber
      paymentRef
      salesVoucherOrderStatus {
        description
        translationKey
      }
      quantity
      uoS
      destination {
        name
      }
      salesVoucherItem {
        id
        trucksCount
        quantity
        createdAt
        destination {
          name
        }
        product {
          itemCode
          title
          uoS
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesVoucherOrdersBySalesVoucherItemIdQuery__
 *
 * To run a query within a React component, call `useGetSalesVoucherOrdersBySalesVoucherItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesVoucherOrdersBySalesVoucherItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesVoucherOrdersBySalesVoucherItemIdQuery({
 *   variables: {
 *      salesVoucherItemId: // value for 'salesVoucherItemId'
 *   },
 * });
 */
export function useGetSalesVoucherOrdersBySalesVoucherItemIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables> & ({ variables: GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>(GetSalesVoucherOrdersBySalesVoucherItemIdDocument, options);
      }
export function useGetSalesVoucherOrdersBySalesVoucherItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>(GetSalesVoucherOrdersBySalesVoucherItemIdDocument, options);
        }
export function useGetSalesVoucherOrdersBySalesVoucherItemIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>(GetSalesVoucherOrdersBySalesVoucherItemIdDocument, options);
        }
export type GetSalesVoucherOrdersBySalesVoucherItemIdQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersBySalesVoucherItemIdQuery>;
export type GetSalesVoucherOrdersBySalesVoucherItemIdLazyQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersBySalesVoucherItemIdLazyQuery>;
export type GetSalesVoucherOrdersBySalesVoucherItemIdSuspenseQueryHookResult = ReturnType<typeof useGetSalesVoucherOrdersBySalesVoucherItemIdSuspenseQuery>;
export type GetSalesVoucherOrdersBySalesVoucherItemIdQueryResult = Apollo.QueryResult<GetSalesVoucherOrdersBySalesVoucherItemIdQuery, GetSalesVoucherOrdersBySalesVoucherItemIdQueryVariables>;
export const GetPaginatedSalesOrdersDocument = gql`
    query getPaginatedSalesOrders($cursor: String, $take: Int = 10, $salesVoucher: String, $customerName: String) {
  salesVoucherOrders(
    where: {or: [{salesVoucherItem: {salesVoucher: {voucherNumber: {contains: $salesVoucher}}}}, {salesVoucherItem: {salesVoucher: {customer: {customerName: {contains: $customerName}}}}}]}
    after: $cursor
    first: $take
    order: {id: DESC}
  ) {
    totalCount
    edges {
      cursor
    }
    nodes {
      salesVoucherItem {
        salesVoucher {
          orderQuote
          voucherNumber
          salesVoucherStatus {
            description
            translationKey
          }
          customer {
            customerCode
            customerName
          }
        }
        product {
          itemCode
        }
      }
      quotationId
      salesOrderNumber
      salesVoucherOrderStatus {
        description
        translationKey
      }
      createdAt
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedSalesOrdersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSalesOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSalesOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSalesOrdersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      salesVoucher: // value for 'salesVoucher'
 *      customerName: // value for 'customerName'
 *   },
 * });
 */
export function useGetPaginatedSalesOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>(GetPaginatedSalesOrdersDocument, options);
      }
export function useGetPaginatedSalesOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>(GetPaginatedSalesOrdersDocument, options);
        }
export function useGetPaginatedSalesOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>(GetPaginatedSalesOrdersDocument, options);
        }
export type GetPaginatedSalesOrdersQueryHookResult = ReturnType<typeof useGetPaginatedSalesOrdersQuery>;
export type GetPaginatedSalesOrdersLazyQueryHookResult = ReturnType<typeof useGetPaginatedSalesOrdersLazyQuery>;
export type GetPaginatedSalesOrdersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedSalesOrdersSuspenseQuery>;
export type GetPaginatedSalesOrdersQueryResult = Apollo.QueryResult<GetPaginatedSalesOrdersQuery, GetPaginatedSalesOrdersQueryVariables>;
export const GetPaginatedSalesVoucherItemsDocument = gql`
    query GetPaginatedSalesVoucherItems($companyId: Int!, $customerName: String, $orderNumber: String, $cursor: String, $take: Int = 10) {
  salesVoucherItems(
    where: {and: [{salesVoucher: {companyId: {eq: $companyId}}}, {or: [{salesVoucher: {voucherNumber: {contains: $orderNumber}}}, {salesVoucher: {customer: {customerName: {contains: $customerName}}}}]}]}
    after: $cursor
    first: $take
    order: {id: DESC}
  ) {
    edges {
      cursor
    }
    totalCount
    nodes {
      id
      salesVoucher {
        voucherNumber
        customer {
          customerName
          customerCode
        }
        createdBy {
          id
          email
          fullName
          userName
        }
        salesVoucherStatus {
          id
          description
          translationKey
        }
        orderQuote
      }
      quotationId
      salesVoucherOrders {
        salesOrderNumber
        salesVoucherOrderStatus {
          id
          description
        }
      }
      product {
        itemCode
      }
      updatedAt
      createdAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedSalesVoucherItemsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSalesVoucherItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSalesVoucherItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSalesVoucherItemsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      customerName: // value for 'customerName'
 *      orderNumber: // value for 'orderNumber'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetPaginatedSalesVoucherItemsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables> & ({ variables: GetPaginatedSalesVoucherItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>(GetPaginatedSalesVoucherItemsDocument, options);
      }
export function useGetPaginatedSalesVoucherItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>(GetPaginatedSalesVoucherItemsDocument, options);
        }
export function useGetPaginatedSalesVoucherItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>(GetPaginatedSalesVoucherItemsDocument, options);
        }
export type GetPaginatedSalesVoucherItemsQueryHookResult = ReturnType<typeof useGetPaginatedSalesVoucherItemsQuery>;
export type GetPaginatedSalesVoucherItemsLazyQueryHookResult = ReturnType<typeof useGetPaginatedSalesVoucherItemsLazyQuery>;
export type GetPaginatedSalesVoucherItemsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedSalesVoucherItemsSuspenseQuery>;
export type GetPaginatedSalesVoucherItemsQueryResult = Apollo.QueryResult<GetPaginatedSalesVoucherItemsQuery, GetPaginatedSalesVoucherItemsQueryVariables>;